export const podcastAssetSummary = {
  "generated_at": "2026-06-16T13:19:08.326Z",
  "bucket": "ai-podcast-radar-assets",
  "r2_prefix": "podcast-text/v1",
  "public_prefix": "/api/podcast-assets",
  "manifest_key": "podcast-text/v1/manifest.json",
  "objects": 1261,
  "episodes": 1031,
  "transcript_assets": 1031,
  "transcript_pdf_assets": 30,
  "cn_readable_assets": 100,
  "cn_knowledge_json_assets": 100
} as const;

export const podcastAssetIndex = {
  "42zhangjing/6a100e7da7621e15d0c88337": {
    "source_id": "42zhangjing",
    "episode_id": "6a100e7da7621e15d0c88337",
    "title": "一个 AI 创始人的虚荣心、装，和愚昧之巅｜对谈 invoko.ai 创始人梦琪",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/6a100e7da7621e15d0c88337-482f76a0198f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/6a100e7da7621e15d0c88337-482f76a0198f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 134354,
      "sha256": "6345eabde97fbc3a1ca263ac12d509cf6a4d700cfdb60abafa9174b6976f2668",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1692,
      "updated_at": "2026-06-09T13:39:30.749Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/6a059d321b7bd50295257a5e": {
    "source_id": "42zhangjing",
    "episode_id": "6a059d321b7bd50295257a5e",
    "title": "当软件容易被创作，新时代的产品长什么样？ | 对谈 Albert",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/6a059d321b7bd50295257a5e-021b58b12c8e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/6a059d321b7bd50295257a5e-021b58b12c8e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99419,
      "sha256": "ac29183a0eac8e0d3966204d54ef41c1278086146d48c5a6012c19b97d313537",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1436,
      "updated_at": "2026-06-09T13:39:30.748Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/69e999241e94ae6921f2901d": {
    "source_id": "42zhangjing",
    "episode_id": "69e999241e94ae6921f2901d",
    "title": "用 Agent 动力学，和 40 个 Agents 一起为「人 + AI」做产品｜对谈 Slock.ai 创始人 RC",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/69e999241e94ae6921f2901d-81c297a909f9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/69e999241e94ae6921f2901d-81c297a909f9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 138938,
      "sha256": "cc622dc376399275f8b4008df0e18b415e4e24773c4bae1c813e250de63d7331",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1976,
      "updated_at": "2026-06-09T13:39:30.747Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/69bbc8ea3c625cc5ae21b461": {
    "source_id": "42zhangjing",
    "episode_id": "69bbc8ea3c625cc5ae21b461",
    "title": "我们是如何定义 OpenClaw for Teams 新产品形态的｜对谈 Kuse&Junior 联创兼 CTO 宇豪",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/69bbc8ea3c625cc5ae21b461-ff3dcb894966/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/69bbc8ea3c625cc5ae21b461-ff3dcb894966/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 152628,
      "sha256": "7c88b06b71a207a201f659e4bd2dcbebd3978285d56b64005d831043d00074be",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2141,
      "updated_at": "2026-06-09T13:39:30.746Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/69b4d2f9f8b8079bfa3ae7f2": {
    "source_id": "42zhangjing",
    "episode_id": "69b4d2f9f8b8079bfa3ae7f2",
    "title": "OpenClaw 之后，我只想未来 3-6 个月的事情｜对谈 Sheet0 创始人王文锋",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/69b4d2f9f8b8079bfa3ae7f2-3249a5886ca4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/69b4d2f9f8b8079bfa3ae7f2-3249a5886ca4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 86463,
      "sha256": "13c1cdaa6190302e624e9f3646d5763327c1a3f2f4b59252c80a443a93c7e389",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 872,
      "updated_at": "2026-06-09T13:39:30.745Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/69a0b34b66e2c303778cd3ce": {
    "source_id": "42zhangjing",
    "episode_id": "69a0b34b66e2c303778cd3ce",
    "title": "AI + 游戏 + 社交的新演绎 | 对谈 Wanaka 创始人张阳",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/69a0b34b66e2c303778cd3ce-e1f462c50d1f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/69a0b34b66e2c303778cd3ce-e1f462c50d1f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 144237,
      "sha256": "3542dea76080fccfd2df8ea03ee603aaa8e3aa9b1413cc3fff807cf892a85095",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1764,
      "updated_at": "2026-06-09T13:39:30.745Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/698563a188663289fe80769a": {
    "source_id": "42zhangjing",
    "episode_id": "698563a188663289fe80769a",
    "title": "从 Clawdbot 到 26 年 AI Coding 主题大爆发｜对谈 PingCAP CTO 东旭",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/698563a188663289fe80769a-fb77fc432378/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/698563a188663289fe80769a-fb77fc432378/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 94204,
      "sha256": "dcf5640e528b7240819070d81c195c917c93a9c4971dac1ae23d878a6fdb1d8c",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 902,
      "updated_at": "2026-06-09T13:39:30.744Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/6961bd3af8b05f9f75c3edb8": {
    "source_id": "42zhangjing",
    "episode_id": "6961bd3af8b05f9f75c3edb8",
    "title": "All in AI 的第一个三年｜对谈绿洲资本合伙人张津剑",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/6961bd3af8b05f9f75c3edb8-0537fb1ccfec/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/6961bd3af8b05f9f75c3edb8-0537fb1ccfec/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 119914,
      "sha256": "908a49fd3c62c782288f4abc99479afaeb45c04f14e8319fe216b9d221abe108",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1112,
      "updated_at": "2026-06-09T13:39:30.743Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/694e181744647f77684bb4f1": {
    "source_id": "42zhangjing",
    "episode_id": "694e181744647f77684bb4f1",
    "title": "中美 AI 创投的真实差异｜对谈 Leonis Capital 合伙人 Jenny",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/694e181744647f77684bb4f1-1d320ec11cd3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/694e181744647f77684bb4f1-1d320ec11cd3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85956,
      "sha256": "bf5a89354b827d6bfd3691a62d2a3d46225984f298aee56aa29b90af4f098adf",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 569,
      "updated_at": "2026-06-09T13:39:30.742Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/693285733fec3166cf688645": {
    "source_id": "42zhangjing",
    "episode_id": "693285733fec3166cf688645",
    "title": "Dify 从被低估到成为明星项目，到底做对了什么｜对谈 Dify 创始人路宇",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/693285733fec3166cf688645-376af007bbb1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/693285733fec3166cf688645-376af007bbb1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 122853,
      "sha256": "4712bf2769cb69bbf44f103fbaad60b6f74667456a2e2c2a23f216acfb08ee63",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1431,
      "updated_at": "2026-06-09T13:39:30.742Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/692035926018cc2c98f08264": {
    "source_id": "42zhangjing",
    "episode_id": "692035926018cc2c98f08264",
    "title": "「你觉得 AI 有泡沫吗？」——有！｜对谈莫傑麟",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/692035926018cc2c98f08264-9ffb83e4bbc4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/692035926018cc2c98f08264-9ffb83e4bbc4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76604,
      "sha256": "df759fbb5f863790289d642e140c9e58128e56ebe950b6f7bea29f328b797a81",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 760,
      "updated_at": "2026-06-09T13:39:30.741Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/690d657baf4fc00da78badba": {
    "source_id": "42zhangjing",
    "episode_id": "690d657baf4fc00da78badba",
    "title": "2018 - 2020，抖音超越快手的关键三年｜对谈 Lessie AI 创始人于北川",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/690d657baf4fc00da78badba-e0e49b61f9ab/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/690d657baf4fc00da78badba-e0e49b61f9ab/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 150247,
      "sha256": "b822ca0a046f803b01d1d89505b2150d3ff89bd9e267f509c798640f59af8f9f",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1673,
      "updated_at": "2026-06-09T13:39:30.740Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/68fb18780156720321d444eb": {
    "source_id": "42zhangjing",
    "episode_id": "68fb18780156720321d444eb",
    "title": "OpusClip 增长秘诀：如果每个阶段只让我选一件事做 | 对谈 Opus 前增长产品负责人君陶",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/68fb18780156720321d444eb-2a7e919042b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/68fb18780156720321d444eb-2a7e919042b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 89698,
      "sha256": "c39ad0163fbd2888f5435923691e747b1a0d72e3ea77354c4e208f9a9eda12bc",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 996,
      "updated_at": "2026-06-09T13:39:30.739Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "42zhangjing/68e8a8fd525f51df3895a239": {
    "source_id": "42zhangjing",
    "episode_id": "68e8a8fd525f51df3895a239",
    "title": "一个原教旨主义产品经理眼中的世界 | 对谈理想 SVP 范皓宇",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/42zhangjing-a25ad5b68848/68e8a8fd525f51df3895a239-4f23713f73be/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/42zhangjing-a25ad5b68848/68e8a8fd525f51df3895a239-4f23713f73be/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 145226,
      "sha256": "1b560c93a9262240ac15248437d8c0049ad68f3ddf892166a3d3972c00d67ed8",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1606,
      "updated_at": "2026-06-09T13:39:30.738Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/82044eb3-e350-42c5-a799-2a2afc150e99": {
    "source_id": "acquired",
    "episode_id": "82044eb3-e350-42c5-a799-2a2afc150e99",
    "title": "Formula 1",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/82044eb3-e350-42c5-a799-2a2afc150e99-ee0ab544cf8c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/82044eb3-e350-42c5-a799-2a2afc150e99-ee0ab544cf8c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 255138,
      "sha256": "f0d7acbd3438f78fe71126e471306752fc3ff7c8e0f61edbfe00060a10d59ad0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1013,
      "updated_at": "2026-06-09T13:39:30.868Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/94dbf581-80c8-4b90-aff2-fa649cd90edd": {
    "source_id": "acquired",
    "episode_id": "94dbf581-80c8-4b90-aff2-fa649cd90edd",
    "title": "Rolex",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/94dbf581-80c8-4b90-aff2-fa649cd90edd-a072f61ec2a9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/94dbf581-80c8-4b90-aff2-fa649cd90edd-a072f61ec2a9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 292796,
      "sha256": "ac1b8b8a25b8022bd1ce76f8783bcd727ad1981d586f9c3a6d608ff664f86d84",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1195,
      "updated_at": "2026-06-09T13:39:30.898Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/14ef00c6-30ba-44cc-9869-33d3d92828a3": {
    "source_id": "acquired",
    "episode_id": "14ef00c6-30ba-44cc-9869-33d3d92828a3",
    "title": "Costco",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/14ef00c6-30ba-44cc-9869-33d3d92828a3-9dedfb295a9b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/14ef00c6-30ba-44cc-9869-33d3d92828a3-9dedfb295a9b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 171934,
      "sha256": "f9c25920ba24486c7bcf75a036355c629daef3dbd7db92a20384fb24d7ddb4ff",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 543,
      "updated_at": "2026-06-09T13:39:30.770Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/4537f61d-0ec1-4837-92e0-9270d140e6d2": {
    "source_id": "acquired",
    "episode_id": "4537f61d-0ec1-4837-92e0-9270d140e6d2",
    "title": "Coca-Cola",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4537f61d-0ec1-4837-92e0-9270d140e6d2-4d3960d26aa2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4537f61d-0ec1-4837-92e0-9270d140e6d2-4d3960d26aa2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 234908,
      "sha256": "4216d1e6e3eab13584675976b6419878a3b4390747eaf71d0db8caa880cf082b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 954,
      "updated_at": "2026-06-09T13:39:30.815Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/9602cea2-2491-4587-90f6-7bf7f7988dd7": {
    "source_id": "acquired",
    "episode_id": "9602cea2-2491-4587-90f6-7bf7f7988dd7",
    "title": "Trader Joe’s",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 201030,
      "sha256": "f5647464fc08ce42f8408192dec9a5573e4c8a5e8aa38aa20e138abc971b07e9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 908,
      "updated_at": "2026-06-09T13:39:30.899Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53280,
      "sha256": "ae2c568fbf00fed1afe7e9fa0b7a2d81a16cd02b986c20ac87a75ea84f404d3f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T23:59:08.404Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9602cea2-2491-4587-90f6-7bf7f7988dd7-24c83cabc198/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 25364,
      "sha256": "38ad62edfac62faf89fc96bde5f7c4e1a2389dddd28d67ff1ad4ef3ae35ca1e6",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T23:59:08.403Z"
    }
  },
  "acquired/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1": {
    "source_id": "acquired",
    "episode_id": "b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1",
    "title": "Google Part III: The AI Company",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100128,
      "sha256": "3b90382667be75f2205cb26ef27e1238ec023879ac4c5532813a9de117d4edb8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 318,
      "updated_at": "2026-06-09T13:39:30.914Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49624,
      "sha256": "b478f027eb76aa362e5304d2504c42c2824a18f6df3fe2502fef43351a15fab9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T15:44:38.474Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1-0e4ac82db8a8/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 73203,
      "sha256": "dabd40707614481886bdfabebf4814d3872fd1610cc8125e18d40a61dbd56688",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T15:44:38.473Z"
    }
  },
  "acquired/ab5cd9d1-109d-49fd-9dc7-e01238da38ea": {
    "source_id": "acquired",
    "episode_id": "ab5cd9d1-109d-49fd-9dc7-e01238da38ea",
    "title": "Google Part II: Alphabet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 236577,
      "sha256": "d722d837b192e2b972594256bf6bcdf2003fb7c3e65d68fb70a1683790fd53e5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 925,
      "updated_at": "2026-06-09T13:39:30.912Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75045,
      "sha256": "7585806b9578f4f5455747518b9e51a82213b94597d5697aa389f09d7dc80680",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T23:24:29.162Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ab5cd9d1-109d-49fd-9dc7-e01238da38ea-7eb6267e8870/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 31882,
      "sha256": "734a9d2d0eb79e6fbe8e38f05b736eda2f533fa16853548951f386caa3a4ba3b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T23:24:29.162Z"
    }
  },
  "acquired/2a660c44-6ee2-4c68-b107-9c4a1e1704f3": {
    "source_id": "acquired",
    "episode_id": "2a660c44-6ee2-4c68-b107-9c4a1e1704f3",
    "title": "The Jamie Dimon Interview",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63890,
      "sha256": "802b0bcab949978350908f45ca1ed1cebbf1539a9b8af4363612cfd38038fa47",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 161,
      "updated_at": "2026-06-09T13:39:30.788Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37640,
      "sha256": "abedc55a92d6adc4f8869a83a6a52a7a1e368b7a1ac74d74daeb2f8c40fa3396",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-06-02T12:46:01.719Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2a660c44-6ee2-4c68-b107-9c4a1e1704f3-3ff828194ee5/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 52467,
      "sha256": "7add24c8a79948c3b9d6568d0bcc902e0b8fb8b1766cdae97924b584db5e492a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-06-02T12:46:01.718Z"
    }
  },
  "acquired/3c13a02f-2836-484e-a29e-c6829e462e8f": {
    "source_id": "acquired",
    "episode_id": "3c13a02f-2836-484e-a29e-c6829e462e8f",
    "title": "Google Part I: Origins of Search",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 244237,
      "sha256": "08416726ec5c671c4e8b1b53cdb26e792af45cb282a9545d383b43ad8dde08cf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1061,
      "updated_at": "2026-06-09T13:39:30.803Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72014,
      "sha256": "6e2749979daf123450aa8d3a8b50d0a57b56ba3ff9c65bfe39863fe5629f51c1",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T00:58:50.577Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3c13a02f-2836-484e-a29e-c6829e462e8f-b55d4c6c2503/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 25300,
      "sha256": "99a2bd10c3dee62b2ff0b5b066d7dce30bfc132b1bde9d15e5e36d986ce1e08b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T00:58:50.577Z"
    }
  },
  "acquired/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca": {
    "source_id": "acquired",
    "episode_id": "d1855fd5-833e-4ec3-8e2f-c610be0aa6ca",
    "title": "The Steve Ballmer Interview",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 157651,
      "sha256": "79396fcbb70742d581e5437c8daceab3f3cf348a2e9e624328e189b4fe8da97e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 595,
      "updated_at": "2026-06-09T13:39:30.930Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39538,
      "sha256": "44e1b08517a966deec00fa4609541ae1141ca92daeb68ed51a00898af26315bd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T12:55:15.660Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d1855fd5-833e-4ec3-8e2f-c610be0aa6ca-d44b276ae842/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 19460,
      "sha256": "f7f9e4c87b648869118abddc06848fc90dcd38b536498c6f66494612ec25b279",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T12:55:15.659Z"
    }
  },
  "acquired/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3": {
    "source_id": "acquired",
    "episode_id": "a9bc0cf6-824d-4e9d-86cb-532734a3b2a3",
    "title": "Epic Systems (MyChart)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 236252,
      "sha256": "30eb47f85dc910714b80f2b0e123cf7f8aa27d1987e500e9cc8917500ef4c7e5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 777,
      "updated_at": "2026-06-09T13:39:30.910Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100331,
      "sha256": "75cc54f65c0d27c546789e7a5fb3e4a2bef8dd3b61a3cd3fb0dd329911f3a254",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T20:50:20.271Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9bc0cf6-824d-4e9d-86cb-532734a3b2a3-fc09d57d99e8/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 41134,
      "sha256": "db447c054b17626a40e5c7a304eeda3742070a410d54053f405619777ce6225a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T20:50:20.270Z"
    }
  },
  "acquired/d7c80edb-6b20-493c-9362-1f2d94f5df4b": {
    "source_id": "acquired",
    "episode_id": "d7c80edb-6b20-493c-9362-1f2d94f5df4b",
    "title": "Indian Premier League Cricket",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 261341,
      "sha256": "419b4206e8c1423bb46fbf424c49729bfbbdbeeb9dc4a703f42a7e7227e67952",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 922,
      "updated_at": "2026-06-09T13:39:30.935Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 80432,
      "sha256": "033f3433a7536d6cf538e9ec8f9f3a31bbff6465d2cf1131f0a4964e7b9d19c3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 3,
      "updated_at": "2026-05-31T19:37:58.636Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7c80edb-6b20-493c-9362-1f2d94f5df4b-1f1c4dd85c73/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 43805,
      "sha256": "b09d93ef7de4a28f707cc4fab8a568f2b270c8344e16b80995ce6b67286ce1d8",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 3,
      "updated_at": "2026-05-31T19:37:58.635Z"
    }
  },
  "acquired/a2fe3257-19eb-48f1-b08e-b815af25cc28": {
    "source_id": "acquired",
    "episode_id": "a2fe3257-19eb-48f1-b08e-b815af25cc28",
    "title": "TSMC Founder Morris Chang",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 114662,
      "sha256": "3a26559fb5bc8e655bd169d028a5b3fdde6cc050d2e9a4980402a6dbe0ddf079",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 377,
      "updated_at": "2026-06-09T13:39:30.908Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51011,
      "sha256": "da910463d6573b12af7732af000251b11cfcd6a48fe39e1951568e02adec8f49",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-06-01T04:02:36.569Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a2fe3257-19eb-48f1-b08e-b815af25cc28-cbf2d97497ad/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 82521,
      "sha256": "a06be87ef873c256a81600b4ddc56209aac0e631bdb76eae3339248de8bfbdfa",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-06-01T04:02:36.568Z"
    }
  },
  "acquired/9ab7f5fd-7774-4c48-8d0b-001b8c682c9d": {
    "source_id": "acquired",
    "episode_id": "9ab7f5fd-7774-4c48-8d0b-001b8c682c9d",
    "title": "Mars Inc. (the chocolate story)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9ab7f5fd-7774-4c48-8d0b-001b8c682c9d-c4f3ab601fda/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9ab7f5fd-7774-4c48-8d0b-001b8c682c9d-c4f3ab601fda/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 168282,
      "sha256": "21b7b1b097de5e3978825571283cd9217268852bd9fb3c1f17fa32a01a206d2a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 492,
      "updated_at": "2026-06-09T13:39:30.903Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/a5b37145-4d48-4f26-8861-36153ac02fdd": {
    "source_id": "acquired",
    "episode_id": "a5b37145-4d48-4f26-8861-36153ac02fdd",
    "title": "IKEA",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a5b37145-4d48-4f26-8861-36153ac02fdd-9db6b887aee2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a5b37145-4d48-4f26-8861-36153ac02fdd-9db6b887aee2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 171930,
      "sha256": "daa27efa0dcea75bd929d13be5de2f9ff459350102bb2ab3f58e830faf2f2093",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 543,
      "updated_at": "2026-06-09T13:39:30.909Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/99d7dbec-4709-40d8-acf1-645d2b9e65e6": {
    "source_id": "acquired",
    "episode_id": "99d7dbec-4709-40d8-acf1-645d2b9e65e6",
    "title": "Acquired LIVE from Chase Center (with Daniel Ek, Emily Chang, Jensen Huang and Mark Zuckerberg)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 135210,
      "sha256": "e1ede1ee36a8d47fcb0f5af69c7eccb36297c4111a7f7f8089e9f579f7bd4c4f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 475,
      "updated_at": "2026-06-09T13:39:30.902Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45521,
      "sha256": "d72f09509e60e3f5812eaadc89a04d38d5e6cabdef6456d3ebd933a5415df8c9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T01:59:35.731Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/99d7dbec-4709-40d8-acf1-645d2b9e65e6-961d81420a4c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 23737,
      "sha256": "afd0d5965a48c8e1e91d97a11161e89ed3b54fd35087ef209c16bf505643dcee",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T01:59:35.730Z"
    }
  },
  "acquired/672f2993-b496-4d4b-968f-49f663807244": {
    "source_id": "acquired",
    "episode_id": "672f2993-b496-4d4b-968f-49f663807244",
    "title": "The Mark Zuckerberg Interview",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77669,
      "sha256": "ea50989f662666b0f1df88aaff8cf816440a1f482a2185172ed25e3a48ba18c5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 206,
      "updated_at": "2026-06-09T13:39:30.842Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37526,
      "sha256": "1adfd323baf42a05a1efa12325551e71b8e9a3aff5ac7a21c653573516b7d635",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 11,
      "updated_at": "2026-06-01T15:01:54.068Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/672f2993-b496-4d4b-968f-49f663807244-5fc4df657db0/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 79261,
      "sha256": "e7db2467eca33843e0f25de75b54305ba37c01c3fef393647ccebcde5a3ed1fa",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 11,
      "updated_at": "2026-06-01T15:01:54.067Z"
    }
  },
  "acquired/a9f28baa-853a-47bb-a600-059d0067691e": {
    "source_id": "acquired",
    "episode_id": "a9f28baa-853a-47bb-a600-059d0067691e",
    "title": "Microsoft Volume II",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 274131,
      "sha256": "6b1812ae35185cad7a71f4abc0f17532287761aa9baa1ca29e853306e1850056",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 878,
      "updated_at": "2026-06-09T13:39:30.911Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 114064,
      "sha256": "b6d2dda18f715a6a678cf675f6fb7b405439f0be24916b2fb74f53962086f671",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T17:21:08.504Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a9f28baa-853a-47bb-a600-059d0067691e-62f017c1a798/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 45140,
      "sha256": "439128476b98fa3190690fd1d67ba2505f268149402124523a3f6923b10ee640",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T17:21:08.503Z"
    }
  },
  "acquired/5bb96f28-43cb-4e0d-909a-f1ff11a5d881": {
    "source_id": "acquired",
    "episode_id": "5bb96f28-43cb-4e0d-909a-f1ff11a5d881",
    "title": "Starbucks (with Howard Schultz)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 170512,
      "sha256": "b51665fb7f4993ce4601839caa6a9088d5d60c835e8c2ca7e43e550cb52c2409",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 710,
      "updated_at": "2026-06-09T13:39:30.838Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73544,
      "sha256": "9e344d01959ce1f3fe0f1a9a2982cf884e2f98d906d10e5f6bf9b905e691d569",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-27T19:02:22.316Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5bb96f28-43cb-4e0d-909a-f1ff11a5d881-ebf6c7028d58/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 33542,
      "sha256": "675085ce3819ad62604cf132d4d409cd1e36cfcb12fb009b886b2532ffa1af0a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-27T19:02:22.316Z"
    }
  },
  "acquired/c4a8c088-76af-4a04-b6ab-db7bad44cf04": {
    "source_id": "acquired",
    "episode_id": "c4a8c088-76af-4a04-b6ab-db7bad44cf04",
    "title": "Microsoft Volume I",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 252728,
      "sha256": "21db54d17625326f0d3bd52580b5db2991391ada9914923eece3ef951c100abe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 805,
      "updated_at": "2026-06-09T13:39:30.923Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82646,
      "sha256": "ea106891969ff636a8a30562a69e0ab4448ce492935d85885e8acb86c53a34e5",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T21:35:53.475Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/c4a8c088-76af-4a04-b6ab-db7bad44cf04-f01c745748cd/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 40439,
      "sha256": "08591d6f24dfc45be886d9d1fb49b86ba4bf409eb857bc7c0b0fcbd5560c84b4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T21:35:53.474Z"
    }
  },
  "acquired/88f34088-9b5d-43fe-ac5f-d5a233647de5": {
    "source_id": "acquired",
    "episode_id": "88f34088-9b5d-43fe-ac5f-d5a233647de5",
    "title": "Renaissance Technologies",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 183639,
      "sha256": "27c7de86a4674c62a72795461737b3b8de715dada5aa4e68d81a09e3922d7beb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 585,
      "updated_at": "2026-06-09T13:39:30.879Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42987,
      "sha256": "92a1f2600d303fc20d05e2c75491b8ccf958327b6164efb8a390987861e16485",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:15:24.777Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/88f34088-9b5d-43fe-ac5f-d5a233647de5-7539d88241b7/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 20530,
      "sha256": "6250ac150880901fd59a784f8ab5bc6f8c3008332da2c73a01ec5bc3c294a8be",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:15:24.777Z"
    }
  },
  "acquired/7fa2f476-fe1f-4c73-916a-6db4c935a47b": {
    "source_id": "acquired",
    "episode_id": "7fa2f476-fe1f-4c73-916a-6db4c935a47b",
    "title": "Hermès",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7fa2f476-fe1f-4c73-916a-6db4c935a47b-d114aa59432c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7fa2f476-fe1f-4c73-916a-6db4c935a47b-d114aa59432c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 237843,
      "sha256": "987b6a670794a8d3399b82db8dbaa0158f9b7baf03858de3cc2494e396eabfdf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 862,
      "updated_at": "2026-06-09T13:39:30.863Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/5a2c6c1e-c7d4-4434-817c-b1669bb5792a": {
    "source_id": "acquired",
    "episode_id": "5a2c6c1e-c7d4-4434-817c-b1669bb5792a",
    "title": "Novo Nordisk (Ozempic)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 210145,
      "sha256": "f66b9571048fe92777ec977b9ba8099fc8036249507344f9fc66999dc5b79418",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 580,
      "updated_at": "2026-06-09T13:39:30.836Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83266,
      "sha256": "2299cc64e5a679b79df4dd637a9147a4c8ed6ac860b025e797b8556a9c03dcb6",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T16:45:59.143Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5a2c6c1e-c7d4-4434-817c-b1669bb5792a-ace2c062ff5a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 38389,
      "sha256": "e44980bcbd6d1e909de98ad37fba87250fefeafac54b7407b530db0709f6c6dd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T16:45:59.142Z"
    }
  },
  "acquired/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6": {
    "source_id": "acquired",
    "episode_id": "7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6",
    "title": "Holiday Special 2023",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 133603,
      "sha256": "cc3b628ec8cd7c3a2e1d026491cb51a620380b74f3351dc605c27d03bb0ad771",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 441,
      "updated_at": "2026-06-09T13:39:30.861Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 59152,
      "sha256": "b80a2d56c2ed3e8e84aa27396a5e864a0723da8e222db18cca7188db9243f63f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:13:39.136Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6-80f6e5e12501/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 25193,
      "sha256": "07b2a012d528902d04b6606e0eb07bf1acabdaa6eb2ed5dc88c24da215b42de2",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:13:39.136Z"
    }
  },
  "acquired/dcbc5a22-0354-420a-879d-634c236ad5df": {
    "source_id": "acquired",
    "episode_id": "dcbc5a22-0354-420a-879d-634c236ad5df",
    "title": "Visa",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/dcbc5a22-0354-420a-879d-634c236ad5df-a5337b903704/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/dcbc5a22-0354-420a-879d-634c236ad5df-a5337b903704/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 213864,
      "sha256": "506300661ac05f09f3fb64552cf111a2391696736185816a683154c8d5fdb57c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 625,
      "updated_at": "2026-06-09T13:39:30.939Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1be0cf12-72b7-4bdb-827f-0fe38425ffa3": {
    "source_id": "acquired",
    "episode_id": "1be0cf12-72b7-4bdb-827f-0fe38425ffa3",
    "title": "NVIDIA CEO Jensen Huang",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83058,
      "sha256": "331bdbd84caab4f05b41269ab5e4ffc9c8e594350f01af50818057ffca35ae93",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 241,
      "updated_at": "2026-06-09T13:39:30.774Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 29273,
      "sha256": "992bdc760c7f36e2a3a978bc7ecf4561f22557e05ec5e2990b59b3f7876d6000",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:15:26.233Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1be0cf12-72b7-4bdb-827f-0fe38425ffa3-394b8a3a90fc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 13088,
      "sha256": "a4b379596266ffbfac8d126788c946aee8022071d437bd83569ffe4969d9095b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T17:15:26.232Z"
    }
  },
  "acquired/09424666-1111-43fc-8355-1d162efc3631": {
    "source_id": "acquired",
    "episode_id": "09424666-1111-43fc-8355-1d162efc3631",
    "title": "Nvidia Part III: The Dawn of the AI Era (2022-2023)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 165982,
      "sha256": "06fd995ab719f3cffd98f71ef43f67fc17b941320a8633409744b16dab54f590",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 469,
      "updated_at": "2026-06-09T13:39:30.761Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93839,
      "sha256": "105441ac2229185c041a0b158a8b701d65d8a85515dcc1eddc9de034ecded379",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-06-01T09:10:44.882Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/09424666-1111-43fc-8355-1d162efc3631-035957eaa533/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 55495,
      "sha256": "fa182e1c03270964f111027abd4c518aa2950e1a7558fc1495e7e4f2b872f2c3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-06-01T09:10:44.881Z"
    }
  },
  "acquired/1b6f99a2-dcf5-4adb-9b59-269902b1bcb3": {
    "source_id": "acquired",
    "episode_id": "1b6f99a2-dcf5-4adb-9b59-269902b1bcb3",
    "title": "Nike",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1b6f99a2-dcf5-4adb-9b59-269902b1bcb3-1bc22b8b0e50/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1b6f99a2-dcf5-4adb-9b59-269902b1bcb3-1bc22b8b0e50/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 224560,
      "sha256": "f7e2e0ede288d31679c98aff6413c8312522a45f8e5657c3dac21da4af4efade",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 649,
      "updated_at": "2026-06-09T13:39:30.773Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1e63c28d-d179-47a6-8f4d-254f51e477bf": {
    "source_id": "acquired",
    "episode_id": "1e63c28d-d179-47a6-8f4d-254f51e477bf",
    "title": "Porsche (with Doug DeMuro)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 197320,
      "sha256": "f32e84c8a62b9bb0b0a5a964a8d9c30900af84ff9ad2a94526c1b30f1ae7f7f8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 766,
      "updated_at": "2026-06-09T13:39:30.777Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52494,
      "sha256": "a6b335d64cfe80a8395180e9e0d1200a3bd51128e4889b9f5971c15cf4f89898",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T08:51:18.409Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1e63c28d-d179-47a6-8f4d-254f51e477bf-a33c8551b25f/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 30897,
      "sha256": "2e3c72eaf1a745b5426cf021a30ac7025a2b298dab94545cdb82cb7a0e69b22c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-05-28T08:51:18.408Z"
    }
  },
  "acquired/81cfd12f-dff9-46b4-8512-16f6807c8f5e": {
    "source_id": "acquired",
    "episode_id": "81cfd12f-dff9-46b4-8512-16f6807c8f5e",
    "title": "Uber CEO Dara Khosrowshahi",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84113,
      "sha256": "41360efad2a54b1247b1e740a44d3f6a853605170d3d31d287a7436ec691c114",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 299,
      "updated_at": "2026-06-09T13:39:30.866Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 90102,
      "sha256": "c24347243a1417e5a4b94d536090534b61016b9a5a5cc2846ae7523c125cf3e2",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-28T00:21:01.847Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/81cfd12f-dff9-46b4-8512-16f6807c8f5e-610f5ba7a04b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 335375,
      "sha256": "8396e860737cd14b4c978d55810986d5802a362590154d310c6ee11ce9568762",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-28T00:21:01.847Z"
    }
  },
  "acquired/8b8a5e98-b290-4edd-8e3c-e105cccebe9b": {
    "source_id": "acquired",
    "episode_id": "8b8a5e98-b290-4edd-8e3c-e105cccebe9b",
    "title": "Lockheed Martin",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 204989,
      "sha256": "209e6a34c13e03dcde43b6039c6d3095d3520290d532d48cf058e42ed6ab1823",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 618,
      "updated_at": "2026-06-09T13:39:30.886Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65220,
      "sha256": "34a68ec544de8429899e427bdbe70f3c9432440165cb92e6dce7168e28b15047",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T11:54:34.824Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8b8a5e98-b290-4edd-8e3c-e105cccebe9b-0870060a6d1b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 27861,
      "sha256": "c1c7dfbf3ccb4c8c4ccad32c52dd6576308f4c228c4b1873d7eba38d376b782c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T11:54:34.823Z"
    }
  },
  "acquired/76a5df5d-600f-493b-9b8e-791cb6ee53b3": {
    "source_id": "acquired",
    "episode_id": "76a5df5d-600f-493b-9b8e-791cb6ee53b3",
    "title": "Spotify CEO Daniel Ek",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83116,
      "sha256": "ac4fd7c0b6517bc4653aba0b756f6282ea7254a1d177d0de4c40b9f187f67b90",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 218,
      "updated_at": "2026-06-09T13:39:30.854Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39583,
      "sha256": "97e57f3805707b9f5626cd6f681186fceac2ee466cc8082578c86fdd29642f46",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 12,
      "updated_at": "2026-06-02T06:40:08.310Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/76a5df5d-600f-493b-9b8e-791cb6ee53b3-56d72b911c9d/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 104096,
      "sha256": "832c45c2ca0d6f4cffccbb5d1a12af88da6cbc2aec4f278945d58e25b92bf66c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 12,
      "updated_at": "2026-06-02T06:40:08.310Z"
    }
  },
  "acquired/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce": {
    "source_id": "acquired",
    "episode_id": "0b8a26c2-fa99-44ba-8b5b-456dad9a00ce",
    "title": "Benchmark’s Mitch Lasky and Blake Robbins on The Art of Business in Gaming",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 128401,
      "sha256": "3b7a44352aae5b51bfbe3c85f12c4cab4b7ddad62094ce83c4e254925ee2fe1b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 405,
      "updated_at": "2026-06-09T13:39:30.764Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46705,
      "sha256": "84d212deaf45d334dfbb4c35b027c5cc6a3ba9ad7adf2a8d2d7a90fc85d152e7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T22:24:30.572Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0b8a26c2-fa99-44ba-8b5b-456dad9a00ce-97dc9426930b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 20615,
      "sha256": "34157fedd386707540f61602c746359fc2e686e14bc19a52ba2da5da067a597d",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T22:24:30.571Z"
    }
  },
  "acquired/65be8a2d-5913-4c2b-9757-2c96be470dd3": {
    "source_id": "acquired",
    "episode_id": "65be8a2d-5913-4c2b-9757-2c96be470dd3",
    "title": "Short: The Death of Sega",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57443,
      "sha256": "9a37da4f266a1cb5f475d458fe8f85b31bac407c172a4f4bc84150cf641c8b32",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 180,
      "updated_at": "2026-06-09T13:39:30.841Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47505,
      "sha256": "33b1bb014fcd2e4221b444641c2ca6791ef6cae31c05f78eb394138999ef4c91",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-28T07:49:27.987Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/65be8a2d-5913-4c2b-9757-2c96be470dd3-cb5b2cb85d74/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 292049,
      "sha256": "09ccb32717afee79110ec851dd6f0736559b712e6a2a068f3d16a7424e9db6f9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-28T07:49:27.986Z"
    }
  },
  "acquired/02a5c009-e940-4a26-9044-c313caf9e279": {
    "source_id": "acquired",
    "episode_id": "02a5c009-e940-4a26-9044-c313caf9e279",
    "title": "Nintendo: The Console Wars",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 120969,
      "sha256": "fc89b965c8677a8e4f4a9627028d3dda824f3f8d2f346176e28844ee1ba78101",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 441,
      "updated_at": "2026-06-09T13:39:30.752Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34211,
      "sha256": "e44c13b3e3f48267c2f997c49924f2b735e4320d008dddd3d858f6ecae0c8b0e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T10:10:51.400Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/02a5c009-e940-4a26-9044-c313caf9e279-f4e8992877e2/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 15756,
      "sha256": "53f138b84b72e64de201bf30e7cd0a27e80f91deb159338f92058f133181c7f3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T10:10:51.400Z"
    }
  },
  "acquired/87edab21-9406-493c-b10b-16d23dccde62": {
    "source_id": "acquired",
    "episode_id": "87edab21-9406-493c-b10b-16d23dccde62",
    "title": "Interview: Hamilton Helmer & Chenyi Shi on How to Build an AWS-Like Second Business",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 80475,
      "sha256": "d4290317139c2b322ab3e5e0288f75a4fec271a7c2befa1cd7ad04d324042c0c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 216,
      "updated_at": "2026-06-09T13:39:30.877Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82796,
      "sha256": "1f66c7d4c319db786860e8a5f162ee123527acb079607844ec0d3e30bffdbc6c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T19:04:25.156Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/87edab21-9406-493c-b10b-16d23dccde62-6346b54782f3/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 243433,
      "sha256": "12e9c03b851c630c709ddc47e8109461b12a842900e8c7314330b5bda9fe48fd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T19:04:25.156Z"
    }
  },
  "acquired/79762840-c356-4dbd-8412-f4d1fec926e8": {
    "source_id": "acquired",
    "episode_id": "79762840-c356-4dbd-8412-f4d1fec926e8",
    "title": "Sessions: David Senra (Founders Podcast)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 205170,
      "sha256": "508a4e02287ced960a20c8df1fac93a4d966c811d44a1eac8b5c29b59100790c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 660,
      "updated_at": "2026-06-09T13:39:30.858Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71108,
      "sha256": "3310443cc462898c7467d8fd7d916e3549c3e5424ab8716ed28c0c991330784e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T08:39:58.899Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/79762840-c356-4dbd-8412-f4d1fec926e8-9a42c00842c0/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 26854,
      "sha256": "05b02b721a4f8ccf66dc80ded07ea9d3b758c6b14c0d9a1e95e95e830ced67e4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T08:39:58.897Z"
    }
  },
  "acquired/3834bd3b-2948-48b7-b23f-aa19bf62026a": {
    "source_id": "acquired",
    "episode_id": "3834bd3b-2948-48b7-b23f-aa19bf62026a",
    "title": "Nintendo's Origins",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 95821,
      "sha256": "67152154fc8cd924c55d8576bbc49c8ab0ae26c9cd1530667ac4d515b5bed346",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 650,
      "updated_at": "2026-06-09T13:39:30.795Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 17331,
      "sha256": "b1e9024843330b32fa0d9f58a5a9c0e9ad4ea7c3d2f65c9bb6394a7fd2ad31b3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T03:37:04.110Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3834bd3b-2948-48b7-b23f-aa19bf62026a-fc88fc5d45a6/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 10717,
      "sha256": "d687ae3f54bfd80e616e4ef396f2b58cb374cd806a873256819ad5cc5a493ebb",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T03:37:04.109Z"
    }
  },
  "acquired/038682f8-cc60-4cbb-a5bb-9b18aa312d1b": {
    "source_id": "acquired",
    "episode_id": "038682f8-cc60-4cbb-a5bb-9b18aa312d1b",
    "title": "LVMH",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/038682f8-cc60-4cbb-a5bb-9b18aa312d1b-f41f85e118e2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/038682f8-cc60-4cbb-a5bb-9b18aa312d1b-f41f85e118e2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 197040,
      "sha256": "01e2ee1039fa15854c3b0316e86fa4af11b7ed6e1026a4516fe932a5182e0f89",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 593,
      "updated_at": "2026-06-09T13:39:30.753Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd": {
    "source_id": "acquired",
    "episode_id": "da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd",
    "title": "Holiday Special 2022",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 140887,
      "sha256": "f7051422b97806d83f502af9ef28dade2c287a43c20ad0844894e374aabfbaa5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 683,
      "updated_at": "2026-06-09T13:39:30.937Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 28700,
      "sha256": "34b489b5aa8d989b0f0dca9c0a1e1e7bdc908850c95bfe2dffffd8cbe41fd54b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T19:28:52.628Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd-b7af5d74bfab/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 15476,
      "sha256": "1581d60d6861686fa8365a48761854336f1ca17f6770c0c49d755ad55fe419db",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T19:28:52.628Z"
    }
  },
  "acquired/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958": {
    "source_id": "acquired",
    "episode_id": "1eaf9d2e-0bf7-4238-8c91-cf7a9506b958",
    "title": "Stratechery (with Ben Thompson)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 125634,
      "sha256": "237e72b07c737b8f396410d6740328de60550f79d1e583241bf12f500d1a73c4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 276,
      "updated_at": "2026-06-09T13:39:30.779Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100655,
      "sha256": "4426e52e10e3373d5a6518ba9fb87258edeea5ce48a4349350dca904ba1161c4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T20:26:26.979Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1eaf9d2e-0bf7-4238-8c91-cf7a9506b958-c37caca71a2a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 227836,
      "sha256": "11a1e13006faa610ba23f130449cfd53210ed2cb57ed96967b6e8e7665219e5f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T20:26:26.979Z"
    }
  },
  "acquired/699a9625-cc14-42e6-a01b-70ef4862e6b3": {
    "source_id": "acquired",
    "episode_id": "699a9625-cc14-42e6-a01b-70ef4862e6b3",
    "title": "Enron",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/699a9625-cc14-42e6-a01b-70ef4862e6b3-ebc3bde680f4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/699a9625-cc14-42e6-a01b-70ef4862e6b3-ebc3bde680f4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 207889,
      "sha256": "39edca475314d3ad24b6626b0c18b0389ad54741e9d43a8c6d29c67067d058ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 706,
      "updated_at": "2026-06-09T13:39:30.848Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/652f4916-c682-4b7d-b0e5-6dcd339ff5f7": {
    "source_id": "acquired",
    "episode_id": "652f4916-c682-4b7d-b0e5-6dcd339ff5f7",
    "title": "Qualcomm",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/652f4916-c682-4b7d-b0e5-6dcd339ff5f7-fb3746e5bc72/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/652f4916-c682-4b7d-b0e5-6dcd339ff5f7-fb3746e5bc72/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 136745,
      "sha256": "15929bf573ba5464f113cce7b44225d682aea896c71192835ebe56e5b72da89f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 423,
      "updated_at": "2026-06-09T13:39:30.840Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554": {
    "source_id": "acquired",
    "episode_id": "ef596ea4-bbbd-4b18-9a4a-e9318f7e0554",
    "title": "Benchmark Part II: The Dinner",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 106710,
      "sha256": "30f9aa8189be3fde120f64a13447ca4df73261a813f1804f5fe8e50bb224e665",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 399,
      "updated_at": "2026-06-09T13:39:30.948Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33952,
      "sha256": "a445bc0674e4b01c27c682cf358f2a34a137ff507d7567005ae0eeee6569305a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 3,
      "updated_at": "2026-05-28T02:41:01.127Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ef596ea4-bbbd-4b18-9a4a-e9318f7e0554-237c7b23474d/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 27590,
      "sha256": "617188a9a4a4bb8203ab9bb0a2abfa6067062befd5d3bfd934ad3d64dd1869f4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 3,
      "updated_at": "2026-05-28T02:41:01.127Z"
    }
  },
  "acquired/d7bd9263-aea3-4726-94c9-61f5d251f478": {
    "source_id": "acquired",
    "episode_id": "d7bd9263-aea3-4726-94c9-61f5d251f478",
    "title": "ACQ Sessions: Jason Calacanis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 141721,
      "sha256": "82eb4b2402d9b7bf8edc4bc9ed761a2af4e6040dc10aa7d74b423b4cf734b692",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 791,
      "updated_at": "2026-06-09T13:39:30.934Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62809,
      "sha256": "6fa6f56de1abc29005667a5992162d342e31f4c13c0c206f9abfb9c2d68fc8a0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T16:42:09.155Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d7bd9263-aea3-4726-94c9-61f5d251f478-a500d21aceae/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 21680,
      "sha256": "860a737dee472084bd1947588a85950a1e7b35cedde1831d9ee1c1e907a5723b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T16:42:09.155Z"
    }
  },
  "acquired/859f2520-f375-42ab-8078-ee5000359735": {
    "source_id": "acquired",
    "episode_id": "859f2520-f375-42ab-8078-ee5000359735",
    "title": "Benchmark Part I",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 212269,
      "sha256": "970d73c5c0aecc78c643b20a6f145196a7db8929a855a23845f3491bd966071b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 704,
      "updated_at": "2026-06-09T13:39:30.874Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 151571,
      "sha256": "7e732b8336ca0383c5c4cfc167e82b0363698c78ae4e205c61c62e6a696b2c2a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T00:30:32.086Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/859f2520-f375-42ab-8078-ee5000359735-98f7bda5ad2f/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 24474,
      "sha256": "b9a2a1ac354db953d173382b6155a27284927341253db34aca3a99c275f4d97b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T00:30:32.085Z"
    }
  },
  "acquired/9b64ddfd-231e-4958-bbb8-68e9a4883667": {
    "source_id": "acquired",
    "episode_id": "9b64ddfd-231e-4958-bbb8-68e9a4883667",
    "title": "Amazon Web Services",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 152755,
      "sha256": "79f132e48f71ac12e48091d299b47aa2f9f360469cd3468c7177ff41f6d91843",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 455,
      "updated_at": "2026-06-09T13:39:30.905Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 166885,
      "sha256": "6c1203aff131591ec2a29a982effd5c80a0d5abedda5918a5563de06b2568c89",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T22:34:04.843Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9b64ddfd-231e-4958-bbb8-68e9a4883667-53264592f56b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 191517,
      "sha256": "4fb39fbefd13bfc31441649711dae13302e8c97662face535654d4264b9f2355",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T22:34:04.842Z"
    }
  },
  "acquired/83ed7817-900d-4f18-8fbc-fe4e9496f416": {
    "source_id": "acquired",
    "episode_id": "83ed7817-900d-4f18-8fbc-fe4e9496f416",
    "title": "Howard Marks & Andrew Marks: Something of Value",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82636,
      "sha256": "9840a8655a9444ccd02dd64021ce6c343b2fc8df4282f6b2a783ef0167e8d06a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 200,
      "updated_at": "2026-06-09T13:39:30.870Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38693,
      "sha256": "ea8481c943ea1150fdbe008bc598c0adc4a218e7eb3e7c72daa655f08a4d35d3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T10:53:06.593Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/83ed7817-900d-4f18-8fbc-fe4e9496f416-1cee35182129/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 18033,
      "sha256": "c685a904d9f2952bb5ee42b42a806e8448d86da12fce404ea42240aaf0683d68",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T10:53:06.593Z"
    }
  },
  "acquired/4a0f8cdb-dc05-498e-8e28-f7b1647168ea": {
    "source_id": "acquired",
    "episode_id": "4a0f8cdb-dc05-498e-8e28-f7b1647168ea",
    "title": "Amazon.com",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4a0f8cdb-dc05-498e-8e28-f7b1647168ea-7f5a442559b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4a0f8cdb-dc05-498e-8e28-f7b1647168ea-7f5a442559b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 169487,
      "sha256": "e0444e1418972eddad8a5237fff5c3048f28e42e721d6eb8f92377b764487ee8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 563,
      "updated_at": "2026-06-09T13:39:30.821Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/cc2d2884-3a78-4af1-88d3-ff63461689ab": {
    "source_id": "acquired",
    "episode_id": "cc2d2884-3a78-4af1-88d3-ff63461689ab",
    "title": "From NFL to Startup COO to Congressman Regulating Crypto (with Rep. Anthony Gonzalez)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/cc2d2884-3a78-4af1-88d3-ff63461689ab-5d0ecbe834e7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/cc2d2884-3a78-4af1-88d3-ff63461689ab-5d0ecbe834e7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 117437,
      "sha256": "0baa509ab13e5b4df9fa7ba86bd467e67de6a6d0259246d27e84195df1e82fc4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 271,
      "updated_at": "2026-06-09T13:39:30.926Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/890bcbd1-8a1a-4cca-bac2-f669fa9b4693": {
    "source_id": "acquired",
    "episode_id": "890bcbd1-8a1a-4cca-bac2-f669fa9b4693",
    "title": "Walmart",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/890bcbd1-8a1a-4cca-bac2-f669fa9b4693-b900c7741b2b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/890bcbd1-8a1a-4cca-bac2-f669fa9b4693-b900c7741b2b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 169481,
      "sha256": "04464bf5a6d87a597d575b9a95dfc3126e38033324ada7591881e0eb8718ef08",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 563,
      "updated_at": "2026-06-09T13:39:30.880Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b238a9be-c8c9-405c-bc62-510442b9bfea": {
    "source_id": "acquired",
    "episode_id": "b238a9be-c8c9-405c-bc62-510442b9bfea",
    "title": "The Playbook: Lessons from 200+ Company Stories",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b238a9be-c8c9-405c-bc62-510442b9bfea-77fdb888b1f0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b238a9be-c8c9-405c-bc62-510442b9bfea-77fdb888b1f0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77615,
      "sha256": "5f8ceee2e966989ea9bf2d5d9814497328d79c1dedf30c36801f3456f5d1f0f0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.916Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/7850c275-85b3-4b6c-a016-c1974eaaf8a8": {
    "source_id": "acquired",
    "episode_id": "7850c275-85b3-4b6c-a016-c1974eaaf8a8",
    "title": "American Dynamism (with Katherine Boyle)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7850c275-85b3-4b6c-a016-c1974eaaf8a8-8d8077ef886c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7850c275-85b3-4b6c-a016-c1974eaaf8a8-8d8077ef886c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77608,
      "sha256": "2ac44a7d47aa7f73ddb8fbd313acfac2be21faf0dee095550349e93d4ce9bbe8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.856Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/6bc30ee3-d6eb-427d-aca5-cd6e94200f5c": {
    "source_id": "acquired",
    "episode_id": "6bc30ee3-d6eb-427d-aca5-cd6e94200f5c",
    "title": "Capital-Efficient Growth (with Zoom CEO Eric Yuan & Veeva CEO Peter Gassner)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/6bc30ee3-d6eb-427d-aca5-cd6e94200f5c-9600a6e97694/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/6bc30ee3-d6eb-427d-aca5-cd6e94200f5c-9600a6e97694/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77644,
      "sha256": "7cdcfe2fa0ae9271892648dfe57c194a580627546cc99e37c3f4f32c36854a6c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.849Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/d296e42b-2a10-4be5-bfa3-d9cf77f2eb77": {
    "source_id": "acquired",
    "episode_id": "d296e42b-2a10-4be5-bfa3-d9cf77f2eb77",
    "title": "Arena Show Part II: Brooks Running (with CEO Jim Weber)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d296e42b-2a10-4be5-bfa3-d9cf77f2eb77-ffdd51815bc7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d296e42b-2a10-4be5-bfa3-d9cf77f2eb77-ffdd51815bc7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77623,
      "sha256": "f8c7eaeeabe39d61a20f56f993bcf2e148e9640fd7827863f8ca6da1aa8ee791",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.931Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/2ce6e362-5907-4498-873e-21972ae41077": {
    "source_id": "acquired",
    "episode_id": "2ce6e362-5907-4498-873e-21972ae41077",
    "title": "Arena Show Part I: Idea Dinner + YC Continuity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2ce6e362-5907-4498-873e-21972ae41077-9a1e00f1ae86/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2ce6e362-5907-4498-873e-21972ae41077-9a1e00f1ae86/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77614,
      "sha256": "abc16bce976948afc1e36f3c7c807850a92608bf5a71014dd66770c9e5b0b9ae",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.790Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f2b6e655-8342-4b10-a1e4-30c7f3146639": {
    "source_id": "acquired",
    "episode_id": "f2b6e655-8342-4b10-a1e4-30c7f3146639",
    "title": "Nvidia Part II: The Machine Learning Company (2006-2022)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f2b6e655-8342-4b10-a1e4-30c7f3146639-cffc567ac6c9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f2b6e655-8342-4b10-a1e4-30c7f3146639-cffc567ac6c9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77624,
      "sha256": "caf0b29a8676580dc538e509704b9066ee9a67fe97a135cdef560061030a7657",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.950Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/89d27263-b204-45d6-98a0-d5e152cc64fd": {
    "source_id": "acquired",
    "episode_id": "89d27263-b204-45d6-98a0-d5e152cc64fd",
    "title": "Platforms and Power (with Hamilton Helmer and Chenyi Shi)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/89d27263-b204-45d6-98a0-d5e152cc64fd-6add7f5913e0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/89d27263-b204-45d6-98a0-d5e152cc64fd-6add7f5913e0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77625,
      "sha256": "b2475eb7b40cfc6c8c127957445d43625d30ea42639c4528b3e60a69e64a37d2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.883Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/363db577-da31-496d-ab2f-d68c085c226e": {
    "source_id": "acquired",
    "episode_id": "363db577-da31-496d-ab2f-d68c085c226e",
    "title": "Nvidia Part I: The GPU Company (1993-2006)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/363db577-da31-496d-ab2f-d68c085c226e-6a845afd3bbd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/363db577-da31-496d-ab2f-d68c085c226e-6a845afd3bbd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77610,
      "sha256": "e8af1982844b088ea8d2a9e62a6d93061fba2d503436c493a380f5541b7fbfa3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.793Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/897829ee-7af2-4359-a1cc-3cf240a950ff": {
    "source_id": "acquired",
    "episode_id": "897829ee-7af2-4359-a1cc-3cf240a950ff",
    "title": "Altimeter (with Brad Gerstner)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/897829ee-7af2-4359-a1cc-3cf240a950ff-da14bc6263ef/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/897829ee-7af2-4359-a1cc-3cf240a950ff-da14bc6263ef/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77598,
      "sha256": "cf1f120b34eb0fe2bae1edb8975d3f890dc4d07aac5942a84e57c908118e0a21",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.880Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1686cb41-3387-4a14-b6f1-7792dfcd0adb": {
    "source_id": "acquired",
    "episode_id": "1686cb41-3387-4a14-b6f1-7792dfcd0adb",
    "title": "SONY",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1686cb41-3387-4a14-b6f1-7792dfcd0adb-3a56c5830082/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1686cb41-3387-4a14-b6f1-7792dfcd0adb-3a56c5830082/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77572,
      "sha256": "3c9939aa6912670e8a51d8faba1ee0d33b81e3b3ff6e1294acfb3ed2d54259e9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.771Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/6841583f-2b0f-4645-a5df-2012ac6765ce": {
    "source_id": "acquired",
    "episode_id": "6841583f-2b0f-4645-a5df-2012ac6765ce",
    "title": "Super Pumped (with Brian Koppelman and Joseph Gordon-Levitt)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/6841583f-2b0f-4645-a5df-2012ac6765ce-99f514074ad2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/6841583f-2b0f-4645-a5df-2012ac6765ce-99f514074ad2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77628,
      "sha256": "4aba5accf185ae72e70292efb9c1f97102df30df6bee61356214041c45998c00",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.844Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3cdaa7f4-b5b8-4d0c-8596-4e42aec3117d": {
    "source_id": "acquired",
    "episode_id": "3cdaa7f4-b5b8-4d0c-8596-4e42aec3117d",
    "title": "The Browser (with Brendan Eich, Chief Architect of Netscape + Mozilla and CEO of Brave)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3cdaa7f4-b5b8-4d0c-8596-4e42aec3117d-c5d53dae9e3e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3cdaa7f4-b5b8-4d0c-8596-4e42aec3117d-c5d53dae9e3e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77655,
      "sha256": "35f7bf6fab74ad618fbb24d58ec4db06d8a24fc9bb272c141ac36de63e21818c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.805Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3607e4d4-851a-4f3a-90af-752b2778f0b9": {
    "source_id": "acquired",
    "episode_id": "3607e4d4-851a-4f3a-90af-752b2778f0b9",
    "title": "Peloton",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3607e4d4-851a-4f3a-90af-752b2778f0b9-d567aa4169c0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3607e4d4-851a-4f3a-90af-752b2778f0b9-d567aa4169c0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77575,
      "sha256": "54f393fd8776ce9d589353868d9062fd9dc9e802c50a6d6ee1f328251fa32073",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.792Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8e6dd85a-bbc5-439d-ae93-c6e9a22c78c4": {
    "source_id": "acquired",
    "episode_id": "8e6dd85a-bbc5-439d-ae93-c6e9a22c78c4",
    "title": "Taylor Swift (Acquired’s Version)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8e6dd85a-bbc5-439d-ae93-c6e9a22c78c4-85e0fd8fe1fd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8e6dd85a-bbc5-439d-ae93-c6e9a22c78c4-85e0fd8fe1fd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77603,
      "sha256": "05116c61e2051c56698aa1ac06fc54cdd413d7ba7c92ca9cdea0666b611e9e07",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.889Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/2e7adf3b-1761-4c82-b108-b199c314076c": {
    "source_id": "acquired",
    "episode_id": "2e7adf3b-1761-4c82-b108-b199c314076c",
    "title": "CAA (with Michael Ovitz)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2e7adf3b-1761-4c82-b108-b199c314076c-3c3961cf7512/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2e7adf3b-1761-4c82-b108-b199c314076c-3c3961cf7512/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77592,
      "sha256": "c43fdb2758be210e5078144f80011027e72f8d24ea8973554ab5bb32fde17848",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.790Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/d3273936-2ea7-4904-b725-2b5e263d59de": {
    "source_id": "acquired",
    "episode_id": "d3273936-2ea7-4904-b725-2b5e263d59de",
    "title": "FTX (with Sam Bankman-Fried & Mario Gabriele)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77613,
      "sha256": "abdddd7ddfb8eb5ddc7d7b03c7d6c65169f09220dbd95ad6649db00d086a61c6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.932Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 94838,
      "sha256": "ef2a5de5660f20f7ff5556ef02cd35058c3acf0fba6e427c14cb95df15e4e5d0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T11:12:21.193Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d3273936-2ea7-4904-b725-2b5e263d59de-ec578fce8b5a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 28223,
      "sha256": "92e6854fa589f4e47f7d5ed0d4b66400af17fb6721c8774df1e0aa63a010126c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T11:12:21.192Z"
    }
  },
  "acquired/39f78858-446c-4049-91aa-3029b1a75190": {
    "source_id": "acquired",
    "episode_id": "39f78858-446c-4049-91aa-3029b1a75190",
    "title": "7 Powers with Hamilton Helmer",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/39f78858-446c-4049-91aa-3029b1a75190-02a41fe89d1b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/39f78858-446c-4049-91aa-3029b1a75190-02a41fe89d1b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77597,
      "sha256": "1fad56193ece7705142bbbc6d75e7d0a3f74769244576d914e63ada7d8b43f67",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.797Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/57fa2b5b-e5c3-428e-9eaf-31b8f920c832": {
    "source_id": "acquired",
    "episode_id": "57fa2b5b-e5c3-428e-9eaf-31b8f920c832",
    "title": "Not Boring (with Packy McCormick)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/57fa2b5b-e5c3-428e-9eaf-31b8f920c832-125349de5a4d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/57fa2b5b-e5c3-428e-9eaf-31b8f920c832-125349de5a4d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77601,
      "sha256": "86c755800207701cbd4f4a2ead8b633beb0a21f00d085348458a5d1aab61748d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.830Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/fdd30042-cb45-4f23-bbbd-b146aa7e3a80": {
    "source_id": "acquired",
    "episode_id": "fdd30042-cb45-4f23-bbbd-b146aa7e3a80",
    "title": "Complexity Investing & Semiconductors (with NZS Capital)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/fdd30042-cb45-4f23-bbbd-b146aa7e3a80-859841041ee8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/fdd30042-cb45-4f23-bbbd-b146aa7e3a80-859841041ee8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77624,
      "sha256": "8afd07bf3c90f8d03a9b384d19d428f2725439b90e32a7bb79d7ec6a35c68a45",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.960Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/5a09bd0e-e307-4e42-8c4e-2a0621965153": {
    "source_id": "acquired",
    "episode_id": "5a09bd0e-e307-4e42-8c4e-2a0621965153",
    "title": "Standard Oil Part II",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5a09bd0e-e307-4e42-8c4e-2a0621965153-c2e1cbb3599e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5a09bd0e-e307-4e42-8c4e-2a0621965153-c2e1cbb3599e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77588,
      "sha256": "d64a5a80db2d2d78a3eda76a6bc0250221bb903d9039dc1a3e756b112d643f7d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.835Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/89bedd4f-cf18-46b3-9df1-9e8568b13398": {
    "source_id": "acquired",
    "episode_id": "89bedd4f-cf18-46b3-9df1-9e8568b13398",
    "title": "Michael Mauboussin Master Class — Moats, Skill, Luck, Decision Making and a Whole Lot More",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/89bedd4f-cf18-46b3-9df1-9e8568b13398-8032bd32f087/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/89bedd4f-cf18-46b3-9df1-9e8568b13398-8032bd32f087/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77660,
      "sha256": "60748a9a1860a31b9597c4f000864eb8b44e6ac643de6a665addb507bf401d0c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.881Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/89c59c1e-fda8-4505-8cb3-3d712915a3b5": {
    "source_id": "acquired",
    "episode_id": "89c59c1e-fda8-4505-8cb3-3d712915a3b5",
    "title": "Standard Oil Part I",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/89c59c1e-fda8-4505-8cb3-3d712915a3b5-af6000cdcdc1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/89c59c1e-fda8-4505-8cb3-3d712915a3b5-af6000cdcdc1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77587,
      "sha256": "cf69b51f6a47c9f22bfbee87b10347a6dc0631ce9f5941e44b6ab40260446847",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.882Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/7c9d39b8-5982-4705-9707-2a422f68cb2a": {
    "source_id": "acquired",
    "episode_id": "7c9d39b8-5982-4705-9707-2a422f68cb2a",
    "title": "TSMC",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7c9d39b8-5982-4705-9707-2a422f68cb2a-d90c16efa37b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7c9d39b8-5982-4705-9707-2a422f68cb2a-d90c16efa37b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 151043,
      "sha256": "b4968a4a6a739e078ecc51f9c1302e456cc4b1ad0948c4206681222995063e19",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 647,
      "updated_at": "2026-06-09T13:39:30.862Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/93f2e610-3b84-4524-ba79-50f306ddbb49": {
    "source_id": "acquired",
    "episode_id": "93f2e610-3b84-4524-ba79-50f306ddbb49",
    "title": "Kevin Rose from Web 2.0 to Web3",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/93f2e610-3b84-4524-ba79-50f306ddbb49-5547000775af/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/93f2e610-3b84-4524-ba79-50f306ddbb49-5547000775af/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77599,
      "sha256": "8de136ce1050d045e6aeca2e4df9e20406db883ef38f2ce982611062a0e8ca71",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.892Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ef45c8a2-f059-4db5-a577-b4004383e039": {
    "source_id": "acquired",
    "episode_id": "ef45c8a2-f059-4db5-a577-b4004383e039",
    "title": "Andreessen Horowitz Part II",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ef45c8a2-f059-4db5-a577-b4004383e039-91c6e27e66f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ef45c8a2-f059-4db5-a577-b4004383e039-91c6e27e66f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "40d743db167246eccd2eb4e65a9cb4061567b1e38039ff412f27e6170af436e8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.947Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/094a7dee-99c5-4adc-9996-40eec032ad51": {
    "source_id": "acquired",
    "episode_id": "094a7dee-99c5-4adc-9996-40eec032ad51",
    "title": "Andreessen Horowitz Part I",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/094a7dee-99c5-4adc-9996-40eec032ad51-6a5a0cedd14b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/094a7dee-99c5-4adc-9996-40eec032ad51-6a5a0cedd14b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "baa8161af5353328c3b499bf8dbb2f7dcab68c204ee2ae76072e908676b3a165",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.762Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3f718efd-12a9-480b-a95c-684383464b21": {
    "source_id": "acquired",
    "episode_id": "3f718efd-12a9-480b-a95c-684383464b21",
    "title": "Special: Solana (with CEO Anatoly Yakovenko)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3f718efd-12a9-480b-a95c-684383464b21-dc844a655936/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3f718efd-12a9-480b-a95c-684383464b21-dc844a655936/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77612,
      "sha256": "0310f628271f211f82e04739d89a80cb24c70fdbb5c800707731c5689447456f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.807Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/dcc1bf7d-439f-4927-aa87-62540ad55374": {
    "source_id": "acquired",
    "episode_id": "dcc1bf7d-439f-4927-aa87-62540ad55374",
    "title": "Ethereum",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/dcc1bf7d-439f-4927-aa87-62540ad55374-2594955f2a37/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/dcc1bf7d-439f-4927-aa87-62540ad55374-2594955f2a37/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77576,
      "sha256": "435199bebe144500f87a3aca28d12d022c61a64bcfc9fbfc87c6ed59a7a682c8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.940Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/86529c0a-1f25-491e-a371-c986e74a0f85": {
    "source_id": "acquired",
    "episode_id": "86529c0a-1f25-491e-a371-c986e74a0f85",
    "title": "Special: Ho Nam from Altos Ventures — A Different Approach to VC",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/86529c0a-1f25-491e-a371-c986e74a0f85-80d4fd822e45/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/86529c0a-1f25-491e-a371-c986e74a0f85-80d4fd822e45/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77634,
      "sha256": "100efc4640590541259e8e0818d6a13e63be2d7e072c19c279b19a4754a506d4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.876Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/0f09141e-2ef7-4d72-8cd3-2fba73e45500": {
    "source_id": "acquired",
    "episode_id": "0f09141e-2ef7-4d72-8cd3-2fba73e45500",
    "title": "Berkshire Hathaway Part III",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "fc3fa17564f4ed59b070b0b74bf6e80bdbd440bc674fa6c130c0e6bceaf46bea",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.764Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60880,
      "sha256": "28e02bfe2c1ac850036f4e7b3e75393795e522ec3d1ab4fd9a7e254a5f81d9f3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T16:27:54.423Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0f09141e-2ef7-4d72-8cd3-2fba73e45500-588ad280122c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 26518,
      "sha256": "92e8c82b05188eb52fbd8d5c279a744af28a9fc80d310abb45b62cf6544dca13",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T16:27:54.422Z"
    }
  },
  "acquired/80977241-26a0-49bf-b506-0b10ec8006ae": {
    "source_id": "acquired",
    "episode_id": "80977241-26a0-49bf-b506-0b10ec8006ae",
    "title": "Special: Amazon Unbound (with Brad Stone)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/80977241-26a0-49bf-b506-0b10ec8006ae-94330079aeae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/80977241-26a0-49bf-b506-0b10ec8006ae-94330079aeae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77609,
      "sha256": "b48e518bf7fe2aa4e1b1f6d19ae5eafb9365c00f5b1e50f4df0e2a7cdd15a437",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.865Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea": {
    "source_id": "acquired",
    "episode_id": "689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea",
    "title": "Berkshire Hathaway Part II",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "ca45661712956def346080e491b0f65049ff9bf9dd4539db0e2982c06ca37500",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.844Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55894,
      "sha256": "cf06a8812f998678358d9c09ed7a56de8adfd24b561d8bdfab7d875b26d9a5e0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-06-02T02:32:56.712Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea-7f80c2488e3c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 31449,
      "sha256": "cf110f19af0c978b9bb629c463138eb7732ce852cf8b9327060a7633ed5fb479",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-06-02T02:32:56.711Z"
    }
  },
  "acquired/a10b378f-2753-40ba-a12a-a83898082557": {
    "source_id": "acquired",
    "episode_id": "a10b378f-2753-40ba-a12a-a83898082557",
    "title": "Special: 2021 China Tech Trends (with Tech Buzz China)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/a10b378f-2753-40ba-a12a-a83898082557-8b2c0b5d7dac/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/a10b378f-2753-40ba-a12a-a83898082557-8b2c0b5d7dac/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77622,
      "sha256": "b56abf1ea6596e56ea6552e85e273d15c7aa4d3f93cd34525f02450f3475b529",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.907Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/482065d7-cc39-4b8c-af32-3cf2795cdbdb": {
    "source_id": "acquired",
    "episode_id": "482065d7-cc39-4b8c-af32-3cf2795cdbdb",
    "title": "Berkshire Hathaway Part I",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77593,
      "sha256": "d4e666246114a70625ff1e664e578209254896b98b22ffaec0ad1fc5f416ca2b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.819Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46570,
      "sha256": "d554e0aa71a674224f0971e31b05018dc43370c40a52454f46deb55247eb9099",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-06-01T17:06:14.759Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/482065d7-cc39-4b8c-af32-3cf2795cdbdb-65208f392f4f/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 28158,
      "sha256": "e5a601a3c440a87170c9777f0f397aa62910cc7e6e3ebd3244d0b86d8b56b2f2",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 1,
      "updated_at": "2026-06-01T17:06:14.759Z"
    }
  },
  "acquired/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51": {
    "source_id": "acquired",
    "episode_id": "f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51",
    "title": "Special: \"Why Now\" for Digital Health (with Levels founder Josh Clemente)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77641,
      "sha256": "2edb5670bb576e7022d454f6445c497f58b5e2deabd168c75d055a90bac0745e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.954Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66175,
      "sha256": "aae313ebb7ef3bf8423d4e0c4432711d2c1f12be9c2ad4dacc2f3531293bd61e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T19:19:03.603Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51-07f50a55c48e/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 224968,
      "sha256": "395ac5dfb700c715abedbbbfd026b356876a77d817050420e44b6f5116d5731f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-27T19:19:03.602Z"
    }
  },
  "acquired/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23": {
    "source_id": "acquired",
    "episode_id": "f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23",
    "title": "Rec Room Part II (with CEO Nick Fajt)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77605,
      "sha256": "995181504abb3094cb7c52a3d98358fb2809c7d235f85c9cd9667ea9591d881c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.953Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49545,
      "sha256": "f052730845ef2ae8621eb9ba29fdcb6d7641a76577db0f84b3fd3b56cb2901c2",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T19:07:09.760Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23-e9927d818cae/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 18853,
      "sha256": "810845ec46f011941e51517008d4ef65a2b98015aaedf7e5caa7d3b270747726",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T19:07:09.759Z"
    }
  },
  "acquired/e93cd0b0-a686-450f-abdf-3c00d9102036": {
    "source_id": "acquired",
    "episode_id": "e93cd0b0-a686-450f-abdf-3c00d9102036",
    "title": "Meituan",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e93cd0b0-a686-450f-abdf-3c00d9102036-fe800388f3ec/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e93cd0b0-a686-450f-abdf-3c00d9102036-fe800388f3ec/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77575,
      "sha256": "5a86ef4baf646b4283c0fa19dea4588525f4ea40611d09fc6b0c3b564c40ee89",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.943Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/cc94959d-f42a-4531-86f6-500838d8da12": {
    "source_id": "acquired",
    "episode_id": "cc94959d-f42a-4531-86f6-500838d8da12",
    "title": "The New York Times Company",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "dc4f1e48dca610317adfec798ef4d7d344deb29f30ec44616aed225161695651",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.927Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 88387,
      "sha256": "25992c12d3a122ed457567a7fec5fc78714b607301648c7073dc364635130223",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 4,
      "updated_at": "2026-06-02T05:37:24.198Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/cc94959d-f42a-4531-86f6-500838d8da12-bb4b4458cf04/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 63483,
      "sha256": "1fa876d53dc1f9e7257f7c6dd0ee63ec60b2414eaf6680dd2cd79848436263f8",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 4,
      "updated_at": "2026-06-02T05:37:24.197Z"
    }
  },
  "acquired/e981ea00-0605-4844-92a4-cc3ff4c5fb25": {
    "source_id": "acquired",
    "episode_id": "e981ea00-0605-4844-92a4-cc3ff4c5fb25",
    "title": "Special: Sequoia Capital's Investment Playbook (with Alfred Lin)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77632,
      "sha256": "1f3b723defde3ee9549471ac80ba31cb28bdc91081a6009e9fde3724129c0126",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.943Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37423,
      "sha256": "e607c601fa1bd60070645c62ea2c3d8e747a38107e2e4c8aaaee899b142048c9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-06-01T03:01:01.840Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e981ea00-0605-4844-92a4-cc3ff4c5fb25-38f86c59f2bf/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 87799,
      "sha256": "d1ced02fc2f2cb33873844aa492b1231ffc0b812c690b575f291e39040d471a1",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-06-01T03:01:01.840Z"
    }
  },
  "acquired/d44194af-92ff-4b40-94a6-d5b48153579b": {
    "source_id": "acquired",
    "episode_id": "d44194af-92ff-4b40-94a6-d5b48153579b",
    "title": "Bitcoin",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d44194af-92ff-4b40-94a6-d5b48153579b-7f34be590fc8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d44194af-92ff-4b40-94a6-d5b48153579b-7f34be590fc8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77575,
      "sha256": "4674d9465306d9c2b897baeafe1bbc1ab596a79f4f0b29039c31a7fcf9fde838",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.932Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b01c6e84-a611-4e44-aa16-8e54c6978347": {
    "source_id": "acquired",
    "episode_id": "b01c6e84-a611-4e44-aa16-8e54c6978347",
    "title": "Special: Acquired x Indie Hackers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77601,
      "sha256": "9ae457f7ff88c6c156852558b1dcbe46d5b19b6bf79ff93c481b92eb5dc1505b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.915Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 232599,
      "sha256": "994dd04c1a8a53df2a3fca19cda032114fca635ba2dcb1e131e9e318dff010f3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T04:34:56.388Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b01c6e84-a611-4e44-aa16-8e54c6978347-509fdb66c9a5/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 17897,
      "sha256": "e01bea3ad04e65cdddb8ad2386fb152f49b334a1187c41318b8ac8489d55be88",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T04:34:56.387Z"
    }
  },
  "acquired/94c5bedb-f60e-4f12-ac9e-8f6da4fce3e0": {
    "source_id": "acquired",
    "episode_id": "94c5bedb-f60e-4f12-ac9e-8f6da4fce3e0",
    "title": "Airbnb",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/94c5bedb-f60e-4f12-ac9e-8f6da4fce3e0-48f60149581b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/94c5bedb-f60e-4f12-ac9e-8f6da4fce3e0-48f60149581b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77574,
      "sha256": "26c93abd588f96f77d7e611b8f699020c4dfd547e87b543d585c063fe2a6d4cf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.895Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/79438add-9a91-438f-87dc-61c54c59af55": {
    "source_id": "acquired",
    "episode_id": "79438add-9a91-438f-87dc-61c54c59af55",
    "title": "DoorDash",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/79438add-9a91-438f-87dc-61c54c59af55-be4f584a4028/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/79438add-9a91-438f-87dc-61c54c59af55-be4f584a4028/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77576,
      "sha256": "b7faaa83447adf3fe7a7a41a0c46c6465a3dea34db810c55cb725a42eae1f98c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.857Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b2758461-c12e-448e-9afe-5c71a5dd852b": {
    "source_id": "acquired",
    "episode_id": "b2758461-c12e-448e-9afe-5c71a5dd852b",
    "title": "Slack + Salesforce Emergency Pod with Packy McCormick of Not Boring",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77635,
      "sha256": "8d1ad830dde82260bb54acdc50ee681daabe44c0d5370692369e0655423cc6e9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.917Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37365,
      "sha256": "e995df5492079ec20b40b1118cf28a6cc5a0241a9f358512634ac55537aa5a23",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T08:08:36.410Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b2758461-c12e-448e-9afe-5c71a5dd852b-e9eaf68a9acc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 44972,
      "sha256": "4be150f6353ee9ec63c2a805d58198ed2d8a5dc7942747238f8054191ac0bf46",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T08:08:36.409Z"
    }
  },
  "acquired/4116e16b-8386-42a3-8780-fd12f77f331c": {
    "source_id": "acquired",
    "episode_id": "4116e16b-8386-42a3-8780-fd12f77f331c",
    "title": "Virgin Galactic",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77583,
      "sha256": "941b04b9cfa481be59d08877e702674ef23145b5705b738c738186d8f7af4e50",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.812Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34816,
      "sha256": "456a6813f88609f54148ef0b621802080ae54c0b30108132bd1e4d0eee97afb7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T18:55:56.338Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4116e16b-8386-42a3-8780-fd12f77f331c-ea22652c662c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 20913,
      "sha256": "1c325e60d92926ed9142b1db93f7faedd9d504c3deff7ed54139667e90eac95b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-31T18:55:56.338Z"
    }
  },
  "acquired/904da83a-f3ba-479a-91cc-8bf48890d654": {
    "source_id": "acquired",
    "episode_id": "904da83a-f3ba-479a-91cc-8bf48890d654",
    "title": "Special: Superhuman Part II - Designing Software to Feel like a Game (with Rahul Vohra)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77655,
      "sha256": "5ab2724d54e9ff492ca3cc01dff0c5188d42a9bf0cb88aeb94e598836bcb369b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.890Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 17426,
      "sha256": "e68d1c3d89d45c2b78fa33f648f308486948c80abc3f3de76ec4d5a5ec684dae",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T20:09:00.515Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/904da83a-f3ba-479a-91cc-8bf48890d654-318c2888d3dc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 22968,
      "sha256": "3147ba29fa9757f7733a11a22c6c10a86d17d651a9c1e8c80271dd6b90f47ed6",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-01T20:09:00.514Z"
    }
  },
  "acquired/779a9cc5-7338-4754-8986-375fb33790f9": {
    "source_id": "acquired",
    "episode_id": "779a9cc5-7338-4754-8986-375fb33790f9",
    "title": "Twitter (with Dick Costolo)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "205c388c51932c6a17dfac92e64f4a40783ba41d9944be441f5e63657a27c6ab",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.855Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39943,
      "sha256": "54428c91097e8474fc8081bded65ac4bc8453d6ce139e6fa728f7cb37fe08713",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T07:39:49.434Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/779a9cc5-7338-4754-8986-375fb33790f9-c0dc868c3adc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 18999,
      "sha256": "207642dd07f9b8ed40f6c9319768e5955ef72e928c1f1bb6db40f0ea54913586",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T07:39:49.428Z"
    }
  },
  "acquired/eb0d094e-84a2-4446-8fa3-73bf53ecd81d": {
    "source_id": "acquired",
    "episode_id": "eb0d094e-84a2-4446-8fa3-73bf53ecd81d",
    "title": "Special: Invest Like the Best on Acquired",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/eb0d094e-84a2-4446-8fa3-73bf53ecd81d-38f1d564d100/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/eb0d094e-84a2-4446-8fa3-73bf53ecd81d-38f1d564d100/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77609,
      "sha256": "d6feecb70d822f8b0ab677a1a306510f69804768bad8f838ae20b5f44c67f0dc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.945Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/9737acd9-4f9b-488c-aba6-39d0bed28406": {
    "source_id": "acquired",
    "episode_id": "9737acd9-4f9b-488c-aba6-39d0bed28406",
    "title": "The NBA",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9737acd9-4f9b-488c-aba6-39d0bed28406-e628957dd2e9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9737acd9-4f9b-488c-aba6-39d0bed28406-e628957dd2e9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77575,
      "sha256": "5edb995b6b211bac396374d35190f0f0818eb2f3c0227ca3fbfe15af5d1d5f3f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.900Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/5180c82e-a792-4e3c-87d6-e28994064250": {
    "source_id": "acquired",
    "episode_id": "5180c82e-a792-4e3c-87d6-e28994064250",
    "title": "Special: Acquired x My First Million",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5180c82e-a792-4e3c-87d6-e28994064250-951c1744b204/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5180c82e-a792-4e3c-87d6-e28994064250-951c1744b204/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77604,
      "sha256": "08b9c03b207f418a19346f4d9e976521ba9651011ed3e7111dfd63bb9b9f8fd1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.823Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/21306962-9052-4069-a856-0eeabcf25ef2": {
    "source_id": "acquired",
    "episode_id": "21306962-9052-4069-a856-0eeabcf25ef2",
    "title": "Epic Games",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/21306962-9052-4069-a856-0eeabcf25ef2-4db9cb2a9837/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/21306962-9052-4069-a856-0eeabcf25ef2-4db9cb2a9837/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77578,
      "sha256": "c0112f749f263a0187839002a6fe9dc2ae6a5b578b7818071b1a102866191a43",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.780Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b481fb9d-927d-479e-ac34-4fc321c53a2a": {
    "source_id": "acquired",
    "episode_id": "b481fb9d-927d-479e-ac34-4fc321c53a2a",
    "title": "Eventbrite (with Julia & Kevin Hartz)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b481fb9d-927d-479e-ac34-4fc321c53a2a-aca3f1febff7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b481fb9d-927d-479e-ac34-4fc321c53a2a-aca3f1febff7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77605,
      "sha256": "111ccf3e64dcce14eb617ef11c44bed9b2c9b688f62ee26c659fd72a27732e31",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.918Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/39f7c4b0-bb54-49cc-9844-d5b33579e9ec": {
    "source_id": "acquired",
    "episode_id": "39f7c4b0-bb54-49cc-9844-d5b33579e9ec",
    "title": "Pinduoduo",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/39f7c4b0-bb54-49cc-9844-d5b33579e9ec-a257a8e02c1d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/39f7c4b0-bb54-49cc-9844-d5b33579e9ec-a257a8e02c1d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77577,
      "sha256": "d2d7f8e9f35e9c630c1d27fc4168c52fb078cfca1e99cf00f5ae6213e27fdf96",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.798Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/845274d4-a3e8-4098-b87c-f5dfc0206525": {
    "source_id": "acquired",
    "episode_id": "845274d4-a3e8-4098-b87c-f5dfc0206525",
    "title": "Oprah (Harpo Studios)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/845274d4-a3e8-4098-b87c-f5dfc0206525-379723f3649e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/845274d4-a3e8-4098-b87c-f5dfc0206525-379723f3649e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77589,
      "sha256": "c9e6bc0d07a06d318c94ea804da857c04f652075ef570cb58b1e829619ccbf3e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.871Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/94da96be-e1d6-40e9-9f9e-6b49cfab79e0": {
    "source_id": "acquired",
    "episode_id": "94da96be-e1d6-40e9-9f9e-6b49cfab79e0",
    "title": "SpaceX",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/94da96be-e1d6-40e9-9f9e-6b49cfab79e0-c552fd1e53ae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/94da96be-e1d6-40e9-9f9e-6b49cfab79e0-c552fd1e53ae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77574,
      "sha256": "3bdb26ca94cc42b34c9991b0cc4dca09c05a49273ec5bb3e2ce7b4d424b03c6e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.896Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f4cbce86-7bbb-4c63-9320-c470ffd6301c": {
    "source_id": "acquired",
    "episode_id": "f4cbce86-7bbb-4c63-9320-c470ffd6301c",
    "title": "Adapting Episode 3: Intel",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f4cbce86-7bbb-4c63-9320-c470ffd6301c-8f5a6ccacc11/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f4cbce86-7bbb-4c63-9320-c470ffd6301c-8f5a6ccacc11/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77593,
      "sha256": "cad07446d48cc100f2c0ee5c16b436a0e05dcfd210b9056678c14f5a1ae6dd58",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.952Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/74f0613b-6e0f-4fb7-9864-b7d23688e479": {
    "source_id": "acquired",
    "episode_id": "74f0613b-6e0f-4fb7-9864-b7d23688e479",
    "title": "Special Episode: Jason Calacanis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/74f0613b-6e0f-4fb7-9864-b7d23688e479-38f349a01a2f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/74f0613b-6e0f-4fb7-9864-b7d23688e479-38f349a01a2f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77600,
      "sha256": "144205e8513b406fcdc94400fd580f509c026c9f33010616bfd58a3cd1dacb39",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.851Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/d9e60557-828e-41a7-b8de-2caf997c0fec": {
    "source_id": "acquired",
    "episode_id": "d9e60557-828e-41a7-b8de-2caf997c0fec",
    "title": "Adapting Episode 1: Canlis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d9e60557-828e-41a7-b8de-2caf997c0fec-00ded100067a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d9e60557-828e-41a7-b8de-2caf997c0fec-00ded100067a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "ee9ce19068bdf108841f59fdb99c7f060f8d37f6d8729f59068332fa187efddf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.936Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/58a5c74d-2eef-4631-9231-3c485a812718": {
    "source_id": "acquired",
    "episode_id": "58a5c74d-2eef-4631-9231-3c485a812718",
    "title": "The Top 10 Acquisitions of All-Time",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77603,
      "sha256": "8116d861f2f4cabe52b29d906b42ea338e17d352035c6615f65a16e94805db94",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.833Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46476,
      "sha256": "1ec526e25231c8bcaf3af55eb056d296d1cd5c0cbbb6154f2bf8ce402850d697",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-06-01T21:39:13.016Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/58a5c74d-2eef-4631-9231-3c485a812718-45cce1e63529/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 301404,
      "sha256": "e316bafa8645397561a1a04a11e7ebec6f393b983e4af6612bf8728580c7daad",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-06-01T21:39:13.016Z"
    }
  },
  "acquired/4b508c22-2ba3-4e1e-936c-9031e1082682": {
    "source_id": "acquired",
    "episode_id": "4b508c22-2ba3-4e1e-936c-9031e1082682",
    "title": "Sequoia Capital Part II (with Doug Leone)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77609,
      "sha256": "3a0bd7f1aa51394323be0cadcaba50314759ded28c62b83320f9c082927096ef",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.822Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55060,
      "sha256": "b5e1374be8cf1847093ac5389d99656ed2987242bbd16481c5e2cb68b92fe8e6",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T01:43:04.442Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/4b508c22-2ba3-4e1e-936c-9031e1082682-9ae32daed394/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 18718,
      "sha256": "b864a0592dd06ba7594e5be3ce7f87bc4a2fed5a53ba37466a684d0a518ee846",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-05-28T01:43:04.442Z"
    }
  },
  "acquired/68e93747-1bbf-479e-98e3-1b7f7d2478a2": {
    "source_id": "acquired",
    "episode_id": "68e93747-1bbf-479e-98e3-1b7f7d2478a2",
    "title": "WhatsApp",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/68e93747-1bbf-479e-98e3-1b7f7d2478a2-4c70fad4583b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/68e93747-1bbf-479e-98e3-1b7f7d2478a2-4c70fad4583b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77576,
      "sha256": "038e447d09081819a23b14dfb965cc98906322f83a384dc96220fe8f9be821b4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.845Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8627ee40-4ffc-4380-82c5-393db59b4b58": {
    "source_id": "acquired",
    "episode_id": "8627ee40-4ffc-4380-82c5-393db59b4b58",
    "title": "The Lean Startup and the Long-Term Stock Exchange (with Eric Ries)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8627ee40-4ffc-4380-82c5-393db59b4b58-63030e6cba7f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8627ee40-4ffc-4380-82c5-393db59b4b58-63030e6cba7f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77634,
      "sha256": "ba2217e0405a048e6ae8fb6ae3b48244c8ea8829173e647de8f85ef60a6f9d95",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.875Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/57d6d0e3-6060-4103-aac9-bd3a71dc18be": {
    "source_id": "acquired",
    "episode_id": "57d6d0e3-6060-4103-aac9-bd3a71dc18be",
    "title": "Convoy (with CEO Dan Lewis)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/57d6d0e3-6060-4103-aac9-bd3a71dc18be-2116857a2e35/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/57d6d0e3-6060-4103-aac9-bd3a71dc18be-2116857a2e35/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "0d91edde532da84c7a13685fe805b8f05a08f1faa7bbad2458c12d485ea70bb0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.829Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/5801e589-b6cf-4fe9-9cd6-f16da7cac595": {
    "source_id": "acquired",
    "episode_id": "5801e589-b6cf-4fe9-9cd6-f16da7cac595",
    "title": "TikTok",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5801e589-b6cf-4fe9-9cd6-f16da7cac595-58b7ded7b935/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5801e589-b6cf-4fe9-9cd6-f16da7cac595-58b7ded7b935/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77574,
      "sha256": "efed192c72f80cd0f54cea1989a1f4808e7f321c8765b87b156fd1051897803f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.830Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/825958f0-e4c5-43b8-b281-8d71eef1721b": {
    "source_id": "acquired",
    "episode_id": "825958f0-e4c5-43b8-b281-8d71eef1721b",
    "title": "Disney, Plus",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/825958f0-e4c5-43b8-b281-8d71eef1721b-56a75bbe994f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/825958f0-e4c5-43b8-b281-8d71eef1721b-56a75bbe994f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77580,
      "sha256": "238ae30442c4ed2f8614ed5b30baa1bafa133e95da57b51cb5268c44343d400c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.869Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f8fe9512570642a0a28e2a64ce5dc3c7": {
    "source_id": "acquired",
    "episode_id": "f8fe9512570642a0a28e2a64ce5dc3c7",
    "title": "The WeWork “Acquisition” (with Dan Primack)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f8fe9512570642a0a28e2a64ce5dc3c7-e10789877976/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f8fe9512570642a0a28e2a64ce5dc3c7-e10789877976/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77611,
      "sha256": "3fb7f4f1badbed96c97d4f1b2717484a2d3a01ca961fb81ab4b771a6f5292fe6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.956Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b46b08930e1e4de3875c476108c74615": {
    "source_id": "acquired",
    "episode_id": "b46b08930e1e4de3875c476108c74615",
    "title": "Season 5, Episode 5: Atari (with Nolan Bushnell)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b46b08930e1e4de3875c476108c74615-41d1059fae5f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b46b08930e1e4de3875c476108c74615-41d1059fae5f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77612,
      "sha256": "46e7ea8773ef9cf72f31de0e56a2bdf0bf6f3a4b05c9e7b70742361e2bbc2cb1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.918Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/84861cd6330b4273a4662cb8ab497021": {
    "source_id": "acquired",
    "episode_id": "84861cd6330b4273a4662cb8ab497021",
    "title": "Sequoia Capital (Part 1)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/84861cd6330b4273a4662cb8ab497021-7f48d721138a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/84861cd6330b4273a4662cb8ab497021-7f48d721138a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77588,
      "sha256": "7bbf96e770b494e9127e0838f78d7bb5375e986a37a343b2fc1f118698dc16e9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.872Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/38dc0771dbb24bcda353f484b4a91fcf": {
    "source_id": "acquired",
    "episode_id": "38dc0771dbb24bcda353f484b4a91fcf",
    "title": "Google Maps",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/38dc0771dbb24bcda353f484b4a91fcf-6670aad0ee31/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/38dc0771dbb24bcda353f484b4a91fcf-6670aad0ee31/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77575,
      "sha256": "1a2638c4c602f617b0f94b769acf94daa41c29b63f8f203ea3b95e40c900ca43",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.796Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/05871ea2eb724bba975ffb99110f0982": {
    "source_id": "acquired",
    "episode_id": "05871ea2eb724bba975ffb99110f0982",
    "title": "The Shopify IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/05871ea2eb724bba975ffb99110f0982-731d14b0a7e9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/05871ea2eb724bba975ffb99110f0982-731d14b0a7e9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77579,
      "sha256": "9005afa78bb591193d587880eea57a7650040e9eb1987464d2e981a2130cdafb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.754Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/10f4e9fe70624496a3ea193dc5269679": {
    "source_id": "acquired",
    "episode_id": "10f4e9fe70624496a3ea193dc5269679",
    "title": "Huawei",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/10f4e9fe70624496a3ea193dc5269679-7b640f69d50b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/10f4e9fe70624496a3ea193dc5269679-7b640f69d50b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77570,
      "sha256": "28a112443f76935e07704eb8bf895f53990575cf69d8e37594f866b81c2c3aaf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.767Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3d39c874d3de4e02acdd8b2eb1c3e42b": {
    "source_id": "acquired",
    "episode_id": "3d39c874d3de4e02acdd8b2eb1c3e42b",
    "title": "Superhuman (with CEO Rahul Vohra)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3d39c874d3de4e02acdd8b2eb1c3e42b-263fe1f0647f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3d39c874d3de4e02acdd8b2eb1c3e42b-263fe1f0647f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77597,
      "sha256": "a1c4b7fd2307718228d30392eb0ee467e86ff462f8f6a32a7dafc741fccba2b9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.806Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ed721f700455499c82d6f3de7b2a481f": {
    "source_id": "acquired",
    "episode_id": "ed721f700455499c82d6f3de7b2a481f",
    "title": "The Slack DPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ed721f700455499c82d6f3de7b2a481f-731e9024fb33/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ed721f700455499c82d6f3de7b2a481f-731e9024fb33/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77577,
      "sha256": "dc639a7d8040859215782be0eee0583c615741f518578c41ab703133cde05214",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.946Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/bdb8c15d1bd44109b239a542a6b53663": {
    "source_id": "acquired",
    "episode_id": "bdb8c15d1bd44109b239a542a6b53663",
    "title": "The Zoom IPO (with Santi Subotovsky)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/bdb8c15d1bd44109b239a542a6b53663-75bd9161ab59/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/bdb8c15d1bd44109b239a542a6b53663-75bd9161ab59/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77600,
      "sha256": "ee8dec582acd05c7276ca7ecb080c14e2cb6d7e163ea6558405a98c928c8fcba",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.921Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8f32e09693174bd9af5aa459dc9b2f4d": {
    "source_id": "acquired",
    "episode_id": "8f32e09693174bd9af5aa459dc9b2f4d",
    "title": "The Electronic Arts IPO (with Trip Hawkins)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8f32e09693174bd9af5aa459dc9b2f4d-6c434333aa54/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8f32e09693174bd9af5aa459dc9b2f4d-6c434333aa54/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77607,
      "sha256": "c03c6029490bf511ec8a9c13b42ad0be3b656647aa6d4a6137bdb503df0085ba",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.889Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/5825b12d317d40c9a8d08785f82bf967": {
    "source_id": "acquired",
    "episode_id": "5825b12d317d40c9a8d08785f82bf967",
    "title": "The Uber IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/5825b12d317d40c9a8d08785f82bf967-67f9abd43982/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/5825b12d317d40c9a8d08785f82bf967-67f9abd43982/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77576,
      "sha256": "f1084848a444446e0bd1174fc1e3f106a2eed6d18097784981c4b3edbb27c194",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.832Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/264d445c9295435b87192d974742aa81": {
    "source_id": "acquired",
    "episode_id": "264d445c9295435b87192d974742aa81",
    "title": "The Pinterest IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/264d445c9295435b87192d974742aa81-26c53fa9e356/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/264d445c9295435b87192d974742aa81-26c53fa9e356/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77581,
      "sha256": "21506630780569e34857749880986e86af27c694fd862850dfbe15d7cb4c64d2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.785Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/e479bdfcc7b443f38c0c39299f04e024": {
    "source_id": "acquired",
    "episode_id": "e479bdfcc7b443f38c0c39299f04e024",
    "title": "The Lyft IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e479bdfcc7b443f38c0c39299f04e024-ffce5ee151c5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e479bdfcc7b443f38c0c39299f04e024-ffce5ee151c5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77576,
      "sha256": "463a74c70442b0796028d72e59984f029f8343f0a0db6868db9029a0344892ef",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.942Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/2713f0278e51430cb495d101b2ca0c87": {
    "source_id": "acquired",
    "episode_id": "2713f0278e51430cb495d101b2ca0c87",
    "title": "Season 4, Episode 3: Instagram Revisited (with Emily White)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2713f0278e51430cb495d101b2ca0c87-6bff6866b6a5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2713f0278e51430cb495d101b2ca0c87-6bff6866b6a5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77624,
      "sha256": "4ecddee98742e7ff85669bfcf5c4978189ad728c9c6177e69dcd627530076e3e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.786Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/6cf59ea131164992bc6985aea47406b5": {
    "source_id": "acquired",
    "episode_id": "6cf59ea131164992bc6985aea47406b5",
    "title": "Season 4, Episode 2: ARM & SoftBank",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/6cf59ea131164992bc6985aea47406b5-ebe113bd7a8a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/6cf59ea131164992bc6985aea47406b5-ebe113bd7a8a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77600,
      "sha256": "c8238bb67c6bcb0d67c1e9f04adaaf23ec1ff581073f58df76b61854a2a41fb0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.850Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f2baaa8cbef34daa88149339eeaafe7f": {
    "source_id": "acquired",
    "episode_id": "f2baaa8cbef34daa88149339eeaafe7f",
    "title": "Season 4, Episode 1: ESPN",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f2baaa8cbef34daa88149339eeaafe7f-c421a069d110/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f2baaa8cbef34daa88149339eeaafe7f-c421a069d110/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77590,
      "sha256": "8a06c3fc46179ce9e761378e35731c0b8b603bc2c5f00867c4e0ca8a008b5a82",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.951Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/09d848d83bd24bda8c7c3ea23fa0d089": {
    "source_id": "acquired",
    "episode_id": "09d848d83bd24bda8c7c3ea23fa0d089",
    "title": "Season 3, Episode 10: Tencent",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/09d848d83bd24bda8c7c3ea23fa0d089-2b4e0e054fc5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/09d848d83bd24bda8c7c3ea23fa0d089-2b4e0e054fc5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "670c068872ddd6f8a1a380a0d7d4d3d21543ce8c8a4456ad9f5647e286f235b3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.763Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/6808e80dfff54a88912e018fab0f819e": {
    "source_id": "acquired",
    "episode_id": "6808e80dfff54a88912e018fab0f819e",
    "title": "Season 3, Episode 9: Netflix (Part 2)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/6808e80dfff54a88912e018fab0f819e-936b038ed209/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/6808e80dfff54a88912e018fab0f819e-936b038ed209/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77602,
      "sha256": "0d3c3893391caf1f48bc35e25a2a864eb6f3963d3cd1c02875d5c3e763951d61",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.843Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/37b576f582544f25908ce410e348285c": {
    "source_id": "acquired",
    "episode_id": "37b576f582544f25908ce410e348285c",
    "title": "Season 3, Episode 8: Netflix (Part 1)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/37b576f582544f25908ce410e348285c-3825ad138aa5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/37b576f582544f25908ce410e348285c-3825ad138aa5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77602,
      "sha256": "081e1bf06d27f6cdc4065d0b5e43528408702eca1c8650979065f1ad13624c36",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.794Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/083f08d557744bdc8d2a65c78ab3b3c0": {
    "source_id": "acquired",
    "episode_id": "083f08d557744bdc8d2a65c78ab3b3c0",
    "title": "Acquired Season 3 Episode 7: Venmo (live with Andrew Kortina)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/083f08d557744bdc8d2a65c78ab3b3c0-9e56ab043c6a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/083f08d557744bdc8d2a65c78ab3b3c0-9e56ab043c6a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77625,
      "sha256": "45732df919b008b35521ef0c10bd3eff4ab952cb443d592c04faddbd299cc5ee",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.758Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f3678bd234784d05bb3973073226fb1c": {
    "source_id": "acquired",
    "episode_id": "f3678bd234784d05bb3973073226fb1c",
    "title": "Season 3, Episode 6: Behance (with Scott Belsky)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f3678bd234784d05bb3973073226fb1c-b18860605b3f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f3678bd234784d05bb3973073226fb1c-b18860605b3f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77613,
      "sha256": "d65c137fba0a2059ada3aee1a561355f852c17d6d26a4aa91d7cfd3a761034b1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.951Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/2f1c3158978c42d39dc9957bd3280bee": {
    "source_id": "acquired",
    "episode_id": "2f1c3158978c42d39dc9957bd3280bee",
    "title": "Season 3, Episode 5: Alibaba",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/2f1c3158978c42d39dc9957bd3280bee-a89d3d508115/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/2f1c3158978c42d39dc9957bd3280bee-a89d3d508115/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77593,
      "sha256": "328dfff0651b5c7328d3a658669ac85cdbce86af57c8c737a8bf007b069ca4fa",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.791Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/24cbfc0b88cf455bbcd903bd2c27fe92": {
    "source_id": "acquired",
    "episode_id": "24cbfc0b88cf455bbcd903bd2c27fe92",
    "title": "Season 3, Episode 4: Recode (with Kara Swisher)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/24cbfc0b88cf455bbcd903bd2c27fe92-8e1bc55103a8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/24cbfc0b88cf455bbcd903bd2c27fe92-8e1bc55103a8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77612,
      "sha256": "5574ed2aa981b9f397334d8edbf7523ce04b61087aa08f77b8d4b6d93a91902f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.784Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f9e170df33df4c58afb3bc0fb3dd44c8": {
    "source_id": "acquired",
    "episode_id": "f9e170df33df4c58afb3bc0fb3dd44c8",
    "title": "Season 3, Episode 3: The Sonos IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f9e170df33df4c58afb3bc0fb3dd44c8-a1be8a31d848/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f9e170df33df4c58afb3bc0fb3dd44c8-a1be8a31d848/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77599,
      "sha256": "b5ef252450f1baba88b163955d11d70b5ca183b5134d8ce580d0f7fed80a479d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.956Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/97e465b8bf2a450bbbef2fec8c12b8de": {
    "source_id": "acquired",
    "episode_id": "97e465b8bf2a450bbbef2fec8c12b8de",
    "title": "Season 3, Episode 2: The Xiaomi IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/97e465b8bf2a450bbbef2fec8c12b8de-5bd077712bfe/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/97e465b8bf2a450bbbef2fec8c12b8de-5bd077712bfe/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77599,
      "sha256": "c2445bd20196bb0eb634ab18c6838ed63d55122aa01936e5b4d36b5fea9d569b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.900Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/7a666af33ab2487ca253acd953450ffa": {
    "source_id": "acquired",
    "episode_id": "7a666af33ab2487ca253acd953450ffa",
    "title": "Season 3, Episode 1: Tesla",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/7a666af33ab2487ca253acd953450ffa-c82bd77f6d17/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/7a666af33ab2487ca253acd953450ffa-c82bd77f6d17/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77591,
      "sha256": "9a363a31009526093f6c2b3d941409aa0583c654b98170e0ad54c732aa3a802b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.859Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8e429cbfcedc4606b2e7021aff14e97a": {
    "source_id": "acquired",
    "episode_id": "8e429cbfcedc4606b2e7021aff14e97a",
    "title": "Season 2, Episode 10: The Rover-DogVacay Merger (with Rover CEO Aaron Easterly)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8e429cbfcedc4606b2e7021aff14e97a-8c6d7da52dc5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8e429cbfcedc4606b2e7021aff14e97a-8c6d7da52dc5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77644,
      "sha256": "3a825e0487250db6a04611693377c7de07308f0116b2f8b56054c806c7ffedeb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.888Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/fbcf6c2338e041759182dc10eb2ba636": {
    "source_id": "acquired",
    "episode_id": "fbcf6c2338e041759182dc10eb2ba636",
    "title": "Season 2, Episode 9: GitHub",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/fbcf6c2338e041759182dc10eb2ba636-fee980f46c86/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/fbcf6c2338e041759182dc10eb2ba636-fee980f46c86/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77592,
      "sha256": "c3384290bef8957b06d719d13d14533726960dfdfb86802972a78a64a90cbd57",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.957Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/092c25ed46df4a0caafb58211b98dd5c": {
    "source_id": "acquired",
    "episode_id": "092c25ed46df4a0caafb58211b98dd5c",
    "title": "Season 2, Episode 8: T-Mobile / Sprint",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/092c25ed46df4a0caafb58211b98dd5c-62e34daceae5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/092c25ed46df4a0caafb58211b98dd5c-62e34daceae5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77603,
      "sha256": "bf2fd7c6ced66569498bbc6a2d378172068e06dd3f76fccb017001cacd6ca533",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.760Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/83a574e9c0d1c2d993e472343fcc0cfd": {
    "source_id": "acquired",
    "episode_id": "83a574e9c0d1c2d993e472343fcc0cfd",
    "title": "Season 2, Episode 7: PowerPoint",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/83a574e9c0d1c2d993e472343fcc0cfd-162b390c6f48/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/83a574e9c0d1c2d993e472343fcc0cfd-162b390c6f48/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77596,
      "sha256": "963c6c657af21d535e23b108b60428e55731a0d38261cace5dff935a5d5c69d6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.869Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3f987c8a5468b2a8806dc70282791593": {
    "source_id": "acquired",
    "episode_id": "3f987c8a5468b2a8806dc70282791593",
    "title": "Season 2, Episode 6: Spotify’s Direct Listing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3f987c8a5468b2a8806dc70282791593-348c63139cf8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3f987c8a5468b2a8806dc70282791593-348c63139cf8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77612,
      "sha256": "a19149a90672d51e7b665eb74fe179455630dd534fb87bd92d5ca7f66405353f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.810Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8e11397c526638c079fa96333ec21953": {
    "source_id": "acquired",
    "episode_id": "8e11397c526638c079fa96333ec21953",
    "title": "Season 2, Episode 5: The Dropbox IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8e11397c526638c079fa96333ec21953-51e32dfe9105/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8e11397c526638c079fa96333ec21953-51e32dfe9105/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77601,
      "sha256": "11ed5ad8202dadf77aac3498c73d1ecdec29bc31b3a8f82daada562968fcb2b1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.887Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/107c7dae2e16c6e20a020ab191137f30": {
    "source_id": "acquired",
    "episode_id": "107c7dae2e16c6e20a020ab191137f30",
    "title": "Season 2, Episode 4: SoftBank, Fortress and the Vision Fund",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/107c7dae2e16c6e20a020ab191137f30-6a48c4f33468/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/107c7dae2e16c6e20a020ab191137f30-6a48c4f33468/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77624,
      "sha256": "cfd31e8864f8df7808a69d2e69dd0c2c921423d442aea261289d7da7d73f9f47",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.766Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/00654835b39d313df6aa75d4ccd5047f": {
    "source_id": "acquired",
    "episode_id": "00654835b39d313df6aa75d4ccd5047f",
    "title": "Season 2, Episode 3: Nest",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/00654835b39d313df6aa75d4ccd5047f-e2805b11d30e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/00654835b39d313df6aa75d4ccd5047f-e2805b11d30e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77590,
      "sha256": "67d3ee0014e329423597d85df6e2201aae8907dc08c4d62e55a497ab768aaf23",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.750Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/3d6f7518de2acdd8bc11266682f8b0ce": {
    "source_id": "acquired",
    "episode_id": "3d6f7518de2acdd8bc11266682f8b0ce",
    "title": "Season 2, Episode 2: Raising a Seed Round with Against Gravity CEO Nick Fajt",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/3d6f7518de2acdd8bc11266682f8b0ce-628ea4a2ee60/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/3d6f7518de2acdd8bc11266682f8b0ce-628ea4a2ee60/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77641,
      "sha256": "b2777d31e2d9988d3215a811d468762598d7896cefc590c4028424bd8095ee94",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.806Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/25461cff3b3df1cafc569f8ff22bf79b": {
    "source_id": "acquired",
    "episode_id": "25461cff3b3df1cafc569f8ff22bf79b",
    "title": "Episode 51: 2017 Holiday Special",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/25461cff3b3df1cafc569f8ff22bf79b-27597f76f092/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/25461cff3b3df1cafc569f8ff22bf79b-27597f76f092/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77597,
      "sha256": "00422e523b46d084d09d457b0a96c9ffe08f637547d762ed43767cce3a704b3f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.785Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/94203e82153143bb13c33652772ba18c": {
    "source_id": "acquired",
    "episode_id": "94203e82153143bb13c33652772ba18c",
    "title": "Episode 50: Apple - Beats",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/94203e82153143bb13c33652772ba18c-3d5ea0322550/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/94203e82153143bb13c33652772ba18c-3d5ea0322550/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77590,
      "sha256": "f0193835b74bd4cfebf3481c28be96c99afb85b7046bd190dfb864e2285e4504",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.893Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/949d97c80354b9f25088c71bef4952ec": {
    "source_id": "acquired",
    "episode_id": "949d97c80354b9f25088c71bef4952ec",
    "title": "Episode 49: The Stitch Fix IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/949d97c80354b9f25088c71bef4952ec-2fce742127c3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/949d97c80354b9f25088c71bef4952ec-2fce742127c3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "59a40f78552c034992c6707abd5cdf25347b98bd1305d9480d7a431a69997cf4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.894Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/17b282957ae2aface09464d9f27b2080": {
    "source_id": "acquired",
    "episode_id": "17b282957ae2aface09464d9f27b2080",
    "title": "Episode 48: Qualcomm - Broadcom",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/17b282957ae2aface09464d9f27b2080-c5c1efa55781/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/17b282957ae2aface09464d9f27b2080-c5c1efa55781/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77596,
      "sha256": "309b3bd0e66ad106e11aa92f2acae86021f0f2ef74451f1a3bdeb39b08a24cc5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.772Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/9e31c6530f559e3bc5f47367a4bb57f7": {
    "source_id": "acquired",
    "episode_id": "9e31c6530f559e3bc5f47367a4bb57f7",
    "title": "Episode 47: The Atlassian IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9e31c6530f559e3bc5f47367a4bb57f7-3d6837e97903/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9e31c6530f559e3bc5f47367a4bb57f7-3d6837e97903/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77594,
      "sha256": "c12767cc80cf1b3580a41103d1866e3dfb7f618a84dc40038e906436476f00e9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.905Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ce2d97784d15b96f23bea5b5e67bdaab": {
    "source_id": "acquired",
    "episode_id": "ce2d97784d15b96f23bea5b5e67bdaab",
    "title": "Episode 46: Blue Bottle Coffee",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ce2d97784d15b96f23bea5b5e67bdaab-dbbf5952380f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ce2d97784d15b96f23bea5b5e67bdaab-dbbf5952380f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "485a01004a623ac02d5e08352630c862a0e059eb6338ff76ff9de5e6673cf485",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.929Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/07ecf09f9495b32c42ef13e0bce4b9cd": {
    "source_id": "acquired",
    "episode_id": "07ecf09f9495b32c42ef13e0bce4b9cd",
    "title": "Episode 45: HTC, Google and the Future of Mobile",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/07ecf09f9495b32c42ef13e0bce4b9cd-b8462cafdb72/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/07ecf09f9495b32c42ef13e0bce4b9cd-b8462cafdb72/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77612,
      "sha256": "9379d1147e8df3efbbf5bbb5a2aa02a7b7553fbe6f4d026461c35f0830a1639a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.757Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/569044e65797645aab2d567103eb86d1": {
    "source_id": "acquired",
    "episode_id": "569044e65797645aab2d567103eb86d1",
    "title": "Episode 44: AOL - Time Warner (with the Internet History Podcast)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/569044e65797645aab2d567103eb86d1-70d7fccb70c5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/569044e65797645aab2d567103eb86d1-70d7fccb70c5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77629,
      "sha256": "285c9abf405e610b83cbdcd555eadaf15e922a7c644bcf81691a5136c331b018",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.828Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/292f038fae4ada71ef78c03a7901fade": {
    "source_id": "acquired",
    "episode_id": "292f038fae4ada71ef78c03a7901fade",
    "title": "Episode 43: The Square IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/292f038fae4ada71ef78c03a7901fade-d8bcb3a8650b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/292f038fae4ada71ef78c03a7901fade-d8bcb3a8650b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77590,
      "sha256": "e4b7f775e100e6f1402ed08e48069da073099c20b7dee9ce4604a8b4fc5831fb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.787Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/534543aa021937948e841f1aadad648e": {
    "source_id": "acquired",
    "episode_id": "534543aa021937948e841f1aadad648e",
    "title": "Episode 42: Opsware (with special guest Michel Feaster)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/534543aa021937948e841f1aadad648e-0f3d7943b27f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/534543aa021937948e841f1aadad648e-0f3d7943b27f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77619,
      "sha256": "3d189c78965ba09ad1d8cbcf2cdf2088d70077a7356af1848fb878ee24048fc0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.825Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1e7c62859076f3599addc29c4b8a556a": {
    "source_id": "acquired",
    "episode_id": "1e7c62859076f3599addc29c4b8a556a",
    "title": "Episode 41: Booking.com with Jetsetter & Room 77 CEO Drew Patterson",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1e7c62859076f3599addc29c4b8a556a-5aca36a1abc7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1e7c62859076f3599addc29c4b8a556a-5aca36a1abc7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77631,
      "sha256": "077f9b3a3c650b8fcf38a6c140c8ea5df308eca2fc7d357a887ae4105ef21d07",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.778Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/47b59f963dbd24d97ae0c221dd06dbbf": {
    "source_id": "acquired",
    "episode_id": "47b59f963dbd24d97ae0c221dd06dbbf",
    "title": "Episode 40: Activision Blizzard",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/47b59f963dbd24d97ae0c221dd06dbbf-e260aacec401/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/47b59f963dbd24d97ae0c221dd06dbbf-e260aacec401/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77595,
      "sha256": "951a821ca89afd0ca4de9633f90d78dd6587248adf6ec78b2a114dcd3120fe13",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.818Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/6110817b7a307f71e006c185957e748d": {
    "source_id": "acquired",
    "episode_id": "6110817b7a307f71e006c185957e748d",
    "title": "Acquired Episode 39: Whole Foods Market",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/6110817b7a307f71e006c185957e748d-823c43f205e2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/6110817b7a307f71e006c185957e748d-823c43f205e2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77603,
      "sha256": "e6ff085d14714ff19201851630f3c29bea3a4bd78f0f9817bed7e6273a49ff60",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.840Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/228041908b7dc87ea04acd97689e86f7": {
    "source_id": "acquired",
    "episode_id": "228041908b7dc87ea04acd97689e86f7",
    "title": "Acquired Episode 38: SoundJam (iTunes)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/228041908b7dc87ea04acd97689e86f7-ddde6cf7946e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/228041908b7dc87ea04acd97689e86f7-ddde6cf7946e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77602,
      "sha256": "09e5e2cbd2f73cedfcaee7ec70390308a3ba0e03a4dbdd031db454523d65af72",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.781Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/c9e049094f6acfdcda0758567b3562f2": {
    "source_id": "acquired",
    "episode_id": "c9e049094f6acfdcda0758567b3562f2",
    "title": "Episode 37: BAMTech, Disney and \"the Biggest Media Company You've Never Heard Of”",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/c9e049094f6acfdcda0758567b3562f2-ff52a4e8d992/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/c9e049094f6acfdcda0758567b3562f2-ff52a4e8d992/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77647,
      "sha256": "1d952dc306cbd8ba504fc7f84b1d0d9d2227939c3fa7280fbbedc10f81524fc8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.924Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/363897dbca765a8a322ebec4e942d117": {
    "source_id": "acquired",
    "episode_id": "363897dbca765a8a322ebec4e942d117",
    "title": "Episode 36: The LA Clippers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/363897dbca765a8a322ebec4e942d117-cfc5f9df46d8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/363897dbca765a8a322ebec4e942d117-cfc5f9df46d8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77591,
      "sha256": "011f5ded0982f42d9c643b75cc70b6ba913526c26ecffce7d115affab8ff19e0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.792Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/e09d7e108acd1da5b24960bd1bc9c0da": {
    "source_id": "acquired",
    "episode_id": "e09d7e108acd1da5b24960bd1bc9c0da",
    "title": "Episode 35: Oculus",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e09d7e108acd1da5b24960bd1bc9c0da-50f71650ab6a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e09d7e108acd1da5b24960bd1bc9c0da-50f71650ab6a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77582,
      "sha256": "067a30c46cc741ad38e9a2a851a65fb745b0bbf6953182c68e7529cfd2a03cec",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.941Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1c82fdabf576907bdb180a3a9c76cb2b": {
    "source_id": "acquired",
    "episode_id": "1c82fdabf576907bdb180a3a9c76cb2b",
    "title": "Episode 34: The Starbucks IPO with Dan Levitan",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1c82fdabf576907bdb180a3a9c76cb2b-7d693be62bff/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1c82fdabf576907bdb180a3a9c76cb2b-7d693be62bff/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77610,
      "sha256": "978f934cc8f3efc1f7c4d164ba566af99c2819b2acf1f89dc8f6634872feb816",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.775Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/fd0f4766b1d58a916974432c83e006ed": {
    "source_id": "acquired",
    "episode_id": "fd0f4766b1d58a916974432c83e006ed",
    "title": "Episode 33: Overture (with the Internet History Podcast!)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/fd0f4766b1d58a916974432c83e006ed-e821d4eec490/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/fd0f4766b1d58a916974432c83e006ed-e821d4eec490/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77621,
      "sha256": "159ad273eaf55b813e8d3beeecd391772524285c29ba83b9035f5c7a7ee76002",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.959Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/dddc14e15f5ec36c881d8c4f8dea253f": {
    "source_id": "acquired",
    "episode_id": "dddc14e15f5ec36c881d8c4f8dea253f",
    "title": "Episode 32: The Snap Inc. IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/dddc14e15f5ec36c881d8c4f8dea253f-b60e7e50e71a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/dddc14e15f5ec36c881d8c4f8dea253f-b60e7e50e71a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77593,
      "sha256": "60c84a2d2458c9ce8198091b0ff848191edd1e3778b47fd48e87c3cbd43f0fcf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.940Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8a8864e11e522d3a575e983edf8514e9": {
    "source_id": "acquired",
    "episode_id": "8a8864e11e522d3a575e983edf8514e9",
    "title": "Episode 31: The Uber - Didi Chuxing Merger with Brad Stone, author of The Upstarts & The Everything Store",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8a8864e11e522d3a575e983edf8514e9-553bd324bfad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8a8864e11e522d3a575e983edf8514e9-553bd324bfad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77669,
      "sha256": "cabb0cafd497ab74030e1ab9fa77cdc50777e0c02fbbd126646e8711679ba29c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.885Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/9f9fae79191f018c9b046e80aa5c8f08": {
    "source_id": "acquired",
    "episode_id": "9f9fae79191f018c9b046e80aa5c8f08",
    "title": "Episode 30: P.A. Semi + AuthenTec",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9f9fae79191f018c9b046e80aa5c8f08-016b7ed9030b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9f9fae79191f018c9b046e80aa5c8f08-016b7ed9030b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77597,
      "sha256": "098c10afcaf400984c5fc34330e88ab8bce21617ef2b250262a01c841de241e2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.907Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/07ab28f3ad805b7c3da7f73d54ee6ff6": {
    "source_id": "acquired",
    "episode_id": "07ab28f3ad805b7c3da7f73d54ee6ff6",
    "title": "Episode 29: Special—2016 Review and 2017 Predictions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/07ab28f3ad805b7c3da7f73d54ee6ff6-281b0d22862e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/07ab28f3ad805b7c3da7f73d54ee6ff6-281b0d22862e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77618,
      "sha256": "18f6333b9ed78acc82d2a08656acac165cccd86698dc0bf2e5fe45d80218f4d7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.756Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ce0f631b88279373f58d2e4da4c63130": {
    "source_id": "acquired",
    "episode_id": "ce0f631b88279373f58d2e4da4c63130",
    "title": "Episode 28: The Amazon IPO with original Amazon Board Member Tom Alberg",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ce0f631b88279373f58d2e4da4c63130-ec1fc7fef37b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ce0f631b88279373f58d2e4da4c63130-ec1fc7fef37b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77635,
      "sha256": "a228a3f0e775ddd60cad14d5850a2865f8c4846c3103d296721b233b9c6864db",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.928Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/48489fc999f2bed317b70af394ab81aa": {
    "source_id": "acquired",
    "episode_id": "48489fc999f2bed317b70af394ab81aa",
    "title": "Episode 27: Special—A Conversation with Microsoft's Head of Strategic Investments Brian Schultz",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/48489fc999f2bed317b70af394ab81aa-31c892ea91e7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/48489fc999f2bed317b70af394ab81aa-31c892ea91e7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77661,
      "sha256": "47ba9c1e6496381c866341855f90dca3742cb8b8c90ccd60ec2c867e39307b3a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.820Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1258283aa330be78a9f27907377a499e": {
    "source_id": "acquired",
    "episode_id": "1258283aa330be78a9f27907377a499e",
    "title": "Episode 26: Marvel",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1258283aa330be78a9f27907377a499e-45f4d5a7bc63/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1258283aa330be78a9f27907377a499e-45f4d5a7bc63/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77582,
      "sha256": "6c7e4007ad5c144ada201fa3cd2e5817aed301e7c50296d774c13b52bbe197d7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.769Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/47835eb18a0c70fa1eaf5690e186fb9c": {
    "source_id": "acquired",
    "episode_id": "47835eb18a0c70fa1eaf5690e186fb9c",
    "title": "Episode 25: The Facebook IPO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/47835eb18a0c70fa1eaf5690e186fb9c-a0f0f7718a91/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/47835eb18a0c70fa1eaf5690e186fb9c-a0f0f7718a91/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77592,
      "sha256": "9802e5a024e1f42473ca765c8ca1cba2c137fa196be492b8a2c068f8769dc993",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.817Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/1c93f39fb8953d06e7049fc015271a67": {
    "source_id": "acquired",
    "episode_id": "1c93f39fb8953d06e7049fc015271a67",
    "title": "Episode 24: Skype",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/1c93f39fb8953d06e7049fc015271a67-d46d23adef73/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/1c93f39fb8953d06e7049fc015271a67-d46d23adef73/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77581,
      "sha256": "0b9504a882e68d96575690250034bf8e48a890fceb653816d6bf5ac4c791ea36",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.775Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8f5833ea04c81885fc1c4cf10e6a4a18": {
    "source_id": "acquired",
    "episode_id": "8f5833ea04c81885fc1c4cf10e6a4a18",
    "title": "Episode 23: NeXT (Live show at the GeekWire Summit)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8f5833ea04c81885fc1c4cf10e6a4a18-9323f822fe33/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8f5833ea04c81885fc1c4cf10e6a4a18-9323f822fe33/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77615,
      "sha256": "30fb2832fd550354be03d300d1f6c6c2d956f7a39534144d95778cf32525ceac",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.890Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/559d8432a44217b12157efdf50b3485f": {
    "source_id": "acquired",
    "episode_id": "559d8432a44217b12157efdf50b3485f",
    "title": "Episode 22: Zillow + Trulia (with Zillow Group CFO Kathleen Philips)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/559d8432a44217b12157efdf50b3485f-905bcb8e4181/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/559d8432a44217b12157efdf50b3485f-905bcb8e4181/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77632,
      "sha256": "dd376586c8f3058b2e5691b94dc84b7eeb64ba0592a4dc4979b83b23adf28dc4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.827Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/0892e3d76c8e4e1591f9b2c695106589": {
    "source_id": "acquired",
    "episode_id": "0892e3d76c8e4e1591f9b2c695106589",
    "title": "Episode 21: Inside the M&A Press with Bloomberg's Alex Sherman",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/0892e3d76c8e4e1591f9b2c695106589-e5167b696a46/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/0892e3d76c8e4e1591f9b2c695106589-e5167b696a46/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77626,
      "sha256": "49dcd00c9bddf76bd6a3660ab4a8b1a329cad9544e781e5022abc05c279d92dd",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.759Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/063b9a9232c2b2ac46faa9960dc5288f": {
    "source_id": "acquired",
    "episode_id": "063b9a9232c2b2ac46faa9960dc5288f",
    "title": "Episode 20: Android",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/063b9a9232c2b2ac46faa9960dc5288f-049e395ad761/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/063b9a9232c2b2ac46faa9960dc5288f-049e395ad761/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77583,
      "sha256": "8b6f3e1ec9f806906934bcd58d224b3311849f6768427e0e6a1293801b42f567",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.755Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/bd91e1672954bd92af237c84787c8ec4": {
    "source_id": "acquired",
    "episode_id": "bd91e1672954bd92af237c84787c8ec4",
    "title": "Episode 19: Jet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/bd91e1672954bd92af237c84787c8ec4-b2f47f89e4c1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/bd91e1672954bd92af237c84787c8ec4-b2f47f89e4c1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77579,
      "sha256": "a6399de7df7cb9a2dee904f9ec2eccee1e1b642c58210abe74a1bbdc37b6dabd",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.920Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/456e8967279ba511a9db49283cbb92d6": {
    "source_id": "acquired",
    "episode_id": "456e8967279ba511a9db49283cbb92d6",
    "title": "Episode 18: Special—An Acquirer’s View into M&A with Taylor Barada, head of Corp Dev at Adobe",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/456e8967279ba511a9db49283cbb92d6-1c586b07666a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/456e8967279ba511a9db49283cbb92d6-1c586b07666a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77661,
      "sha256": "2ea5bc019f4786cac4eadac1ff6df93c6d33e211f721d4846f9a82510f9618d5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.816Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/9b046e7c1d8038f83d04161597933347": {
    "source_id": "acquired",
    "episode_id": "9b046e7c1d8038f83d04161597933347",
    "title": "Acquired Episode 17: Waze",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/9b046e7c1d8038f83d04161597933347-e751a10dc07e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/9b046e7c1d8038f83d04161597933347-e751a10dc07e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77589,
      "sha256": "d45e32cab4cc70d70185092d2c44770c9f3c765b85f5f3e0fc3e848cccc6bac1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.904Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f59fb0d63ec187c0409fe9d82c003964": {
    "source_id": "acquired",
    "episode_id": "f59fb0d63ec187c0409fe9d82c003964",
    "title": "Acquired Episode 16: Midroll + Stitcher (acquired by Scripps)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f59fb0d63ec187c0409fe9d82c003964-f87beba4e9a7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f59fb0d63ec187c0409fe9d82c003964-f87beba4e9a7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77625,
      "sha256": "1a665bcd07a6bf83b68f8baefae72c982c879f179490ebc731ac6244a0a04fcf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.953Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/985823cf8bee8f13f9511c184af852c2": {
    "source_id": "acquired",
    "episode_id": "985823cf8bee8f13f9511c184af852c2",
    "title": "Acquired Episode 15: ExactTarget (acquired by Salesforce) with Scott Dorsey",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/985823cf8bee8f13f9511c184af852c2-6066b4f43639/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/985823cf8bee8f13f9511c184af852c2-6066b4f43639/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77639,
      "sha256": "ed5695a4d39e37466b10ccb16489a47b4aa390b71876475837d02a293b6ae6ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.901Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b844f25d48ba472fa009277bb46b336d": {
    "source_id": "acquired",
    "episode_id": "b844f25d48ba472fa009277bb46b336d",
    "title": "Episode 14: LinkedIn",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b844f25d48ba472fa009277bb46b336d-de4acfea6bad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b844f25d48ba472fa009277bb46b336d-de4acfea6bad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77584,
      "sha256": "576cdfd578921d9dfcf55f10769765865c2f770710dafdc91386dc46b90384fe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.919Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/aed73a50c078b6fca7a205c239ac0a8f": {
    "source_id": "acquired",
    "episode_id": "aed73a50c078b6fca7a205c239ac0a8f",
    "title": "Episode 13: Push Pop Press (Facebook Instant Articles) with Todd Bishop",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/aed73a50c078b6fca7a205c239ac0a8f-dab40734f36e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/aed73a50c078b6fca7a205c239ac0a8f-dab40734f36e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77635,
      "sha256": "b2b643fce9395d81d8abe45f1cab4c7849cfec0ee4aa61fae5f90f03fe1e3aba",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.913Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/8a793886869b7eea87ecc186db8525f6": {
    "source_id": "acquired",
    "episode_id": "8a793886869b7eea87ecc186db8525f6",
    "title": "Episode 12: Snapchat",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/8a793886869b7eea87ecc186db8525f6-cd7747fef582/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/8a793886869b7eea87ecc186db8525f6-cd7747fef582/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77584,
      "sha256": "0eca9d57cdaed6288ef2063a0b063c8d284e9242c54596a5087c334930b4f9bb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.884Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/ea5c32a13d18d098b8b76f4e33853535": {
    "source_id": "acquired",
    "episode_id": "ea5c32a13d18d098b8b76f4e33853535",
    "title": "Episode 11: PayPal",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/ea5c32a13d18d098b8b76f4e33853535-03e76c32d8d0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/ea5c32a13d18d098b8b76f4e33853535-03e76c32d8d0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77582,
      "sha256": "4944c059048a620b635674fff612986333d2717bbae3d632c9ad3804231a7694",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.944Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/b7caa0b30fc0a2536a1a2feab5f95fbf": {
    "source_id": "acquired",
    "episode_id": "b7caa0b30fc0a2536a1a2feab5f95fbf",
    "title": "Acquired Episode 10: Virgin America",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/b7caa0b30fc0a2536a1a2feab5f95fbf-1d920da11854/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/b7caa0b30fc0a2536a1a2feab5f95fbf-1d920da11854/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77599,
      "sha256": "3a0cc3b93b3becfb255e6976e1de01863e0839d9f8257aff15b3f98ee41bc2f3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.919Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/e2a1607ed8a140c2b3cec43e3aeb3deb": {
    "source_id": "acquired",
    "episode_id": "e2a1607ed8a140c2b3cec43e3aeb3deb",
    "title": "Episode 9: Writely (Google Docs)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/e2a1607ed8a140c2b3cec43e3aeb3deb-90e123d00842/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/e2a1607ed8a140c2b3cec43e3aeb3deb-90e123d00842/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77596,
      "sha256": "bf5c8aa36713d290ab1e52f7c3a1a8eae4a9cb939e969d2853046a90b563567d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.942Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/769092593be74c249d88e96189f0d105": {
    "source_id": "acquired",
    "episode_id": "769092593be74c249d88e96189f0d105",
    "title": "Episode 8: Acompli, Sunrise, and Wunderlist (w/ Kurt DelBene)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/769092593be74c249d88e96189f0d105-63c01df46125/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/769092593be74c249d88e96189f0d105-63c01df46125/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77625,
      "sha256": "3f60ef98b3d146c21235cb9273362988610305bbd42658c19d0562392ad9d902",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.853Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/23a8377b2bde49b88abc56c9ba1502da": {
    "source_id": "acquired",
    "episode_id": "23a8377b2bde49b88abc56c9ba1502da",
    "title": "Episode 7: YouTube",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/23a8377b2bde49b88abc56c9ba1502da-ec4a4f0445a3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/23a8377b2bde49b88abc56c9ba1502da-ec4a4f0445a3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77582,
      "sha256": "ea70ab0b8ec7c97c0d0de105663caba5173e6a24c7f85e7b7309daa9de27d5f0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.782Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/41de9a1f06ec4e5c8e80df4d05dc7ce3": {
    "source_id": "acquired",
    "episode_id": "41de9a1f06ec4e5c8e80df4d05dc7ce3",
    "title": "Episode 6: Lucasfilm",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/41de9a1f06ec4e5c8e80df4d05dc7ce3-a322e443eb22/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/41de9a1f06ec4e5c8e80df4d05dc7ce3-a322e443eb22/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77584,
      "sha256": "f3213483b7d88c76c6a5084e3ab7cf1f973c3e45506cb54271ee3a7c3f26142e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.813Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/f5f8c5af7f8444f595929d8e1a74b54d": {
    "source_id": "acquired",
    "episode_id": "f5f8c5af7f8444f595929d8e1a74b54d",
    "title": "Episode 5: Siri",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/f5f8c5af7f8444f595929d8e1a74b54d-1af8b72b322e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/f5f8c5af7f8444f595929d8e1a74b54d-1af8b72b322e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77579,
      "sha256": "341bafe7f8943f8ca1a0ccbeba02d1cec37788c9dab69bb2b05f774dfa6f5819",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.954Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/d77bb7b9cdad4292b2831def25aa1d90": {
    "source_id": "acquired",
    "episode_id": "d77bb7b9cdad4292b2831def25aa1d90",
    "title": "Episode 4: Bungie (with Xbox Co-Founder Ed Fries)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/d77bb7b9cdad4292b2831def25aa1d90-52e274a8f574/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/d77bb7b9cdad4292b2831def25aa1d90-52e274a8f574/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77613,
      "sha256": "ce7629a66f8687b1b9037d2eb65190441b977268a3710983f087915f0e875abf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.933Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/755f4e36a056482aaca897fde45a9989": {
    "source_id": "acquired",
    "episode_id": "755f4e36a056482aaca897fde45a9989",
    "title": "Episode 3: Twitch",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/755f4e36a056482aaca897fde45a9989-334a626b095c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/755f4e36a056482aaca897fde45a9989-334a626b095c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77581,
      "sha256": "7cbf18b593e464fb3832a3dd9bc8cb98365498401b6d20a86339bbaaac02f450",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.852Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/242a738f9c0c4acf81edc6b22287a95c": {
    "source_id": "acquired",
    "episode_id": "242a738f9c0c4acf81edc6b22287a95c",
    "title": "Episode 2: Instagram",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/242a738f9c0c4acf81edc6b22287a95c-49b9dc73792e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/242a738f9c0c4acf81edc6b22287a95c-49b9dc73792e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77584,
      "sha256": "e57487e0032938ffdd1cb9bbf2a6db1ccc324fc130a65eca073d625b8cc25406",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.783Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "acquired/c42b01bab0f14dfc8ed136c3066bbffc": {
    "source_id": "acquired",
    "episode_id": "c42b01bab0f14dfc8ed136c3066bbffc",
    "title": "Episode 1: Pixar",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/acquired-7bcde334bfa6/c42b01bab0f14dfc8ed136c3066bbffc-a97c3d6e4d25/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/acquired-7bcde334bfa6/c42b01bab0f14dfc8ed136c3066bbffc-a97c3d6e4d25/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77580,
      "sha256": "c2a5b9bf5599db0d435ebb1ba6ad7e927697f66e1e19b2bd81a93bea20c131a7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:30.922Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ai-a16z/5989354b-c3fe-4aad-aa08-fb20e5f33656": {
    "source_id": "ai-a16z",
    "episode_id": "5989354b-c3fe-4aad-aa08-fb20e5f33656",
    "title": "AI Infrastructure, Distribution, and the Next Wave of Software",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53692,
      "sha256": "bbd215f2e3b4cebbfb9f5aeb75b69eaddc80885cd60b4998ba1a0598d2827a09",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 381,
      "updated_at": "2026-06-09T13:39:30.967Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 91933,
      "sha256": "64bed30fe72bf3f8f879610458d4b748f9e331719edde66e03f22c2efb97212b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T08:05:18.965Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/5989354b-c3fe-4aad-aa08-fb20e5f33656-c80c0bb5dec4/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 202083,
      "sha256": "8b647d972526f01dc51c7d9dd5d00d3966deb5a0f3e02808b04241c3908c88e8",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:30:53.334Z"
    }
  },
  "ai-a16z/2f551b1d-9baf-4861-b1ba-01422b837920": {
    "source_id": "ai-a16z",
    "episode_id": "2f551b1d-9baf-4861-b1ba-01422b837920",
    "title": "The Agent Era: Building Software Beyond Chat with Box CEO Aaron Levie",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 107543,
      "sha256": "58ccd8089d8986ae1e75aa9d42f9cf07e280a12a151c2d5ec05a948ea01e9760",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1093,
      "updated_at": "2026-06-09T13:39:30.963Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 120563,
      "sha256": "b8ecb53a983dfbcd016a449027e2002a9501ecc1390071dbb98a3e14e5dd1645",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T11:30:35.568Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/2f551b1d-9baf-4861-b1ba-01422b837920-9af93536c67c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 221178,
      "sha256": "8bc13b32b92a97ccf38accc2eba24416f0dd02b9d3d50111cf81a3df51a7d882",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:32:27.996Z"
    }
  },
  "ai-a16z/921579e0-e8d0-45e9-b04b-7385f5b57620": {
    "source_id": "ai-a16z",
    "episode_id": "921579e0-e8d0-45e9-b04b-7385f5b57620",
    "title": "How AI Is Reshaping IT Services from the Inside",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48343,
      "sha256": "57abc1fe9fcb8367f93ccd0eef73bd90196cd09a42403e1959c2166c487c32ec",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 386,
      "updated_at": "2026-06-09T13:39:30.969Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41071,
      "sha256": "041688b476b30d201dc9ec5775c45431331192fb27d710790863dde1de0f80f5",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-20T03:46:21.104Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/921579e0-e8d0-45e9-b04b-7385f5b57620-9e8f5612c904/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 36708,
      "sha256": "1585166ee0765fd7cd6d1fe5b78a967fcbd5d78c28be9f2780f151c9259383cc",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-20T03:46:21.104Z"
    }
  },
  "ai-a16z/d87eb61a-181f-46a2-abbb-c7ed638956ed": {
    "source_id": "ai-a16z",
    "episode_id": "d87eb61a-181f-46a2-abbb-c7ed638956ed",
    "title": "Patrick Collison on Stripe’s Early Choices, Smalltalk, and What Comes After Coding",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83726,
      "sha256": "95d29b0df478ee68c4a3705b406290554f7d70e6e9a17610c77667450d432c31",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 855,
      "updated_at": "2026-06-09T13:39:30.971Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 105789,
      "sha256": "9649a42f1194027aaaa04233600f0485178ea19e4f4ec18ac4c0ac2a8bd5d2c6",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T12:01:02.779Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/d87eb61a-181f-46a2-abbb-c7ed638956ed-d2cd797c88e1/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 259906,
      "sha256": "125c042886aa36e76fe301d6998a7c19b32063c2fe147703e7e782d9862a1f5f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:32:27.820Z"
    }
  },
  "ai-a16z/9f0cc270-8126-435b-b3c8-866aeb99257f": {
    "source_id": "ai-a16z",
    "episode_id": "9f0cc270-8126-435b-b3c8-866aeb99257f",
    "title": "OpenClaw: Why the Internet Isn't Built for AI Agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82707,
      "sha256": "d9a288dd23d253fe0b04fe03350f03c3b8ed434e46e14d07b293de8ed43cd1c2",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 816,
      "updated_at": "2026-06-09T13:39:30.970Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100476,
      "sha256": "508c39f85e75f0bea596bd7810ed08b4798f5b388ac7bd5466884cc7ecdb09be",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T09:54:21.977Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/9f0cc270-8126-435b-b3c8-866aeb99257f-fe62931ff1d8/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 211342,
      "sha256": "913512ac3911ac8825ef5ed98f6fa106f99b15601848bfbc0438fc90598520ed",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:30:53.524Z"
    }
  },
  "ai-a16z/51b10f8c-13d1-4366-bb72-432c01aa2bbd": {
    "source_id": "ai-a16z",
    "episode_id": "51b10f8c-13d1-4366-bb72-432c01aa2bbd",
    "title": "What's Missing Between LLMs and AGI - Vishal Misra & Martin Casado",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66804,
      "sha256": "0e1456b91849222e950ffd635c357faf466cefb498654e709abd4ac54482f625",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 678,
      "updated_at": "2026-06-09T13:39:30.966Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99599,
      "sha256": "7a84311b778f085e48258213e8a024528b4c1a1e5bed4ffc2ad8f87432d74f17",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T08:29:48.103Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/51b10f8c-13d1-4366-bb72-432c01aa2bbd-e6a89a32e37e/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 122993,
      "sha256": "f8be418d558f52b28a6cccc36b959f27fb0a1556b54d029e3d15d2673eb774ed",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T08:29:48.098Z"
    }
  },
  "ai-a16z/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e": {
    "source_id": "ai-a16z",
    "episode_id": "8beebac5-d54e-43f1-ac2e-dbfb233fbd2e",
    "title": "Replit's CEO on Vibe Coding, Wealth Building, and What Most People Get Wrong About AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 126065,
      "sha256": "52e7ded47dd8b4b79baa2312f7a7db2dfa47aeb4c59f3f5e5413fd49d95f8567",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1050,
      "updated_at": "2026-06-09T13:39:30.968Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 142797,
      "sha256": "7b3975cb691a56f9327bf0ed2cf2419954714421d579b4b690f23e9964b7ae58",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T09:24:35.481Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/8beebac5-d54e-43f1-ac2e-dbfb233fbd2e-ff9db6631554/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 266690,
      "sha256": "4574214147d898d20ce23b6e122a67ef139519027757e045a4a458cb92123956",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:30:53.661Z"
    }
  },
  "ai-a16z/1c9f6a89-1949-4073-bd9b-cdbc9fed660a": {
    "source_id": "ai-a16z",
    "episode_id": "1c9f6a89-1949-4073-bd9b-cdbc9fed660a",
    "title": "Jack Altman & Martin Casado on the Future of VC",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 90668,
      "sha256": "2ad9b982b6b23242c803bd919635727c8cd5f12d0fbeef0bc4f12ab7bd6197da",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 857,
      "updated_at": "2026-06-09T13:39:30.962Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 112119,
      "sha256": "425088aa6c98c39a9faa0b835cb3d0ce42f90fc18dbac23e54caafbb64950599",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T12:52:33.211Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1c9f6a89-1949-4073-bd9b-cdbc9fed660a-993bac2811bc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 212449,
      "sha256": "56304a5746ed98be38be7ad467040f8b93901f24e053573f3320ba7bb04207f9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:30:53.473Z"
    }
  },
  "ai-a16z/1286e4d6-4e66-48f4-a651-fe5f7ef37a52": {
    "source_id": "ai-a16z",
    "episode_id": "1286e4d6-4e66-48f4-a651-fe5f7ef37a52",
    "title": "Durable Execution and the Infrastructure Powering AI Agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 86348,
      "sha256": "ae9a6fddaa1dfc0293da10736f17dec2dc6df7f73ac3aa325f2fffe698388fa1",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 752,
      "updated_at": "2026-06-09T13:39:30.961Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 101011,
      "sha256": "c219487871259d739a4c7786caeab2a8c4b81b42eb805ff4f08620599e33167f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T10:24:00.296Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/1286e4d6-4e66-48f4-a651-fe5f7ef37a52-d6254294e0d0/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 196654,
      "sha256": "c431e4f3c7a96048f9648c0321ac0aeb0d98f24d2f7b315619f56705d4073e1e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-19T13:30:53.390Z"
    }
  },
  "ai-a16z/43efd0a1-d1f3-4741-97d6-d5a2234b563c": {
    "source_id": "ai-a16z",
    "episode_id": "43efd0a1-d1f3-4741-97d6-d5a2234b563c",
    "title": "Sam Altman on Sora, Energy, and Building an AI Empire",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82755,
      "sha256": "5083e12a6dbea078e55218ac21a133e3cfc2ce600d0347ff2e6a12e438658726",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 928,
      "updated_at": "2026-06-09T13:39:30.965Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 101311,
      "sha256": "7466ba97929b19dc755fa5c55cd79ca353930a4dce7c06272243e65b67133635",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-20T05:54:36.756Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/43efd0a1-d1f3-4741-97d6-d5a2234b563c-77e7469f7899/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 232686,
      "sha256": "b1585ad2ff2f7953b5dd0566ae7e004139a53edf07b3487da65e60c2882fa6fa",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-20T05:54:36.756Z"
    }
  },
  "ai-a16z/7b6738ca-a088-449f-9ea9-72419b1e28a3": {
    "source_id": "ai-a16z",
    "episode_id": "7b6738ca-a088-449f-9ea9-72419b1e28a3",
    "title": "Why This Isn't the Dot-Com Bubble | Martin Casado on WSJ's BOLD NAMES",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42112,
      "sha256": "e5450510eb6418309576b1afd876d732e1304b2124fd49be9187f47444655c53",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 358,
      "updated_at": "2026-06-09T13:39:30.968Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37421,
      "sha256": "fcc6a025561fcac7e398655ff4166368786792d8db585b2faf37607469d6b6bb",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-19T12:18:46.058Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/7b6738ca-a088-449f-9ea9-72419b1e28a3-9b96e2edcda5/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 25086,
      "sha256": "81ccbfc7203875b64b2c2d6261add45af9c194c5355813eb5cf054058b8757e4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-19T12:18:46.057Z"
    }
  },
  "ai-a16z/33e5ce92-78fa-4754-8dcd-dea0f774955f": {
    "source_id": "ai-a16z",
    "episode_id": "33e5ce92-78fa-4754-8dcd-dea0f774955f",
    "title": "Feed Drop from The Generalist: Why a16z's Martin Casado believes the AI boom still has years to run",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 123982,
      "sha256": "460d8903006e1198b3d80d20151c2bb6c2e42489e6764a9892be2aaa8911cf46",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1181,
      "updated_at": "2026-06-09T13:39:30.964Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 132806,
      "sha256": "d624c7453dea2f7d4a43ac48a0fcab42cd2f7610315001d9757b2ca2771c457c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-20T00:20:55.593Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/ai-a16z-eca7a14e77cf/33e5ce92-78fa-4754-8dcd-dea0f774955f-e01be0fa1b56/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 231869,
      "sha256": "31e6eb1a67b5a81dfaefaa310e8177ce4d7df65ec2dec823ec80b76bbaf389e9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-20T00:20:55.592Z"
    }
  },
  "decoder/84e74054-be7b-11f0-a56a-1b2c7ac4862d": {
    "source_id": "decoder",
    "episode_id": "84e74054-be7b-11f0-a56a-1b2c7ac4862d",
    "title": "How companies weaponize the terms of service against you",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/84e74054-be7b-11f0-a56a-1b2c7ac4862d-562aa33e74c7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/84e74054-be7b-11f0-a56a-1b2c7ac4862d-562aa33e74c7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67866,
      "sha256": "fc6c2a7f8593f2002b2922bc4a28a46a38294327ad8de2b4f0a0181256df8aae",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 180,
      "updated_at": "2026-06-09T13:39:31.005Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/84c17130-be7b-11f0-a56a-03025de97f84": {
    "source_id": "decoder",
    "episode_id": "84c17130-be7b-11f0-a56a-03025de97f84",
    "title": "Joanna Stern is not a robot, but she lived with them",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/84c17130-be7b-11f0-a56a-03025de97f84-8ec2e1c75e61/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/84c17130-be7b-11f0-a56a-03025de97f84-8ec2e1c75e61/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 20097,
      "sha256": "c024207d492760193ef9fa4f79385df95d7c88e51b86764f3b2cdfcf543c80bc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 50,
      "updated_at": "2026-06-09T13:39:31.004Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/84765b14-be7b-11f0-a56a-53febd1fc9d0": {
    "source_id": "decoder",
    "episode_id": "84765b14-be7b-11f0-a56a-53febd1fc9d0",
    "title": "Dara Khosrowshahi on replacing Uber drivers — and himself — with AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/84765b14-be7b-11f0-a56a-53febd1fc9d0-0104efc529df/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/84765b14-be7b-11f0-a56a-53febd1fc9d0-0104efc529df/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34811,
      "sha256": "5e63c5ec840b49b0123277a5ef3b034df33dc5c9924c83d3fac284271ddcb85d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 104,
      "updated_at": "2026-06-09T13:39:31.003Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/84553e5c-be7b-11f0-a56a-b36a1afa84b0": {
    "source_id": "decoder",
    "episode_id": "84553e5c-be7b-11f0-a56a-b36a1afa84b0",
    "title": "How to win — or lose — Decoder",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/84553e5c-be7b-11f0-a56a-b36a1afa84b0-edd4e01a63b5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/84553e5c-be7b-11f0-a56a-b36a1afa84b0-edd4e01a63b5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 4084,
      "sha256": "00ddbbf15fdedc4ecb216eacde8472e33125941e6e7be8b4f04ea2d18b2d2dcb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 20,
      "updated_at": "2026-06-09T13:39:31.002Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/84330832-be7b-11f0-a56a-934579470eb3": {
    "source_id": "decoder",
    "episode_id": "84330832-be7b-11f0-a56a-934579470eb3",
    "title": "That UL safety logo is a lot more complicated than it looks",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/84330832-be7b-11f0-a56a-934579470eb3-a544e0304d4e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/84330832-be7b-11f0-a56a-934579470eb3-a544e0304d4e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 4284,
      "sha256": "4ddecec603369dd6a3e196a32a16ec271109dc580d8921008e0b486c1987ef13",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 28,
      "updated_at": "2026-06-09T13:39:31.002Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/83ec9640-be7b-11f0-a56a-bfa3ae0b63fb": {
    "source_id": "decoder",
    "episode_id": "83ec9640-be7b-11f0-a56a-bfa3ae0b63fb",
    "title": "Canva's CEO on its big pivot to AI enterprise software",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/83ec9640-be7b-11f0-a56a-bfa3ae0b63fb-890a1edebd60/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/83ec9640-be7b-11f0-a56a-bfa3ae0b63fb-890a1edebd60/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67071,
      "sha256": "19a191b6d2f68a7f8ff1ad9e1545e6f66a79071c794bbf205476e59ed9648b21",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 191,
      "updated_at": "2026-06-09T13:39:31.001Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/83cad0dc-be7b-11f0-a56a-6ba9a189ce1c": {
    "source_id": "decoder",
    "episode_id": "83cad0dc-be7b-11f0-a56a-6ba9a189ce1c",
    "title": "Ronan Farrow on Sam Altman's \"unconstrained\" relationship with the truth",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/83cad0dc-be7b-11f0-a56a-6ba9a189ce1c-8ae66fcb705a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/83cad0dc-be7b-11f0-a56a-6ba9a189ce1c-8ae66fcb705a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54258,
      "sha256": "1b4ca6a2eee2b7d15b3a4641de2bbc8533cd0275295a5d3a58e96abb63cc0965",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.001Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/83619554-be7b-11f0-a56a-a311da853d5a": {
    "source_id": "decoder",
    "episode_id": "83619554-be7b-11f0-a56a-a311da853d5a",
    "title": "Cisco CEO Chuck Robbins wants data centers in space",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/83619554-be7b-11f0-a56a-a311da853d5a-d2b2a537160d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/83619554-be7b-11f0-a56a-a311da853d5a-d2b2a537160d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68059,
      "sha256": "d629b1d5fb12a371ba40bd51bfb009605bc469df4fd42be9f51a7479a9dc5b96",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 148,
      "updated_at": "2026-06-09T13:39:31.000Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c26ec260-a938-11f0-a3e7-43e3e87b1c4a": {
    "source_id": "decoder",
    "episode_id": "c26ec260-a938-11f0-a3e7-43e3e87b1c4a",
    "title": "Confronting the CEO of the AI company that impersonated me",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c26ec260-a938-11f0-a3e7-43e3e87b1c4a-272addd7d400/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c26ec260-a938-11f0-a3e7-43e3e87b1c4a-272addd7d400/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 80051,
      "sha256": "ab2dff0b57a1be538e6d2637a75c4e860ff5d08212cbb6d08e670524d243fdbe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 258,
      "updated_at": "2026-06-09T13:39:31.034Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c22511c4-a938-11f0-a3e7-afe3094ed3a1": {
    "source_id": "decoder",
    "episode_id": "c22511c4-a938-11f0-a3e7-afe3094ed3a1",
    "title": "Hasbro's CEO lets AI Peppa Pig help design toys",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c22511c4-a938-11f0-a3e7-afe3094ed3a1-285b2db7eca2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c22511c4-a938-11f0-a3e7-afe3094ed3a1-285b2db7eca2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67236,
      "sha256": "1eaac3f16339f7de5b629509f58c0158690985e8fff6bbf7052115d1c5661968",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 141,
      "updated_at": "2026-06-09T13:39:31.033Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c1ff5b5a-a938-11f0-a3e7-374907ae7e8d": {
    "source_id": "decoder",
    "episode_id": "c1ff5b5a-a938-11f0-a3e7-374907ae7e8d",
    "title": "Zillow's CEO on growth during a housing crisis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c1ff5b5a-a938-11f0-a3e7-374907ae7e8d-404493f84f2e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c1ff5b5a-a938-11f0-a3e7-374907ae7e8d-404493f84f2e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71175,
      "sha256": "4d42c701ddea4f340835043dc0105856e26603a047ac6e0ecc7721b5c0f1f444",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 151,
      "updated_at": "2026-06-09T13:39:31.032Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c1df71aa-a938-11f0-a3e7-7bc7866aaa5d": {
    "source_id": "decoder",
    "episode_id": "c1df71aa-a938-11f0-a3e7-7bc7866aaa5d",
    "title": "Inside Xbox's executive shakeup",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c1df71aa-a938-11f0-a3e7-7bc7866aaa5d-389b46b42534/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c1df71aa-a938-11f0-a3e7-7bc7866aaa5d-389b46b42534/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37783,
      "sha256": "e225b12ae6ec3917dcc60b629889a5ac5e7811601cd90ea17bb6bd7b883e7055",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 116,
      "updated_at": "2026-06-09T13:39:31.032Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c13c179e-a938-11f0-a3e7-933e43244997": {
    "source_id": "decoder",
    "episode_id": "c13c179e-a938-11f0-a3e7-933e43244997",
    "title": "Hank Green lets loose on YouTube, billionaires, and algorithms",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c13c179e-a938-11f0-a3e7-933e43244997-f57b847be8b6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c13c179e-a938-11f0-a3e7-933e43244997-f57b847be8b6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64488,
      "sha256": "24717688b58603bfaa0af19106414520945a7403d39b91dd3e8d54f1d12d5cbf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 197,
      "updated_at": "2026-06-09T13:39:31.027Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/6c426ba0-0908-11f1-b6fc-4b799d354440": {
    "source_id": "decoder",
    "episode_id": "6c426ba0-0908-11f1-b6fc-4b799d354440",
    "title": "Let's talk about Ring, lost dogs, and the surveillance state",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6c426ba0-0908-11f1-b6fc-4b799d354440-8edd356b3eb5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6c426ba0-0908-11f1-b6fc-4b799d354440-8edd356b3eb5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 70738,
      "sha256": "eb8e0c1aceebce4c3908c4ae67c6b58cb2ac16b59bd0e970ec764bda2a467e88",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 176,
      "updated_at": "2026-06-09T13:39:30.998Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c1885046-a938-11f0-a3e7-03664a261404": {
    "source_id": "decoder",
    "episode_id": "c1885046-a938-11f0-a3e7-03664a261404",
    "title": "The surprising case for AI judges",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c1885046-a938-11f0-a3e7-03664a261404-a9ffa9608768/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c1885046-a938-11f0-a3e7-03664a261404-a9ffa9608768/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55517,
      "sha256": "ddfea59879670e1fb036e724d7ef93f1451959e2b556a0a017717487a2bba9b8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 147,
      "updated_at": "2026-06-09T13:39:31.029Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c0ef865e-a938-11f0-a3e7-cb47f2fe047a": {
    "source_id": "decoder",
    "episode_id": "c0ef865e-a938-11f0-a3e7-cb47f2fe047a",
    "title": "Siemens CEO's mission to automate everything",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c0ef865e-a938-11f0-a3e7-cb47f2fe047a-da12aae0fd56/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c0ef865e-a938-11f0-a3e7-cb47f2fe047a-da12aae0fd56/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56174,
      "sha256": "b2b28f8a46171a9e458495bf37e397f9185edb106c3182be03cddf37f7a1bcf7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.026Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c168c78a-a938-11f0-a3e7-9b7075c66393": {
    "source_id": "decoder",
    "episode_id": "c168c78a-a938-11f0-a3e7-9b7075c66393",
    "title": "Reality is losing the deepfake war",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c168c78a-a938-11f0-a3e7-9b7075c66393-b96697656819/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c168c78a-a938-11f0-a3e7-9b7075c66393-b96697656819/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47739,
      "sha256": "27379b395fda1304493b9d918c8209f4593d2a170d322f2261a97a8e558dc59c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 103,
      "updated_at": "2026-06-09T13:39:31.028Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c0c4a934-a938-11f0-a3e7-272b23671aeb": {
    "source_id": "decoder",
    "episode_id": "c0c4a934-a938-11f0-a3e7-272b23671aeb",
    "title": "Docusign's CEO on the dangers of trusting AI to read, and write, your contracts",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c0c4a934-a938-11f0-a3e7-272b23671aeb-c8b4e24ef452/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c0c4a934-a938-11f0-a3e7-272b23671aeb-c8b4e24ef452/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61641,
      "sha256": "9037410aac2b7ba3cae124c8b967d09fb7c19c4d57619c107954bc882ef95920",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 171,
      "updated_at": "2026-06-09T13:39:31.024Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/bfdf03ac-a938-11f0-a3e7-d31425f4a31b": {
    "source_id": "decoder",
    "episode_id": "bfdf03ac-a938-11f0-a3e7-d31425f4a31b",
    "title": "Experian's tech chief defends credit scores: 'We're not Palantir'",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/bfdf03ac-a938-11f0-a3e7-d31425f4a31b-48dd858d4e49/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/bfdf03ac-a938-11f0-a3e7-d31425f4a31b-48dd858d4e49/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62563,
      "sha256": "a0242cb439f2c475d2d145ec23c7fcbeed52b849bb8b79d525363c0ec437b33a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 159,
      "updated_at": "2026-06-09T13:39:31.021Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/bf8b4e10-a938-11f0-a3e7-bfd37fa24ff6": {
    "source_id": "decoder",
    "episode_id": "bf8b4e10-a938-11f0-a3e7-bfd37fa24ff6",
    "title": "Dropout CEO Sam Reich on the business of subscription comedy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/bf8b4e10-a938-11f0-a3e7-bfd37fa24ff6-dfb6643c363b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/bf8b4e10-a938-11f0-a3e7-bfd37fa24ff6-dfb6643c363b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55770,
      "sha256": "d7ce779ff8faed6dff584a51b62c1eab01da72bf6749e272ada9df6cc412422a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 274,
      "updated_at": "2026-06-09T13:39:31.020Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c61defa0-d358-11ef-a25c-9b1aec4ce2fd": {
    "source_id": "decoder",
    "episode_id": "c61defa0-d358-11ef-a25c-9b1aec4ce2fd",
    "title": "\"All chaos and panic\": Nilay answers your burning Decoder questions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c61defa0-d358-11ef-a25c-9b1aec4ce2fd-819c329e6ddc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c61defa0-d358-11ef-a25c-9b1aec4ce2fd-819c329e6ddc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34807,
      "sha256": "e8ddffc7da716640fda123467050f60496db72be8c8fd1e2b5afc7ceaff777f8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 104,
      "updated_at": "2026-06-09T13:39:31.043Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c5699d20-d358-11ef-a25c-ebce244e6161": {
    "source_id": "decoder",
    "episode_id": "c5699d20-d358-11ef-a25c-ebce244e6161",
    "title": "IBM CEO Arvind Krishna says there is no AI bubble after all",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63971,
      "sha256": "2c1cd7a8a443c45e7576b097d6fbc2343b9c23a187632a4b784246fe9382aea7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 179,
      "updated_at": "2026-06-09T13:39:31.041Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43278,
      "sha256": "956f95bf5ea08a30fb100d2237fc0deafa9e24a5f6073c05c73e931a2635ee79",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-06-02T14:57:25.982Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5699d20-d358-11ef-a25c-ebce244e6161-5ed046ca6658/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 180987,
      "sha256": "1388bd45aaaf91b237657d0479869a000fb36c045f98ed00c9ec28fa6b3f5bbc",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-06-02T14:57:25.982Z"
    }
  },
  "decoder/c4ff85d4-d358-11ef-a25c-932a71c99a88": {
    "source_id": "decoder",
    "episode_id": "c4ff85d4-d358-11ef-a25c-932a71c99a88",
    "title": "Ring's Jamie Siminoff thinks AI can reduce crime",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c4ff85d4-d358-11ef-a25c-932a71c99a88-7d19652162c5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c4ff85d4-d358-11ef-a25c-932a71c99a88-7d19652162c5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 70726,
      "sha256": "32e1b6bb0cf9f9e5033cbb4c64aa7dcd95a1670f5c43ce3092e241f0baa70ddc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 176,
      "updated_at": "2026-06-09T13:39:31.040Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c4b8feb6-d358-11ef-a25c-334a95be7aea": {
    "source_id": "decoder",
    "episode_id": "c4b8feb6-d358-11ef-a25c-334a95be7aea",
    "title": "Sir Tim Berners-Lee doesn’t think AI will destroy the web",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c4b8feb6-d358-11ef-a25c-334a95be7aea-0cdc4e45e42f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c4b8feb6-d358-11ef-a25c-334a95be7aea-0cdc4e45e42f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47470,
      "sha256": "40aec476c9369cebd9e79c06e1006a279216c8b28049e3e76c19a2ba374d7905",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 138,
      "updated_at": "2026-06-09T13:39:31.039Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c474fdba-d358-11ef-a25c-d3797cbf4c39": {
    "source_id": "decoder",
    "episode_id": "c474fdba-d358-11ef-a25c-d3797cbf4c39",
    "title": "Lyft CEO David Risher on paying drivers more and the shift to robotaxis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c474fdba-d358-11ef-a25c-d3797cbf4c39-fdc3e0f11a0a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c474fdba-d358-11ef-a25c-d3797cbf4c39-fdc3e0f11a0a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67219,
      "sha256": "8a997456a5b232f8e1900af68565ee8acb507fe4102d6fee25fa6fa02d233275",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 129,
      "updated_at": "2026-06-09T13:39:31.038Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c42fa224-d358-11ef-a25c-2f82fb1f00f2": {
    "source_id": "decoder",
    "episode_id": "c42fa224-d358-11ef-a25c-2f82fb1f00f2",
    "title": "LexisNexis CEO says the AI law era is already here",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c42fa224-d358-11ef-a25c-2f82fb1f00f2-8c1b79c022a2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c42fa224-d358-11ef-a25c-2f82fb1f00f2-8c1b79c022a2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55534,
      "sha256": "fb587f3be8d5920d5ac148af8724794090a54eabcfa24c0eda17b4b6ccbd596b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 147,
      "updated_at": "2026-06-09T13:39:31.038Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c40d05e8-d358-11ef-a25c-23a0558d3fcb": {
    "source_id": "decoder",
    "episode_id": "c40d05e8-d358-11ef-a25c-23a0558d3fcb",
    "title": "Why GM will give you Gemini — but not CarPlay",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c40d05e8-d358-11ef-a25c-23a0558d3fcb-4bbefe7f08cf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c40d05e8-d358-11ef-a25c-23a0558d3fcb-4bbefe7f08cf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71249,
      "sha256": "0a4b9162032fbc6153756b2e025561ff37019e0a28a5dbd0fc6b8e19cbeac55e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 157,
      "updated_at": "2026-06-09T13:39:31.036Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c3eb05ba-d358-11ef-a25c-739b95a15ef9": {
    "source_id": "decoder",
    "episode_id": "c3eb05ba-d358-11ef-a25c-739b95a15ef9",
    "title": "Zocdoc CEO: \"Dr. Google is going to be replaced by Dr. AI\"",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c3eb05ba-d358-11ef-a25c-739b95a15ef9-714081795230/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c3eb05ba-d358-11ef-a25c-739b95a15ef9-714081795230/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61551,
      "sha256": "e31c59e4e2f6a259fcfb1b32b9ceb95ed8f1f550d72beb6b3ee2165f919b1084",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 156,
      "updated_at": "2026-06-09T13:39:31.036Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c2f81648-d358-11ef-a25c-839971bcb265": {
    "source_id": "decoder",
    "episode_id": "c2f81648-d358-11ef-a25c-839971bcb265",
    "title": "Dropout CEO Sam Reich on business, comedy, and keeping culture weird",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c2f81648-d358-11ef-a25c-839971bcb265-f19cabec8af2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c2f81648-d358-11ef-a25c-839971bcb265-f19cabec8af2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55778,
      "sha256": "9892c74d0e427b3df2ca8075df97da788c035e841d21ecab354548f91e851268",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 274,
      "updated_at": "2026-06-09T13:39:31.034Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c1deb5fa-d358-11ef-a25c-2315c26b1f35": {
    "source_id": "decoder",
    "episode_id": "c1deb5fa-d358-11ef-a25c-2315c26b1f35",
    "title": "Amazon is betting on agents to win the AI race",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c1deb5fa-d358-11ef-a25c-2315c26b1f35-15f9cf079156/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c1deb5fa-d358-11ef-a25c-2315c26b1f35-15f9cf079156/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51321,
      "sha256": "18c993e3267155fd1c219289395639a394950a511973409412d3d2ecd63472fe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 135,
      "updated_at": "2026-06-09T13:39:31.031Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c1bc17de-d358-11ef-a25c-af84b8e15617": {
    "source_id": "decoder",
    "episode_id": "c1bc17de-d358-11ef-a25c-af84b8e15617",
    "title": "How the head of Obsidian went from superfan to CEO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c1bc17de-d358-11ef-a25c-af84b8e15617-6d52049bc588/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c1bc17de-d358-11ef-a25c-af84b8e15617-6d52049bc588/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40212,
      "sha256": "1daf4f9b87fb4a4735e3e98371655e5697bb02481e867c1f89851a84ec589e03",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 97,
      "updated_at": "2026-06-09T13:39:31.030Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c19a1e9a-d358-11ef-a25c-7b1dca07a154": {
    "source_id": "decoder",
    "episode_id": "c19a1e9a-d358-11ef-a25c-7b1dca07a154",
    "title": "ChatGPT chief Nick Turley doesn't want you too attached to AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c19a1e9a-d358-11ef-a25c-7b1dca07a154-05a9739092e2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c19a1e9a-d358-11ef-a25c-7b1dca07a154-05a9739092e2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55515,
      "sha256": "b900fca264a2c6c4fd8e7f773ad165759ba6d0158e95e226c3a2e58589f4c137",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 142,
      "updated_at": "2026-06-09T13:39:31.029Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c177feb4-d358-11ef-a25c-5f91a1b41dc7": {
    "source_id": "decoder",
    "episode_id": "c177feb4-d358-11ef-a25c-5f91a1b41dc7",
    "title": "Notion's CEO wants you to demand better from your tools",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c177feb4-d358-11ef-a25c-5f91a1b41dc7-0e92057b8280/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c177feb4-d358-11ef-a25c-5f91a1b41dc7-0e92057b8280/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50700,
      "sha256": "986c602c151d9fc496528858380335860cb1f096c2bdacce3bec7fbb9a626cec",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.028Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c132e1bc-d358-11ef-a25c-df101e7c9b58": {
    "source_id": "decoder",
    "episode_id": "c132e1bc-d358-11ef-a25c-df101e7c9b58",
    "title": "Why tech is racing to adopt AI coding",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c132e1bc-d358-11ef-a25c-df101e7c9b58-039c89d92edf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c132e1bc-d358-11ef-a25c-df101e7c9b58-039c89d92edf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52231,
      "sha256": "5eb81858016fe8db5a01c931dd2795e286a8d1115365c78ded23280290f35dff",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 123,
      "updated_at": "2026-06-09T13:39:31.027Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c0ed94b8-d358-11ef-a25c-f3b1620ef908": {
    "source_id": "decoder",
    "episode_id": "c0ed94b8-d358-11ef-a25c-f3b1620ef908",
    "title": "Can we ever trust an AI lawyer?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c0ed94b8-d358-11ef-a25c-f3b1620ef908-348f0abad906/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c0ed94b8-d358-11ef-a25c-f3b1620ef908-348f0abad906/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44040,
      "sha256": "cbd93883b486a5f0383518ffe59fe66d353b4b0cc002e0f898b561334e03bafe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:31.025Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c08673e6-d358-11ef-a25c-3f63437a60ff": {
    "source_id": "decoder",
    "episode_id": "c08673e6-d358-11ef-a25c-3f63437a60ff",
    "title": "Perplexity CEO on why the browser is AI's killer app",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c08673e6-d358-11ef-a25c-3f63437a60ff-2450c8758463/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c08673e6-d358-11ef-a25c-3f63437a60ff-2450c8758463/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45161,
      "sha256": "22b17071319134994e871e1669b2b23cb029cdcca8083858501639414b49cc43",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 104,
      "updated_at": "2026-06-09T13:39:31.024Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c0635a6e-d358-11ef-a25c-3bc1135fef5e": {
    "source_id": "decoder",
    "episode_id": "c0635a6e-d358-11ef-a25c-3bc1135fef5e",
    "title": "How decision making will change when AI answers are cheap and (too) easy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c0635a6e-d358-11ef-a25c-3bc1135fef5e-8ec088f1b3f5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c0635a6e-d358-11ef-a25c-3bc1135fef5e-8ec088f1b3f5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54733,
      "sha256": "06c53c56a7d260bad00a122e25a8de0cbe457b2f130b57e14e8c8faaee89bd4c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 126,
      "updated_at": "2026-06-09T13:39:31.023Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c01a61c4-d358-11ef-a25c-9ff5ade71a2d": {
    "source_id": "decoder",
    "episode_id": "c01a61c4-d358-11ef-a25c-9ff5ade71a2d",
    "title": "How SharkNinja took over the home",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c01a61c4-d358-11ef-a25c-9ff5ade71a2d-c1d9cf17ee57/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c01a61c4-d358-11ef-a25c-9ff5ade71a2d-c1d9cf17ee57/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75238,
      "sha256": "d009e902e3e250eed394d81102e03775dc5dc67e66c2fc46a17a4f82adb82d0f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.022Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a3e89ae0-801d-11ef-8ba6-8faae0d4b730": {
    "source_id": "decoder",
    "episode_id": "a3e89ae0-801d-11ef-8ba6-8faae0d4b730",
    "title": "Hinge CEO Justin McLeod says dating AI chatbots is 'playing with fire'",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a3e89ae0-801d-11ef-8ba6-8faae0d4b730-19f8f3788835/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a3e89ae0-801d-11ef-8ba6-8faae0d4b730-19f8f3788835/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62484,
      "sha256": "447191da685c107d580cf8c9aa4894cd428f7b2b77c6012d4a595e4c8282f3a3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 182,
      "updated_at": "2026-06-09T13:39:31.014Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a3777982-801d-11ef-8ba6-0b5a04662127": {
    "source_id": "decoder",
    "episode_id": "a3777982-801d-11ef-8ba6-0b5a04662127",
    "title": "Airbnb CEO Brian Chesky wants to build the everything app",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a3777982-801d-11ef-8ba6-0b5a04662127-9d2599140dec/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a3777982-801d-11ef-8ba6-0b5a04662127-9d2599140dec/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76034,
      "sha256": "42ca57b9d50080b95c7b2561f1d15512870daa625074e9203a3811aa759921fd",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 135,
      "updated_at": "2026-06-09T13:39:31.013Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c9748492-fe92-11ef-9f94-fb950e7bcd69": {
    "source_id": "decoder",
    "episode_id": "c9748492-fe92-11ef-9f94-fb950e7bcd69",
    "title": "Google CEO Sundar Pichai on the next phase of AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c9748492-fe92-11ef-9f94-fb950e7bcd69-614c093f2776/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c9748492-fe92-11ef-9f94-fb950e7bcd69-614c093f2776/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42896,
      "sha256": "ff57999766b48884857c98f7547d79cc5cae7b32e1580cf4630dad02519aef5d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 111,
      "updated_at": "2026-06-09T13:39:31.044Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a3511ad0-801d-11ef-8ba6-bf445f8b20d3": {
    "source_id": "decoder",
    "episode_id": "a3511ad0-801d-11ef-8ba6-bf445f8b20d3",
    "title": "Why Uber's CEO is okay with reinventing the bus",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a3511ad0-801d-11ef-8ba6-bf445f8b20d3-78541afa2f98/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a3511ad0-801d-11ef-8ba6-bf445f8b20d3-78541afa2f98/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56014,
      "sha256": "8baa55d9cd8d2c98226ede7340bbda253598e49dca85391b35cbf3adfa66bd94",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 186,
      "updated_at": "2026-06-09T13:39:31.012Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a32c4412-801d-11ef-8ba6-074404a5bd27": {
    "source_id": "decoder",
    "episode_id": "a32c4412-801d-11ef-8ba6-074404a5bd27",
    "title": "Microsoft CTO Kevin Scott on how AI can save the web, not destroy it",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a32c4412-801d-11ef-8ba6-074404a5bd27-2021ab64245a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a32c4412-801d-11ef-8ba6-074404a5bd27-2021ab64245a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58501,
      "sha256": "447e4df371fa1b78bf244bf95a4eb932dc7b121f250826f1cc6b53bac23e315f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 129,
      "updated_at": "2026-06-09T13:39:31.011Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a33e6930-801d-11ef-8ba6-0b4daca3a86e": {
    "source_id": "decoder",
    "episode_id": "a33e6930-801d-11ef-8ba6-0b4daca3a86e",
    "title": "Workday's new product head hopes he can make you like Workday",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a33e6930-801d-11ef-8ba6-0b4daca3a86e-f525f0372edc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a33e6930-801d-11ef-8ba6-0b4daca3a86e-f525f0372edc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69806,
      "sha256": "a40456f2aaf5719e27b64c120116494e0ea3a4b36549560ea39fdb8ef26a9761",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 139,
      "updated_at": "2026-06-09T13:39:31.011Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a2aad044-801d-11ef-8ba6-ef0f79b62677": {
    "source_id": "decoder",
    "episode_id": "a2aad044-801d-11ef-8ba6-ef0f79b62677",
    "title": "Are prediction markets gambling? Robinhood's Vlad Tenev is betting not",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a2aad044-801d-11ef-8ba6-ef0f79b62677-a0d09773d164/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a2aad044-801d-11ef-8ba6-ef0f79b62677-a0d09773d164/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64684,
      "sha256": "e65bdab1199f7321ca022f3ee10fb53b365f16571711619b61f0025b4daa4cda",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 141,
      "updated_at": "2026-06-09T13:39:31.010Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a2982e12-801d-11ef-8ba6-6744abdac488": {
    "source_id": "decoder",
    "episode_id": "a2982e12-801d-11ef-8ba6-6744abdac488",
    "title": "UiPath CEO Daniel Dines on AI agents replacing our jobs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a2982e12-801d-11ef-8ba6-6744abdac488-66fdcecd90f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a2982e12-801d-11ef-8ba6-6744abdac488-66fdcecd90f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49101,
      "sha256": "e6a448704cd0eb5df63ea8752fcf1c7f48acc0c3032541c2013d2015526166df",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 118,
      "updated_at": "2026-06-09T13:39:31.009Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a1c38770-801d-11ef-8ba6-2fe5424fc25b": {
    "source_id": "decoder",
    "episode_id": "a1c38770-801d-11ef-8ba6-2fe5424fc25b",
    "title": "Splice CEO Kakul Srivastava on why push-button AI is “insulting” to musicians",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a1c38770-801d-11ef-8ba6-2fe5424fc25b-7ad2e76f4157/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a1c38770-801d-11ef-8ba6-2fe5424fc25b-7ad2e76f4157/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64310,
      "sha256": "130ea8ea0c9c8dad814895c3b33b0f0905f51b6b8ad2bc09d3aa44f3bee01ac3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 185,
      "updated_at": "2026-06-09T13:39:31.008Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a1afd040-801d-11ef-8ba6-8be08f498edb": {
    "source_id": "decoder",
    "episode_id": "a1afd040-801d-11ef-8ba6-8be08f498edb",
    "title": "Dow Jones CEO Almar Latour on AI, press freedom, and the future of news",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a1afd040-801d-11ef-8ba6-8be08f498edb-4018184a8330/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a1afd040-801d-11ef-8ba6-8be08f498edb-4018184a8330/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54774,
      "sha256": "f5514404858ec404506a71f3ba943be3ec1d2a7c8170e07749d292ba791ee66a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 139,
      "updated_at": "2026-06-09T13:39:31.008Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a19c9c3c-801d-11ef-8ba6-77938d708683": {
    "source_id": "decoder",
    "episode_id": "a19c9c3c-801d-11ef-8ba6-77938d708683",
    "title": "Amazon’s Panos Panay on the long road to Alexa’s AI overhaul",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a19c9c3c-801d-11ef-8ba6-77938d708683-5b90fc12ce76/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a19c9c3c-801d-11ef-8ba6-77938d708683-5b90fc12ce76/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73509,
      "sha256": "1de7ecaf37b7be04c7b386fda0c2a179e4b3bd37d84bcf3305c8a32e1c8cf47b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 260,
      "updated_at": "2026-06-09T13:39:31.007Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a1140106-801d-11ef-8ba6-af3899d0198f": {
    "source_id": "decoder",
    "episode_id": "a1140106-801d-11ef-8ba6-af3899d0198f",
    "title": "Vimeo CEO Philip Moyer is betting on the human touch — and AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a1140106-801d-11ef-8ba6-af3899d0198f-997f19926957/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a1140106-801d-11ef-8ba6-af3899d0198f-997f19926957/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 74921,
      "sha256": "dda7b02731cf62ef17fd3739fdb949c6df57a8cdb45a61802df4bed4c499dc3d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 145,
      "updated_at": "2026-06-09T13:39:31.007Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a1019f5c-801d-11ef-8ba6-4b90389ffffb": {
    "source_id": "decoder",
    "episode_id": "a1019f5c-801d-11ef-8ba6-4b90389ffffb",
    "title": "How Ciena keeps the internet online, with CEO Gary Smith",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a1019f5c-801d-11ef-8ba6-4b90389ffffb-7a1cea6a9525/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a1019f5c-801d-11ef-8ba6-4b90389ffffb-7a1cea6a9525/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60379,
      "sha256": "7c4defbad7e6e81fe421541c3044899ad64ff943069d1aed21de7d6cf342c924",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.006Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/a0c7e0f0-801d-11ef-8ba6-8b1a31ddc7a8": {
    "source_id": "decoder",
    "episode_id": "a0c7e0f0-801d-11ef-8ba6-8b1a31ddc7a8",
    "title": "Why CEO Matt Garman is willing to bet AWS on AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/a0c7e0f0-801d-11ef-8ba6-8b1a31ddc7a8-3988def82eea/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/a0c7e0f0-801d-11ef-8ba6-8b1a31ddc7a8-3988def82eea/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72568,
      "sha256": "5404c9c1665c46519ce0eb3754922ead87f5ff8716bb2b49841f74aad0f0eef3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 184,
      "updated_at": "2026-06-09T13:39:31.005Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/63fc8dfa-9eb0-11ee-9922-230727d4627b": {
    "source_id": "decoder",
    "episode_id": "63fc8dfa-9eb0-11ee-9922-230727d4627b",
    "title": "Arm CEO Rene Haas on the AI chip race, Intel, and what Trump means for tech",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/63fc8dfa-9eb0-11ee-9922-230727d4627b-0ee598f3d714/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/63fc8dfa-9eb0-11ee-9922-230727d4627b-0ee598f3d714/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35612,
      "sha256": "018622d4c3fc0025321c98c8f7bd572816257ecef3f3422a9a95872a4b019bdb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:30.995Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/63c57b94-9eb0-11ee-9922-d33a7e064dd0": {
    "source_id": "decoder",
    "episode_id": "63c57b94-9eb0-11ee-9922-d33a7e064dd0",
    "title": "Microsoft AI CEO Mustafa Suleyman says conversational AI is the next web browser",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/63c57b94-9eb0-11ee-9922-d33a7e064dd0-dfa10da4bd00/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/63c57b94-9eb0-11ee-9922-d33a7e064dd0-dfa10da4bd00/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67822,
      "sha256": "5c5ac67fe70e8516a44ac2403fa0b700a7fdeff17de8c3cec56aac11b77620ab",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 131,
      "updated_at": "2026-06-09T13:39:30.994Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/638a0b54-9eb0-11ee-9922-5308b4a58e38": {
    "source_id": "decoder",
    "episode_id": "638a0b54-9eb0-11ee-9922-5308b4a58e38",
    "title": "Rewind: Bluesky CEO Jay Graber on the future of federated social media",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/638a0b54-9eb0-11ee-9922-5308b4a58e38-f323d1b1c172/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/638a0b54-9eb0-11ee-9922-5308b4a58e38-f323d1b1c172/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76481,
      "sha256": "5bf0e8e20945e384740fa19f0b0fa4bf8d05cda21482754fbfde2392b9acce94",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 155,
      "updated_at": "2026-06-09T13:39:30.993Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/b2d36286-a2b6-11ef-be18-0f552333c1df": {
    "source_id": "decoder",
    "episode_id": "b2d36286-a2b6-11ef-be18-0f552333c1df",
    "title": "GoDaddy CEO Aman Bhutani on the enduring power of the website",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b2d36286-a2b6-11ef-be18-0f552333c1df-f00af749eef7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b2d36286-a2b6-11ef-be18-0f552333c1df-f00af749eef7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52343,
      "sha256": "4fc7501ee2184a48a930e4eb29dd2a9ef6c71d747dbc1950fa6930697d5131be",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 143,
      "updated_at": "2026-06-09T13:39:31.015Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/32ffc7de-99cf-11ee-b66d-6305b8628b91": {
    "source_id": "decoder",
    "episode_id": "32ffc7de-99cf-11ee-b66d-6305b8628b91",
    "title": "Remix: Google Zero is here — now what?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/32ffc7de-99cf-11ee-b66d-6305b8628b91-ffd86d8dfbfa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/32ffc7de-99cf-11ee-b66d-6305b8628b91-ffd86d8dfbfa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 6699,
      "sha256": "2b2f83ac107b4ddaeac33e5bd080bc365ee61e6d3d027386a8719ac9bd6df8f1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 14,
      "updated_at": "2026-06-09T13:39:30.991Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c4115000-9eaf-11ee-a873-93a9e6c35539": {
    "source_id": "decoder",
    "episode_id": "c4115000-9eaf-11ee-a873-93a9e6c35539",
    "title": "Airbnb CEO Brian Chesky on what founder mode really means",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c4115000-9eaf-11ee-a873-93a9e6c35539-7e86c4d9b17e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c4115000-9eaf-11ee-a873-93a9e6c35539-7e86c4d9b17e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73929,
      "sha256": "29cc1b390b57ca5f01c214e49947eab3e2c2388d0bf221ef8915ee9279eb69e1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 196,
      "updated_at": "2026-06-09T13:39:31.037Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c3e1b688-9eaf-11ee-a873-a7fc9a0aa2a2": {
    "source_id": "decoder",
    "episode_id": "c3e1b688-9eaf-11ee-a873-a7fc9a0aa2a2",
    "title": "Intuit asked us to delete part of this Decoder episode",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c3e1b688-9eaf-11ee-a873-a7fc9a0aa2a2-ebe9c163db53/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c3e1b688-9eaf-11ee-a873-a7fc9a0aa2a2-ebe9c163db53/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46968,
      "sha256": "537e50f4d126291c0179e8719e9e1c5f45e8ee87c5450af4e05aeae2a4d32d40",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 108,
      "updated_at": "2026-06-09T13:39:31.035Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/370cf766-867d-11ef-9711-a740bde94b41": {
    "source_id": "decoder",
    "episode_id": "370cf766-867d-11ef-9711-a740bde94b41",
    "title": "Duolingo CEO Luis Von Ahn wants you addicted to learning",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/370cf766-867d-11ef-9711-a740bde94b41-7bac258834c3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/370cf766-867d-11ef-9711-a740bde94b41-7bac258834c3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75016,
      "sha256": "0227ae1ae666a47239e212d3d5637e5409cf50f4ae1c908aba9f81b06bd87f5c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 255,
      "updated_at": "2026-06-09T13:39:30.992Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c3b2756c-9eaf-11ee-a873-9326cad30ba8": {
    "source_id": "decoder",
    "episode_id": "c3b2756c-9eaf-11ee-a873-9326cad30ba8",
    "title": "Rabbit CEO Jesse Lyu isn't thinking too far ahead",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c3b2756c-9eaf-11ee-a873-9326cad30ba8-27793890c513/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c3b2756c-9eaf-11ee-a873-9326cad30ba8-27793890c513/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 80461,
      "sha256": "f36bd891d83660e7041cec7b286ec380deac640516f3d5c5dd5753d7d5b4b7f7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 315,
      "updated_at": "2026-06-09T13:39:31.035Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/31a00476-99cf-11ee-b66d-0fed62114e5f": {
    "source_id": "decoder",
    "episode_id": "31a00476-99cf-11ee-b66d-0fed62114e5f",
    "title": "Why Mark Zuckerberg wants to end the smartphone era",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/31a00476-99cf-11ee-b66d-0fed62114e5f-28d9aa2e33bf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/31a00476-99cf-11ee-b66d-0fed62114e5f-28d9aa2e33bf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63113,
      "sha256": "b97f04a3a66840feead1c67212a910fc86febe6da4725d1682e232c4649c3f17",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 157,
      "updated_at": "2026-06-09T13:39:30.991Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/66e64854-9eaf-11ee-bdec-3f883bdc6486": {
    "source_id": "decoder",
    "episode_id": "66e64854-9eaf-11ee-bdec-3f883bdc6486",
    "title": "Arc creator Josh Miller on why you need a better browser than Chrome",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/66e64854-9eaf-11ee-bdec-3f883bdc6486-f0c9d73df3f1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/66e64854-9eaf-11ee-bdec-3f883bdc6486-f0c9d73df3f1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75939,
      "sha256": "700f19751647769ab1001f1f46e917b309998885c592b0400f1b1ebe170ee055",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 229,
      "updated_at": "2026-06-09T13:39:30.996Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/66b71598-9eaf-11ee-bdec-57620c3c85e1": {
    "source_id": "decoder",
    "episode_id": "66b71598-9eaf-11ee-bdec-57620c3c85e1",
    "title": "How Philips CEO Roy Jakobs is turning the company around after major recall",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/66b71598-9eaf-11ee-bdec-57620c3c85e1-6e128b69158d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/66b71598-9eaf-11ee-bdec-57620c3c85e1-6e128b69158d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64575,
      "sha256": "4ef6f7c6cb36aea1c2ee771e42bb8c7530c17426a5d1adc5e1d16f0a4b03b9b7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 167,
      "updated_at": "2026-06-09T13:39:30.996Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/6686053e-9eaf-11ee-bdec-3f0e84dd5824": {
    "source_id": "decoder",
    "episode_id": "6686053e-9eaf-11ee-bdec-3f0e84dd5824",
    "title": "Anthropic’s Mike Krieger wants to build AI products that are worth the hype",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6686053e-9eaf-11ee-bdec-3f0e84dd5824-19e839241290/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6686053e-9eaf-11ee-bdec-3f0e84dd5824-19e839241290/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84088,
      "sha256": "0e5504644f69144b98f7f68c81f8b9dece27b7198a8b3d809e08f95f086f08fb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 165,
      "updated_at": "2026-06-09T13:39:30.995Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/30c1eba0-99cf-11ee-b66d-0f4c6312179b": {
    "source_id": "decoder",
    "episode_id": "30c1eba0-99cf-11ee-b66d-0f4c6312179b",
    "title": "How The Onion is saving itself from the digital media death spiral",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/30c1eba0-99cf-11ee-b66d-0f4c6312179b-d95d5cff9e35/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/30c1eba0-99cf-11ee-b66d-0f4c6312179b-d95d5cff9e35/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58743,
      "sha256": "da8b3fb19dd2557316cc5eb18aa3cb3b1dcbc7bca1725693ec625d0c7c257398",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 186,
      "updated_at": "2026-06-09T13:39:30.989Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/1db52222-9eaf-11ee-8f31-d7713b856fd8": {
    "source_id": "decoder",
    "episode_id": "1db52222-9eaf-11ee-8f31-d7713b856fd8",
    "title": "GitHub CEO Thomas Dohmke says the AI industry needs competition to thrive",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/1db52222-9eaf-11ee-8f31-d7713b856fd8-dcd6e3bba4c0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/1db52222-9eaf-11ee-8f31-d7713b856fd8-dcd6e3bba4c0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77583,
      "sha256": "fa9c68a66d4013be5d496c036bd9548fe8197d7d150490dfb6ae712a69f7eba8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 175,
      "updated_at": "2026-06-09T13:39:30.973Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/1d744b80-9eaf-11ee-8f31-eb90f30745c6": {
    "source_id": "decoder",
    "episode_id": "1d744b80-9eaf-11ee-8f31-eb90f30745c6",
    "title": "Replika CEO Eugenia Kuyda says it’s okay if we end up marrying AI chatbots",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/1d744b80-9eaf-11ee-8f31-eb90f30745c6-04cae8cf372e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/1d744b80-9eaf-11ee-8f31-eb90f30745c6-04cae8cf372e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63327,
      "sha256": "e3832e1271bfcd4007e748c3a9ca7f2e93448170136019139251401073482d70",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 156,
      "updated_at": "2026-06-09T13:39:30.973Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/306772f6-99cf-11ee-b66d-77a37f7bfcca": {
    "source_id": "decoder",
    "episode_id": "306772f6-99cf-11ee-b66d-77a37f7bfcca",
    "title": "DOJ antitrust chief is ‘overjoyed’ after Google monopoly verdict",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/306772f6-99cf-11ee-b66d-77a37f7bfcca-3beb903e9613/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/306772f6-99cf-11ee-b66d-77a37f7bfcca-3beb903e9613/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41292,
      "sha256": "23a16ce1a98a05162b1b3dd39afa164a16cbd41e8e7852d57504da222ea123a6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 118,
      "updated_at": "2026-06-09T13:39:30.988Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/1d2ef116-9eaf-11ee-8f31-2b8a0be4d7b8": {
    "source_id": "decoder",
    "episode_id": "1d2ef116-9eaf-11ee-8f31-2b8a0be4d7b8",
    "title": "Booking CEO Glenn Fogel wants you to take out your travel frustrations on AI chatbots",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/1d2ef116-9eaf-11ee-8f31-2b8a0be4d7b8-dd6bfa2330c8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/1d2ef116-9eaf-11ee-8f31-2b8a0be4d7b8-dd6bfa2330c8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76320,
      "sha256": "cd0d5ad41e2c3616ed644c43d14d0c8e65add735d3baa2e54fc3cf1e4a07cea1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 183,
      "updated_at": "2026-06-09T13:39:30.972Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c6374b92-9eae-11ee-9174-c7749a975248": {
    "source_id": "decoder",
    "episode_id": "c6374b92-9eae-11ee-9174-c7749a975248",
    "title": "Logitech CEO Hanneke Faber wants your next mouse to last forever",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c6374b92-9eae-11ee-9174-c7749a975248-479d93bcc124/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c6374b92-9eae-11ee-9174-c7749a975248-479d93bcc124/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60829,
      "sha256": "ccf9402e9d148258df9b078b0fab8e9ee27fc0063de4e874b615622a644b69d8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 191,
      "updated_at": "2026-06-09T13:39:31.044Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c5ce81fc-9eae-11ee-9174-2f53d8d196e3": {
    "source_id": "decoder",
    "episode_id": "c5ce81fc-9eae-11ee-9174-2f53d8d196e3",
    "title": "Biden’s top tech advisor on why AI safety is a “today problem”",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5ce81fc-9eae-11ee-9174-2f53d8d196e3-239d29283b34/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5ce81fc-9eae-11ee-9174-2f53d8d196e3-239d29283b34/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58981,
      "sha256": "a1466272c6a5c7df28d04d0721a1db4cea0f9e0469052a2ed255a267272f80c3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 119,
      "updated_at": "2026-06-09T13:39:31.042Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c59a8744-9eae-11ee-9174-b793ab6a0840": {
    "source_id": "decoder",
    "episode_id": "c59a8744-9eae-11ee-9174-b793ab6a0840",
    "title": "Canva CEO Melanie Perkins is happy to provide designers alternatives to Adobe",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c59a8744-9eae-11ee-9174-b793ab6a0840-b4b2eac6b87a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c59a8744-9eae-11ee-9174-b793ab6a0840-b4b2eac6b87a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65652,
      "sha256": "a9402781dc7f9c9cede2c92f011322b1b9d4656d5886b44e56ab6385e37ad1e0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 171,
      "updated_at": "2026-06-09T13:39:31.041Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/c5640d04-9eae-11ee-9174-93a3824dc0b0": {
    "source_id": "decoder",
    "episode_id": "c5640d04-9eae-11ee-9174-93a3824dc0b0",
    "title": "How Big Green Egg CEO Dan Gertsacov is getting zoomers into the cult of kamado cooking",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76330,
      "sha256": "696ad8e3bc60aac5e7d2c132052a377a3af1ebf444dee378a8d66651b3eb4bf8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 146,
      "updated_at": "2026-06-09T13:39:31.040Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44817,
      "sha256": "9206a1485035261775f5dce8cd3c7ff866d342ba1ae0aea5843ec833df68af2b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 16,
      "updated_at": "2026-06-02T17:49:42.016Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/c5640d04-9eae-11ee-9174-93a3824dc0b0-42a9286dd91d/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 89503,
      "sha256": "661b769cbf93258fa94175098213604eec423b2506724d54f02e24643dd91909",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 16,
      "updated_at": "2026-06-02T17:49:42.016Z"
    }
  },
  "decoder/6ca19c5e-9eae-11ee-b73c-53307db26e94": {
    "source_id": "decoder",
    "episode_id": "6ca19c5e-9eae-11ee-b73c-53307db26e94",
    "title": "Netflix co-CEO Greg Peters on the streamer's shifting culture and where ads, AI, and games fit in",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6ca19c5e-9eae-11ee-b73c-53307db26e94-9c85320acb99/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6ca19c5e-9eae-11ee-b73c-53307db26e94-9c85320acb99/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65111,
      "sha256": "78e8db37a2a9271c54eabb69060cd2a7eba33226c2e8844843ac89d7215b52a5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 153,
      "updated_at": "2026-06-09T13:39:30.999Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/6c6f43c6-9eae-11ee-b73c-27dc0d527167": {
    "source_id": "decoder",
    "episode_id": "6c6f43c6-9eae-11ee-b73c-27dc0d527167",
    "title": "Why Tubi CEO Anjali Sud thinks free TV can win again",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6c6f43c6-9eae-11ee-b73c-27dc0d527167-5dfc473853ce/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6c6f43c6-9eae-11ee-b73c-27dc0d527167-5dfc473853ce/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60119,
      "sha256": "d68d86e9977b8f104414100ad2eaa669b6bf02f0e9acdc2aa3dc329eefe1e3aa",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:30.999Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/6c3d72c4-9eae-11ee-b73c-1b8f70a5c63e": {
    "source_id": "decoder",
    "episode_id": "6c3d72c4-9eae-11ee-b73c-1b8f70a5c63e",
    "title": "AI will make money sooner than you think, says Cohere CEO Aidan Gomez",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6c3d72c4-9eae-11ee-b73c-1b8f70a5c63e-47f7bf8546f8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6c3d72c4-9eae-11ee-b73c-1b8f70a5c63e-47f7bf8546f8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61559,
      "sha256": "45b6311726a19849ee2054c7eb9ce68e6167fc5161f39864d83d2f8236e4d251",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 156,
      "updated_at": "2026-06-09T13:39:30.998Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/6c09719a-9eae-11ee-b73c-03c04f9b09a5": {
    "source_id": "decoder",
    "episode_id": "6c09719a-9eae-11ee-b73c-03c04f9b09a5",
    "title": "Zoom CEO Eric Yuan wants AI clones in meetings",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/6c09719a-9eae-11ee-b73c-03c04f9b09a5-e12e331614d2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/6c09719a-9eae-11ee-b73c-03c04f9b09a5-e12e331614d2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56155,
      "sha256": "01c8dc39e4620e18242a349565cbf33ba1194ab4256fa9307bd2872c2deddade",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 139,
      "updated_at": "2026-06-09T13:39:30.997Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/26ad4ef0-9eae-11ee-ab8b-0f8d6f573202": {
    "source_id": "decoder",
    "episode_id": "26ad4ef0-9eae-11ee-ab8b-0f8d6f573202",
    "title": "Google's Sundar Pichai on AI-powered search and the future of the web",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/26ad4ef0-9eae-11ee-ab8b-0f8d6f573202-e279acae97a8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/26ad4ef0-9eae-11ee-ab8b-0f8d6f573202-e279acae97a8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38805,
      "sha256": "8a3c7e2e75d1eb38c87a8887562c1ffc18fe350b95010d81512a184a99a95864",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 111,
      "updated_at": "2026-06-09T13:39:30.978Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/267c4288-9eae-11ee-ab8b-6359ebbbeaa1": {
    "source_id": "decoder",
    "episode_id": "267c4288-9eae-11ee-ab8b-6359ebbbeaa1",
    "title": "Why Adobe CEO Shantanu Narayen is confident we'll all adapt to AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/267c4288-9eae-11ee-ab8b-6359ebbbeaa1-f8e0c79dcfa8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/267c4288-9eae-11ee-ab8b-6359ebbbeaa1-f8e0c79dcfa8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55121,
      "sha256": "69cb4ce2996527f36ae7aad9c0cd17d0e1b30039c520fa5ee6a6da4846a5237e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 100,
      "updated_at": "2026-06-09T13:39:30.976Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/be8b174e-9ead-11ee-b35f-275cfb433f5e": {
    "source_id": "decoder",
    "episode_id": "be8b174e-9ead-11ee-b35f-275cfb433f5e",
    "title": "Discord CEO Jason Citron makes the case for a smaller, more private internet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/be8b174e-9ead-11ee-b35f-275cfb433f5e-f1a4fc2ba927/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/be8b174e-9ead-11ee-b35f-275cfb433f5e-f1a4fc2ba927/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58885,
      "sha256": "062b1f83f2d8c3857edb06a74f4a1b5b03d9094a805c9bd96808db7f10d012ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.019Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/be5a3638-9ead-11ee-b35f-8bbdd86947f3": {
    "source_id": "decoder",
    "episode_id": "be5a3638-9ead-11ee-b35f-8bbdd86947f3",
    "title": "Dropbox CEO Drew Houston wants you to embrace AI and remote work",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/be5a3638-9ead-11ee-b35f-8bbdd86947f3-4173fb351764/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/be5a3638-9ead-11ee-b35f-8bbdd86947f3-4173fb351764/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67118,
      "sha256": "8be4fd78a96c14b9f1696b32b94ccb6a364da03297fc9fdd022df57e17ddff62",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 150,
      "updated_at": "2026-06-09T13:39:31.019Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/bdf8dee2-9ead-11ee-b35f-c3372799f355": {
    "source_id": "decoder",
    "episode_id": "bdf8dee2-9ead-11ee-b35f-c3372799f355",
    "title": "Mailchimp CEO Rania Succar on culture, acquisitions, and how big 'small business' really is",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73278,
      "sha256": "d208f0aefb3bb208cd5d5f49c11bda24ef137d8cf06703fd46f7ffcd268844a7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 156,
      "updated_at": "2026-06-09T13:39:31.018Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 31441,
      "sha256": "cbeaf3c8e8233073ccd043f0820b46a7c3160f18007b75cdca3f385f3f718a87",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T13:49:12.051Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/bdf8dee2-9ead-11ee-b35f-c3372799f355-79ef5d661031/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 20739,
      "sha256": "e4a6b2fe6f3b7f9958b497f41fa35395323293ae3d0e0806546075861d0e19e7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 0,
      "updated_at": "2026-06-02T13:49:12.050Z"
    }
  },
  "decoder/30e99d84-9ead-11ee-bdf7-5bb4e5693a5a": {
    "source_id": "decoder",
    "episode_id": "30e99d84-9ead-11ee-bdf7-5bb4e5693a5a",
    "title": "Federation is the future of social media, says Bluesky CEO Jay Graber",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/30e99d84-9ead-11ee-bdf7-5bb4e5693a5a-12c5c002f4f1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/30e99d84-9ead-11ee-bdf7-5bb4e5693a5a-12c5c002f4f1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76480,
      "sha256": "8bc4bd49d6a492ecb4d77dbc5922c3e42b38b91e10154688decf6f5a631e9cfb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 155,
      "updated_at": "2026-06-09T13:39:30.990Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/30b83488-9ead-11ee-bdf7-dba9bc2a6e79": {
    "source_id": "decoder",
    "episode_id": "30b83488-9ead-11ee-bdf7-dba9bc2a6e79",
    "title": "Figma CEO Dylan Field is optimistic about the future and AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/30b83488-9ead-11ee-bdf7-dba9bc2a6e79-d65e17704953/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/30b83488-9ead-11ee-bdf7-dba9bc2a6e79-d65e17704953/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50992,
      "sha256": "a59ff12d7285c55d4af1db96a6e67b8dccd1ec7df715ce91816a8368b7eba85a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 146,
      "updated_at": "2026-06-09T13:39:30.989Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/305679e6-9ead-11ee-bdf7-b7c082bfa2b6": {
    "source_id": "decoder",
    "episode_id": "305679e6-9ead-11ee-bdf7-b7c082bfa2b6",
    "title": "Guest host Hank Green makes Nilay Patel explain why websites have a future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/305679e6-9ead-11ee-bdf7-b7c082bfa2b6-a7668a8c0f61/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/305679e6-9ead-11ee-bdf7-b7c082bfa2b6-a7668a8c0f61/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63358,
      "sha256": "6aa10865b602ae4f8acce1d224f26cc4e1a2e47f96d7876e82b992fc500d30e1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 206,
      "updated_at": "2026-06-09T13:39:30.987Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/caa3b29e-9eac-11ee-b113-03c9ad8f527f": {
    "source_id": "decoder",
    "episode_id": "caa3b29e-9eac-11ee-b113-03c9ad8f527f",
    "title": "Platformer’s Casey Newton on surviving the great media collapse and what comes next",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/caa3b29e-9eac-11ee-b113-03c9ad8f527f-3f2d0ddb0290/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/caa3b29e-9eac-11ee-b113-03c9ad8f527f-3f2d0ddb0290/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73216,
      "sha256": "d92b921302fbd82bdd5beefac9af02a2726084dc7adcf76e7afa1f7ffc181b12",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 176,
      "updated_at": "2026-06-09T13:39:31.045Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2688897c-613b-11ee-90e0-e3ab60533aeb": {
    "source_id": "decoder",
    "episode_id": "2688897c-613b-11ee-90e0-e3ab60533aeb",
    "title": "Why Sen. Brian Schatz thinks child safety bills can trump the First Amendment",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2688897c-613b-11ee-90e0-e3ab60533aeb-64c16c31268a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2688897c-613b-11ee-90e0-e3ab60533aeb-64c16c31268a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65978,
      "sha256": "65c2023916e5df96188ede49ddd21e209d20fd36284d9fdc174855f444a0efb5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 111,
      "updated_at": "2026-06-09T13:39:30.977Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/265b967e-613b-11ee-90e0-0fb574dd9f0c": {
    "source_id": "decoder",
    "episode_id": "265b967e-613b-11ee-90e0-0fb574dd9f0c",
    "title": "Rep. Ro Khanna on what it will take for Congress to regulate AI, privacy, and social media",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/265b967e-613b-11ee-90e0-0fb574dd9f0c-1bee089e866d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/265b967e-613b-11ee-90e0-0fb574dd9f0c-1bee089e866d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49202,
      "sha256": "e760e958a521bdb35eece66dac1535c3391284d8b1e2a54c6747941d442a5861",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:30.975Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/262b08d8-613b-11ee-90e0-f3be137f702a": {
    "source_id": "decoder",
    "episode_id": "262b08d8-613b-11ee-90e0-f3be137f702a",
    "title": "How Adobe is managing the AI copyright dilemma, with general counsel Dana Rao",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/262b08d8-613b-11ee-90e0-f3be137f702a-96e6e63aa307/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/262b08d8-613b-11ee-90e0-f3be137f702a-96e6e63aa307/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 91620,
      "sha256": "b9b403dc98cdeb4fbc7b80c2e15c4d1d7eaaf077b8361cee3d8a5f6edaf82957",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 207,
      "updated_at": "2026-06-09T13:39:30.974Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2eff6b56-350f-11ed-8d52-b735f4374d5e": {
    "source_id": "decoder",
    "episode_id": "2eff6b56-350f-11ed-8d52-b735f4374d5e",
    "title": "USDS head Mina Hsiang wants Big Tech’s best minds to help fix the government",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2eff6b56-350f-11ed-8d52-b735f4374d5e-a0d3695a579e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2eff6b56-350f-11ed-8d52-b735f4374d5e-a0d3695a579e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62060,
      "sha256": "32f295c7fc928f3e1e11c33932c683bbf6bad2b142bc192c5f6ea26d1f1031fa",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 129,
      "updated_at": "2026-06-09T13:39:30.986Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2ee64a4a-350f-11ed-8d52-3fb61862057d": {
    "source_id": "decoder",
    "episode_id": "2ee64a4a-350f-11ed-8d52-3fb61862057d",
    "title": "IBM's Jerry Chow explains the next phase of quantum computing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2ee64a4a-350f-11ed-8d52-3fb61862057d-34d0683eee8e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2ee64a4a-350f-11ed-8d52-3fb61862057d-34d0683eee8e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50135,
      "sha256": "afea5ffb35231375ee0cda01bf981b8d8c5719fc9a624c0a9baa28a027709aaf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 140,
      "updated_at": "2026-06-09T13:39:30.985Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2eb97f56-350f-11ed-8d52-d7536f93f753": {
    "source_id": "decoder",
    "episode_id": "2eb97f56-350f-11ed-8d52-d7536f93f753",
    "title": "Wix CEO Avishai Abrahami isn’t worried AI will kill the web",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2eb97f56-350f-11ed-8d52-d7536f93f753-c64b7093441e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2eb97f56-350f-11ed-8d52-d7536f93f753-c64b7093441e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73111,
      "sha256": "ba8825cdde1659d7b32f953360b9a4c399b428fa13111a627c93848ee59106fe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 270,
      "updated_at": "2026-06-09T13:39:30.984Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2e8ccb00-350f-11ed-8d52-e34e831b2fbb": {
    "source_id": "decoder",
    "episode_id": "2e8ccb00-350f-11ed-8d52-e34e831b2fbb",
    "title": "Barack Obama on AI, free speech, and the future of the internet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2e8ccb00-350f-11ed-8d52-e34e831b2fbb-e6e790092b8a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2e8ccb00-350f-11ed-8d52-e34e831b2fbb-e6e790092b8a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39142,
      "sha256": "aca75e4010e60e317de4d03a3dfbe2e63f2f462fb006acfdc879570bbb84e9a3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 146,
      "updated_at": "2026-06-09T13:39:30.983Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2e5f4dce-350f-11ed-8d52-ff7110c149dc": {
    "source_id": "decoder",
    "episode_id": "2e5f4dce-350f-11ed-8d52-ff7110c149dc",
    "title": "AI is on a collision course with the music industry. Reservoir's Golnar Khosrowshahi thinks there’s a way through it",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2e5f4dce-350f-11ed-8d52-ff7110c149dc-8fae8cb01838/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2e5f4dce-350f-11ed-8d52-ff7110c149dc-8fae8cb01838/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56784,
      "sha256": "d2e0be6f17cd0699307bd433e494245dc4acccbe28da3401ee3529a2d6cdc0ca",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 239,
      "updated_at": "2026-06-09T13:39:30.982Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2e765528-350f-11ed-8d52-bf85006e2bdc": {
    "source_id": "decoder",
    "episode_id": "2e765528-350f-11ed-8d52-bf85006e2bdc",
    "title": "Harvard professor Lawrence Lessig on why AI and social media are causing a free speech crisis for the internet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2e765528-350f-11ed-8d52-bf85006e2bdc-dd65bae2b8fb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2e765528-350f-11ed-8d52-bf85006e2bdc-dd65bae2b8fb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51875,
      "sha256": "54642ed5f2f14768f495522339ed210a7de37b6132acf7f562ddd5c90564d1ba",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 124,
      "updated_at": "2026-06-09T13:39:30.982Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2e47f3fe-350f-11ed-8d52-a7446d6bec51": {
    "source_id": "decoder",
    "episode_id": "2e47f3fe-350f-11ed-8d52-a7446d6bec51",
    "title": "Clearview AI and the end of privacy, with author Kashmir Hill",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2e47f3fe-350f-11ed-8d52-a7446d6bec51-20853ead3982/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2e47f3fe-350f-11ed-8d52-a7446d6bec51-20853ead3982/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62261,
      "sha256": "d1ccbe7a739279828ae79aa66868508d8b61b66c792b89cc6523cbbd490dff81",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 147,
      "updated_at": "2026-06-09T13:39:30.981Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/b86d1cc2-4287-11ee-84f6-c313b8134c83": {
    "source_id": "decoder",
    "episode_id": "b86d1cc2-4287-11ee-84f6-c313b8134c83",
    "title": "CEO David Baszucki's mission to make Roblox a billion-player platform",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b86d1cc2-4287-11ee-84f6-c313b8134c83-50cb32d31c26/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b86d1cc2-4287-11ee-84f6-c313b8134c83-50cb32d31c26/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 27378,
      "sha256": "60b5784879b27f9ee02762fcc74cc897a5c58a0773ed81870f18b05b528f7884",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 87,
      "updated_at": "2026-06-09T13:39:31.017Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/b846bc1c-4287-11ee-84f6-479398980580": {
    "source_id": "decoder",
    "episode_id": "b846bc1c-4287-11ee-84f6-479398980580",
    "title": "Getty Images CEO Craig Peters has a plan to defend photography from AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b846bc1c-4287-11ee-84f6-479398980580-866f27bdec2b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b846bc1c-4287-11ee-84f6-479398980580-866f27bdec2b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 30417,
      "sha256": "68493851b12c67cdedab91b23679a6afd8631f162099fa6f193c80b10204becc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 83,
      "updated_at": "2026-06-09T13:39:31.017Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/2e19da50-350f-11ed-8d52-1b3b4c990275": {
    "source_id": "decoder",
    "episode_id": "2e19da50-350f-11ed-8d52-1b3b4c990275",
    "title": "Microsoft CTO Kevin Scott on how AI and art will coexist in the future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2e19da50-350f-11ed-8d52-1b3b4c990275-32d372399c23/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2e19da50-350f-11ed-8d52-1b3b4c990275-32d372399c23/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36532,
      "sha256": "fba70e434b494073d9a11bd94d33304204816b94833405ca869d9b46858555ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 109,
      "updated_at": "2026-06-09T13:39:30.980Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/b7fd910e-4287-11ee-84f6-7b700edb5381": {
    "source_id": "decoder",
    "episode_id": "b7fd910e-4287-11ee-84f6-7b700edb5381",
    "title": "'The Android of agriculture': Monarch Tractor CEO Praveen Penmetsa on the future of farming",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b7fd910e-4287-11ee-84f6-7b700edb5381-ce9ead0990ac/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b7fd910e-4287-11ee-84f6-7b700edb5381-ce9ead0990ac/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 25880,
      "sha256": "514297d82d527655c04e10f5e4839bf30f4ab72d93935a334b19a0cb30eafefe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 66,
      "updated_at": "2026-06-09T13:39:31.016Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "decoder/b8224832-4287-11ee-84f6-17b2c770d928": {
    "source_id": "decoder",
    "episode_id": "b8224832-4287-11ee-84f6-17b2c770d928",
    "title": "AMD CEO Lisa Su on the AI revolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 30067,
      "sha256": "2528527d0307b8741b4a32830b42e6087d38605e3574e53a4ed831da8f1c52bf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 92,
      "updated_at": "2026-06-09T13:39:31.016Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40717,
      "sha256": "942dc5ab8c845183a632f529a9fdbdb1eb31dda55a49439949649474b03a94ba",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 20,
      "updated_at": "2026-06-02T10:41:52.754Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/b8224832-4287-11ee-84f6-17b2c770d928-ec515dd28f4b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 93241,
      "sha256": "041f04f0250d80af7e98836e6f0e6dac1dd29ee1757771e09b37fe3262ad1504",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 20,
      "updated_at": "2026-06-02T10:41:52.754Z"
    }
  },
  "decoder/2d643efc-350f-11ed-8d52-97387b7208ea": {
    "source_id": "decoder",
    "episode_id": "2d643efc-350f-11ed-8d52-97387b7208ea",
    "title": "There's no AI without the cloud, says AWS CEO Adam Selipsky",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/decoder-c9fbd9152b7f/2d643efc-350f-11ed-8d52-97387b7208ea-d9ed59ee0b94/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/decoder-c9fbd9152b7f/2d643efc-350f-11ed-8d52-97387b7208ea-d9ed59ee0b94/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65563,
      "sha256": "f988c15f3bfc724014db1185f89d6275dbae55ccbe0a3f393f280cc145a7e8ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 122,
      "updated_at": "2026-06-09T13:39:30.979Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:197852876": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:197852876",
    "title": "Eric Jang – Building AlphaGo from scratch",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-197852876-e22abcd4edb3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-197852876-e22abcd4edb3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 144297,
      "sha256": "1be3756e38e3e769c5504f269a79888bf88fec6d23de1d0936b9092aa1122a0a",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 396,
      "updated_at": "2026-06-09T13:39:31.132Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:196892360": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:196892360",
    "title": "David Reich – Why the Bronze Age was an inflection point in human evolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-196892360-b237d427b26d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-196892360-b237d427b26d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 133344,
      "sha256": "4cf4ae0c051f1d74d25e79bcb53d6e060968f9e34c2637833ac567f593b3e76a",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 318,
      "updated_at": "2026-06-09T13:39:31.131Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:195859978": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:195859978",
    "title": "Reiner Pope – The math behind how LLMs are trained and served",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-195859978-eca05de85f05/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-195859978-eca05de85f05/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 116316,
      "sha256": "28e02e232f16e5f858d977574db23a61bb1d9079480957c37db108dd63bead84",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 423,
      "updated_at": "2026-06-09T13:39:31.130Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:194289889": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:194289889",
    "title": "Jensen Huang – TPU competition, why we should sell chips to China, & Nvidia’s supply chain moat",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-194289889-f2ead1d526df/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-194289889-f2ead1d526df/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 97609,
      "sha256": "fdd449adfdc0c6e22f06effbd57108827103dca348bc3783a3725ced991b3db5",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 287,
      "updated_at": "2026-06-09T13:39:31.130Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:193466212": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:193466212",
    "title": "Michael Nielsen – How science actually progresses",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-193466212-6bc18590fae4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-193466212-6bc18590fae4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 113991,
      "sha256": "517498965d3a2dc2829b35e3e8873957ab4fd2ab9cf9c46ca2208b158a1828fa",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 267,
      "updated_at": "2026-06-09T13:39:31.129Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:191582481": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:191582481",
    "title": "Terence Tao – Kepler, Newton, and the true nature of mathematical discovery",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-191582481-978fd7288204/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-191582481-978fd7288204/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76274,
      "sha256": "dc137eed5148800f94b05c65fa0dbcb890fb957c37a3ec732caba9b64e990b72",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 187,
      "updated_at": "2026-06-09T13:39:31.128Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:190839917": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:190839917",
    "title": "Dylan Patel — Deep dive on the 3 big bottlenecks to scaling AI compute",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-190839917-370fc2f32843/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-190839917-370fc2f32843/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 155752,
      "sha256": "f5ba1917789aac2f3a2261ec696e6b37bf41f1c57669bcb4ab1076738e08f44a",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 430,
      "updated_at": "2026-06-09T13:39:31.127Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:190633588": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:190633588",
    "title": "The most important question nobody's asking about AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-190633588-d9f25bad3cbd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-190633588-d9f25bad3cbd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53127,
      "sha256": "608f4784d53a0d353224a54a71ee51a3468332188fe03d60f3cded9d5a4f8cd9",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 722,
      "updated_at": "2026-06-09T13:39:31.126Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:190118311": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:190118311",
    "title": "Why Leonardo was a saboteur, Gutenberg went broke, and Florence was weird – Ada Palmer",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-190118311-63af07dfd04f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-190118311-63af07dfd04f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 127663,
      "sha256": "c2c3d28b86fbac2184b63605bd8c408737882520ef0c15896ce9d5e33d69d7da",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 315,
      "updated_at": "2026-06-09T13:39:31.125Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:187852154": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:187852154",
    "title": "Dario Amodei — \"We are near the end of the exponential\"",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-187852154-caa8e8f18293/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-187852154-caa8e8f18293/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 135527,
      "sha256": "9b9a4e9dd8da9505dac832df89c5a6d2d086e434f16d1c22d9562e159a36127e",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 354,
      "updated_at": "2026-06-09T13:39:31.125Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:186967347": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:186967347",
    "title": "Elon Musk — \"In 36 months, the cheapest place to put AI will be space”",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-186967347-79297f917f01/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-186967347-79297f917f01/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 154763,
      "sha256": "6d3de133ccb41df5a77b8058e4efe41011f73a6d29446f48de17e576888cb707",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 726,
      "updated_at": "2026-06-09T13:39:31.124Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:182960540": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:182960540",
    "title": "Adam Marblestone — AI is missing something fundamental about the brain",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-182960540-002c9d7da723/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-182960540-002c9d7da723/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 115248,
      "sha256": "3da0c6eac0ca18f58f6296cafb08e21f76654debcf6524815f26b3e25e566b64",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 271,
      "updated_at": "2026-06-09T13:39:31.122Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:182443852": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:182443852",
    "title": "Thoughts on AI progress (Dec 2025)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-182443852-f4be0b811575/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-182443852-f4be0b811575/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 27630,
      "sha256": "2a5f3ec02a2e5116fdd04da6905c3f639fb2e877fbaf976233eab1eb0c59ac6a",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 377,
      "updated_at": "2026-06-09T13:39:31.121Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:182083324": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:182083324",
    "title": "Sarah Paine — Why Russia Lost the Cold War",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-182083324-ab66822e320f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-182083324-ab66822e320f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 109743,
      "sha256": "074f4231969d4de4f7ed582e92815ae3eaf0af4c0d54a55c9fea1cf8703a9b83",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 228,
      "updated_at": "2026-06-09T13:39:31.121Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:179924094": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:179924094",
    "title": "Ilya Sutskever — We're moving from the age of scaling to the age of research",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-179924094-9e3fd15c3241/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-179924094-9e3fd15c3241/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83113,
      "sha256": "8540575f2f01d3346efef32dcf34b41a9817897c3da1bc192105cd229b67ae52",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 224,
      "updated_at": "2026-06-09T13:39:31.119Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:178688356": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:178688356",
    "title": "Satya Nadella — How Microsoft is preparing for AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-178688356-4a4fe2725ba2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-178688356-4a4fe2725ba2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87989,
      "sha256": "e2091b0c19c8936ba0e678c93ea319e6c49378f00a8c9c4a65a467983279408f",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 214,
      "updated_at": "2026-06-09T13:39:31.119Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:177641179": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:177641179",
    "title": "Sarah Paine — How Russia sabotaged China's rise",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-177641179-4b6255c21791/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-177641179-4b6255c21791/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87260,
      "sha256": "fea5a0a9ae479892f451f3ccf7d61aa694d823f41e6d196694bafa579eec8a7d",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 194,
      "updated_at": "2026-06-09T13:39:31.106Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:176425744": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:176425744",
    "title": "Andrej Karpathy — AGI is still a decade away",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-176425744-2efe3287366f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-176425744-2efe3287366f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 164388,
      "sha256": "a0c4bde469a50b97a681cbf9bee191bf38b18686a4710d33a57892744b1e45cc",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 397,
      "updated_at": "2026-06-09T13:39:31.105Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:175802370": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:175802370",
    "title": "Nick Lane – Life as we know it is chemically inevitable",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-175802370-388774eba1ae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-175802370-388774eba1ae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83394,
      "sha256": "5e9324157ef853573c173a19ba44d985cdaedb0f500d699d49f6bb1cd5bc4453",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 201,
      "updated_at": "2026-06-09T13:39:31.104Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:174609513": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:174609513",
    "title": "Richard Sutton – Father of RL thinks LLMs are a dead end",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-174609513-afe8d7ad85d1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-174609513-afe8d7ad85d1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61388,
      "sha256": "eb7b73218f84a14bbf025f5b2da4ba2867b069231beb93db77cdf0fefbe68dbe",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 182,
      "updated_at": "2026-06-09T13:39:31.103Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:173427890": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:173427890",
    "title": "Fully autonomous robots are much closer than you think – Sergey Levine",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-173427890-067a26556d95/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-173427890-067a26556d95/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 92425,
      "sha256": "2b3ccfb0d9498adfa17c2e09f46137614e4fe6a59fbc407aec68d4e0f52adb9a",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 213,
      "updated_at": "2026-06-09T13:39:31.103Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:172873013": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:172873013",
    "title": "How Hitler almost starved Britain – Sarah Paine",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-172873013-134ef588e70f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-172873013-134ef588e70f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 90668,
      "sha256": "d2ee445a5cdce000e876328de8b32c1fc699c3d4d60b3f380c9a2d4640c3ff47",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 183,
      "updated_at": "2026-06-09T13:39:31.102Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:171561010": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:171561010",
    "title": "Evolution designed us to die fast; we can change that — Jacob Kimmel",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-171561010-fa084d3c2c65/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-171561010-fa084d3c2c65/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 131073,
      "sha256": "74cb19c1c3c1281942bdad90d172ca8010f4b31d242281c34d8a4b028d191125",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 299,
      "updated_at": "2026-06-09T13:39:31.102Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:171017457": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:171017457",
    "title": "China is killing the US on energy. Does that mean they’ll win AGI? — Casey Handmer",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-171017457-2bbafe3d403e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-171017457-2bbafe3d403e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83417,
      "sha256": "0be094c15584d311b9d76be8220e78aedbdea9296336e8e9a4ea05be5ca3aecf",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 301,
      "updated_at": "2026-06-09T13:39:31.101Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:170334851": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:170334851",
    "title": "Artificial meat is harder than artificial intelligence — Lewis Bollard",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-170334851-494f3953961f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-170334851-494f3953961f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79877,
      "sha256": "f03c6064cf79d183d47f9662e082e68cc3f380a2431780e54bba481e57b2e60c",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 209,
      "updated_at": "2026-06-09T13:39:31.100Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:169236978": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:169236978",
    "title": "Sarah Paine — How Imperial Japan defeated Tsarist Russia & Qing China",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-169236978-cd1ccf12b800/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-169236978-cd1ccf12b800/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 113122,
      "sha256": "4e43052037e718f4e7403d50ef84b2d29b19bddb23f101f035764b51db2fb2a6",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 241,
      "updated_at": "2026-06-09T13:39:31.100Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:167473378": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:167473378",
    "title": "Why I don’t think AGI is right around the corner",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-167473378-ec7131a43dbb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-167473378-ec7131a43dbb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 32873,
      "sha256": "a68f5989fb4737102c18e289924873d75354794129e257185a8d3f4740d557a2",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 449,
      "updated_at": "2026-06-09T13:39:31.099Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:166888604": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:166888604",
    "title": "A billion years of evolution in a single afternoon — George Church",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-166888604-8a408350b353/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-166888604-8a408350b353/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79434,
      "sha256": "160df017a13b9cc82513dd763b5e1ecfdbd11de995a29ec2c173d987095abd82",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 237,
      "updated_at": "2026-06-09T13:39:31.099Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:166313955": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:166313955",
    "title": "Why China's manufacturing economy is dominating — Arthur Kroeber",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-166313955-a12544df33d9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-166313955-a12544df33d9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 134240,
      "sha256": "740f39b9db12785594e8aa3d1a5bdfc2163ab3421abee2b6af512f1e4561e8de",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 299,
      "updated_at": "2026-06-09T13:39:31.098Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:165778647": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:165778647",
    "title": "\"China is digging out of a crisis. And America’s luck is wearing thin.\" — Ken Rogoff",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-165778647-c0e55edd0aa3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-165778647-c0e55edd0aa3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93924,
      "sha256": "9bc7ebf851d9dcecad60449063efaaea92f5236fccd7a2bf8f94aba267bf3e44",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 260,
      "updated_at": "2026-06-09T13:39:31.097Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:164717983": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:164717983",
    "title": "Xi Jinping’s paranoid approach to AGI, debt crisis, & Politburo politics — Victor Shih",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-164717983-4fe07150a97b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-164717983-4fe07150a97b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 89645,
      "sha256": "b832bf11940a7ada3c90445a713bf2d17976da1bde9c6aa846519be1a980f304",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 291,
      "updated_at": "2026-06-09T13:39:31.096Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:164189186": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:164189186",
    "title": "Is RL + LLMs enough for AGI? — Sholto Douglas & Trenton Bricken",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-164189186-2196be580d6e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-164189186-2196be580d6e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 157380,
      "sha256": "afff8c5e640df2b8ecb00fded3ac3d5c63122d0bc86082fb06b253133a9ec11b",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 572,
      "updated_at": "2026-06-09T13:39:31.095Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:162651762": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:162651762",
    "title": "What will automated firms look like?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-162651762-14703d796eba/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-162651762-14703d796eba/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 17498,
      "sha256": "0ff72eda172d80ce65f3e518887016bcf065a15fceb88a7f3192a95017c7719d",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 222,
      "updated_at": "2026-06-09T13:39:31.095Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:162392947": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:162392947",
    "title": "Mark Zuckerberg — AI will write most Meta code in 18 months",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-162392947-d4d448871103/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-162392947-d4d448871103/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69550,
      "sha256": "87e141c901150052d6178dca441a939d0676e39d7dbc784f0e08973824c844e7",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 195,
      "updated_at": "2026-06-09T13:39:31.094Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:162037097": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:162037097",
    "title": "Why Rome actually fell: plagues, slavery, & ice age — Kyle Harper",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-162037097-fe60566019f9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-162037097-fe60566019f9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73574,
      "sha256": "b9f0fde05f37e864dc7bf5414665b0e346821d904f9161976acc8d1b72cbca01",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 170,
      "updated_at": "2026-06-09T13:39:31.093Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:161532341": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:161532341",
    "title": "AGI is still 30 years away — Ege Erdil & Tamay Besiroglu",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-161532341-ae26949e6c2c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-161532341-ae26949e6c2c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 190628,
      "sha256": "fd135b0825a96895a0080452c2b147035acd5fe671fe49476a9caae2929a1097",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 13,
      "updated_at": "2026-06-09T13:39:31.092Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:160495909": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:160495909",
    "title": "AI 2027: month-by-month model of intelligence explosion — Scott Alexander & Daniel Kokotajlo",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-160495909-fc100c164524/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-160495909-fc100c164524/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 205602,
      "sha256": "f982c0d747b592f4999d2f122bfc112759fa57602aeff4e8fd89fcdbac1fbdd8",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 473,
      "updated_at": "2026-06-09T13:39:31.092Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:159824609": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:159824609",
    "title": "AMA: career advice given AGI, how I research ft. Sholto & Trenton",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-159824609-f02d9b10af88/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-159824609-f02d9b10af88/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69991,
      "sha256": "8b767862a3378c71d44eaa04a5a22177b04214100a779b5b295281b5d276da41",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 497,
      "updated_at": "2026-06-09T13:39:31.091Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:158922207": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:158922207",
    "title": "Joseph Henrich — Humans defeated smarter species with cultural evolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-158922207-208930302ff2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-158922207-208930302ff2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 133453,
      "sha256": "3f052993ca0fc02cab2e144649c0322707f755dc6617cc2918fc099bdfff4288",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 274,
      "updated_at": "2026-06-09T13:39:31.090Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:158452931": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:158452931",
    "title": "Notes on China",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-158452931-09a25c267323/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-158452931-09a25c267323/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36861,
      "sha256": "f8a9b8eb3ac186e346901d25cb0ee562be5e1a3e608cb95078da747e21be66d4",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 487,
      "updated_at": "2026-06-09T13:39:31.089Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:157454089": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:157454089",
    "title": "Satya Nadella — Microsoft’s AGI plan & quantum breakthrough",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-157454089-78657180ddad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-157454089-78657180ddad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73048,
      "sha256": "0c6c969b365152469f70c759853311b06cca404c9e2ad2f4fc24b4bd57ac1053",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 241,
      "updated_at": "2026-06-09T13:39:31.088Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:157004096": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:157004096",
    "title": "Jeff Dean & Noam Shazeer — 25 years at Google: from PageRank to AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-157004096-9e9526a00800/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-157004096-9e9526a00800/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 131479,
      "sha256": "3f3b7a410b5e7b8430f14c1330fc9a6cdb312459bc1475356247f53a3eac31de",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 479,
      "updated_at": "2026-06-09T13:39:31.087Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:156094021": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:156094021",
    "title": "Sarah Paine — How Mao conquered China (lecture & interview)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-156094021-084475b67bcb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-156094021-084475b67bcb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 116525,
      "sha256": "77f329c0f34bde7835c95b10ad2340deb91ea7b72086d92c456ccc2b291f214f",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 456,
      "updated_at": "2026-06-09T13:39:31.087Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:155541767": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:155541767",
    "title": "Sarah Paine — Why Japan lost WWII (lecture & interview)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-155541767-ce6347a6a81c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-155541767-ce6347a6a81c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 135175,
      "sha256": "0c7f0bad4e5c9a92d0ccdd5af43b8cb1efe757beca93e665b9187bae8bb5b038",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 482,
      "updated_at": "2026-06-09T13:39:31.086Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:154955657": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:154955657",
    "title": "Sarah Paine — The war for India (lecture & interview)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-154955657-4c8b526ee4bf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-154955657-4c8b526ee4bf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 137570,
      "sha256": "050c659d75fd2b2268819ae3512fd86cf5884205b069a1ee5cc600616a9fd8b6",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 214,
      "updated_at": "2026-06-09T13:39:31.085Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:154483840": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:154483840",
    "title": "Tyler Cowen — The #1 bottleneck to AI progress is humans",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-154483840-da6ec99840e5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-154483840-da6ec99840e5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72147,
      "sha256": "77c487cfeff4669de19e2c7edf2d320c289b733f61effd94a19bb3307e9cc8ce",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 297,
      "updated_at": "2026-06-09T13:39:31.084Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:153641659": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:153641659",
    "title": "Adam Brown — Bubble universes, space elevators, & AdS/CFT",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-153641659-5aeb6d32451b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-153641659-5aeb6d32451b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 173542,
      "sha256": "5d269d6df75dccab6b22cadf159ffbc5334a25c18adecbf20ad31429976d825b",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 578,
      "updated_at": "2026-06-09T13:39:31.084Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:151435243": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:151435243",
    "title": "Gwern — Anonymous writer who predicted AI trajectory on $12K/year salary",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-151435243-1f34d3cb96fe/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-151435243-1f34d3cb96fe/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 97646,
      "sha256": "ed7df6c3bab1353edec530d4e62a8b5546db3baa0feec6fc9ea922b2cfc39e95",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 317,
      "updated_at": "2026-06-09T13:39:31.083Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:149705443": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:149705443",
    "title": "@Asianometry & Dylan Patel — How the semiconductor industry actually works",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-149705443-7eda62509da7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-149705443-7eda62509da7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 138969,
      "sha256": "4e699f77673cd5fc00e75dfed276c7bfd9dd87abd63a4a0c2278e916ab0425b3",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 564,
      "updated_at": "2026-06-09T13:39:31.081Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:149019792": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:149019792",
    "title": "Daniel Yergin — Oil destroyed Hitler, fracking destroyed Putin",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-149019792-93ea0c308472/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-149019792-93ea0c308472/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 78103,
      "sha256": "a17df745280307ccd171babdb49d064f8e3863e43806f28fa9117ba34807591b",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 199,
      "updated_at": "2026-06-09T13:39:31.079Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:148257189": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:148257189",
    "title": "David Reich — How one small tribe conquered the world 70,000 years ago",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-148257189-78ea3ac89188/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-148257189-78ea3ac89188/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 117607,
      "sha256": "c8766044e23b281440c1400634ac84dca02fc22f5cc7fd928bd8434f9ff949b2",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 232,
      "updated_at": "2026-06-09T13:39:31.078Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:148002360": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:148002360",
    "title": "Joe Carlsmith — Preventing an AI takeover",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-148002360-361ef9aaa319/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-148002360-361ef9aaa319/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 286345,
      "sha256": "813d672bf633c63bd066a945db6efa80d8c168ca270478a5ade207fa1281c0b3",
      "source_kind": "official_caption",
      "source_quality": "official_transcript",
      "record_count": 3699,
      "updated_at": "2026-06-09T13:39:31.078Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:146935176": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:146935176",
    "title": "Patrick McKenzie — Money laundering, big tech censorship, SBF & Japan",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-146935176-b6d82a76fcef/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-146935176-b6d82a76fcef/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 126714,
      "sha256": "311ada0a5ee8c2edecd47c8200e02e2c0bfdd22b7a61d807e74b9d9c7a18b60a",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 367,
      "updated_at": "2026-06-09T13:39:31.077Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:146005940": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:146005940",
    "title": "Tony Blair — Why political leaders keep failing at major change",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-146005940-cb1657909902/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-146005940-cb1657909902/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48544,
      "sha256": "36cf725fef3a54d2299ba095ba1d02fa73acc3d82b6a0fcf8160405118356d8f",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 138,
      "updated_at": "2026-06-09T13:39:31.076Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:145543832": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:145543832",
    "title": "Francois Chollet — Why the biggest AI models can't solve simple puzzles",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-145543832-c5975375ae2b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-145543832-c5975375ae2b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99938,
      "sha256": "2d17826a6d0568d6fe8babe83bdd5701a061d2ffb3a4ec1231ec6de1c5f5be0d",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 323,
      "updated_at": "2026-06-09T13:39:31.076Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:145136502": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:145136502",
    "title": "Leopold Aschenbrenner — 2027 AGI, China/US super-intelligence race, & the return of history",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-145136502-a88bdc79a4f5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-145136502-a88bdc79a4f5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 282499,
      "sha256": "36311522e4d0cf8b0b7c7fc55233e7e377c681f8ddc3d7914f7ee1a645928e10",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 1006,
      "updated_at": "2026-06-09T13:39:31.075Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:144657191": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:144657191",
    "title": "John Schulman (OpenAI Cofounder) — Reasoning, RLHF, & plan for 2027 AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-144657191-65067e11a1cc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-144657191-65067e11a1cc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76276,
      "sha256": "4721f72c33c8011c3d85d68bc7b4cb83daa36a2985106d10914ccb2b63007e83",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 224,
      "updated_at": "2026-06-09T13:39:31.073Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:143705335": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:143705335",
    "title": "Mark Zuckerberg — Llama 3, $10B models, Caesar Augustus, & 1 GW datacenters",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-143705335-9a068bb6b518/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-143705335-9a068bb6b518/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68246,
      "sha256": "88f970e717ad35b0624c99001a6186ee090f5682d18b788bd8c77c4b71c03b7c",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 150,
      "updated_at": "2026-06-09T13:39:31.073Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:143040987": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:143040987",
    "title": "Sholto Douglas & Trenton Bricken — How LLMs actually think",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-143040987-435dacfc12f9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-143040987-435dacfc12f9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 201632,
      "sha256": "01c3b955e1bc87ca4cf4c757ef4f1b732b981ca1b3368575300bcbbf9e6e879e",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 613,
      "updated_at": "2026-06-09T13:39:31.072Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:142112869": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:142112869",
    "title": "Demis Hassabis — Scaling, superhuman AIs, AlphaZero atop LLMs, AlphaFold",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-142112869-7e150bf8aaaa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-142112869-7e150bf8aaaa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64074,
      "sha256": "338cf0f03852165ddb44ad6cc400420e3447aae8fde3ae72ccc5d60fea333b54",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 95,
      "updated_at": "2026-06-09T13:39:31.071Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:141895788": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:141895788",
    "title": "Patrick Collison — Why Silicon Valley's most talented should leave",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-141895788-08734909c082/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-141895788-08734909c082/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100358,
      "sha256": "2240b00255bd89c3d69b1b4faee0f7c4a6c75c6189bcc3a5c42979da142f9c65",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 217,
      "updated_at": "2026-06-09T13:39:31.071Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:141221777": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:141221777",
    "title": "Tyler Cowen — Hayek, Keynes, & Smith on AI, animal spirits, anarchy, & growth",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-141221777-fb424a0503d3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-141221777-fb424a0503d3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 119294,
      "sha256": "ff14791e6692df5e8953325b4a1f75843f734faad73920cc1b46bdc46738106d",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 326,
      "updated_at": "2026-06-09T13:39:31.070Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:138879824": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:138879824",
    "title": "Dominic Cummings - COVID, Brexit, & Fixing Western Governance",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-138879824-9d6dcd2b4494/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-138879824-9d6dcd2b4494/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 158437,
      "sha256": "246f727c64feca22c55b3899b7a9df43dfff7771cdb49d0d6e49b25f86c194d8",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 413,
      "updated_at": "2026-06-09T13:39:31.069Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:138448008": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:138448008",
    "title": "Paul Christiano — Preventing an AI takeover",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-138448008-eec8cf948fbf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-138448008-eec8cf948fbf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 239136,
      "sha256": "688deab995494bb6d8fbf3a894b2c7d5f59aea1602acba5e9ef0d02cd37e3b67",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 318,
      "updated_at": "2026-06-09T13:39:31.068Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:138292315": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:138292315",
    "title": "Shane Legg (DeepMind Founder) — 2028 AGI, superhuman alignment, new architectures",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-138292315-bc947057c7f9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-138292315-bc947057c7f9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43938,
      "sha256": "f9425622d67b1d720f46f44674fbed54a45c39d71f8c7abe59fcc4ad54d93558",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 126,
      "updated_at": "2026-06-09T13:39:31.067Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:137883930": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:137883930",
    "title": "Grant Sanderson (@3blue1brown) — Past, present, & future of mathematics",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-137883930-9c75e5e744e9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-137883930-9c75e5e744e9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 103301,
      "sha256": "66948711965e04f416df68a295ee4a772bbe844bb1b5f86a16bf7b03319836fa",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 267,
      "updated_at": "2026-06-09T13:39:31.066Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:135814349": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:135814349",
    "title": "Dario Amodei (Anthropic CEO) — The hidden pattern behind every AI breakthrough",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-135814349-0feaef365b75/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-135814349-0feaef365b75/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 134187,
      "sha256": "a8e7724c09146adb1c3b494569522744129ab868542215a8827d99e4d28b95c7",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 513,
      "updated_at": "2026-06-09T13:39:31.065Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:130214147": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:130214147",
    "title": "Carl Shulman (Pt 2) — AI Takeover, bio & cyber attacks, detecting deception, & humanity's far future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-130214147-19c76001f71f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-130214147-19c76001f71f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 149829,
      "sha256": "361ab2d9628f45026696132758691194a99f56d69bb85f0864829584a3660ade",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 181,
      "updated_at": "2026-06-09T13:39:31.064Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:128144047": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:128144047",
    "title": "Carl Shulman (Pt 1) — Intelligence explosion, primate evolution, robot doublings, & alignment",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-128144047-6e594e37cb66/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-128144047-6e594e37cb66/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 133525,
      "sha256": "b65a822915f7fe7048f16f9ff3e6b05b310d1aac6b3de379edb0559e4d11eef6",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 138,
      "updated_at": "2026-06-09T13:39:31.064Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:122974454": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:122974454",
    "title": "Richard Rhodes — The making of the atomic bomb",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-122974454-71e9ffceafab/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-122974454-71e9ffceafab/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 131913,
      "sha256": "e30627d916c1a6e8c9d67a695b3fb6c7a62cda2c98fff9da58c14516e6395910",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 144,
      "updated_at": "2026-06-09T13:39:31.063Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:112763732": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:112763732",
    "title": "Eliezer Yudkowsky — Why AI will kill us, aligning LLMs, nature of intelligence, SciFi, & rationality",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-112763732-f06b3df6fb48/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-112763732-f06b3df6fb48/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 242264,
      "sha256": "689116466aa8016925a46b1778d9f15b9169f8045abe97ff83d9aa1d1ae616ce",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 635,
      "updated_at": "2026-06-09T13:39:31.062Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:106731655": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:106731655",
    "title": "Ilya Sutskever (OpenAI Chief Scientist) — Why next-token prediction could surpass human intelligence",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-106731655-1d4bbbe56624/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-106731655-1d4bbbe56624/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50889,
      "sha256": "0b5a42f9b91d6517ce32305d18895fe9c63370bdba60ad3e4f4f278bb9c3f3b5",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 185,
      "updated_at": "2026-06-09T13:39:31.060Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:109629822": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:109629822",
    "title": "Nat Friedman (Github CEO) — Reading ancient scrolls, open source, & AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-109629822-6c93b6da3c19/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-109629822-6c93b6da3c19/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 98566,
      "sha256": "b34ffb59d78b4ee98615d02561fbb85401228af891e230273e6de363b4865c26",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 132,
      "updated_at": "2026-06-09T13:39:31.061Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:99489876": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:99489876",
    "title": "Marc Andreessen — AI, crypto, 1000 Elon Musks, regrets, vulnerabilities, & managerial revolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-99489876-43bc120d1630/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-99489876-43bc120d1630/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 88154,
      "sha256": "6ba2653a9bb5550fb475673686691ba216a356a9927f154a437d2f2592e66b5f",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 171,
      "updated_at": "2026-06-09T13:39:31.142Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:88869530": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:88869530",
    "title": "Holden Karnofsky — History's most important century",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-88869530-1e5699776148/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-88869530-1e5699776148/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 139269,
      "sha256": "704fd7fd3cdaba0864dab2fbaf58862277cf50b38db68a173aee3e701f4f5d13",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 211,
      "updated_at": "2026-06-09T13:39:31.141Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:87260678": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:87260678",
    "title": "Edward Glaeser - Cities, Terrorism, Housing, & Remote Work",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-87260678-240710fcd60f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-87260678-240710fcd60f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 59740,
      "sha256": "6957e8ff3bb7f057ba7446cfc4b34417fe06debd15e20039db8399c3a8c77891",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 117,
      "updated_at": "2026-06-09T13:39:31.140Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:80970088": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:80970088",
    "title": "Brian Potter - Future of Construction, Ugly Modernism, & Environmental Review",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-80970088-272403b060ea/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-80970088-272403b060ea/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 130825,
      "sha256": "12f4567791c28f04f263639cd74318783980bebb7fa0c25b88845486494be42b",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 204,
      "updated_at": "2026-06-09T13:39:31.139Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:75408365": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:75408365",
    "title": "Tyler Cowen - Talent, Collapse, & Pessimism of Sex",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-75408365-b010ad105755/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-75408365-b010ad105755/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 109888,
      "sha256": "254fb432af58857127bb91531405fcdbfe27b10ae6f9d4b9eded83d4efe6dc17",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 371,
      "updated_at": "2026-06-09T13:39:31.137Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:67808980": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:67808980",
    "title": "Will MacAskill - Longtermism, Altruism, History, & Technology",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-67808980-5bb818619889/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-67808980-5bb818619889/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51376,
      "sha256": "3e0d955e7d3d73c96c1795469420ccbe4249d6e1eb0dd783390f70efa99cd858",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 131,
      "updated_at": "2026-06-09T13:39:31.136Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:63827201": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:63827201",
    "title": "Alexander Mikaberidze - Napoleon, War, Progress, and Global Order",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-63827201-264e05522f6c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-63827201-264e05522f6c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93447,
      "sha256": "c6ef2bd62ca28428f071dbb13c755e6129efa8c59ffcb6ff77f5a34d6dc99793",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 770,
      "updated_at": "2026-06-09T13:39:31.136Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:61927464": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:61927464",
    "title": "Sam Bankman-Fried - Crypto, Altruism, and Leadership",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-61927464-339e76aa872f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-61927464-339e76aa872f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41638,
      "sha256": "e3e6d17edf65e36c9f6a1853f670f9308cbf6f5acd1a37c34722a80ffc544324",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 87,
      "updated_at": "2026-06-09T13:39:31.135Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:54281341": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:54281341",
    "title": "Ananyo Bhattacharya - John von Neumann, Jewish Genius, and Nuclear War",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-54281341-d02f797b3814/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-54281341-d02f797b3814/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45967,
      "sha256": "13f2a7342fc98bc1d4f8cc217951834162445ce1ad8d713729f51928eb805a6e",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 244,
      "updated_at": "2026-06-09T13:39:31.134Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:53416271": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:53416271",
    "title": "Stephen Grugett (Manifold Markets Founder) - Predictions Markets & Revolutionizing Governance",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-53416271-a3a3de524c0e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-53416271-a3a3de524c0e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75823,
      "sha256": "e9f15014a5778d779c7b3c8ec6b5c583cf718af47d2c05e0232ae5f31e75c0d4",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 710,
      "updated_at": "2026-06-09T13:39:31.133Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/substack:post:53132223": {
    "source_id": "dwarkesh",
    "episode_id": "substack:post:53132223",
    "title": "Pradyu Prasad - Imperial Japan, the God Emperor, and Militarization in the Modern World",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/substack-post-53132223-e895d48b4d7d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/substack-post-53132223-e895d48b4d7d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 133009,
      "sha256": "77a0ba157527b5747c7b8b294386d6e9cddbad0347ef0c6b0daeab14e06fb294",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1182,
      "updated_at": "2026-06-09T13:39:31.133Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/ffd226de-c3cc-4ace-b774-6ab0014a4831": {
    "source_id": "dwarkesh",
    "episode_id": "ffd226de-c3cc-4ace-b774-6ab0014a4831",
    "title": "Jimmy Soni - Peter Thiel, Elon Musk, and the Paypal Mafia",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/ffd226de-c3cc-4ace-b774-6ab0014a4831-f9ec1a15419b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/ffd226de-c3cc-4ace-b774-6ab0014a4831-f9ec1a15419b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100658,
      "sha256": "79e42a0d2a47396fe056b354a6f2b118c669cc93546853bc8d95a807a796ff57",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 821,
      "updated_at": "2026-06-09T13:39:31.059Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/f8b35dae-5bb0-4f87-92ad-a5a3c6d46233": {
    "source_id": "dwarkesh",
    "episode_id": "f8b35dae-5bb0-4f87-92ad-a5a3c6d46233",
    "title": "Bryan Caplan - Discrimination, Poverty, & Mental Illness",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/f8b35dae-5bb0-4f87-92ad-a5a3c6d46233-8334eca84215/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/f8b35dae-5bb0-4f87-92ad-a5a3c6d46233-8334eca84215/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84757,
      "sha256": "69fa0851b5127f42e3738278d0e36d378dda31d638c4444d6d5d6f97dcd1660b",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 545,
      "updated_at": "2026-06-09T13:39:31.058Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/32d37eb3-6dbf-48fa-bd7a-0267c37f696b": {
    "source_id": "dwarkesh",
    "episode_id": "32d37eb3-6dbf-48fa-bd7a-0267c37f696b",
    "title": "Richard Hanania - Foreign Policy, Fertility, and Wokeness",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/32d37eb3-6dbf-48fa-bd7a-0267c37f696b-8b1da200fcd7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/32d37eb3-6dbf-48fa-bd7a-0267c37f696b-8b1da200fcd7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 86034,
      "sha256": "f5156b9a774b453ce3fdf4b6631b0802e185b9c5d00d362b2a4b0267857be7b0",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 639,
      "updated_at": "2026-06-09T13:39:31.049Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/1ffe9a59-d756-48ca-b87a-192259f43ca2": {
    "source_id": "dwarkesh",
    "episode_id": "1ffe9a59-d756-48ca-b87a-192259f43ca2",
    "title": "David Deutsch - AI, America, Fun, & Bayes",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/1ffe9a59-d756-48ca-b87a-192259f43ca2-cf88f9543ac5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/1ffe9a59-d756-48ca-b87a-192259f43ca2-cf88f9543ac5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62931,
      "sha256": "1e3e7aca5f5933de83385037fd28a045ae197159a17b0212e3a2879eb030ef58",
      "source_kind": "official_html_transcript",
      "source_quality": "official_transcript",
      "record_count": 94,
      "updated_at": "2026-06-09T13:39:31.047Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/85904519-0ca8-4521-b066-d2122436f7a1": {
    "source_id": "dwarkesh",
    "episode_id": "85904519-0ca8-4521-b066-d2122436f7a1",
    "title": "Byrne Hobart - Optionality, Stagnation, and Secret Societies",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/85904519-0ca8-4521-b066-d2122436f7a1-42069ff21ebc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/85904519-0ca8-4521-b066-d2122436f7a1-42069ff21ebc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100749,
      "sha256": "67bceb847cf2fb858710e2e232cf9444cf0b9750876e9a190b4d8ab9c8c916e9",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 688,
      "updated_at": "2026-06-09T13:39:31.050Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/2b997491-6b70-49b2-93de-c03c88c76597": {
    "source_id": "dwarkesh",
    "episode_id": "2b997491-6b70-49b2-93de-c03c88c76597",
    "title": "David Friedman - Dating Markets, Legal Systems, Bitcoin, and Automation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/2b997491-6b70-49b2-93de-c03c88c76597-4249aba0fe2d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/2b997491-6b70-49b2-93de-c03c88c76597-4249aba0fe2d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 112061,
      "sha256": "5a3e33941ea39e9025a68cfcdca807c98681a80de2fb16a79f8d5bc23b1c1f90",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 995,
      "updated_at": "2026-06-09T13:39:31.047Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/ecb713ac-42ba-4559-8658-52f07e7f8890": {
    "source_id": "dwarkesh",
    "episode_id": "ecb713ac-42ba-4559-8658-52f07e7f8890",
    "title": "Sarah Fitz-Claridge - Taking Children Seriously",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/ecb713ac-42ba-4559-8658-52f07e7f8890-77567eba17cf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/ecb713ac-42ba-4559-8658-52f07e7f8890-77567eba17cf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 59457,
      "sha256": "47974160c2f645107a3387472f4633fcc90e8e8bfe5d7e9b5f1ad9890c65adf8",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 413,
      "updated_at": "2026-06-09T13:39:31.057Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/e3005a16-7cd3-4e5f-9226-4f987c767799": {
    "source_id": "dwarkesh",
    "episode_id": "e3005a16-7cd3-4e5f-9226-4f987c767799",
    "title": "Michael Huemer - Anarchy, Capitalism, and Progress",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/e3005a16-7cd3-4e5f-9226-4f987c767799-ce3293da80d2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/e3005a16-7cd3-4e5f-9226-4f987c767799-ce3293da80d2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 128171,
      "sha256": "328eef8f978c9ae7e3e22d18a8786adfd8421a21634d6f2dca19593a2e495850",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1131,
      "updated_at": "2026-06-09T13:39:31.056Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/e4203d6a-12bf-488a-a3e8-8d9385395c20": {
    "source_id": "dwarkesh",
    "episode_id": "e4203d6a-12bf-488a-a3e8-8d9385395c20",
    "title": "Uncle Bob - The Long Reach of Code",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/e4203d6a-12bf-488a-a3e8-8d9385395c20-dfb3e729c804/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/e4203d6a-12bf-488a-a3e8-8d9385395c20-dfb3e729c804/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57211,
      "sha256": "8aba4dd6b7afe4aa0322aac1bcfc73ade74e4105874bd66a70fed18ad79bb12b",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 492,
      "updated_at": "2026-06-09T13:39:31.057Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/15793f76-92ce-4970-ac60-bb3efdaa9333": {
    "source_id": "dwarkesh",
    "episode_id": "15793f76-92ce-4970-ac60-bb3efdaa9333",
    "title": "Scott Aaronson - Quantum Computing, Complexity, and Creativity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/15793f76-92ce-4970-ac60-bb3efdaa9333-d45468bcd095/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/15793f76-92ce-4970-ac60-bb3efdaa9333-d45468bcd095/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 89911,
      "sha256": "123af45f172f61ce1de065a56283b651fa3d90be32b0fc37e481a45b268561ad",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 590,
      "updated_at": "2026-06-09T13:39:31.046Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/9374f6f9-3713-44e2-95b9-01860a885e1f": {
    "source_id": "dwarkesh",
    "episode_id": "9374f6f9-3713-44e2-95b9-01860a885e1f",
    "title": "Charles Murray - Human Accomplishment and the Future of Liberty",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/9374f6f9-3713-44e2-95b9-01860a885e1f-b484db28986f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/9374f6f9-3713-44e2-95b9-01860a885e1f-b484db28986f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 131995,
      "sha256": "3205b02c7a6ac100cd41eeb95959182d312b3eb921f82e333987929e465b276f",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1210,
      "updated_at": "2026-06-09T13:39:31.051Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/98ce85bb-85a4-4e8f-bb02-568ae1e2cb0a": {
    "source_id": "dwarkesh",
    "episode_id": "98ce85bb-85a4-4e8f-bb02-568ae1e2cb0a",
    "title": "Alex Tabarrok - Prizes, Prices, and Public Goods",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/98ce85bb-85a4-4e8f-bb02-568ae1e2cb0a-6571a4d1c911/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/98ce85bb-85a4-4e8f-bb02-568ae1e2cb0a-6571a4d1c911/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 112944,
      "sha256": "f9b043497e5a2c2499b1cc28a1ce0d44b41284452ae8d5bf351afda7bc5722e9",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1021,
      "updated_at": "2026-06-09T13:39:31.053Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/b7f28c5f-6deb-4949-9f7f-4634da5b54e7": {
    "source_id": "dwarkesh",
    "episode_id": "b7f28c5f-6deb-4949-9f7f-4634da5b54e7",
    "title": "Caleb Watney - America's Innovation Engine",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/b7f28c5f-6deb-4949-9f7f-4634da5b54e7-1a69c65dd3d9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/b7f28c5f-6deb-4949-9f7f-4634da5b54e7-1a69c65dd3d9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77904,
      "sha256": "76ea76c7bdc5f1eabedb625acf027ac090d79cb5bb2b2ca4018c17d59d51151b",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 480,
      "updated_at": "2026-06-09T13:39:31.055Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/da2e9579-d282-4e06-a7ce-f3fe565a7cf4": {
    "source_id": "dwarkesh",
    "episode_id": "da2e9579-d282-4e06-a7ce-f3fe565a7cf4",
    "title": "Robin Hanson - The Long View",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/da2e9579-d282-4e06-a7ce-f3fe565a7cf4-9218b469aaef/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/da2e9579-d282-4e06-a7ce-f3fe565a7cf4-9218b469aaef/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 143365,
      "sha256": "af4074b5e1c3f21d78cc1b97758e9812df582e6ac20679a7067db74dfe2a5927",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 1231,
      "updated_at": "2026-06-09T13:39:31.056Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/a2472ffc-32fe-45a9-96f2-7b3e55dd7138": {
    "source_id": "dwarkesh",
    "episode_id": "a2472ffc-32fe-45a9-96f2-7b3e55dd7138",
    "title": "Jason Crawford - The Roots of Progress",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/a2472ffc-32fe-45a9-96f2-7b3e55dd7138-50f2a36a8a95/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/a2472ffc-32fe-45a9-96f2-7b3e55dd7138-50f2a36a8a95/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 74469,
      "sha256": "95db8fc55425546926e531cd47263b3f4ae0a578631490cbe1451010998c6535",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 731,
      "updated_at": "2026-06-09T13:39:31.053Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/4c6063da-3fa3-4319-83df-a0bad562c718": {
    "source_id": "dwarkesh",
    "episode_id": "4c6063da-3fa3-4319-83df-a0bad562c718",
    "title": "Matjaž Leonardis - Science, Identity, and Probability",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/4c6063da-3fa3-4319-83df-a0bad562c718-9371e941e577/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/4c6063da-3fa3-4319-83df-a0bad562c718-9371e941e577/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47260,
      "sha256": "7acc2dec23f798fb640dda913e0bfa0077a7e1f1ea18fefa97acd5623713f749",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 373,
      "updated_at": "2026-06-09T13:39:31.049Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "dwarkesh/b7c107f0-86ed-487f-93e8-7cc95963ae1c": {
    "source_id": "dwarkesh",
    "episode_id": "b7c107f0-86ed-487f-93e8-7cc95963ae1c",
    "title": "Tyler Cowen - The Great Reset",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/dwarkesh-0e50355db355/b7c107f0-86ed-487f-93e8-7cc95963ae1c-fa189f5c2779/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/dwarkesh-0e50355db355/b7c107f0-86ed-487f-93e8-7cc95963ae1c-fa189f5c2779/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 67030,
      "sha256": "813d26cce667d1852969bddd8858d40b9dae9074f3aa642d80efa079fb3f6631",
      "source_kind": "whisper_cpp_raw_json",
      "source_quality": "asr_transcript",
      "record_count": 608,
      "updated_at": "2026-06-09T13:39:31.054Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:200614482": {
    "source_id": "latent-space",
    "episode_id": "substack:post:200614482",
    "title": "Reality: The Final Eval — Lukas Petersson and Axel Backlund of Andon Labs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-200614482-c408656e3141/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-200614482-c408656e3141/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93602,
      "sha256": "9b42646c3920f186ffc460c744aa738cc9151b56c835bdf581c5be65d19e0798",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 478,
      "updated_at": "2026-06-09T13:39:18.160Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:200249307": {
    "source_id": "latent-space",
    "episode_id": "substack:post:200249307",
    "title": "GitHub's plan for Agents — Kyle Daigle, GitHub",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-200249307-5b2b4976283b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-200249307-5b2b4976283b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 92771,
      "sha256": "a5ce5bdb7caf0127c4d0beb8ed37fd42cb9b0094ffcbe480eba74e7fba24f6b0",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 290,
      "updated_at": "2026-06-09T13:39:18.155Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:200078058": {
    "source_id": "latent-space",
    "episode_id": "substack:post:200078058",
    "title": "Why Video Agent models are next — Ethan He, xAI Grok Imagine",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-200078058-5f6c3b3d9d12/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-200078058-5f6c3b3d9d12/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 102972,
      "sha256": "a290d54ca0f750f311e335a480cd9a23a7aa9ec3f9abd3c9b1b92bf2f7c39e4a",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 482,
      "updated_at": "2026-06-09T13:39:18.150Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:199607874": {
    "source_id": "latent-space",
    "episode_id": "substack:post:199607874",
    "title": "The Age of Async Agents — Cognition's Walden Yan & OpenInspect's Cole Murray",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-199607874-caafccb81829/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-199607874-caafccb81829/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77106,
      "sha256": "dfc75de7d0db16cd66d7e0f813d88678df638b475133fc7989429d963b488ad7",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 252,
      "updated_at": "2026-06-09T13:39:18.145Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:198688585": {
    "source_id": "latent-space",
    "episode_id": "substack:post:198688585",
    "title": "Giving Agents Computers — Ivan Burazin, Daytona",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-198688585-55a9f3bfecdb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-198688585-55a9f3bfecdb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 94442,
      "sha256": "206d0abafc1a496e0f7c3cb74fcf71f07d7582346685af45cb37a66e781e7454",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 403,
      "updated_at": "2026-06-09T13:39:18.141Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:198575235": {
    "source_id": "latent-space",
    "episode_id": "substack:post:198575235",
    "title": "Railway: The Agent-Native Cloud — Jake Cooper",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-198575235-2a7153a90f85/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-198575235-2a7153a90f85/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73537,
      "sha256": "6195fadb7b4f69431d8330f8107bdf0017cf5a64f8338088b9e7245c4d70b3da",
      "source_kind": "official_catalog_embedded_transcript",
      "source_quality": "official_transcript",
      "record_count": 307,
      "updated_at": "2026-06-09T13:39:18.136Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:197417280": {
    "source_id": "latent-space",
    "episode_id": "substack:post:197417280",
    "title": "AI-Native Healthcare: 100M Doctor Visits, 10–20 Hours Saved, Prior Auth in Minutes — Janie Lee & Chai Asawa, Abridge",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-197417280-2c6296885273/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-197417280-2c6296885273/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76285,
      "sha256": "e6a514a16a08290e75f4b1c989cded984747e73ca2114c340e900b534dd4ad9b",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 276,
      "updated_at": "2026-06-09T13:39:31.233Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:195677117": {
    "source_id": "latent-space",
    "episode_id": "substack:post:195677117",
    "title": "Physical AI that Moves the World — Qasar Younis & Peter Ludwig, Applied Intuition",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-195677117-0b4dbbe08a85/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-195677117-0b4dbbe08a85/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 92058,
      "sha256": "95c5353172d3fabaab2440a413648be8aa827e34218008a7715e5c36604e6011",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 410,
      "updated_at": "2026-06-09T13:39:31.232Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:195264855": {
    "source_id": "latent-space",
    "episode_id": "substack:post:195264855",
    "title": "AIE Europe Debrief + Agent Labs Thesis: Unsupervised Learning x Latent Space Crossover Special (2026)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-195264855-d8a243238924/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-195264855-d8a243238924/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71498,
      "sha256": "5d465cc63e4dbd9d14c542cff679cf4ce09df823053bfe56ed7cca948edb95e1",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 190,
      "updated_at": "2026-06-09T13:39:31.231Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:195067855": {
    "source_id": "latent-space",
    "episode_id": "substack:post:195067855",
    "title": "Shopify’s AI Phase Transition: 2026 Usage Explosion, Unlimited Opus-4.6 Token Budget, Tangle, Tangent, SimGym — with Mikhail Parakhin, Shopify CTO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-195067855-ab71999b209f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-195067855-ab71999b209f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 78486,
      "sha256": "71c777ad01d9480073a64161fcaea017448f7e9c0c2fe079419d79d8e96ac4e9",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 139,
      "updated_at": "2026-06-09T13:39:31.231Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:194195821": {
    "source_id": "latent-space",
    "episode_id": "substack:post:194195821",
    "title": "Notion’s Token Town: 5 Rebuilds, 100+ Tools, MCP vs CLIs and the Software Factory Future — Simon Last & Sarah Sachs of Notion",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-194195821-d7b1aa1e7b9f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-194195821-d7b1aa1e7b9f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 118825,
      "sha256": "69591807dc2f1b508814d321fc76f726cecaf92f793f05bf9c6d830263fba43e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 448,
      "updated_at": "2026-06-09T13:39:31.230Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:193478192": {
    "source_id": "latent-space",
    "episode_id": "substack:post:193478192",
    "title": "Extreme Harness Engineering for Token Billionaires: 1M LOC, 1B toks/day, 0% human code, 0% human review — Ryan Lopopolo, OpenAI Frontier & Symphony",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-193478192-41571bef1791/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-193478192-41571bef1791/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93448,
      "sha256": "7d278ad828998a0cb78e6021939aad84e48b0e7db658cdfac63c56fa5a696c8f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 506,
      "updated_at": "2026-06-09T13:39:31.229Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:193082940": {
    "source_id": "latent-space",
    "episode_id": "substack:post:193082940",
    "title": "Marc Andreessen introspects on The Death of the Browser, Pi + OpenClaw, and Why \"This Time Is Different\"",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-193082940-f7dfa5691688/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-193082940-f7dfa5691688/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 123769,
      "sha256": "b810a0c784be85ff9ee6b0d4e3320f4122d34506b6b251ceab4e6f36110e9742",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 234,
      "updated_at": "2026-06-09T13:39:31.228Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:192967759": {
    "source_id": "latent-space",
    "episode_id": "substack:post:192967759",
    "title": "Moonlake: Causal World Models should be Multimodal, Interactive, and Efficient — with Chris Manning and Fan-yun Sun",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-192967759-a3ca4f6c935c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-192967759-a3ca4f6c935c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 80636,
      "sha256": "4037ade0d6d43f8f2d358ed849be9d62d974df0ab8bf88c878efc7711b92b68e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 458,
      "updated_at": "2026-06-09T13:39:31.227Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:192356063": {
    "source_id": "latent-space",
    "episode_id": "substack:post:192356063",
    "title": "Mistral: Voxtral TTS, Forge, Leanstral, & what's next for Mistral 4 — w/ Pavan Kumar Reddy & Guillaume Lample",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-192356063-a6dc64384c70/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-192356063-a6dc64384c70/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64419,
      "sha256": "6a92c9c36cc5690f7131b8195e55687463caead40703dca79a7aaf0d7b6e3454",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 214,
      "updated_at": "2026-06-09T13:39:31.226Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:191603783": {
    "source_id": "latent-space",
    "episode_id": "substack:post:191603783",
    "title": "Dreamer: the Personal Agent OS — David Singleton",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-191603783-92a2e702082f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-191603783-92a2e702082f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 92219,
      "sha256": "09e6d07b8c9d37df85e1b4f5a726c5decd66abe233db303badf704e5c9275a46",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 484,
      "updated_at": "2026-06-09T13:39:31.225Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:191097767": {
    "source_id": "latent-space",
    "episode_id": "substack:post:191097767",
    "title": "Why Anthropic Thinks AI Should Have Its Own Computer — Felix Rieseberg of Claude Cowork & Claude Code Desktop",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-191097767-70ab15871529/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-191097767-70ab15871529/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 112991,
      "sha256": "5023237cc6ca8840148b5efc22c4ab2003880646c33c30d3f55d98cc69c5212f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 402,
      "updated_at": "2026-06-09T13:39:31.224Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:190777516": {
    "source_id": "latent-space",
    "episode_id": "substack:post:190777516",
    "title": "Retrieval After RAG: Hybrid Search, Agents, and Database Design — Simon Hørup Eskildsen of Turbopuffer",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-190777516-6ed049c9bb20/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-190777516-6ed049c9bb20/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77879,
      "sha256": "23d11c0c6c27c3ddf07beef865fad41258578ebb0aab752244dba2cff6fecdf4",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 170,
      "updated_at": "2026-06-09T13:39:31.223Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:190477229": {
    "source_id": "latent-space",
    "episode_id": "substack:post:190477229",
    "title": "NVIDIA's AI Engineers: Agent Inference at Planetary Scale and \"Speed of Light\" — Nader Khalil (Brev), Kyle Kranen (Dynamo)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-190477229-b371c9d47c80/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-190477229-b371c9d47c80/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 119743,
      "sha256": "58fa055b4184fcbcbb497861fea913c13f3987470264eeb16f1a004870bef24e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 589,
      "updated_at": "2026-06-09T13:39:31.222Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:190063769": {
    "source_id": "latent-space",
    "episode_id": "substack:post:190063769",
    "title": "Cursor's Third Era: Cloud Agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-190063769-a792c7517691/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-190063769-a792c7517691/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87491,
      "sha256": "651072f149e28059eebfa1f35116c10e37f75fd07c787011f438ba6ac6532d30",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 422,
      "updated_at": "2026-06-09T13:39:31.222Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:189936942": {
    "source_id": "latent-space",
    "episode_id": "substack:post:189936942",
    "title": "Every Agent Needs a Box — Aaron Levie, Box",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-189936942-98d3d54ea065/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-189936942-98d3d54ea065/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 109200,
      "sha256": "f3388fbbe625d234e8b9ac1abd723b9306d841b0b7960fb45460c6a84b826659",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 535,
      "updated_at": "2026-06-09T13:39:31.221Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:189149291": {
    "source_id": "latent-space",
    "episode_id": "substack:post:189149291",
    "title": "🔬Searching the Space of All Possible Materials — Prof. Max Welling, CuspAI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-189149291-52e405ed5b41/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-189149291-52e405ed5b41/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37040,
      "sha256": "9fde65765b6e457adee1890c5db22cf6db1446d5ff4eda6ee37cb18561fc3ec7",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 54,
      "updated_at": "2026-06-09T13:39:31.220Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:188504140": {
    "source_id": "latent-space",
    "episode_id": "substack:post:188504140",
    "title": "Bitter Lessons in Venture vs Growth: Anthropic vs OpenAI, Noam Shazeer, World Labs, Thinking Machines, Cursor, ASIC Economics — Martin Casado & Sarah Wang of a16z",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-188504140-98422597763c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-188504140-98422597763c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 86023,
      "sha256": "939578895c6ed04b9f3c94908bef1d3f3e951fde549b218d280cdf2257ceb116",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 484,
      "updated_at": "2026-06-09T13:39:31.219Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:187741497": {
    "source_id": "latent-space",
    "episode_id": "substack:post:187741497",
    "title": "Owning the AI Pareto Frontier — Jeff Dean",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-187741497-ce078c4e86f3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-187741497-ce078c4e86f3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84957,
      "sha256": "7dc29d850275e919e6fd729206fd2877f59c19560f8ae79f525cc3806659517d",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.219Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:187696911": {
    "source_id": "latent-space",
    "episode_id": "substack:post:187696911",
    "title": "🔬Beyond AlphaFold: How Boltz is Open-Sourcing the Future of Drug Discovery",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-187696911-52ed09fa8e0e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-187696911-52ed09fa8e0e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 74409,
      "sha256": "f7df4b912543b0e3046e9812f4fe8af064cc4c218054fb5a24fb2b4f75e7f054",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 86,
      "updated_at": "2026-06-09T13:39:31.218Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:187000315": {
    "source_id": "latent-space",
    "episode_id": "substack:post:187000315",
    "title": "The First Mechanistic Interpretability Frontier Lab — Myra Deng & Mark Bissell of Goodfire AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-187000315-5707b35132fa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-187000315-5707b35132fa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79371,
      "sha256": "f83e3cbab915bebfb1640ffcb68ea97d35a39f44739b828a23acd002943217ef",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.217Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:183902568": {
    "source_id": "latent-space",
    "episode_id": "substack:post:183902568",
    "title": "Artificial Analysis: Independent LLM Evals as a Service — with George Cameron and Micah-Hill Smith",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-183902568-f7757efc520c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-183902568-f7757efc520c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 91552,
      "sha256": "1af0bda400edeec33010d9ddbe348f532430c1bc899c6dd073aaf60c9e81bbf6",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 204,
      "updated_at": "2026-06-09T13:39:31.216Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:160956446": {
    "source_id": "latent-space",
    "episode_id": "substack:post:160956446",
    "title": "SF Compute: Commoditizing Compute to solve the GPU Bubble forever",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-160956446-a679725cedf4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-160956446-a679725cedf4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84473,
      "sha256": "d624440f224ba058d392941e4c75b2ab982890b4377672ebfae3a884f30c1fa1",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 22,
      "updated_at": "2026-06-09T13:39:31.215Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:160464452": {
    "source_id": "latent-space",
    "episode_id": "substack:post:160464452",
    "title": "The Creators of Model Context Protocol",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-160464452-9a3c604f3f31/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-160464452-9a3c604f3f31/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 89764,
      "sha256": "c3fe317fe96928fd9b59751b8bd6dd2ca36362160a0daa277ca43b030625d790",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.214Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:160102198": {
    "source_id": "latent-space",
    "episode_id": "substack:post:160102198",
    "title": "Unsupervised Learning x Latent Space Crossover Special",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-160102198-cce3e7e58cf1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-160102198-cce3e7e58cf1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87408,
      "sha256": "4e65b661dc77e9d9c3e63bce65ef3a05bde62891ebc4ce8a455e9397bf1a1e05",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 441,
      "updated_at": "2026-06-09T13:39:31.214Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:159929627": {
    "source_id": "latent-space",
    "episode_id": "substack:post:159929627",
    "title": "The Agent Network — Dharmesh Shah",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-159929627-d457635806ed/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-159929627-d457635806ed/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 128155,
      "sha256": "aa7db5055778d14d5661f8d3e282188803e42c71e391d831db379daa1212d7a9",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 160,
      "updated_at": "2026-06-09T13:39:31.213Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:158077685": {
    "source_id": "latent-space",
    "episode_id": "substack:post:158077685",
    "title": "Building Snipd: The AI Podcast App for Learning",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-158077685-17da573d63d9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-158077685-17da573d63d9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84633,
      "sha256": "e440be1429d603ac8489e7eb7c63f53123f8ab16883037585798859ef0e37925",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 163,
      "updated_at": "2026-06-09T13:39:31.211Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:158852522": {
    "source_id": "latent-space",
    "episode_id": "substack:post:158852522",
    "title": "⚡️The new OpenAI Agents Platform",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-158852522-33f2b07d486d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-158852522-33f2b07d486d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 31284,
      "sha256": "69c888f98a6db0e6ec7d9c723be941bde3bebf15828fe3dff99b495cbcc66a9f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 63,
      "updated_at": "2026-06-09T13:39:31.212Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:158069581": {
    "source_id": "latent-space",
    "episode_id": "substack:post:158069581",
    "title": "Open Operator, Serverless Browsers and the Future of Computer-Using Agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-158069581-ff70898c089c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-158069581-ff70898c089c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79056,
      "sha256": "dc58f035dbc3c088a0ee09e3a4dd1b9daa471820324ede174d7243e32825fb0b",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 124,
      "updated_at": "2026-06-09T13:39:31.211Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:157348543": {
    "source_id": "latent-space",
    "episode_id": "substack:post:157348543",
    "title": "The Inventors of Deep Research",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-157348543-ac25f9190bd5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-157348543-ac25f9190bd5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69360,
      "sha256": "c100b2a84c8f86451a7b285cba4289ec883620e3f0cc56a55ea78eb44db6ee3f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 107,
      "updated_at": "2026-06-09T13:39:31.210Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:157072991": {
    "source_id": "latent-space",
    "episode_id": "substack:post:157072991",
    "title": "Bee AI: The Wearable Ambient Agent",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-157072991-448b12d75798/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-157072991-448b12d75798/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 78297,
      "sha256": "32b47d52682a1327074b9c6d10f5b0f7457d58ac3b8ed676ce4cd4129efbedd9",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 233,
      "updated_at": "2026-06-09T13:39:31.209Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:156886978": {
    "source_id": "latent-space",
    "episode_id": "substack:post:156886978",
    "title": "The AI Architect — Bret Taylor",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-156886978-48512375f0e6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-156886978-48512375f0e6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 118194,
      "sha256": "c2606fd130b9eefdc8a62bec174ee86611f84b06e70c3f412f2da2851105e112",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 487,
      "updated_at": "2026-06-09T13:39:31.208Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:156609115": {
    "source_id": "latent-space",
    "episode_id": "substack:post:156609115",
    "title": "Agent Engineering with Pydantic + Graphs — with Samuel Colvin",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-156609115-c3230f1cb061/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-156609115-c3230f1cb061/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75029,
      "sha256": "d73a843afc8f23aad6ad701541263ecebb78b422541e9ad9683da74417556eb6",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 127,
      "updated_at": "2026-06-09T13:39:31.207Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:155459121": {
    "source_id": "latent-space",
    "episode_id": "substack:post:155459121",
    "title": "The Agent Reasoning Interface: o1/o3, Claude 3, ChatGPT Canvas, Tasks, and Operator — with Karina Nguyen of OpenAI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-155459121-a25a313219f9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-155459121-a25a313219f9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75120,
      "sha256": "3a485bdf810760f69fcc84abc39702204cb23e60b7a8bf5cf4f705de4deb21f0",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.204Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:155708308": {
    "source_id": "latent-space",
    "episode_id": "substack:post:155708308",
    "title": "Outlasting Noam Shazeer, crowdsourcing Chai AI with >1.4m DAU, and becoming the \"Western DeepSeek\" — with William Beauchamp, Chai Research",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-155708308-9bbc3fc3b1db/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-155708308-9bbc3fc3b1db/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 81198,
      "sha256": "fa7edd3e85b987682f92eca046b55a14631e05ed712d721aa2b0e3041605f60f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 90,
      "updated_at": "2026-06-09T13:39:31.206Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:154656957": {
    "source_id": "latent-space",
    "episode_id": "substack:post:154656957",
    "title": "[Ride Home] Simon Willison: Things we learned about LLMs in 2024",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-154656957-4fd753bb274f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-154656957-4fd753bb274f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 95565,
      "sha256": "6f294f2f323f449ae84838bda8593ba669eb0c0f1eb0eb7bb8c3376c1016ec57",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 430,
      "updated_at": "2026-06-09T13:39:31.203Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:154427658": {
    "source_id": "latent-space",
    "episode_id": "substack:post:154427658",
    "title": "Beating Google at Search with Neural PageRank and $5M of H200s — with Will Bryk of Exa.ai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-154427658-737c6449f2b9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-154427658-737c6449f2b9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72983,
      "sha256": "e89f351c20a1ca534ba5bd5757e9998bc0b02a9bdb05d2af6ca3c6f48d734e70",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 128,
      "updated_at": "2026-06-09T13:39:31.201Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:154105963": {
    "source_id": "latent-space",
    "episode_id": "substack:post:154105963",
    "title": "AI Engineering for Art — with comfyanonymous, of ComfyUI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-154105963-4abceefd2e8e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-154105963-4abceefd2e8e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50131,
      "sha256": "9f49437d96ceafd2d00ca59c995f33c0646f0f64222947563bafc3da079b48aa",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 185,
      "updated_at": "2026-06-09T13:39:31.200Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:153836966": {
    "source_id": "latent-space",
    "episode_id": "substack:post:153836966",
    "title": "Latent.Space 2024 Year in Review",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-153836966-77109a6e0915/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-153836966-77109a6e0915/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 140377,
      "sha256": "33adee8c8fd8c32ac19aaa86e68cb6df66c7c9f3bb8f65c1c8adcc6fb8b3e58f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 656,
      "updated_at": "2026-06-09T13:39:31.200Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:153568377": {
    "source_id": "latent-space",
    "episode_id": "substack:post:153568377",
    "title": "2024 in Agents [LS Live! @ NeurIPS 2024]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-153568377-d838a47341be/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-153568377-d838a47341be/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56283,
      "sha256": "0c310d8d5ab95d200fbaaff3132db596761f42958fe821ad9e7ed140abe435ee",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 237,
      "updated_at": "2026-06-09T13:39:31.199Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:153567986": {
    "source_id": "latent-space",
    "episode_id": "substack:post:153567986",
    "title": "2024 in Synthetic Data and Smol Models [LS Live @ NeurIPS]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-153567986-e5f6d1cf5d41/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-153567986-e5f6d1cf5d41/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33350,
      "sha256": "d1d1f7f3d98b11576ab14608627ad0c068303e15bc7ae3bf71ddb537106fa40b",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:31.198Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:153556680": {
    "source_id": "latent-space",
    "episode_id": "substack:post:153556680",
    "title": "2024 in Post-Transformers Architectures (State Space Models, RWKV) [LS Live @ NeurIPS]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-153556680-e044a4f8abd6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-153556680-e044a4f8abd6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52145,
      "sha256": "6bc9273d2beb5bbe9678702266569936a0f5bab0b0f0114380636e2256fb5531",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 187,
      "updated_at": "2026-06-09T13:39:31.197Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:153509369": {
    "source_id": "latent-space",
    "episode_id": "substack:post:153509369",
    "title": "2024 in Open Models [LS Live @ NeurIPS]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-153509369-cd47bb4a38ee/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-153509369-cd47bb4a38ee/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37787,
      "sha256": "befe27c2e778ae30478ca0a9e844afd5cb233e2cbeddb0f2676105ecef0b7e23",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 141,
      "updated_at": "2026-06-09T13:39:31.197Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:152358099": {
    "source_id": "latent-space",
    "episode_id": "substack:post:152358099",
    "title": "Bolt.new, Flow Engineering for Code Agents, and >$8m ARR in 2 months as a Claude Wrapper",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-152358099-9e00d1e2f30d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-152358099-9e00d1e2f30d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 125327,
      "sha256": "c3ffe532cbd647216ef9905dac24cc0499cb22e99a02068f3dddd9234a1ae746",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 142,
      "updated_at": "2026-06-09T13:39:31.196Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:151960189": {
    "source_id": "latent-space",
    "episode_id": "substack:post:151960189",
    "title": "The new Claude 3.5 Sonnet, Computer Use, and Building SOTA Agents — with Erik Schluntz, Anthropic",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-151960189-9de0652dd42b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-151960189-9de0652dd42b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87321,
      "sha256": "6669c13e08d2b47635c9493cb2bdcddf2f0cab138b51f82342805b67c8b87fae",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 248,
      "updated_at": "2026-06-09T13:39:31.194Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:152075599": {
    "source_id": "latent-space",
    "episode_id": "substack:post:152075599",
    "title": "Why Compound AI + Open Source will beat Closed AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-152075599-9c90b9be37a5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-152075599-9c90b9be37a5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56411,
      "sha256": "4a8fbb8e3fb3bac73bd455234cc41fe571d7c3ac733425c64527e7ccb2a3771a",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 110,
      "updated_at": "2026-06-09T13:39:31.195Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:151713576": {
    "source_id": "latent-space",
    "episode_id": "substack:post:151713576",
    "title": "Agents @ Work: Lindy.ai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-151713576-000485d712e4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-151713576-000485d712e4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85806,
      "sha256": "95c0666999d35e1c24a3cd5e3c8a2dbb38d26a86c07bca4de01afa6a8febbc94",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 274,
      "updated_at": "2026-06-09T13:39:31.193Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:151438391": {
    "source_id": "latent-space",
    "episode_id": "substack:post:151438391",
    "title": "Agents @ Work: Dust.tt",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-151438391-91bde4ac6be2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-151438391-91bde4ac6be2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 70194,
      "sha256": "2e75e6b6431bb592258d7c14a02e94479ac84c12e87316d414634846a40af64a",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 201,
      "updated_at": "2026-06-09T13:39:31.192Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:151006734": {
    "source_id": "latent-space",
    "episode_id": "substack:post:151006734",
    "title": "In the Arena: How LMSys changed LLM Benchmarking Forever",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-151006734-1099791ef5ba/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-151006734-1099791ef5ba/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46982,
      "sha256": "a3e80ccc6ed822873fead52832933be9a4214f4b56d8ce18e7f3895e55da1bb8",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 153,
      "updated_at": "2026-06-09T13:39:31.191Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:150638218": {
    "source_id": "latent-space",
    "episode_id": "substack:post:150638218",
    "title": "How NotebookLM Was Made",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-150638218-84f8418ae894/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-150638218-84f8418ae894/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100827,
      "sha256": "36fde0d91456b2cd683fc9b2d54f44e01d8e51335a89e143137ef36654dcba1e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 532,
      "updated_at": "2026-06-09T13:39:31.190Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:150237951": {
    "source_id": "latent-space",
    "episode_id": "substack:post:150237951",
    "title": "Building the AI Engineer Nation — with Josephine Teo, Minister of Digital Development and Information, Singapore",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-150237951-6351baf0d39d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-150237951-6351baf0d39d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57952,
      "sha256": "2d3ac0f81f5f38c1e6f64d9214f5ef0c75fa5a24b3cf6aebee2394391a388b73",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 98,
      "updated_at": "2026-06-09T13:39:31.188Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:150323118": {
    "source_id": "latent-space",
    "episode_id": "substack:post:150323118",
    "title": "Building the Silicon Brain - with Drew Houston of Dropbox",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-150323118-53b2b474b057/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-150323118-53b2b474b057/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 90633,
      "sha256": "dc049ba62450d77f937918d116e2991a22b47bf2e0a5038fcd95c3e61d17c1c7",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 68,
      "updated_at": "2026-06-09T13:39:31.189Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:150108358": {
    "source_id": "latent-space",
    "episode_id": "substack:post:150108358",
    "title": "Production AI Engineering starts with Evals — with Ankur Goyal of Braintrust",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-150108358-f03df3f70d5a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-150108358-f03df3f70d5a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 122811,
      "sha256": "5f10eef633761bdf8da7485a29dc006f32f70b4ae6d3d8acceae7c4686e2d61b",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 246,
      "updated_at": "2026-06-09T13:39:31.187Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:149739218": {
    "source_id": "latent-space",
    "episode_id": "substack:post:149739218",
    "title": "Building AGI in Real Time (OpenAI Dev Day 2024)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-149739218-4db591d1fc0b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-149739218-4db591d1fc0b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 169460,
      "sha256": "d5a8b2192831fe599acabcc754de6e71ca5c310354eff5596adc4f90b88f2f5c",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 803,
      "updated_at": "2026-06-09T13:39:31.187Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:148799665": {
    "source_id": "latent-space",
    "episode_id": "substack:post:148799665",
    "title": "Language Agents: From Reasoning to Acting",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-148799665-b72dedb1f5ca/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-148799665-b72dedb1f5ca/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 108142,
      "sha256": "8e666189ba43237256ddfc62fdc7af9fd377fd195da22dc7bfe8f266c6fbd1ca",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 426,
      "updated_at": "2026-06-09T13:39:31.185Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:149105932": {
    "source_id": "latent-space",
    "episode_id": "substack:post:149105932",
    "title": "The Ultimate Guide to Prompting",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-149105932-70e3f8cc7b63/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-149105932-70e3f8cc7b63/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 70644,
      "sha256": "bfd3f492309153945270d1f3a7b70125d6f27f3f42366751ce59f6505f8e05dd",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 97,
      "updated_at": "2026-06-09T13:39:31.186Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:148204151": {
    "source_id": "latent-space",
    "episode_id": "substack:post:148204151",
    "title": "Why you should write your own LLM benchmarks — with Nicholas Carlini, Google DeepMind",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-148204151-36dceb7df3ea/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-148204151-36dceb7df3ea/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85865,
      "sha256": "900950f86d633df43225d54d3606552a17fcfb3c3cab49c061c2dac1e64f2e2d",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 214,
      "updated_at": "2026-06-09T13:39:31.184Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:147753766": {
    "source_id": "latent-space",
    "episode_id": "substack:post:147753766",
    "title": "AI Magic: Shipping 1000s of successful products with no managers and a team of 12 — Jeremy Howard of Answer.ai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-147753766-c78a6754bbc2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-147753766-c78a6754bbc2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60799,
      "sha256": "45141b753f6d31390183966d3681d1530aef6e41c52776349ee89956ed86e747",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 58,
      "updated_at": "2026-06-09T13:39:31.183Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:147418165": {
    "source_id": "latent-space",
    "episode_id": "substack:post:147418165",
    "title": "Segment Anything 2: Demo-first Model Development",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-147418165-94a47e8f8c80/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-147418165-94a47e8f8c80/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68655,
      "sha256": "609877d694f942b05ee669553b3b7889574a666e3abb42482321164feaf35ebc",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 222,
      "updated_at": "2026-06-09T13:39:31.182Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:147252120": {
    "source_id": "latent-space",
    "episode_id": "substack:post:147252120",
    "title": "The Winds of AI Winter (Q2 Four Wars Recap) + ChatGPT Voice Mode Preview",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-147252120-7094c025bf47/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-147252120-7094c025bf47/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 127334,
      "sha256": "7741a25a17ad4324edc1f14af8ce67a519895852ddbfa0da6e7c23da5ba0d180",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 210,
      "updated_at": "2026-06-09T13:39:31.181Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:146879553": {
    "source_id": "latent-space",
    "episode_id": "substack:post:146879553",
    "title": "Llama 2, 3 & 4: Synthetic Data, RLHF, Agents on the path to Open Source AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-146879553-577b9fb32dcb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-146879553-577b9fb32dcb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69185,
      "sha256": "5c066921c08b4da1f712406f8b871412a9a4939b045fbc4bd0d2f841eb614e75",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:31.180Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:146497374": {
    "source_id": "latent-space",
    "episode_id": "substack:post:146497374",
    "title": "Benchmarks 201: Why Leaderboards > Arenas >> LLM-as-Judge",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-146497374-08807884d0e9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-146497374-08807884d0e9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54316,
      "sha256": "ca3f6c3943fef713667e0262cf2216ed3271b4666fd2031ac33e9533d1d68fe9",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 86,
      "updated_at": "2026-06-09T13:39:31.180Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:145606648": {
    "source_id": "latent-space",
    "episode_id": "substack:post:145606648",
    "title": "The 10,000x Yolo Researcher Metagame — with Yi Tay of Reka",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-145606648-5afe560f4cf4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-145606648-5afe560f4cf4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 148035,
      "sha256": "8a5309ab72a756b680771e85e82085f75b0857cf14dac72c2597bfc1effe91e7",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 606,
      "updated_at": "2026-06-09T13:39:31.178Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:145986807": {
    "source_id": "latent-space",
    "episode_id": "substack:post:145986807",
    "title": "State of the Art: Training >70B LLMs on 10,000 H100 clusters",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-145986807-1b461f0cf711/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-145986807-1b461f0cf711/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 124438,
      "sha256": "4e228036824cd53906d83e7281f21e12023510269d73f453fc35f17e1176f93e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 663,
      "updated_at": "2026-06-09T13:39:31.179Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:145870526": {
    "source_id": "latent-space",
    "episode_id": "substack:post:145870526",
    "title": "How To Hire AI Engineers — with James Brady & Adam Wiggins of Elicit",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-145870526-910389c8483e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-145870526-910389c8483e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77702,
      "sha256": "a3df713c0a7a178d797ade643cd46402d1c313fa0c002910053ce4829775f323",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 225,
      "updated_at": "2026-06-09T13:39:31.178Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:145472808": {
    "source_id": "latent-space",
    "episode_id": "substack:post:145472808",
    "title": "How AI is eating Finance — with Mike Conover of Brightwave",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-145472808-e9db7af1a3d5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-145472808-e9db7af1a3d5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58236,
      "sha256": "81557b25a822cc3938028d9510d599c32168b41d9e3b13946db609690800097e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.176Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:145118861": {
    "source_id": "latent-space",
    "episode_id": "substack:post:145118861",
    "title": "How to train a Million Context LLM — with Mark Huang of Gradient.ai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-145118861-5b1d7ff65ca8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-145118861-5b1d7ff65ca8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60736,
      "sha256": "46c70774f91de5ea281a1ca13c10ab5fa0b1dbe24541916b52c8bfc71020d498",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 83,
      "updated_at": "2026-06-09T13:39:31.176Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:144493224": {
    "source_id": "latent-space",
    "episode_id": "substack:post:144493224",
    "title": "Emulating Humans with NSFW Chatbots - with Jesse Silver",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-144493224-b3691c30c39d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-144493224-b3691c30c39d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55939,
      "sha256": "7cc0d19c0a44a953c9945b8f17c87b4a8843d957779946576cf5b1a4c082d632",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 67,
      "updated_at": "2026-06-09T13:39:31.175Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:143697169": {
    "source_id": "latent-space",
    "episode_id": "substack:post:143697169",
    "title": "High Agency Pydantic > VC Backed Frameworks — with Jason Liu of Instructor",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-143697169-1a19d10aa725/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-143697169-1a19d10aa725/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66851,
      "sha256": "93f3b696c05dba4f25109474b0192aea0f750f16ce6dfcc10fab73fe1b6f4021",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 119,
      "updated_at": "2026-06-09T13:39:31.174Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:143400989": {
    "source_id": "latent-space",
    "episode_id": "substack:post:143400989",
    "title": "Supervise the Process of AI Research — with Jungwon Byun and Andreas Stuhlmüller of Elicit",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-143400989-932989e014f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-143400989-932989e014f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 70988,
      "sha256": "e15902cb0fda1dc8379fcaa4db5480675ca82a813c426234a707020bb30736eb",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 144,
      "updated_at": "2026-06-09T13:39:31.173Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:143334144": {
    "source_id": "latent-space",
    "episode_id": "substack:post:143334144",
    "title": "Latent Space Chats: NLW (Four Wars, GPT5), Josh Albrecht/Ali Rohde (TNAI), Dylan Patel/Semianalysis (Groq), Milind Naphade (Nvidia GTC), Personal AI (ft. Harrison Chase — LangFriend/LangMem)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-143334144-cd8570af86a4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-143334144-cd8570af86a4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 157337,
      "sha256": "a090f0abb5badcb5922dc43755e2f7693fdb95af200421188decaae248da535c",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 641,
      "updated_at": "2026-06-09T13:39:31.173Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:143067206": {
    "source_id": "latent-space",
    "episode_id": "substack:post:143067206",
    "title": "Presenting the AI Engineer World's Fair — with Sam Schillace, Deputy CTO of Microsoft",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-143067206-baf3bccec8d2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-143067206-baf3bccec8d2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 58177,
      "sha256": "ba962fb3d54c777cdb0b4148810a248f44306fbf358ff24f6c6ddac41cf5d881",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 218,
      "updated_at": "2026-06-09T13:39:31.171Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:142431075": {
    "source_id": "latent-space",
    "episode_id": "substack:post:142431075",
    "title": "Top 5 Research Trends + OpenAI Sora, Google Gemini, Groq Math (Jan-Feb 2024 Audio Recap) + Latent Space Anniversary with Lindy.ai, RWKV, Pixee, Julius.ai, Listener Q&A!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-142431075-1e867d7f765a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-142431075-1e867d7f765a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 127299,
      "sha256": "d1a7e40f3dd5c2fb7fd03f8602a4c67153e04efeb5286758e4928c390f9391ba",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 484,
      "updated_at": "2026-06-09T13:39:31.170Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:142310057": {
    "source_id": "latent-space",
    "episode_id": "substack:post:142310057",
    "title": "Open Source AI is AI we can Trust — with Soumith Chintala of Meta AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-142310057-f7e6a7e017c7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-142310057-f7e6a7e017c7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 78354,
      "sha256": "238a06706448aff2ff4863bfe1c50225aad45b9973073bac73ecd86760353e01",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 139,
      "updated_at": "2026-06-09T13:39:31.169Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:142111901": {
    "source_id": "latent-space",
    "episode_id": "substack:post:142111901",
    "title": "A Brief History of the Open Source AI Hacker - with Ben Firshman of Replicate",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-142111901-bc29b9850c10/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-142111901-bc29b9850c10/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 87348,
      "sha256": "f1e0be44c00b0ff1e8cd101628678b65173ceda62d0da8f98d54490294d9624a",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 169,
      "updated_at": "2026-06-09T13:39:31.169Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:141683117": {
    "source_id": "latent-space",
    "episode_id": "substack:post:141683117",
    "title": "Truly Serverless Infra for AI Engineers - with Erik Bernhardsson of Modal",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-141683117-479850ce4476/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-141683117-479850ce4476/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83695,
      "sha256": "9bfbbad2d66f1054f3046a121d20d3bc33fea0e16e59e83a25aac4e33685d00e",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 166,
      "updated_at": "2026-06-09T13:39:31.168Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:141447889": {
    "source_id": "latent-space",
    "episode_id": "substack:post:141447889",
    "title": "Cloud Intelligence at the speed of 5000 tok/s - with Ce Zhang and Vipul Ved Prakash of Together AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-141447889-1d0361fe9ef1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-141447889-1d0361fe9ef1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68592,
      "sha256": "eb6b3dc8e0dc4f19f1666551baefcb947cb6e50408cf6433846dbb4bb993beab",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 142,
      "updated_at": "2026-06-09T13:39:31.167Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:140985865": {
    "source_id": "latent-space",
    "episode_id": "substack:post:140985865",
    "title": "Why StackOverflow usage is down 50% — with David Hsu of Retool",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-140985865-bbd096d0370b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-140985865-bbd096d0370b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75242,
      "sha256": "3dc4ff7499fb458fd9db5f19bad336ef08fa896bdf9dd0e583fd1472e0873037",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 73,
      "updated_at": "2026-06-09T13:39:31.166Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:140498023": {
    "source_id": "latent-space",
    "episode_id": "substack:post:140498023",
    "title": "RLHF 201 - with Nathan Lambert of AI2 and Interconnects",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-140498023-01c61f1c8c58/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-140498023-01c61f1c8c58/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 104696,
      "sha256": "1006c50ef336b303e790de219c56762b4f25bec3e1ede9a4f93b870001e64c40",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 159,
      "updated_at": "2026-06-09T13:39:31.166Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:140363662": {
    "source_id": "latent-space",
    "episode_id": "substack:post:140363662",
    "title": "The Accidental AI Canvas - with Steve Ruiz of tldraw",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-140363662-39a384c72bb9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-140363662-39a384c72bb9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73885,
      "sha256": "e86eddf34bba96a15ec5ce1be236149ef5b7a1998297c1398503dbefc9be26f5",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 119,
      "updated_at": "2026-06-09T13:39:31.165Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:139926717": {
    "source_id": "latent-space",
    "episode_id": "substack:post:139926717",
    "title": "The AI-First Graphics Editor - with Suhail Doshi of Playground AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-139926717-f59b9f0f2795/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-139926717-f59b9f0f2795/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72608,
      "sha256": "512681958c271df0028d4865a005581dbc0bcb2668f11dfaa189508f4bdf3ea8",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 164,
      "updated_at": "2026-06-09T13:39:31.164Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:139766004": {
    "source_id": "latent-space",
    "episode_id": "substack:post:139766004",
    "title": "The \"Normsky\" architecture for AI coding agents — with Beyang Liu + Steve Yegge of SourceGraph",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-139766004-ed476e61057c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-139766004-ed476e61057c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 102720,
      "sha256": "a1f5c2e13140bc3a781f33fbe4e1b566c9d4af683bbcf7e84797e02013123ae7",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 348,
      "updated_at": "2026-06-09T13:39:31.164Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:139607453": {
    "source_id": "latent-space",
    "episode_id": "substack:post:139607453",
    "title": "The Busy Person's Intro to Finetuning & Open Source AI - Wing Lian, Axolotl",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-139607453-6bba3ae182eb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-139607453-6bba3ae182eb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79347,
      "sha256": "a327412ff2617a70e5a0018dfc45d35646945fffa8bffb51b4c02e10288141c9",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 296,
      "updated_at": "2026-06-09T13:39:31.163Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:139219943": {
    "source_id": "latent-space",
    "episode_id": "substack:post:139219943",
    "title": "Notebooks = Chat++ and RAG = RecSys! — with Bryan Bischof of Hex Magic",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-139219943-8dd2dfc51ce0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-139219943-8dd2dfc51ce0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53862,
      "sha256": "d1d3e5bedbbb6e866fa3eb17cb568989733a9b6e93c2a6403ad41413c7af9523",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 58,
      "updated_at": "2026-06-09T13:39:31.162Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:138846476": {
    "source_id": "latent-space",
    "episode_id": "substack:post:138846476",
    "title": "The State of Silicon and the GPU Poors - with Dylan Patel of SemiAnalysis",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-138846476-e2b3bee2271e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-138846476-e2b3bee2271e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68827,
      "sha256": "d72049c6702cf6a3796a23d80bb367a7605d82e8b40f834011108218c97e9a37",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 63,
      "updated_at": "2026-06-09T13:39:31.161Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:138678364": {
    "source_id": "latent-space",
    "episode_id": "substack:post:138678364",
    "title": "AGI is Being Achieved Incrementally (OpenAI DevDay w/ Simon Willison, Alex Volkov, Jim Fan, Raza Habib, Shreya Rajpal, Rahul Ligma, et al)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-138678364-6590941bb16e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-138678364-6590941bb16e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 193921,
      "sha256": "46223dfd4fe64806867ba73e955f27e34240ba8df56cb856d7be1d0234bcd8fa",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 857,
      "updated_at": "2026-06-09T13:39:31.160Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:138498146": {
    "source_id": "latent-space",
    "episode_id": "substack:post:138498146",
    "title": "Beating GPT-4 with Open Source LLMs — with Michael Royzen of Phind",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-138498146-ef17c329590e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-138498146-ef17c329590e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77405,
      "sha256": "3f03ec3d5f333fb98fde9f2bd59368c5dc63944a699462c4f944dd8f62b2b297",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 197,
      "updated_at": "2026-06-09T13:39:31.159Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:138284391": {
    "source_id": "latent-space",
    "episode_id": "substack:post:138284391",
    "title": "Powering your Copilot for Data – with Artem Keydunov of Cube.dev",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-138284391-4482bb84ee2f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-138284391-4482bb84ee2f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43824,
      "sha256": "745165d6973967725134b37480dde74bd0816e1edaeb2e379a4d2e12a08fe547",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 59,
      "updated_at": "2026-06-09T13:39:31.158Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:138050038": {
    "source_id": "latent-space",
    "episode_id": "substack:post:138050038",
    "title": "The End of Finetuning — with Jeremy Howard of Fast.ai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-138050038-dea728aa4cfa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-138050038-dea728aa4cfa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83537,
      "sha256": "ca42a352af245037d52cfdd46a0e5839b1f99305ada01461d3b4b724467561c8",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 168,
      "updated_at": "2026-06-09T13:39:31.158Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:137874596": {
    "source_id": "latent-space",
    "episode_id": "substack:post:137874596",
    "title": "Why AI Agents Don't Work (yet) - with Kanjun Qiu of Imbue",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-137874596-76c71773696e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-137874596-76c71773696e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76650,
      "sha256": "41141758eb64e22abbc3a859489249a3c254ffdaacd794ef45776d57b9489810",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 181,
      "updated_at": "2026-06-09T13:39:31.157Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:137668059": {
    "source_id": "latent-space",
    "episode_id": "substack:post:137668059",
    "title": "RAG Is A Hack - with Jerry Liu from LlamaIndex",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-137668059-8a6e97ae3bed/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-137668059-8a6e97ae3bed/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 95869,
      "sha256": "783aa09f7499035b91e040878d3672ca25f647b2a02652e66024af0b6eb081eb",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 299,
      "updated_at": "2026-06-09T13:39:31.154Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:136992893": {
    "source_id": "latent-space",
    "episode_id": "substack:post:136992893",
    "title": "Doing it the Hard Way: Making the AI engine and language 🔥 of the future — with Chris Lattner of Modular",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-136992893-3f130c028fb5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-136992893-3f130c028fb5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 111363,
      "sha256": "60711745c2beacea58705c5c492defbb4f9a0f54a7c6287f53ed474784cd12eb",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 229,
      "updated_at": "2026-06-09T13:39:31.153Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:136578557": {
    "source_id": "latent-space",
    "episode_id": "substack:post:136578557",
    "title": "The Point of LangChain — with Harrison Chase of LangChain",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-136578557-5b398096e82f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-136578557-5b398096e82f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79827,
      "sha256": "aca1c27843fc6ad6c455cacbfaffefa8e7f7bc656a99fef82730243941c8b00d",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 213,
      "updated_at": "2026-06-09T13:39:31.153Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:136284642": {
    "source_id": "latent-space",
    "episode_id": "substack:post:136284642",
    "title": "Cursor.so: The AI-first Code Editor — with Aman Sanger of Anysphere",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-136284642-b00facbb3b0a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-136284642-b00facbb3b0a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 69039,
      "sha256": "ee2bebd0ba9d289af002dbde32536c5aa7b522c703e13008d48be8af22626f32",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 165,
      "updated_at": "2026-06-09T13:39:31.152Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:135877261": {
    "source_id": "latent-space",
    "episode_id": "substack:post:135877261",
    "title": "LLMs Everywhere: Running 70B models in browsers and iPhones using MLC — with Tianqi Chen of CMU / OctoML",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-135877261-e4f547d9a7f5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-135877261-e4f547d9a7f5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55322,
      "sha256": "e6ce7347abf108b10b3bc9be59ca80af25ad2ac23111a61fbc1be62a38465664",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 106,
      "updated_at": "2026-06-09T13:39:31.151Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:135723345": {
    "source_id": "latent-space",
    "episode_id": "substack:post:135723345",
    "title": "[AI Breakdown] Summer AI Technical Roundup: a Latent Space x AI Breakdown crossover pod!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-135723345-adfc979c9f27/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-135723345-adfc979c9f27/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57633,
      "sha256": "a9941a9ecac0e87fb42b2bf07296c1a4cb7783fb800e68b4977d7c2da3ef382f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.151Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:135258128": {
    "source_id": "latent-space",
    "episode_id": "substack:post:135258128",
    "title": "Llama 2: The New Open LLM SOTA (ft. Nathan Lambert, Matt Bornstein, Anton Troynikov, Russell Kaplan, Whole Mars Catalog et al.)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-135258128-381f2b579ecb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-135258128-381f2b579ecb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 103252,
      "sha256": "8c7a046a78af544867da81dbfec4262d63692ce83f52d4b85f90f7457e9e70dd",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 463,
      "updated_at": "2026-06-09T13:39:31.150Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:129414110": {
    "source_id": "latent-space",
    "episode_id": "substack:post:129414110",
    "title": "Commoditizing the Petaflop — with George Hotz of the tiny corp",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-129414110-bdc748d74a42/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-129414110-bdc748d74a42/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99642,
      "sha256": "0d9894e2b140c04cfa9ac331248018107b06e0952651dd1eb22ba32f3fe3b257",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 391,
      "updated_at": "2026-06-09T13:39:31.149Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:126747491": {
    "source_id": "latent-space",
    "episode_id": "substack:post:126747491",
    "title": "From RLHF to RLHB: The Case for Learning from Human Behavior - with Jeffrey Wang and Joe Reeve of Amplitude",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-126747491-4926755b5758/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-126747491-4926755b5758/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56736,
      "sha256": "6b9ea5d2b03e2b647c25c0772605a324c50b7c36637604c922955ba6516ff926",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 88,
      "updated_at": "2026-06-09T13:39:31.148Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:125082085": {
    "source_id": "latent-space",
    "episode_id": "substack:post:125082085",
    "title": "Building the AI × UX Scenius — with Linus Lee of Notion AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-125082085-f024f88f14fd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-125082085-f024f88f14fd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83200,
      "sha256": "87c4c7c884101c3d960da9780147f7eb39e1212bfe706afdaa0a3c84df136e34",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 155,
      "updated_at": "2026-06-09T13:39:31.148Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:123420423": {
    "source_id": "latent-space",
    "episode_id": "substack:post:123420423",
    "title": "Debugging the Internet with AI agents – with Itamar Friedman of Codium AI and AutoGPT",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-123420423-f6dd1916b8af/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-123420423-f6dd1916b8af/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 68007,
      "sha256": "a33d368be57098c74bb55539a34699c07659774eb3d9a46038d65abe45345f99",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:31.147Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:122567124": {
    "source_id": "latent-space",
    "episode_id": "substack:post:122567124",
    "title": "MPT-7B and The Beginning of Context=Infinity — with Jonathan Frankle and Abhinav Venigalla of MosaicML",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-122567124-ff1d811a8099/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-122567124-ff1d811a8099/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 90457,
      "sha256": "90add86270d1b4a4b0bdf224016f28d69702c03b414ac9b1fc23fe815c1c052d",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 220,
      "updated_at": "2026-06-09T13:39:31.145Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:121662773": {
    "source_id": "latent-space",
    "episode_id": "substack:post:121662773",
    "title": "Guaranteed quality and structure in LLM outputs - with Shreya Rajpal of Guardrails AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-121662773-5bebb47f07e1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-121662773-5bebb47f07e1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83343,
      "sha256": "e60e35fb27e79eb2fd705862161ad41174ea476d9a3b6035e512324c17a4b64f",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 198,
      "updated_at": "2026-06-09T13:39:31.144Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:120093157": {
    "source_id": "latent-space",
    "episode_id": "substack:post:120093157",
    "title": "The AI Founder Gene: Being Early, Building Fast, and Believing in Greatness — with Sharif Shameem of Lexica",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-120093157-28b88afd9dc8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-120093157-28b88afd9dc8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62376,
      "sha256": "6a1eba6a99dd8731454ec49f71038e2925b974637ded99cc4482aa4a6fe8b60d",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 167,
      "updated_at": "2026-06-09T13:39:31.144Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:118824331": {
    "source_id": "latent-space",
    "episode_id": "substack:post:118824331",
    "title": "Training a SOTA Code LLM in 1 week and Quantifying the Vibes — with Reza Shabani of Replit",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-118824331-20e99c6cf620/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-118824331-20e99c6cf620/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84843,
      "sha256": "b6ea7b3521bf65ce078ef6ecfc046f46f99841e27aa7f464dd8f8f7873701505",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 332,
      "updated_at": "2026-06-09T13:39:31.143Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "latent-space/substack:post:116379427": {
    "source_id": "latent-space",
    "episode_id": "substack:post:116379427",
    "title": "AI-powered Search for the Enterprise — with Deedy Das of Glean",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/latent-space-dac969df8b20/substack-post-116379427-3a5494f63a69/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/latent-space-dac969df8b20/substack-post-116379427-3a5494f63a69/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 78321,
      "sha256": "8c2cc86e40e49d0ee2d28ee6b988fb21569a8b54184f8b3ac37e5d4002ab78f0",
      "source_kind": "official_rss_transcript",
      "source_quality": "official_transcript",
      "record_count": 285,
      "updated_at": "2026-06-09T13:39:31.142Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6450": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6450",
    "title": "#496 – FFmpeg: The Incredible Technology Behind Video on the Internet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6450-be60425377c7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6450-be60425377c7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 284307,
      "sha256": "64953c5b7b80956fe6192ae99ae0e6ef1240e63fed8d3a4ea0de1a898172b87d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 963,
      "updated_at": "2026-06-09T13:39:31.289Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6441": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6441",
    "title": "#495 – Vikings, Ragnar, Berserkers, Valhalla & the Warriors of the Viking Age",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6441-f17d20c3c006/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6441-f17d20c3c006/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 128602,
      "sha256": "4d524f4e454d3352abbce44d7e12fcaac6e26e9b92deb94a12aa9a05d82c8044",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 449,
      "updated_at": "2026-06-09T13:39:31.288Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6434": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6434",
    "title": "#494 – Jensen Huang: NVIDIA – The $4 Trillion Company & the AI Revolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6434-b03f85140c83/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6434-b03f85140c83/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 142872,
      "sha256": "1505dd3689f7cb093683e519a5b9ddbb2636bf5dd05384f219ec1cac8b8bf0e6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 398,
      "updated_at": "2026-06-09T13:39:31.287Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6421": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6421",
    "title": "#492 – Rick Beato: Greatest Guitarists of All Time, History & Future of Music",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6421-f47d5d8ae30d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6421-f47d5d8ae30d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 167475,
      "sha256": "2123fb856b8a9975dedcd9fdb2741a7741bfe50021011091fcb69b6f6d1adfa3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 713,
      "updated_at": "2026-06-09T13:39:31.287Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6413": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6413",
    "title": "#491 – OpenClaw: The Viral AI Agent that Broke the Internet – Peter Steinberger",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 198951,
      "sha256": "d6c65f8abeb0a16215f5892e2b3b66f9818e16abf4d26d8351bc5e2bd10d4be1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 779,
      "updated_at": "2026-06-09T13:39:31.286Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 114249,
      "sha256": "22c60532274644ef1b94f93a3d2fa6c31a60c01ace76d13fed23c61017603a02",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:41.990Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6413-cdf42712bd55/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 88791,
      "sha256": "82b435465ef46433e5587e66d084950f3a14dcb4559e7e704869ed25ea62aae7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:41.990Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6394": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6394",
    "title": "#490 – State of AI in 2026: LLMs, Coding, Scaling Laws, China, Agents, GPUs, AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6394-4d12371c21c3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6394-4d12371c21c3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 281908,
      "sha256": "c8398fe9019dcdc44183f6b670611a4005bc89178b5218f4c11d5cd8aeaa3802",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 624,
      "updated_at": "2026-06-09T13:39:31.285Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6384": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6384",
    "title": "#489 – Paul Rosolie: Uncontacted Tribes in the Amazon Jungle",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 200605,
      "sha256": "d24a59036acf48345f105a2f3d7fe99d5695d5ddc6d1332e04a646cb628bc496",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 551,
      "updated_at": "2026-06-09T13:39:31.283Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 153094,
      "sha256": "9576d5f2d9e203c9d4b0c4643001abedc4a8da7ae587dd1991e07fe264f834cf",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:50:49.512Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6384-e3716290b5b0/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 83044,
      "sha256": "7b17788d5e589d1137ca82bd0a6c7226c8f8ef4adf82c3eadcd65a28118740df",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:50:49.511Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6378": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6378",
    "title": "#488 – Infinity, Paradoxes that Broke Mathematics, Gödel Incompleteness & the Multiverse – Joel David Hamkins",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6378-fefdfe72b684/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6378-fefdfe72b684/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 239283,
      "sha256": "0e813070373f2e2e6f94814c1a87ed1803e56b04941c7e441d13b15b16e6343c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 602,
      "updated_at": "2026-06-09T13:39:31.282Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6361": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6361",
    "title": "#486 – Michael Levin: Hidden Reality of Alien Intelligence & Biological Life",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6361-b52e63738fe6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6361-b52e63738fe6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 228847,
      "sha256": "f386edaed1b209a3bf462ee2ae77ecb7864831dd5c13c286aa450c28ecb87db6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 481,
      "updated_at": "2026-06-09T13:39:31.281Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6354": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6354",
    "title": "#485 – David Kirtley: Nuclear Fusion, Plasma Physics, and the Future of Energy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6354-a6ba5bfc9958/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6354-a6ba5bfc9958/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 164681,
      "sha256": "ff89083c4d69c60bedb1ca3e6361ab7ee3c3c15c718e970e627434105654a1d3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 357,
      "updated_at": "2026-06-09T13:39:31.280Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6348": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6348",
    "title": "#484 – Dan Houser: GTA, Red Dead Redemption, Rockstar, Absurd & Future of Gaming",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 189765,
      "sha256": "1945c1a060c18691a58789125d48cbdcf7316c12934e04435132f53b18ad729e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 670,
      "updated_at": "2026-06-09T13:39:31.279Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 120694,
      "sha256": "63a4b7ecb291bed7017a4368ea69fc2551bf5e0db90bc10a984e346089c9d804",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:04.381Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6348-de6bd62eb428/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 76083,
      "sha256": "11eb3f2456130f961d59b865ec94dead297cbb48a41d6e8d112168a0754473c1",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:04.381Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6328": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6328",
    "title": "#482 – Pavel Durov: Telegram, Freedom, Censorship, Money, Power & Human Nature",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 210296,
      "sha256": "4ea354084d797269e5fc898c200ff1914b55342a61f25b95a2a23ac2586064a1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 420,
      "updated_at": "2026-06-09T13:39:31.278Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 199280,
      "sha256": "5ed89b1c52ad16c7707315019853334cc57f072ebae834270cbfeca5853c1f55",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:15.462Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6328-bcb6c1b8fb54/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 100639,
      "sha256": "51a39d400ec5c9b94ca4f771cfd013a9eff2187f17a1b94fd18dade784e12056",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:15.461Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6320": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6320",
    "title": "#481 – Norman Ohler: Hitler, Nazis, Drugs, WW2, Blitzkrieg, LSD, MKUltra & CIA",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6320-83020f75656f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6320-83020f75656f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 270195,
      "sha256": "6d62279eeadc2902ea7f601b6b0f04033c11622f3daa769f2a1c8855653d45f7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 817,
      "updated_at": "2026-06-09T13:39:31.277Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6312": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6312",
    "title": "#480 – Dave Hone: T-Rex, Dinosaurs, Extinction, Evolution, and Jurassic Park",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6312-0d25bbb72063/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6312-0d25bbb72063/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 250574,
      "sha256": "1716a84f6d0333b568a3642c63f2abe6e5bb42894a6b3228f8f7f6c7735791f9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 825,
      "updated_at": "2026-06-09T13:39:31.276Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6278": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6278",
    "title": "#477 – Keyu Jin: China’s Economy, Tariffs, Trade, Trump, Communism & Capitalism",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6278-64f1968cf555/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6278-64f1968cf555/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 102710,
      "sha256": "4ad4c219006845515173b6f8e3f1da36fc18789417c6d2f4256e46b6486b3dbe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 219,
      "updated_at": "2026-06-09T13:39:31.275Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6271": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6271",
    "title": "#476 – Jack Weatherford: Genghis Khan and the Mongol Empire",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6271-3471cc924c40/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6271-3471cc924c40/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 254956,
      "sha256": "0ccab0bd6cb333cf93ba65fdd261b950f4d4c678e805cdbef4b67e48adf68284",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 628,
      "updated_at": "2026-06-09T13:39:31.274Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6265": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6265",
    "title": "#475 – Demis Hassabis: Future of AI, Simulating Reality, Physics and Video Games",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 156713,
      "sha256": "968ab42c4f0a91bf62d0671b00e198e2f7c20c09367dd010e89653ac4f2653a9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 371,
      "updated_at": "2026-06-09T13:39:31.273Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 145666,
      "sha256": "3aef960e4f31c715f4b2b1dee99a99fde0ce1547af7432421a4b8c4717aae5c4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:23.322Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6265-6c42808bd4bf/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 86829,
      "sha256": "81c93c36197679caceb5dbccd9fdedd2e6c3ebd2b853fcef9e197548ca610e27",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:23.321Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6259": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6259",
    "title": "#474 – DHH: Future of Programming, AI, Ruby on Rails, Productivity & Parenting",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6259-7b8e151237a2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6259-7b8e151237a2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 382035,
      "sha256": "25f7c1f25735b8f43d38318d702b0c38cd5308c262a2198f3f10e2a5f796dd1a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 870,
      "updated_at": "2026-06-09T13:39:31.272Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6249": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6249",
    "title": "#472 – Terence Tao: Hardest Problems in Mathematics, Physics & the Future of AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 211510,
      "sha256": "6ce29a983ca0772be226e014661134044d90e641047d848631bb4d7a8b0a53da",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 508,
      "updated_at": "2026-06-09T13:39:31.271Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 199084,
      "sha256": "daea5c08c457870553bc4beabd39390e8ea20dd487aeb76087373171b26c7b7a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:49.473Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6249-258522596884/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 115360,
      "sha256": "0b43838246b926e8ffe87b8950018e9e58257b9b7859d03b8d29937acdfe0000",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:49.472Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6244": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6244",
    "title": "#471 – Sundar Pichai: CEO of Google and Alphabet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6244-0c1bf2cef4a8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6244-0c1bf2cef4a8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 128502,
      "sha256": "60cffea4469a4a8c7a01eadd576e5ae481fa346d3662cf5a1408cf16a9dfb557",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 377,
      "updated_at": "2026-06-09T13:39:31.270Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6211": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6211",
    "title": "#465 – Robert Rodriguez: Sin City, Desperado, El Mariachi, Alita, and Filmmaking",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6211-a5e7275e123b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6211-a5e7275e123b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 273345,
      "sha256": "4907ba7d3801c2f2b82ea34b6fcfeb609347cd747ee9421333ab46ee28809108",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 730,
      "updated_at": "2026-06-09T13:39:31.269Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6181": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6181",
    "title": "#460 – Narendra Modi: Prime Minister of India – Power, Democracy, War & Peace",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 148871,
      "sha256": "b0ea2009edea09f2586324bd81d09ae8604b7399079f0da87026239f58c2db13",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 272,
      "updated_at": "2026-06-09T13:39:31.268Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 174507,
      "sha256": "bed4bd207f80edc87e87f70d1aa78caadf26c61d9da197e455273ade7bc4fa9e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:00.743Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6181-41119ecf003e/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 92644,
      "sha256": "c1b68e8ceb31a6bfe4ba410ec8a18c645ca0fe9e2ee0aef1228a87e45f3ce658",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:00.743Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6155": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6155",
    "title": "#459 – DeepSeek, China, OpenAI, NVIDIA, xAI, TSMC, Stargate, and AI Megaclusters",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 355354,
      "sha256": "f0d05dbfd32d1f9578e44c01d0eb439bf706dbcb5774ff943ed1f7d52d5fdc29",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1014,
      "updated_at": "2026-06-09T13:39:31.267Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 262753,
      "sha256": "f439f9ec09f89354167296864fa4bb66cc4c6218a690bf323ebd49c60ff0925b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:45.723Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6155-1ff9b8415281/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 142924,
      "sha256": "c556316f69496dfdea44d8ee2955be354e741382dfcf866482e4b9469f12c805",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:45.723Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6148": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6148",
    "title": "#458 – Marc Andreessen: Trump, Power, Tech, AI, Immigration & Future of America",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 276196,
      "sha256": "298c99c39d8987d4317923e5955269c99b6fe018783f4c9a3651078a1d89a8e3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 595,
      "updated_at": "2026-06-09T13:39:31.265Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 277020,
      "sha256": "7196c007f57c247d61813494d941ad51238e547e5db30d2aa93a969b6ba9c6fe",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:50:11.966Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6148-60a1cf01bb24/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 144574,
      "sha256": "0369d158e0a06f560882eb558042af185802bb9916d222c044f42365f0f7a39d",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:50:11.966Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6138": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6138",
    "title": "#457 – Jennifer Burns: Milton Friedman, Ayn Rand, Economics, Capitalism, Freedom",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6138-85a66d98b16d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6138-85a66d98b16d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 233073,
      "sha256": "d757131fcb85a347ab2cfd5ecba15882ce7d7fb6b8efd1d9aa8b9046ed92a0e8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 459,
      "updated_at": "2026-06-09T13:39:31.264Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6105": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6105",
    "title": "#456 – Volodymyr Zelenskyy: Ukraine, War, Peace, Putin, Trump, NATO, and Freedom",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 159271,
      "sha256": "b55807fb3f1a0119313b10a75b828607328bc5683bff933525670bde31ec34ad",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 438,
      "updated_at": "2026-06-09T13:39:31.263Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 138837,
      "sha256": "2649b177f38f94fbb7eb9e3d3ea4d26bd57616a5519bbd95ea38b18facabaa03",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 13,
      "updated_at": "2026-05-21T23:16:08.426Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6105-79074a5ccc1c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 112043,
      "sha256": "fb69498dfe9b9e7c7714ee7337807a1580cc08a45dab4edd045c6385afe77c4e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 13,
      "updated_at": "2026-05-21T23:16:08.426Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6099": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6099",
    "title": "#455 – Adam Frank: Alien Civilizations and the Search for Extraterrestrial Life",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 234765,
      "sha256": "d6c1d5f853308bfcaa800b616ed15b429902a5228cc298cc6197b6599d9c8c43",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 655,
      "updated_at": "2026-06-09T13:39:31.262Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 186518,
      "sha256": "bc4261c98a2596a7fc540a2faff2e7f0b214c3694e0f9e1088df6cab548800a0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:23.365Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6099-d75245256ccd/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 111532,
      "sha256": "4ad93a426a0697d8c79ed3a627ddced0511096e7ebd9d00dcf2495f099f848cd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:23.365Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6077": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6077",
    "title": "#452 – Dario Amodei: Anthropic CEO on Claude, AGI & the Future of AI & Humanity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 334843,
      "sha256": "76151cb46d3e7a67188843c88951664f3b9f4e2f8a7cef6f10cdb65430d5847e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 781,
      "updated_at": "2026-06-09T13:39:31.261Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 288116,
      "sha256": "590896ba32e220c3f7cf5538088ae03d1bfb02cec8039d9c8e2eee170e81c2cd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:57.020Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6077-f1e6085f96f1/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 132415,
      "sha256": "06da20da002f2f04aa899085060bbbd743e3fb6d61cd061a857b5bfc0d9c40aa",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:57.020Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=6042": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6042",
    "title": "#447 – Cursor Team: Future of Programming with AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6042-b892be0808b2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6042-b892be0808b2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 155113,
      "sha256": "77c13a521aa5450e800a2c8f0adf4010da0e601ee50793200e365e855de14d14",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 460,
      "updated_at": "2026-06-09T13:39:31.260Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=6007": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=6007",
    "title": "#442 – Donald Trump Interview",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64180,
      "sha256": "2b9b17504f6438748bda06a3dbac9f5728f0f05e89a78172b5f0f5036018706c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 158,
      "updated_at": "2026-06-09T13:39:31.259Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61544,
      "sha256": "61fe860fc577fd5d18f0c1a36ef2eecaca1cdd46bba67732b573e2731b617f52",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-21T23:13:25.788Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-6007-e75fea356404/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 132457,
      "sha256": "660d9b71208b1da82d50ea9200ad21f4091b19403a59992865c395592ec38f51",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-21T23:13:25.788Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5990": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5990",
    "title": "#440 – Pieter Levels: Programming, Viral AI Startups, and Digital Nomad Life",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 284287,
      "sha256": "76e672469fa215489d37f51802d892cdd71c8fcd4a3e2c287d6918cefa9c48e2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1380,
      "updated_at": "2026-06-09T13:39:31.258Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 140309,
      "sha256": "e1aa3d4e95837d45a7dfd0076a4789a9acad13bf3f37e263dd4f26a671bb3166",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:31.143Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5990-ad4a3bd9d48a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 110168,
      "sha256": "c796cf4909d3c7f253c360a5668674eb8bdac9f7783831260f20dc641722d683",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:49:31.143Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5979": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5979",
    "title": "#439 – Craig Jones: Jiu Jitsu, $2 Million Prize, CJI, ADCC, Ukraine & Trolling",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5979-4253c0f5f6ee/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5979-4253c0f5f6ee/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 150388,
      "sha256": "cd42f50166232e68324c38d30f21d1f47e5b44fdfe35647929289e64b5b2ad03",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 576,
      "updated_at": "2026-06-09T13:39:31.257Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5968": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5968",
    "title": "#438 – Elon Musk: Neuralink and the Future of Humanity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 531087,
      "sha256": "ddf9c24ca8559baaba7a569f78277a0aed0cdc3c70e6899d7bf4710b198405eb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1772,
      "updated_at": "2026-06-09T13:39:31.256Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 364040,
      "sha256": "6a6ee9ba75eaf4e6b0fb53a0cbfd6c118c212eebab953299da803d7a102210a4",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 11,
      "updated_at": "2026-05-22T02:49:04.800Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5968-29e534cef818/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 161849,
      "sha256": "afeea271cc9bb44ccf020e312b1497dcf6cc2a3aeca18c5bcf4456013df5653f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 11,
      "updated_at": "2026-05-22T02:49:04.799Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5934": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5934",
    "title": "#434 – Aravind Srinivas: Perplexity CEO on Future of AI, Search & the Internet",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5934-cc898cc254a1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5934-cc898cc254a1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 184945,
      "sha256": "9d77893439013d68dfd3c90b503de07b39abb07cfdd6b6dc7aa887aaa090346c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 614,
      "updated_at": "2026-06-09T13:39:31.254Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5927": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5927",
    "title": "#433 – Sara Walker: Physics of Life, Time, Complexity, and Aliens",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5927-55476e6a7a30/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5927-55476e6a7a30/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 188752,
      "sha256": "51fc5af96fde5e456a817fb21424fb357d7b03816aa2c6ac50680a91b53fcc6d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 715,
      "updated_at": "2026-06-09T13:39:31.253Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5913": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5913",
    "title": "#431 – Roman Yampolskiy: Dangers of Superintelligent AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5913-cc0ab99255ff/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5913-cc0ab99255ff/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 136103,
      "sha256": "e78b1ae7c852d72594144273674f6e9e62ac35c88e7eb8f4acb5c17070f6a885",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 421,
      "updated_at": "2026-06-09T13:39:31.252Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5901": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5901",
    "title": "#430 – Charan Ranganath: Human Memory, Imagination, Deja Vu, and False Memories",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5901-e43b7bf4ff7d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5901-e43b7bf4ff7d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 193243,
      "sha256": "0656f531214a43287fe15902ada0df73e10991261d19576d880440912897b715",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 429,
      "updated_at": "2026-06-09T13:39:31.251Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5880": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5880",
    "title": "#428 – Sean Carroll: General Relativity, Quantum Mechanics, Black Holes & Aliens",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 168110,
      "sha256": "df743029e41aa8a5e44b7ab0625fdc61af37c13668bb7647f9ff356514dcbc24",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 555,
      "updated_at": "2026-06-09T13:39:31.250Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 123019,
      "sha256": "8d922f837774f6ae5645c0bb678e6b2870c19edebac668ed3cdb4316116ddda9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:08.395Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5880-07b27ec330c5/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 85405,
      "sha256": "b61ac064c39ae4c844661a7e4352225b9a526ef3df3d6411f856fc1396aef452",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:08.395Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5877": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5877",
    "title": "#427 – Neil Adams: Judo, Olympics, Winning, Losing, and the Champion Mindset",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5877-dfef07f5170b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5877-dfef07f5170b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 146075,
      "sha256": "f02445bcbaa0b88712a527cd2ebe8cbeaeb4d6b63b12356f38b1aab53275ca94",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 561,
      "updated_at": "2026-06-09T13:39:31.249Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5874": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5874",
    "title": "#426 – Edward Gibson: Human Language, Psycholinguistics, Syntax, Grammar & LLMs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5874-adf10e7c8831/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5874-adf10e7c8831/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 194034,
      "sha256": "abfb95560c2c352bca1cc66e49f2cacd8230e06426100141d59c44809ed154ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 656,
      "updated_at": "2026-06-09T13:39:31.248Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5850": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5850",
    "title": "#422 – Mark Cuban: Shark Tank, DEI & Wokeism Debate, Elon Musk, Politics & Drugs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 146278,
      "sha256": "c13eab49249a46ed3ecda6ac9b7e6e1a4c74adf3a360d6cc351e771756cadb48",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 522,
      "updated_at": "2026-06-09T13:39:31.247Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99935,
      "sha256": "36f226d050cee698ca4c1d5689550063955ba26246dec86e62d31e86854920f3",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:50:27.061Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5850-51c823f84d24/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 102813,
      "sha256": "9783343b8f6fab25e0faebf933e4aeaeccbcd509bdacbf418e8f96eb2662f427",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 10,
      "updated_at": "2026-05-22T02:50:27.060Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5834": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5834",
    "title": "#419 – Sam Altman: OpenAI, GPT-5, Sora, Board Saga, Elon Musk, Ilya, Power & AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 120818,
      "sha256": "db4d9454a5dc7c30b775be5ece3a266942d3d84c5f9db3e9c5f00d7ce4d48ac0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 499,
      "updated_at": "2026-06-09T13:39:31.246Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72729,
      "sha256": "fa0a7de577fafd0b77ab082a4212853f45e3c157263959475cefae26b6858431",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:49:34.699Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5834-4f33c084c7e8/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 74221,
      "sha256": "5dcbd3d1c62222d619884a05e6d2ca8dec138214a8b78da764bb3bca2d2f99e1",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:49:34.698Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5817": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5817",
    "title": "#416 – Yann Lecun: Meta AI, Open Source, Limits of LLMs, AGI & the Future of AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 154432,
      "sha256": "29608ea1398f489da11558d45d2bafdd4a43db473bedc7a671347a865a0cc73a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 394,
      "updated_at": "2026-06-09T13:39:31.245Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 136807,
      "sha256": "1cabc97c9b9b661d33d0f1ec2fe332b59ecbb48bf7ca5f9e0e10f3a4f7cf69f8",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:38.209Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5817-14b74ef2117b/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 87592,
      "sha256": "48bf4ff77dcfefddd8e0b424a7fd9aea474a4d3c1dc7d4010007e3500d826211",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 6,
      "updated_at": "2026-05-22T02:50:38.209Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5794": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5794",
    "title": "#413 – Bill Ackman: Investing, Financial Battles, Harvard, DEI, X & Free Speech",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 221176,
      "sha256": "8a297506ad600b1e7123d687c495451c558fcee4182d03ad4dfdbad6da61d2ac",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 541,
      "updated_at": "2026-06-09T13:39:31.245Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 201057,
      "sha256": "0941ae08b8792725e604027cba09eb2ef27822b09da727e5ad8e5fe151d28834",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-05-22T02:49:27.297Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5794-d4310b276039/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 122475,
      "sha256": "45b6eb49cf569e33afa737948d3d04bf1c98ec39d658e3c208cbebf42fd64c9d",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-05-22T02:49:27.297Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5773": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5773",
    "title": "#412 – Marc Raibert: Boston Dynamics and the Future of Robotics",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5773-0d2e9d40724e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5773-0d2e9d40724e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 105997,
      "sha256": "1d8be916f27c764991f05ba4177547017d21e13a8c7a7e0818d6da4d1dcf5939",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 385,
      "updated_at": "2026-06-09T13:39:31.244Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5728": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5728",
    "title": "#407 – Guillaume Verdon: Beff Jezos, E/acc Movement, Physics, Computation & AGI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5728-4c95577279d7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5728-4c95577279d7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 148949,
      "sha256": "2307c339909f019992d4ac8b10755e71022920752489ff4916398910445fb2e2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 347,
      "updated_at": "2026-06-09T13:39:31.242Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5707": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5707",
    "title": "#404 – Lee Cronin: Controversial Nature Paper on Evolution of Life and Universe",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 210108,
      "sha256": "971245f22fe381dc7b8807be544c86a0bcd0a59a3a4e5adbd9e69b4681437f8d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 776,
      "updated_at": "2026-06-09T13:39:31.242Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 132198,
      "sha256": "dd792259bd37615c095ed6302e850555f1ffc8d779d109c4771582fc302e5e0a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-05-22T02:49:53.165Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5707-ffc718437394/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 96377,
      "sha256": "0159d5cd0d6bea7495458146148aeff4e5503223e928f97cec2541d2709f6e32",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 9,
      "updated_at": "2026-05-22T02:49:53.165Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5674": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5674",
    "title": "#400 – Elon Musk: War, AI, Aliens, Politics, Physics, Video Games, and Humanity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 124922,
      "sha256": "705d427b18fdb00c456ca8b573b83ac7ce2ebf263cc1555cba76c073a8a3d633",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 549,
      "updated_at": "2026-06-09T13:39:31.240Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 79813,
      "sha256": "972eaca8caabc725ba1cf56c318240faa0062325d11347fb8650d63832683434",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-21T23:04:51.945Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5674-3c212eb11161/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 174078,
      "sha256": "d0ad6b701954c1895d2af1afcc03437938c8c7ef2771f95986ba2c811862a053",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-21T23:04:51.944Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5661": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5661",
    "title": "#398 – Mark Zuckerberg: First Interview in the Metaverse",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 65434,
      "sha256": "db97edec487ce37e034efb010884fa5bbc348075623d805040c4656840c11818",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.239Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 76044,
      "sha256": "8b55bd508c7b5b0d8fe33536bed526c8c87313dda65fd9dbcf58985431474ec0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 5,
      "updated_at": "2026-05-22T02:49:11.852Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5661-38690273039a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 53916,
      "sha256": "ab9de55810f405c5b83a2f624e06fd4d00db2a333c30e12c43d0154bf752323f",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 5,
      "updated_at": "2026-05-22T02:49:11.852Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5618": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5618",
    "title": "#392 – Joscha Bach: Life, Intelligence, Consciousness, AI & the Future of Humans",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5618-313e9d8e446c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5618-313e9d8e446c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 182474,
      "sha256": "52bf3ddafbda90e81fc00c4c05d92c7388bd00f8655685cddb7388dbdad3695c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 478,
      "updated_at": "2026-06-09T13:39:31.238Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "lex-fridman/https://lexfridman.com/?p=5607": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5607",
    "title": "#390 – Yuval Noah Harari: Human Nature, Intelligence, Power, and Conspiracies",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 149535,
      "sha256": "c9884f65924019226f7532aa698a65c2820b7a74bf2d8105705add8675054b62",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 347,
      "updated_at": "2026-06-09T13:39:31.237Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 130997,
      "sha256": "836b0fcda26685528adb2d3aa3678b3a5b93339d63bbccdd0e453f72e8ec7ccf",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:38.311Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5607-5dfd41ee56bc/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 83177,
      "sha256": "2fd63c197254c44195754d57aeea6f9b78909b296d9654139f797f6d96b2dbdb",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 7,
      "updated_at": "2026-05-22T02:49:38.310Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5596": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5596",
    "title": "#389 – Benjamin Netanyahu: Israel, Palestine, Power, Corruption, Hate, and Peace",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66748,
      "sha256": "f283b19783bd6997d2f5adc69597ec1f7301fdf488c49e162166237dc9df2a6c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 156,
      "updated_at": "2026-06-09T13:39:31.236Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 75970,
      "sha256": "4375a398c75846a04333f56c056c050d3a9fe3c6b530526cc078156a4b08f2db",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:19.176Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5596-6554c697d1f2/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 74525,
      "sha256": "1de0e7c4b8ebe9f7c99d532c895c36dde6439fe6007431ba0987687c7acdc89a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:49:19.176Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5583": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5583",
    "title": "#387 – George Hotz: Tiny Corp, Twitter, AI Safety, Self-Driving, GPT, AGI & God",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 225910,
      "sha256": "350f392042e80a812c3862043149b289c7a310a206d35399bb8b3d0e7957cb12",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 1365,
      "updated_at": "2026-06-09T13:39:31.235Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 101053,
      "sha256": "492dea9f86d5d3108ffc9474db4b2b8a3a8484111199279598dbda220123dc07",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:50:00.684Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5583-c7d6f46ab3c4/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 94597,
      "sha256": "1d9fdf5ace908ccf9a2c3e4e9833b1904383accc9f590704e53d3cf7d6a19ec7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 8,
      "updated_at": "2026-05-22T02:50:00.684Z"
    }
  },
  "lex-fridman/https://lexfridman.com/?p=5567": {
    "source_id": "lex-fridman",
    "episode_id": "https://lexfridman.com/?p=5567",
    "title": "#385 – Jimmy Wales: Wikipedia",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5567-066776ec4853/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/lex-fridman-cee0f7ee773b/https-lexfridman-com-p-5567-066776ec4853/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 202395,
      "sha256": "7d7d9838fc20b574931a8ef1f7aa98919526708926053cdfa57eebf1cac00c79",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 465,
      "updated_at": "2026-06-09T13:39:31.234Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6a2a32c83eedf1f4b268db58": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6a2a32c83eedf1f4b268db58",
    "title": "王晶×罗永浩！谁还记得大导演张彻楚原？我死了什么都不需要留下",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a2a32c83eedf1f4b268db58-7d83441f178c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a2a32c83eedf1f4b268db58-7d83441f178c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 244256,
      "sha256": "2c060cb146a8fe1b3ff687e84b0a02b571d8940507c4768236712ee2ae89f61b",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2793,
      "updated_at": "2026-06-16T13:11:30.646Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a2a32c83eedf1f4b268db58-7d83441f178c/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a2a32c83eedf1f4b268db58-7d83441f178c/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1012244,
      "sha256": "c1f68441d23444d3d703532028bfc7638e7898ccd120f7f697cb55ff128618af",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2793,
      "updated_at": "2026-06-16T13:12:22.450Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6a190f4f7460cabdeb57a7ad": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6a190f4f7460cabdeb57a7ad",
    "title": "罗永浩的X字路口！当一群情绪不稳定的杠精讨论起情绪稳定",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a190f4f7460cabdeb57a7ad-b6d9f383f9e6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a190f4f7460cabdeb57a7ad-b6d9f383f9e6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 292640,
      "sha256": "7c60eb558c1635a0c1142f70335ae6870feaf64858e7eec01b91726a671d1b2e",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4813,
      "updated_at": "2026-06-16T13:11:30.509Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a190f4f7460cabdeb57a7ad-b6d9f383f9e6/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a190f4f7460cabdeb57a7ad-b6d9f383f9e6/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1035402,
      "sha256": "39aafe701ea8d932c9bd11d84410df9ca9bf33357dd2ab0126e719ec0b8330b2",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4813,
      "updated_at": "2026-06-16T13:12:21.913Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6a0e83fa1b7bd502958f347d": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6a0e83fa1b7bd502958f347d",
    "title": "郑执×罗永浩！总是赶末班车的人，可以改进时间管理......也可以拥有一辆属于自己的车",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a0e83fa1b7bd502958f347d-219a9b297510/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a0e83fa1b7bd502958f347d-219a9b297510/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 261710,
      "sha256": "d808666d266afa00552be7cb8e5aa1c0d14e4a31912ee4a289d4e566cfe21607",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3500,
      "updated_at": "2026-06-16T13:11:30.312Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a0e83fa1b7bd502958f347d-219a9b297510/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a0e83fa1b7bd502958f347d-219a9b297510/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1050356,
      "sha256": "02f58fcf74ce3caaa50f9882d55b00a660b86b1288f29e4dad0e46a4e442e2a8",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3500,
      "updated_at": "2026-06-16T13:12:21.117Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6a037114e1eb34a939471baf": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6a037114e1eb34a939471baf",
    "title": "李想×罗永浩！李想的理想：通过 AI 技术，让普通人也过上富豪的生活",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a037114e1eb34a939471baf-8dde731f6a88/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a037114e1eb34a939471baf-8dde731f6a88/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 152100,
      "sha256": "bcf3c384afce70559187be0e782eec3dd1822120eb462b795659cd49a9901362",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 436,
      "updated_at": "2026-06-16T13:11:30.157Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a037114e1eb34a939471baf-8dde731f6a88/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6a037114e1eb34a939471baf-8dde731f6a88/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 748438,
      "sha256": "96c25a2adf4c5d4980630144581db9093ee7ca72b44e4ce71cf40a38f1656d0d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 436,
      "updated_at": "2026-06-16T13:12:20.484Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69f12bc9d97e02e4ca5d1bc6": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69f12bc9d97e02e4ca5d1bc6",
    "title": "蔡康永×罗永浩！在残酷的世界寻找自在与和解、保持慈悲与真实",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69f12bc9d97e02e4ca5d1bc6-47cc1d21a4b6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69f12bc9d97e02e4ca5d1bc6-47cc1d21a4b6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 276145,
      "sha256": "49696297d4784d7e395f1c780098d394315562fb196bbb438e31bcfddd5d70f0",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2478,
      "updated_at": "2026-06-16T13:11:30.131Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69f12bc9d97e02e4ca5d1bc6-47cc1d21a4b6/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69f12bc9d97e02e4ca5d1bc6-47cc1d21a4b6/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1124408,
      "sha256": "a0a83fd85160312178cea0fd0cf2650d593ace6102f9fd8c47bb0ffc7aaa4d58",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2478,
      "updated_at": "2026-06-16T13:12:20.277Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69e19a1ee2c8be31556f0c7a": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69e19a1ee2c8be31556f0c7a",
    "title": "携程梁建章×罗永浩！在企业家与学者之间，他选择了最艰难的“往返票”",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69e19a1ee2c8be31556f0c7a-0edf35b48fff/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69e19a1ee2c8be31556f0c7a-0edf35b48fff/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 304750,
      "sha256": "9fb67b74da76daaa3284c26e58c819b0cb130b4eca74dddc3f2d5b783455dcc5",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3420,
      "updated_at": "2026-06-16T13:11:30.023Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69e19a1ee2c8be31556f0c7a-0edf35b48fff/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69e19a1ee2c8be31556f0c7a-0edf35b48fff/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 992130,
      "sha256": "b2afd8126edf2ce7fd3c25eb362406f8bbd98f19bc4f79217c0efcff8c24c850",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3420,
      "updated_at": "2026-06-16T13:12:19.751Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69db5089e2c8be3155fd7978": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69db5089e2c8be3155fd7978",
    "title": "“无聊斋” × 罗永浩的十字路口！喜剧工作者在AI时代可以多“活”几年",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69db5089e2c8be3155fd7978-e992d564d90c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69db5089e2c8be3155fd7978-e992d564d90c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 293870,
      "sha256": "c57377bb05b2c914e7d8dad77f98b993cc50e15cb2c5dbf9ad2135b1765c3877",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4787,
      "updated_at": "2026-06-16T13:11:29.882Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69db5089e2c8be3155fd7978-e992d564d90c/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69db5089e2c8be3155fd7978-e992d564d90c/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1026922,
      "sha256": "99c4f338c0bfb79f8471d3f98368356fabe01de54f6883430b5680c69534f8f2",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4787,
      "updated_at": "2026-06-16T13:12:19.095Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69cdbe5eb977fb2c47e1e409": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69cdbe5eb977fb2c47e1e409",
    "title": "崔健×罗永浩！去天堂和去地狱，都要带上艺术家",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69cdbe5eb977fb2c47e1e409-5726977449d6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69cdbe5eb977fb2c47e1e409-5726977449d6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 196688,
      "sha256": "febc87782d8683eedd904fc99ff44c12d70b47d2aa592a1e0146b5f931bde721",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2328,
      "updated_at": "2026-06-16T13:11:29.686Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69cdbe5eb977fb2c47e1e409-5726977449d6/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69cdbe5eb977fb2c47e1e409-5726977449d6/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 856809,
      "sha256": "f317256dbfed1f8c69172649bc8990bcb2a7743601e8296c2e5e7afea58fa4fb",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2328,
      "updated_at": "2026-06-16T13:12:18.295Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69c45e30e73b70b045dc11c5": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69c45e30e73b70b045dc11c5",
    "title": "杨笠×罗永浩！不想成为“靶心”，也无意成为“灯塔”",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69c45e30e73b70b045dc11c5-2b2fc40303b3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69c45e30e73b70b045dc11c5-2b2fc40303b3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 310145,
      "sha256": "6a308d795cf76816d06ca837f9a6d5acd004b1c6db95d330335a457e941e6046",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3429,
      "updated_at": "2026-06-16T13:11:29.578Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69c45e30e73b70b045dc11c5-2b2fc40303b3/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69c45e30e73b70b045dc11c5-2b2fc40303b3/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1057887,
      "sha256": "d2caa815b0d303671baa1bb466ea80d2e4c756f3f0be96f7fc59effc7ce3497b",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3429,
      "updated_at": "2026-06-16T13:12:17.839Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69a8fe02c8cdeb38c2e6df73": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69a8fe02c8cdeb38c2e6df73",
    "title": "戏剧导演孟京辉×罗永浩！从“爱惹事的反叛者”，到戏剧乌托邦的建构者",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a8fe02c8cdeb38c2e6df73-03c64594e57b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a8fe02c8cdeb38c2e6df73-03c64594e57b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 370445,
      "sha256": "3c6cc15dcc52be738c3360d02a418ff39b97fc445a07aee1b09c27c28b675808",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5034,
      "updated_at": "2026-06-16T13:11:29.435Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a8fe02c8cdeb38c2e6df73-03c64594e57b/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a8fe02c8cdeb38c2e6df73-03c64594e57b/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1186563,
      "sha256": "d39ae1806e945c67638d81108e301d7e6a8be7195003c4ca79a23639689c5a62",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5034,
      "updated_at": "2026-06-16T13:12:17.193Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69a24e6d66e2c30377b1ede3": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69a24e6d66e2c30377b1ede3",
    "title": "“不开玩笑” × 罗永浩的十字路口！折腾未必会赢，但不折腾一定会后悔",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a24e6d66e2c30377b1ede3-1f34fe0951fb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a24e6d66e2c30377b1ede3-1f34fe0951fb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 249229,
      "sha256": "ee407fd1a7b72cf70e94afd7d0b95cfce92117d92c17336527e8213d84d652ef",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3852,
      "updated_at": "2026-06-16T13:11:29.205Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a24e6d66e2c30377b1ede3-1f34fe0951fb/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69a24e6d66e2c30377b1ede3-1f34fe0951fb/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 981123,
      "sha256": "1e37d4dd4a4831bb973a6b6665501441e288b8105ae6860162275c9846d4628c",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3852,
      "updated_at": "2026-06-16T13:12:16.302Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/698ba733a22480add6956a2a": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "698ba733a22480add6956a2a",
    "title": "音乐人张玮玮×罗永浩！我们都是那个“混乱又伟大”的 90 年代的幸存者",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/698ba733a22480add6956a2a-1c6301ebe438/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/698ba733a22480add6956a2a-1c6301ebe438/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 468171,
      "sha256": "e3a16ecd43f86cd9b0ef82b1ce47c39d7f6f423ea6957433e80ab11a3b1f47a6",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5891,
      "updated_at": "2026-06-16T13:11:29.045Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/698ba733a22480add6956a2a-1c6301ebe438/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/698ba733a22480add6956a2a-1c6301ebe438/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1416753,
      "sha256": "f6216118f08dc268f82141bbf98bdca27705a549648f4e892f665c3e0932bfaf",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5891,
      "updated_at": "2026-06-16T13:12:15.637Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6982c33dc78b82389298d08d": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6982c33dc78b82389298d08d",
    "title": "蒋奇明&双雪涛×罗永浩！如何成为飞行家",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6982c33dc78b82389298d08d-eb66fa01e84f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6982c33dc78b82389298d08d-eb66fa01e84f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 254834,
      "sha256": "2ee9b01502b93089a9e932b5976fd014e47d4e7c4707506389fd12cd3e4e1e97",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3421,
      "updated_at": "2026-06-16T13:11:28.794Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6982c33dc78b82389298d08d-eb66fa01e84f/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6982c33dc78b82389298d08d-eb66fa01e84f/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 966683,
      "sha256": "fb179972a609deb8a888aaa2e7e8d4bfd9cb1bd734f611449f20265cf8939851",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3421,
      "updated_at": "2026-06-16T13:12:14.507Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69685b3def1cf272a7737d5d": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69685b3def1cf272a7737d5d",
    "title": "刘震云×罗永浩！有些玩笑含着泪也要开完",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69685b3def1cf272a7737d5d-f634e74ff83c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69685b3def1cf272a7737d5d-f634e74ff83c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 401891,
      "sha256": "d9e5d526bde706e7beea08346695ec757702489aee23d0a17886e9f7005cc18d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5867,
      "updated_at": "2026-06-16T13:11:28.654Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69685b3def1cf272a7737d5d-f634e74ff83c/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69685b3def1cf272a7737d5d-f634e74ff83c/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1225290,
      "sha256": "d26b7c3fd6c2623d0a24e6f59d39b4b68d0fc9321ae9dc84045e64d65631f413",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5867,
      "updated_at": "2026-06-16T13:12:13.897Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69608f978f388c61e1fa0ad0": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69608f978f388c61e1fa0ad0",
    "title": "Lovart 创始人陈冕×罗永浩！且让我大闹一场，然后悄然离去",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69608f978f388c61e1fa0ad0-d48907cddbfb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69608f978f388c61e1fa0ad0-d48907cddbfb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 348132,
      "sha256": "258d797c082f6359ce92454837bae237e1d0041d90d9f97edae029eda7be2531",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4292,
      "updated_at": "2026-06-16T13:11:28.412Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69608f978f388c61e1fa0ad0-d48907cddbfb/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69608f978f388c61e1fa0ad0-d48907cddbfb/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1123548,
      "sha256": "0fc966777bdeba3826c76fd65935d0df386544ac01e8e3dc45d256d436867279",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4292,
      "updated_at": "2026-06-16T13:12:12.906Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/694cb5e1946dca09253c1b2e": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "694cb5e1946dca09253c1b2e",
    "title": "影石Insta360 创始人刘靖康×罗永浩！比生存更重要的是那些微小的念头",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/694cb5e1946dca09253c1b2e-eff096c18d7e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/694cb5e1946dca09253c1b2e-eff096c18d7e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 438303,
      "sha256": "6f12725c707ae810768f4ed8e72f14a262008f1eb4b72568de5b44025197bafe",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5682,
      "updated_at": "2026-06-16T13:11:28.224Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/694cb5e1946dca09253c1b2e-eff096c18d7e/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/694cb5e1946dca09253c1b2e-eff096c18d7e/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1267628,
      "sha256": "2deb2780f7439d7666bc064d2cdbcd2fde936db7e867d39c8e738fa7537495cf",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5682,
      "updated_at": "2026-06-16T13:12:12.135Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6942389c4c65abaff36b20a8": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6942389c4c65abaff36b20a8",
    "title": "导演大鹏×罗永浩！我这两辈子",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6942389c4c65abaff36b20a8-88775c8b5d62/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6942389c4c65abaff36b20a8-88775c8b5d62/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 419880,
      "sha256": "70f56d3d6c1d2e12926f679c146afc3f0f61bf8d490733b2c9d24b6a9ccfb723",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5758,
      "updated_at": "2026-06-16T13:11:27.990Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6942389c4c65abaff36b20a8-88775c8b5d62/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6942389c4c65abaff36b20a8-88775c8b5d62/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1292028,
      "sha256": "2ced9415bd17a618f3e1674eab3067d463065afcb36195569c65f948ce243b4c",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5758,
      "updated_at": "2026-06-16T13:12:11.153Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69392768281939cce65925d3": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69392768281939cce65925d3",
    "title": "MiniMax 创始人闫俊杰×罗永浩！大山并非无法翻越",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69392768281939cce65925d3-9e558e199a3b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69392768281939cce65925d3-9e558e199a3b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 390753,
      "sha256": "7f4426e30653b9965b55ab2de6e52ffe51bc46caf45b2948392e0416e345d9cc",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4859,
      "updated_at": "2026-06-16T13:11:27.735Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69392768281939cce65925d3-9e558e199a3b/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69392768281939cce65925d3-9e558e199a3b/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1097097,
      "sha256": "85abc63a0b3c2a43f48554340f1b0834c2a1e02e547a8036280847f23a79c020",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4859,
      "updated_at": "2026-06-16T13:12:10.151Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69286665f2b167179817c7e4": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69286665f2b167179817c7e4",
    "title": "导演毕赣×罗永浩！清醒、深刻、独一无二的造梦者",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69286665f2b167179817c7e4-ff062b4d66ca/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69286665f2b167179817c7e4-ff062b4d66ca/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 276578,
      "sha256": "b3f9729919f31b83bbaefa5c6d415f1085a8acfd0f905922a2b221876d2be2c0",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2812,
      "updated_at": "2026-06-16T13:11:27.532Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69286665f2b167179817c7e4-ff062b4d66ca/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69286665f2b167179817c7e4-ff062b4d66ca/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1051702,
      "sha256": "2e7951fb7f0eb80a3a1ed91897ced87b6881a3d1d30ef99ac2b5078f3415c141",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2812,
      "updated_at": "2026-06-16T13:12:09.301Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/691d4c86cbba038b4241a301": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "691d4c86cbba038b4241a301",
    "title": "何同学×罗永浩！青年何同学的骄傲与烦恼",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/691d4c86cbba038b4241a301-d8d21f14127c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/691d4c86cbba038b4241a301-d8d21f14127c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 352385,
      "sha256": "636691a6d5976c42a1778f044ec6b42ba26974461e4ce048c3d6389ad074dd80",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4020,
      "updated_at": "2026-06-16T13:11:27.412Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/691d4c86cbba038b4241a301-d8d21f14127c/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/691d4c86cbba038b4241a301-d8d21f14127c/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1129525,
      "sha256": "f7208921bc3a03bcad5ada9073335b95cdc2ae0eadd7e01df5c88f404cd45bad",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4020,
      "updated_at": "2026-06-16T13:12:08.734Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/6911792bd99642be964e9813": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "6911792bd99642be964e9813",
    "title": "魔术大师刘谦×罗永浩！你所不知道的刘谦",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6911792bd99642be964e9813-4b964792108a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6911792bd99642be964e9813-4b964792108a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 404416,
      "sha256": "8f4feccfda94ad7f6bf265f8faaf24334c6893cf122db189900c9cd7d5d8e8cc",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5395,
      "updated_at": "2026-06-16T13:11:27.238Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6911792bd99642be964e9813-4b964792108a/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/6911792bd99642be964e9813-4b964792108a/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1199404,
      "sha256": "0a5b5ca605a8bbaa8b411e28d040dd9eaa0db73696c846bcb23ee9f9d3668207",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5395,
      "updated_at": "2026-06-16T13:12:08.000Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/69013002740634ca477ad956": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "69013002740634ca477ad956",
    "title": "贾樟柯×罗永浩！成为贾樟柯（上）",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69013002740634ca477ad956-9924dfff4a50/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69013002740634ca477ad956-9924dfff4a50/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 355925,
      "sha256": "6ee515fb0419681afe74793a358d9380455401e2daa4e849eb304dc061111897",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5094,
      "updated_at": "2026-06-16T13:11:26.995Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69013002740634ca477ad956-9924dfff4a50/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/69013002740634ca477ad956-9924dfff4a50/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1204273,
      "sha256": "b88ca92808bd9b971e972e10737ec44893c71d41f456ca4da45795089b774b7a",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5094,
      "updated_at": "2026-06-16T13:12:07.068Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68f8351e2265473020a2058a": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68f8351e2265473020a2058a",
    "title": "名创优品叶国富×罗永浩！重塑线下购物，让人们重新爱上逛街！",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f8351e2265473020a2058a-5f9a5519e22e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f8351e2265473020a2058a-5f9a5519e22e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 248750,
      "sha256": "51f2df1bcc42d28c638064b754316b34b85344732695bffd7c33ea4ce24fba18",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2770,
      "updated_at": "2026-06-16T13:11:26.794Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f8351e2265473020a2058a-5f9a5519e22e/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f8351e2265473020a2058a-5f9a5519e22e/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 933679,
      "sha256": "67e5b823a2dfc6b0ec0f4038500c86f87dc062dd9779aeee7f113b6c692c62d5",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2770,
      "updated_at": "2026-06-16T13:12:06.192Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68f1044e456ffec65e21a811": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68f1044e456ffec65e21a811",
    "title": "宋方金×罗永浩！故事必须有人讲下去",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f1044e456ffec65e21a811-db48b3d0208f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f1044e456ffec65e21a811-db48b3d0208f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 556505,
      "sha256": "b3c2e620cdad28d914612b4a49e4d1ff9d79caf2ed318f02aac821a644ae4192",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 8020,
      "updated_at": "2026-06-16T13:11:26.674Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f1044e456ffec65e21a811-db48b3d0208f/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68f1044e456ffec65e21a811-db48b3d0208f/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1481322,
      "sha256": "2df894c631ae776c162394cfd8f943cd0fb70db6371795c149dbd00932f22e4f",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 8020,
      "updated_at": "2026-06-16T13:12:05.663Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68e74f521bef327f3d7ddcd7": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68e74f521bef327f3d7ddcd7",
    "title": "影视飓风TIM×罗永浩！用影像打开世界的梦想家",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68e74f521bef327f3d7ddcd7-8222bcd6030f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68e74f521bef327f3d7ddcd7-8222bcd6030f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 262987,
      "sha256": "b89438a01bc94f6d85934b63dc510375fca0ca3bf11f4c14c3f9cfeee69d2ae1",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2634,
      "updated_at": "2026-06-16T13:11:26.319Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68e74f521bef327f3d7ddcd7-8222bcd6030f/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68e74f521bef327f3d7ddcd7-8222bcd6030f/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1060617,
      "sha256": "8478c6f928f44b44803c0046300d3df0f729e2cccf082fc7dc8e7cc738566955",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2634,
      "updated_at": "2026-06-16T13:12:04.312Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68d29202522b40626cead830": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68d29202522b40626cead830",
    "title": "周鸿祎×罗永浩！周鸿祎深度谈 AI！近四小时高密度输出",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68d29202522b40626cead830-feaaf5d4a969/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68d29202522b40626cead830-feaaf5d4a969/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 322093,
      "sha256": "d7f72391b7a9508a6150aff2a2d687128553c3a560d4f353fefc400fb0e7847d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3930,
      "updated_at": "2026-06-16T13:11:26.202Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68d29202522b40626cead830-feaaf5d4a969/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68d29202522b40626cead830-feaaf5d4a969/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1121424,
      "sha256": "20f2b894dbb45831a0073cd0f8ab772ecbb33ad801204fd1650e229f7957ada1",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3930,
      "updated_at": "2026-06-16T13:12:03.782Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68c086ac2c82c9dcca930f35": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68c086ac2c82c9dcca930f35",
    "title": "五条人之仁科×罗永浩！近五个小时的变态超长对谈！",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68c086ac2c82c9dcca930f35-ec5514b4e7ca/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68c086ac2c82c9dcca930f35-ec5514b4e7ca/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 492497,
      "sha256": "93df458e562c3419bf8b8d83990497e1ae4b68c7c6451501badeac6c86c7875c",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 7208,
      "updated_at": "2026-06-16T13:11:26.021Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68c086ac2c82c9dcca930f35-ec5514b4e7ca/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68c086ac2c82c9dcca930f35-ec5514b4e7ca/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1378729,
      "sha256": "c4e6baf5b7b70c4fae0016a111d0e1c9f91560e7c9b8216b8b927a2ec552ca37",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 7208,
      "updated_at": "2026-06-16T13:12:03.072Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68b4d92f97178f08ee9b2d79": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68b4d92f97178f08ee9b2d79",
    "title": "何广智×罗永浩！何广智：我到长安了",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68b4d92f97178f08ee9b2d79-ab6a016c6f51/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68b4d92f97178f08ee9b2d79-ab6a016c6f51/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 341866,
      "sha256": "6a71801056dc206dfa6abd6e71eb74698454dd14e7b7d9993ad019240e03c160",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4623,
      "updated_at": "2026-06-16T13:11:25.712Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68b4d92f97178f08ee9b2d79-ab6a016c6f51/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68b4d92f97178f08ee9b2d79-ab6a016c6f51/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1125641,
      "sha256": "c9d3c7b0a2c084cd21299b697d9fb4b3d54af21758be09acc4aa5295ebd91aab",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 4623,
      "updated_at": "2026-06-16T13:12:01.865Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68acd788293471fed470ef39": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68acd788293471fed470ef39",
    "title": "何小鹏×罗永浩！何小鹏讲述从财富自由奔赴无尽地狱模式的创业故事",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68acd788293471fed470ef39-485decf2ad53/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68acd788293471fed470ef39-485decf2ad53/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 212789,
      "sha256": "733905d6c124d63db3b6ac1612905049825c115d83c52799fea66fbd0099a63d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2115,
      "updated_at": "2026-06-16T13:11:25.511Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68acd788293471fed470ef39-485decf2ad53/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68acd788293471fed470ef39-485decf2ad53/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 902408,
      "sha256": "b011599ff51b6a9d37e97077164845f789fd8fd8fd9330433cbb000bb127885e",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2115,
      "updated_at": "2026-06-16T13:12:01.064Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "luo-yonghao-crossroads/68a3d1fe293471fed44ce974": {
    "source_id": "luo-yonghao-crossroads",
    "episode_id": "68a3d1fe293471fed44ce974",
    "title": "李想×罗永浩！四小时马拉松访谈！李想首度公开讲述 25 年创业之路",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68a3d1fe293471fed44ce974-ef00b81e8e25/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68a3d1fe293471fed44ce974-ef00b81e8e25/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 428136,
      "sha256": "442843d9310285b29c27cea0fd8149f138d5b547abc55b7c16b4641ad7161325",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5567,
      "updated_at": "2026-06-16T13:11:25.414Z"
    },
    "transcript_pdf": {
      "kind": "transcript_pdf",
      "key": "podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68a3d1fe293471fed44ce974-ef00b81e8e25/transcript.pdf",
      "public_path": "/api/podcast-assets/podcast-text/v1/luo-yonghao-crossroads-8069f9443cca/68a3d1fe293471fed44ce974-ef00b81e8e25/transcript.pdf",
      "file_name": "transcript.pdf",
      "content_type": "application/pdf",
      "size_bytes": 1229291,
      "sha256": "a03efffcd62809df3ab6cfcf0c1d0058110ea1482c7e55f733351118be173e58",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5567,
      "updated_at": "2026-06-16T13:12:00.630Z"
    },
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/70520b9f-a961-4443-879f-b47b1baaea78": {
    "source_id": "mlst",
    "episode_id": "70520b9f-a961-4443-879f-b47b1baaea78",
    "title": "The AI Models Smart Enough to Know They're Cheating — Beth Barnes & David Rein [METR]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 118717,
      "sha256": "9049c0c06b8b75e3411ca5cf2a36db7e8dfa26c723d671b2bfec5014ae234699",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 98,
      "updated_at": "2026-06-09T13:39:31.295Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 98406,
      "sha256": "c61067994a14967ce13aabe4aca1c1679dcf4df812293fbd126a48e21d111d81",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 15,
      "updated_at": "2026-05-26T01:44:11.562Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/70520b9f-a961-4443-879f-b47b1baaea78-4f21fc82752a/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 92840,
      "sha256": "017b1a7bfa9d2bb3591217f294c04c0b10d8c8662a54eacd2a85aac8e07e364e",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 15,
      "updated_at": "2026-05-26T01:44:11.561Z"
    }
  },
  "mlst/a45b8877-0a03-4410-9846-886d2c2a41bb": {
    "source_id": "mlst",
    "episode_id": "a45b8877-0a03-4410-9846-886d2c2a41bb",
    "title": "When AI Discovers The Next Transformer - Robert Lange (Sakana)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/a45b8877-0a03-4410-9846-886d2c2a41bb-3ff8f1e868a6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/a45b8877-0a03-4410-9846-886d2c2a41bb-3ff8f1e868a6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84390,
      "sha256": "5d23e1d0e597f43a04d8fb293f56597d834cee1bac63bf46593f591e1c339c60",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 116,
      "updated_at": "2026-06-09T13:39:31.302Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/900fe43b-34a0-4263-9352-f9c9e3036710": {
    "source_id": "mlst",
    "episode_id": "900fe43b-34a0-4263-9352-f9c9e3036710",
    "title": "\"Vibe Coding is a Slot Machine\" - Jeremy Howard",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/900fe43b-34a0-4263-9352-f9c9e3036710-7a5f6f354236/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/900fe43b-34a0-4263-9352-f9c9e3036710-7a5f6f354236/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85568,
      "sha256": "8b960d1f74bf06dbb93a37eadc2a3c9f3c543a9161331fe85b42a6cabe609926",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 142,
      "updated_at": "2026-06-09T13:39:31.300Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/e51c0c84-f709-44b4-b7b0-9ed8d2b0cb42": {
    "source_id": "mlst",
    "episode_id": "e51c0c84-f709-44b4-b7b0-9ed8d2b0cb42",
    "title": "VAEs Are Energy-Based Models? [Dr. Jeff Beck]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/e51c0c84-f709-44b4-b7b0-9ed8d2b0cb42-a8da2ee873b2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e51c0c84-f709-44b4-b7b0-9ed8d2b0cb42-a8da2ee873b2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53035,
      "sha256": "a18f5cec874741b047b40a57bb36796f220a671930ba2e83a2d4569e5a3a883d",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 62,
      "updated_at": "2026-06-09T13:39:31.307Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/536ae6c8-bbd3-425b-969f-65e25c673d90": {
    "source_id": "mlst",
    "episode_id": "536ae6c8-bbd3-425b-969f-65e25c673d90",
    "title": "Why Every Brain Metaphor in History Has Been Wrong [SPECIAL EDITION]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43394,
      "sha256": "63d7d9987fd1b1c290009349252e0fd8595948fa56bf90e54f25f016e9478024",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 45,
      "updated_at": "2026-06-09T13:39:31.294Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 61008,
      "sha256": "7a5e2707d11a20fea51b090760d8faecdafc9cb805fc74a52ce2d53a45a3344a",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T22:53:47.068Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/536ae6c8-bbd3-425b-969f-65e25c673d90-3597c1288828/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 134385,
      "sha256": "bb51a716fc23aee228e5b7490dc0da34ed740b71989c7733a8229eed0a2fcbff",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T22:53:47.032Z"
    }
  },
  "mlst/e43e3788-5d55-4e10-94a9-e5df4c166a68": {
    "source_id": "mlst",
    "episode_id": "e43e3788-5d55-4e10-94a9-e5df4c166a68",
    "title": "Bayesian Brain, Scientific Method, and Models [Dr. Jeff Beck]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/e43e3788-5d55-4e10-94a9-e5df4c166a68-2d76aa198675/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e43e3788-5d55-4e10-94a9-e5df4c166a68-2d76aa198675/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85169,
      "sha256": "85828af5725a88310afa4bd5069b303c68b0dab644e403631710b81f5e0d6df7",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 77,
      "updated_at": "2026-06-09T13:39:31.307Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/86553cae-172d-46c8-ad6f-fe3eb01af737": {
    "source_id": "mlst",
    "episode_id": "86553cae-172d-46c8-ad6f-fe3eb01af737",
    "title": "Your Brain is Running a Simulation Right Now [Max Bennett]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 207656,
      "sha256": "80f43a9dc98ce67e3f53d2883f48f6c4f23b7e90acfabcfbcf0d2262e4128134",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 111,
      "updated_at": "2026-06-09T13:39:31.299Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 312680,
      "sha256": "ee17e0a49e8590dfadaded89803fc46f7a99c2ef2653aaba1189a541a83313cd",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T11:57:09.426Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/86553cae-172d-46c8-ad6f-fe3eb01af737-96328e3b0b2d/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 176967,
      "sha256": "3fee3d79592d2d8bead978c7d753acc3f26d43f65cb9e1ea79edca5c0b77c210",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T11:57:09.425Z"
    }
  },
  "mlst/bd9c4159-2dec-4a95-af06-e7a92faea686": {
    "source_id": "mlst",
    "episode_id": "bd9c4159-2dec-4a95-af06-e7a92faea686",
    "title": "The 3 Laws of Knowledge [César Hidalgo]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/bd9c4159-2dec-4a95-af06-e7a92faea686-781c98ebef77/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/bd9c4159-2dec-4a95-af06-e7a92faea686-781c98ebef77/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 108418,
      "sha256": "8aa4ceefb9d53141c7d4dfcfa0ae6443bf155f81d00e576ca7da5f9728f98e37",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.304Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/0ff34341-7c39-4bee-b3a3-c8fc4ae25c8b": {
    "source_id": "mlst",
    "episode_id": "0ff34341-7c39-4bee-b3a3-c8fc4ae25c8b",
    "title": "\"I Desperately Want To Live In The Matrix\" - Dr. Mike Israetel",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/0ff34341-7c39-4bee-b3a3-c8fc4ae25c8b-c439740dd8d0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/0ff34341-7c39-4bee-b3a3-c8fc4ae25c8b-c439740dd8d0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 202130,
      "sha256": "123f280552cdf71461e883adf6cba7ea9cae2fae8c0d4b8584d7bff84bb1328a",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 198,
      "updated_at": "2026-06-09T13:39:31.290Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/4c94188d-7a08-473c-8eda-c95faaee0dca": {
    "source_id": "mlst",
    "episode_id": "4c94188d-7a08-473c-8eda-c95faaee0dca",
    "title": "Making deep learning perform real algorithms with Category Theory (Andrew Dudzik, Petar Velichkovich, Taco Cohen, Bruno Gavranović, Paul Lessard)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/4c94188d-7a08-473c-8eda-c95faaee0dca-63607cb8c17e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/4c94188d-7a08-473c-8eda-c95faaee0dca-63607cb8c17e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46763,
      "sha256": "aa4a75dd7d522a6fde45a78132e2793e7c34f7f2cd0cbf847cbca32f4787f59f",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.293Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/8fa1483b-896e-4f90-949b-81a7ae9762ed": {
    "source_id": "mlst",
    "episode_id": "8fa1483b-896e-4f90-949b-81a7ae9762ed",
    "title": "Are AI Benchmarks Telling The Full Story? [SPONSORED] (Andrew Gordon and Nora Petrova - Prolific)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/8fa1483b-896e-4f90-949b-81a7ae9762ed-01be35cd5dd1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/8fa1483b-896e-4f90-949b-81a7ae9762ed-01be35cd5dd1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 23869,
      "sha256": "f69e63e5635030fff70e6d383f107287922270ce5ef1a41e198224b16a116f08",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 137,
      "updated_at": "2026-06-09T13:39:31.300Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/6309cd81-ec51-41b6-bec6-1179c26d81ca": {
    "source_id": "mlst",
    "episode_id": "6309cd81-ec51-41b6-bec6-1179c26d81ca",
    "title": "The Mathematical Foundations of Intelligence [Professor Yi Ma]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/6309cd81-ec51-41b6-bec6-1179c26d81ca-77240059ff72/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/6309cd81-ec51-41b6-bec6-1179c26d81ca-77240059ff72/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 95332,
      "sha256": "e833eec25b7bf9829691d025661f0d83a95977a0449ea6b07f81dc3157262160",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 1023,
      "updated_at": "2026-06-09T13:39:31.294Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/debf8b10-0cf7-4ba7-a702-408bc4480bb4": {
    "source_id": "mlst",
    "episode_id": "debf8b10-0cf7-4ba7-a702-408bc4480bb4",
    "title": "Pedro Domingos: Tensor Logic Unifies AI Paradigms",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 99061,
      "sha256": "cf5ec094e0e99659d7d9ee7023f2b76cb344739ff5bb40ff441c75bd492fec12",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 103,
      "updated_at": "2026-06-09T13:39:31.306Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 101596,
      "sha256": "38fba2bcea0d717c2ca573140845ba1015a7a30760b9d8fa5bdee4a727929f3d",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T04:28:25.462Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/debf8b10-0cf7-4ba7-a702-408bc4480bb4-7c5f7892dbb2/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 149519,
      "sha256": "6345ef111773e79ba8a30815ee992d99b643cea485b978ac55019934d9c488b7",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T04:28:25.461Z"
    }
  },
  "mlst/29d987a7-8718-4f28-be32-b04616951736": {
    "source_id": "mlst",
    "episode_id": "29d987a7-8718-4f28-be32-b04616951736",
    "title": "He Co-Invented the Transformer. Now: Continuous Thought Machines - Llion Jones and Luke Darlow [Sakana AI]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/29d987a7-8718-4f28-be32-b04616951736-284618cd3fd7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/29d987a7-8718-4f28-be32-b04616951736-284618cd3fd7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71912,
      "sha256": "b03074a0338b35836e26ca51b33b7923a475c7af1de65be5f5c23eedfee0cf58",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 80,
      "updated_at": "2026-06-09T13:39:31.291Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/912b42eb-c444-4f87-9c8d-0859806c191f": {
    "source_id": "mlst",
    "episode_id": "912b42eb-c444-4f87-9c8d-0859806c191f",
    "title": "The Universal Hierarchy of Life - Prof. Chris Kempes [SFI]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/912b42eb-c444-4f87-9c8d-0859806c191f-8353213b5e28/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/912b42eb-c444-4f87-9c8d-0859806c191f-8353213b5e28/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 60562,
      "sha256": "89f7d8da4197fd0e1c85226e0891fe7ba5a5f5d93feb34a83720dfa1da0f9514",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 499,
      "updated_at": "2026-06-09T13:39:31.301Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/e66db573-9f5c-4ef8-aae5-c0e9bfff1d95": {
    "source_id": "mlst",
    "episode_id": "e66db573-9f5c-4ef8-aae5-c0e9bfff1d95",
    "title": "Google Researcher Shows Life \"Emerges From Code\" - Blaise Agüera y Arcas",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/e66db573-9f5c-4ef8-aae5-c0e9bfff1d95-4eb8ce28a5e8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e66db573-9f5c-4ef8-aae5-c0e9bfff1d95-4eb8ce28a5e8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 85242,
      "sha256": "d62cd74ff8d0790fcd8d15c679f1e85eaf7fdc0fa7044f8747b7cf1bee9109f2",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 586,
      "updated_at": "2026-06-09T13:39:31.308Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/e1ff02ca-df6a-4672-991f-d0443a7c834c": {
    "source_id": "mlst",
    "episode_id": "e1ff02ca-df6a-4672-991f-d0443a7c834c",
    "title": "The Secret Engine of AI - Prolific [Sponsored] (Sara Saab, Enzo Blindow)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 82441,
      "sha256": "406784e2b4c73d5e8005617a38648409668e90934f2478c29a6c95674ddbff16",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 128,
      "updated_at": "2026-06-09T13:39:31.306Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 64620,
      "sha256": "6faf27243b4714196581dacdca437a8ac872b4ced927fe767e927d1f3dd362b9",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 19,
      "updated_at": "2026-05-24T22:50:11.856Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/e1ff02ca-df6a-4672-991f-d0443a7c834c-9b5208fec42e/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 81658,
      "sha256": "00d780a32c31c7b520c42b46e49793919a9b0ed84aec91751baa6fbf43a57bf0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 19,
      "updated_at": "2026-05-24T22:50:11.855Z"
    }
  },
  "mlst/7c125595-39ca-4fe2-9fb9-2081d4a7802e": {
    "source_id": "mlst",
    "episode_id": "7c125595-39ca-4fe2-9fb9-2081d4a7802e",
    "title": "AI Agents Can Code 10,000 Lines of Hacking Tools In Seconds - Dr. Ilia Shumailov (ex-GDM)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/7c125595-39ca-4fe2-9fb9-2081d4a7802e-cfeeabcaf2b4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/7c125595-39ca-4fe2-9fb9-2081d4a7802e-cfeeabcaf2b4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 72028,
      "sha256": "4828d7f31f0c0e6541b415cefa21ee25384028db5c649f1e80e7bdcc14e31323",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.298Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/f26da6ec-68d8-47b5-9f4f-4fc85aeef964": {
    "source_id": "mlst",
    "episode_id": "f26da6ec-68d8-47b5-9f4f-4fc85aeef964",
    "title": "Deep Learning is Not So Mysterious or Different - Prof. Andrew Gordon Wilson (NYU)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/f26da6ec-68d8-47b5-9f4f-4fc85aeef964-965a361c2d72/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/f26da6ec-68d8-47b5-9f4f-4fc85aeef964-965a361c2d72/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 138898,
      "sha256": "afacbbe5f7ce253df146813364b6fad432928a6670210ea7aba43db1105ea454",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.308Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/31530e8e-0338-4528-837e-c1795abb80d5": {
    "source_id": "mlst",
    "episode_id": "31530e8e-0338-4528-837e-c1795abb80d5",
    "title": "Karl Friston - Why Intelligence Can't Get Too Large (Goldilocks principle)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/31530e8e-0338-4528-837e-c1795abb80d5-b9bfb3845f07/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/31530e8e-0338-4528-837e-c1795abb80d5-b9bfb3845f07/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 111206,
      "sha256": "c76b836265b1bcf21f7f8e0b26886533c9958930da3ac3dd953a60256aa6bf03",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 1263,
      "updated_at": "2026-06-09T13:39:31.292Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/78ae3b32-d001-4795-870d-b572603b56ed": {
    "source_id": "mlst",
    "episode_id": "78ae3b32-d001-4795-870d-b572603b56ed",
    "title": "The Day AI Solves My Puzzles Is The Day I Worry (Prof. Cristopher Moore)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/78ae3b32-d001-4795-870d-b572603b56ed-63359e43acdd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/78ae3b32-d001-4795-870d-b572603b56ed-63359e43acdd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 83443,
      "sha256": "d3e561524e74b519742e4c1e3634c8e44a885b1f11246923116be54a103f9f61",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 69,
      "updated_at": "2026-06-09T13:39:31.297Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/fc2055b9-b9ef-4546-a398-c89dc584373a": {
    "source_id": "mlst",
    "episode_id": "fc2055b9-b9ef-4546-a398-c89dc584373a",
    "title": "DeepMind Genie 3 [World Exclusive] (Jack Parker Holder, Shlomi Fruchter)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/fc2055b9-b9ef-4546-a398-c89dc584373a-2d009b6b47b4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/fc2055b9-b9ef-4546-a398-c89dc584373a-2d009b6b47b4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 77355,
      "sha256": "49db2b4a9a21fb3dec3d6d81d325431d8c15aa504e8f9b2dd1d1af95d9eddc73",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 512,
      "updated_at": "2026-06-09T13:39:31.309Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "mlst/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a": {
    "source_id": "mlst",
    "episode_id": "c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a",
    "title": "The Fractured Entangled Representation Hypothesis (Kenneth Stanley, Akarsh Kumar)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 192806,
      "sha256": "4ee81f22820f07b7a87c95c8f9d78e67b97b058cd3dc43e6400bba70b163653b",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 1477,
      "updated_at": "2026-06-09T13:39:31.305Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66274,
      "sha256": "654aa7f1bf8dce5ab42cd8e2b93b7e900bb7cf9ed87cd5120744c59b34e80588",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T12:35:38.053Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a-2d4d3b3cfe4c/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 149045,
      "sha256": "1e59480538921a188f4dde2b38be5fb700b1380eef008550a819db24a6a4ea4c",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 30,
      "updated_at": "2026-05-24T12:35:38.052Z"
    }
  },
  "mlst/715ff48a-41df-477b-bc5d-902a8567cdfd": {
    "source_id": "mlst",
    "episode_id": "715ff48a-41df-477b-bc5d-902a8567cdfd",
    "title": "The Fractured Entangled Representation Hypothesis (Intro)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 21521,
      "sha256": "9731299f93e7dd8dae08d3e2acaa69c6eecff6a615c911817d8852e39d10f3ee",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 128,
      "updated_at": "2026-06-09T13:39:31.296Z"
    },
    "transcript_pdf": null,
    "cn_readable": {
      "kind": "cn_readable",
      "key": "podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/cn-readable.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/cn-readable.md",
      "file_name": "cn-readable.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42780,
      "sha256": "82b9dcd6d95afaac2d755b59fe97175bccaa8afe7561fbd21505d84faaaaffc0",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 24,
      "updated_at": "2026-05-24T01:25:35.497Z"
    },
    "cn_knowledge_json": {
      "kind": "cn_knowledge_json",
      "key": "podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/cn-knowledge.json",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/715ff48a-41df-477b-bc5d-902a8567cdfd-fdd4c3508d19/cn-knowledge.json",
      "file_name": "cn-knowledge.json",
      "content_type": "application/json; charset=utf-8",
      "size_bytes": 147448,
      "sha256": "ec3b21e0b44fc16e17723a19c78dabb2d68c02b185474e78834812166e04b59b",
      "source_kind": "cn_knowledge",
      "source_quality": "processed_cn_knowledge",
      "record_count": 24,
      "updated_at": "2026-05-24T01:25:35.497Z"
    }
  },
  "mlst/a935de76-26f6-48c2-852c-80086f0caf33": {
    "source_id": "mlst",
    "episode_id": "a935de76-26f6-48c2-852c-80086f0caf33",
    "title": "Three Red Lines We're About to Cross Toward AGI (Daniel Kokotajlo, Gary Marcus, Dan Hendrycks)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/mlst-31ef3b292411/a935de76-26f6-48c2-852c-80086f0caf33-a530461c26f5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/mlst-31ef3b292411/a935de76-26f6-48c2-852c-80086f0caf33-a530461c26f5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 144980,
      "sha256": "1cba1e5fde8292b2a90bc0e763cd1e858b4bcf04cf1fbac205857c3bfa511fd6",
      "source_kind": "official_rescript_transcript",
      "source_quality": "official_transcript",
      "record_count": 319,
      "updated_at": "2026-06-09T13:39:31.303Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/22b5acc0-4e7e-11f1-b656-db49fb93781a": {
    "source_id": "possible",
    "episode_id": "22b5acc0-4e7e-11f1-b656-db49fb93781a",
    "title": "Anthropic’s push into finance",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/22b5acc0-4e7e-11f1-b656-db49fb93781a-69322a37204c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/22b5acc0-4e7e-11f1-b656-db49fb93781a-69322a37204c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35637,
      "sha256": "d8120f94e5eb01009954a0b023d2516c3491acea7f6263b399a5f8ed5f8f0df4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 57,
      "updated_at": "2026-06-09T13:39:31.321Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/afa03bf8-490d-11f1-ae0e-cf75e97bd73d": {
    "source_id": "possible",
    "episode_id": "afa03bf8-490d-11f1-ae0e-cf75e97bd73d",
    "title": "The artist AI can’t kill",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/afa03bf8-490d-11f1-ae0e-cf75e97bd73d-6fa293655b86/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/afa03bf8-490d-11f1-ae0e-cf75e97bd73d-6fa293655b86/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 63765,
      "sha256": "23214f673af59503daafbb3b6854b5fd1aeb719532e8c5b2cf50e8ccc7bc2b44",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 174,
      "updated_at": "2026-06-09T13:39:31.367Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/9d3a90d2-4389-11f1-adc3-afdbbb1c9908": {
    "source_id": "possible",
    "episode_id": "9d3a90d2-4389-11f1-adc3-afdbbb1c9908",
    "title": "Divine intervention in AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/9d3a90d2-4389-11f1-adc3-afdbbb1c9908-39ceea5f3f0b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/9d3a90d2-4389-11f1-adc3-afdbbb1c9908-39ceea5f3f0b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 25996,
      "sha256": "5d1a55d85680c98b4bb9fb897ff22c6711ec3f81e00b9d00de971114659550e3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 43,
      "updated_at": "2026-06-09T13:39:31.357Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/3f4dc6d8-3dfd-11f1-b31e-8b1c6f1be5cd": {
    "source_id": "possible",
    "episode_id": "3f4dc6d8-3dfd-11f1-b31e-8b1c6f1be5cd",
    "title": "Netflix co-founder Reed Hastings: stories, schools, superpowers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/3f4dc6d8-3dfd-11f1-b31e-8b1c6f1be5cd-ca5f6a8aae4e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/3f4dc6d8-3dfd-11f1-b31e-8b1c6f1be5cd-ca5f6a8aae4e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62315,
      "sha256": "523049e49682cb60f20120af846c378e555302b5945b24c2ba71bf591f6d434a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 183,
      "updated_at": "2026-06-09T13:39:31.332Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/db8d6e7c-388f-11f1-b41f-c3186e2b5dc7": {
    "source_id": "possible",
    "episode_id": "db8d6e7c-388f-11f1-b41f-c3186e2b5dc7",
    "title": "The grid(lock) slowing AI down",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/db8d6e7c-388f-11f1-b41f-c3186e2b5dc7-2b7ff91135fa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/db8d6e7c-388f-11f1-b41f-c3186e2b5dc7-2b7ff91135fa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 26057,
      "sha256": "adf766711c2041004599265d4d1a52a4ac72670f6700e75e77d4a0b663dcd0ea",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.378Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/fa1f3eb8-3305-11f1-8816-a70875ef2619": {
    "source_id": "possible",
    "episode_id": "fa1f3eb8-3305-11f1-8816-a70875ef2619",
    "title": "AI’s expanding attack surface",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/fa1f3eb8-3305-11f1-8816-a70875ef2619-fcf0ea3c1d68/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/fa1f3eb8-3305-11f1-8816-a70875ef2619-fcf0ea3c1d68/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 21644,
      "sha256": "e9c857650da93e575d4edbf8b8aba25141ad3b21efe90e11276721fc798c5a43",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.390Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e42f07f6-2d87-11f1-a8ef-4f51d17c43d9": {
    "source_id": "possible",
    "episode_id": "e42f07f6-2d87-11f1-a8ef-4f51d17c43d9",
    "title": "Should we give AI a bank account?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e42f07f6-2d87-11f1-a8ef-4f51d17c43d9-73db5a7340a2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e42f07f6-2d87-11f1-a8ef-4f51d17c43d9-73db5a7340a2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 62218,
      "sha256": "cf062006c60f4e9f32216bb19492fd23904ae1249fc0d45c50439915d610fa10",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 146,
      "updated_at": "2026-06-09T13:39:31.381Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f185b640-27e0-11f1-8fcf-cf7f827faf7a": {
    "source_id": "possible",
    "episode_id": "f185b640-27e0-11f1-8fcf-cf7f827faf7a",
    "title": "After SaaS",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f185b640-27e0-11f1-8fcf-cf7f827faf7a-defb00c04c9f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f185b640-27e0-11f1-8fcf-cf7f827faf7a-defb00c04c9f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 20658,
      "sha256": "4b455d16d93c15c5fa8070862374cdf227ef2cface9d5c584cb0c740e79cd989",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.387Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6619dd6c-2253-11f1-ba94-939004352ba3": {
    "source_id": "possible",
    "episode_id": "6619dd6c-2253-11f1-ba94-939004352ba3",
    "title": "Humans secretly prefer AI writing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6619dd6c-2253-11f1-ba94-939004352ba3-a1fbc30c08be/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6619dd6c-2253-11f1-ba94-939004352ba3-a1fbc30c08be/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 23009,
      "sha256": "d29a2920d3efbcfb4916871f19e7a78e973ac87302b23e40cd2eb1c2003a7186",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 12,
      "updated_at": "2026-06-09T13:39:31.340Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/368494f8-1d0c-11f1-ad0d-4bf0ba7cfafe": {
    "source_id": "possible",
    "episode_id": "368494f8-1d0c-11f1-ad0d-4bf0ba7cfafe",
    "title": "The AI Kept Choosing War",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/368494f8-1d0c-11f1-ad0d-4bf0ba7cfafe-1edc1b6a1277/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/368494f8-1d0c-11f1-ad0d-4bf0ba7cfafe-1edc1b6a1277/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33054,
      "sha256": "ae1372506eab9fe212c8511ccf2fe6bcbc025bd1d4c5a674d1524e7d37a377a0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 55,
      "updated_at": "2026-06-09T13:39:31.328Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/65a3c7ce-179c-11f1-b828-2bb2d715f8c7": {
    "source_id": "possible",
    "episode_id": "65a3c7ce-179c-11f1-b828-2bb2d715f8c7",
    "title": "How Notion rebuilt for the age of AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/65a3c7ce-179c-11f1-b828-2bb2d715f8c7-18a2539383de/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/65a3c7ce-179c-11f1-b828-2bb2d715f8c7-18a2539383de/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57390,
      "sha256": "005d84eac9795def2d0feecfc468fac28bc6fbe97178cd0cb18e2a069c7e9d4a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 168,
      "updated_at": "2026-06-09T13:39:31.340Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/abe5c1a8-1213-11f1-aeaf-0ff35c155c1c": {
    "source_id": "possible",
    "episode_id": "abe5c1a8-1213-11f1-aeaf-0ff35c155c1c",
    "title": "Network effects, AI medicine, and the fight for free speech",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/abe5c1a8-1213-11f1-aeaf-0ff35c155c1c-b9b7b4a11738/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/abe5c1a8-1213-11f1-aeaf-0ff35c155c1c-b9b7b4a11738/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 23062,
      "sha256": "9cba62f8052e4516f4a9d1af841d0657ec506f121bf6a524ff05094b0eafb1ee",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 44,
      "updated_at": "2026-06-09T13:39:31.363Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6b559c0a-0c8a-11f1-829b-9bc4a7a3d8cf": {
    "source_id": "possible",
    "episode_id": "6b559c0a-0c8a-11f1-829b-9bc4a7a3d8cf",
    "title": "Does AI really save time?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6b559c0a-0c8a-11f1-829b-9bc4a7a3d8cf-f26b9efb36eb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6b559c0a-0c8a-11f1-829b-9bc4a7a3d8cf-f26b9efb36eb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 28117,
      "sha256": "6be323e328272fe1c3ddef0e1d280b33b33ab55874cfb782c7239b407965b139",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 43,
      "updated_at": "2026-06-09T13:39:31.341Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/4c6c980c-0708-11f1-9806-93af51d6f68d": {
    "source_id": "possible",
    "episode_id": "4c6c980c-0708-11f1-9806-93af51d6f68d",
    "title": "Making sense of the layoff wave",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/4c6c980c-0708-11f1-9806-93af51d6f68d-b27de83099c2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/4c6c980c-0708-11f1-9806-93af51d6f68d-b27de83099c2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 28678,
      "sha256": "395b84c1cbb08a446b680d8fe26810da4011c6ab248be166dd10df09b82bbe2f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 59,
      "updated_at": "2026-06-09T13:39:31.334Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/052d8048-fc07-11f0-8623-2ffdbfabfb81": {
    "source_id": "possible",
    "episode_id": "052d8048-fc07-11f0-8623-2ffdbfabfb81",
    "title": "Reid Riffs with Parth Patil on AI-Native Startups (Part 3 of 3)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/052d8048-fc07-11f0-8623-2ffdbfabfb81-e08e63b2dac6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/052d8048-fc07-11f0-8623-2ffdbfabfb81-e08e63b2dac6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35996,
      "sha256": "3f1f1bdae968c5b85413c16b4d38bed78d03654d3f4f0118c8f6492f1a857c95",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.311Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/5d28e9b8-e09b-11f0-b3af-6b636adb3f3f": {
    "source_id": "possible",
    "episode_id": "5d28e9b8-e09b-11f0-b3af-6b636adb3f3f",
    "title": "Stephen Colbert on connection, discovery, and human nature",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/5d28e9b8-e09b-11f0-b3af-6b636adb3f3f-f117f0b83bfa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/5d28e9b8-e09b-11f0-b3af-6b636adb3f3f-f117f0b83bfa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52989,
      "sha256": "b4a77c25c8715eee6cf5ef1ddbe696ec3ff934fef9a0618e94584b4fb2e43201",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 137,
      "updated_at": "2026-06-09T13:39:31.337Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/37339982-db10-11f0-b99e-0f4c27928146": {
    "source_id": "possible",
    "episode_id": "37339982-db10-11f0-b99e-0f4c27928146",
    "title": "The power of AI, from curing cancer to ballot boxes",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/37339982-db10-11f0-b99e-0f4c27928146-0503271e68f2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/37339982-db10-11f0-b99e-0f4c27928146-0503271e68f2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 31035,
      "sha256": "c9ad6016da378f34ccb6f3fad8b9b63a55abe069e6ff8c5c89dc9f40d92250c0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 51,
      "updated_at": "2026-06-09T13:39:31.329Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e53cbd1e-d571-11f0-89e7-832f2be6f6dc": {
    "source_id": "possible",
    "episode_id": "e53cbd1e-d571-11f0-89e7-832f2be6f6dc",
    "title": "The AI energy war is here",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e53cbd1e-d571-11f0-89e7-832f2be6f6dc-8d65223a4edb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e53cbd1e-d571-11f0-89e7-832f2be6f6dc-8d65223a4edb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 17494,
      "sha256": "7c0da764f107e0c74a9c0d8927729824a7a44acfc2862a5d7b827bed518ee788",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.381Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/a766a79c-cfff-11f0-88f3-632467375c41": {
    "source_id": "possible",
    "episode_id": "a766a79c-cfff-11f0-88f3-632467375c41",
    "title": "R.I.P. Computer Keyboard (1964 – 2025)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/a766a79c-cfff-11f0-88f3-632467375c41-fea52968ab56/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/a766a79c-cfff-11f0-88f3-632467375c41-fea52968ab56/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56793,
      "sha256": "e07c746b1d83bc5cf0cc04a92380bd257d620fb951bb94cf13b571279a7c4050",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.361Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e2b80e76-ca82-11f0-b861-133cc9761b94": {
    "source_id": "possible",
    "episode_id": "e2b80e76-ca82-11f0-b861-133cc9761b94",
    "title": "AI’s Influence On The Church, Cybersecurity, and Disney",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e2b80e76-ca82-11f0-b861-133cc9761b94-ca1c3977b2a1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e2b80e76-ca82-11f0-b861-133cc9761b94-ca1c3977b2a1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56810,
      "sha256": "f6c7330d5664faef274f5e3ed238c024f270e87df82b9af3acbd3a8afb156199",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.380Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f7c5fd54-c4e8-11f0-8fca-7712c93b66d5": {
    "source_id": "possible",
    "episode_id": "f7c5fd54-c4e8-11f0-8fca-7712c93b66d5",
    "title": "Our AI blindspot: incentives over intentions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f7c5fd54-c4e8-11f0-8fca-7712c93b66d5-8782f52c7f9f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f7c5fd54-c4e8-11f0-8fca-7712c93b66d5-8782f52c7f9f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 71751,
      "sha256": "27943b004ddfed9480c502f419fe27e8441fc4a90df7869198e0a7df17f20dc3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 159,
      "updated_at": "2026-06-09T13:39:31.389Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/268e63ba-b459-11f0-914d-ffed567da8d8": {
    "source_id": "possible",
    "episode_id": "268e63ba-b459-11f0-914d-ffed567da8d8",
    "title": "Steve Kerr and Kris Brown on Leadership, Purpose, and Innovation in Sport and Society",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/268e63ba-b459-11f0-914d-ffed567da8d8-635bc8fb16ba/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/268e63ba-b459-11f0-914d-ffed567da8d8-635bc8fb16ba/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56838,
      "sha256": "26ec1c246e0583c39f0ebfd90a6df35636f0eb1a1ff5c8d46b282028aafd6c18",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.323Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/fc9ef882-aecf-11f0-9757-a7bd5b92117f": {
    "source_id": "possible",
    "episode_id": "fc9ef882-aecf-11f0-9757-a7bd5b92117f",
    "title": "Aza Raskin on interspecies communication, empathy, and AI’s next frontier",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/fc9ef882-aecf-11f0-9757-a7bd5b92117f-f58e3af0ad3a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/fc9ef882-aecf-11f0-9757-a7bd5b92117f-f58e3af0ad3a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56828,
      "sha256": "7b0ff312324d1b9e58bbddfeb2dc302ccf2eefc626f0089784092202b0eca563",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.391Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/76c821a6-a953-11f0-8846-f3252f84ab9e": {
    "source_id": "possible",
    "episode_id": "76c821a6-a953-11f0-8846-f3252f84ab9e",
    "title": "Reid riffs on fostering trust with founders, in boardrooms, and in AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/76c821a6-a953-11f0-8846-f3252f84ab9e-8777d4212721/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/76c821a6-a953-11f0-8846-f3252f84ab9e-8777d4212721/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56822,
      "sha256": "7eebfc5927fa6c90e2d4b9eb3b5364131d5bca49a26826b6178fe986cd767e4b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.345Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1eec4c46-a3ef-11f0-ae0e-f38d0ef403b3": {
    "source_id": "possible",
    "episode_id": "1eec4c46-a3ef-11f0-ae0e-f38d0ef403b3",
    "title": "David Fajgenbaum on drug repurposing, AI, and saving his own life",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1eec4c46-a3ef-11f0-ae0e-f38d0ef403b3-8c885c28aabb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1eec4c46-a3ef-11f0-ae0e-f38d0ef403b3-8c885c28aabb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 81669,
      "sha256": "b5d3745e8263573870f56e2fe515494c94e2900fc99f4e99760a6bd5f3d0afa0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 169,
      "updated_at": "2026-06-09T13:39:31.318Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/26fe20aa-9e61-11f0-9a78-5f9f5e59f1b5": {
    "source_id": "possible",
    "episode_id": "26fe20aa-9e61-11f0-9a78-5f9f5e59f1b5",
    "title": "Reid riffs on Trump’s $100K visa fee, 3-day work weeks, and AI trust issues",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/26fe20aa-9e61-11f0-9a78-5f9f5e59f1b5-2cf49c415202/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/26fe20aa-9e61-11f0-9a78-5f9f5e59f1b5-2cf49c415202/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56830,
      "sha256": "5acb5ede390c277ebd9e4638a90c4b9867a29f8c596b44b9fcfa87ba19ef03bc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.324Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1a84f708-98a4-11f0-8b31-2feaced0ccaf": {
    "source_id": "possible",
    "episode_id": "1a84f708-98a4-11f0-8b31-2feaced0ccaf",
    "title": "Lisa Su on semiconductors, compute, and big bets",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1a84f708-98a4-11f0-8b31-2feaced0ccaf-5d21bd4d9e75/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1a84f708-98a4-11f0-8b31-2feaced0ccaf-5d21bd4d9e75/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56801,
      "sha256": "a987613002cf27c51208b3caccb036cc304c6120bb7c97e2e7ecec6ff50a6c11",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.315Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/81b521c6-934c-11f0-b667-eba5cf21abfc": {
    "source_id": "possible",
    "episode_id": "81b521c6-934c-11f0-b667-eba5cf21abfc",
    "title": "Reid Riffs on AI translations, Apple Intelligence, and OpenAI’s Critterz",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/81b521c6-934c-11f0-b667-eba5cf21abfc-2b45e9264435/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/81b521c6-934c-11f0-b667-eba5cf21abfc-2b45e9264435/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56827,
      "sha256": "7c025d4d3eab4da923e6682f46bfdfaf939cb058c0d16bc5add29a500c0afbae",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.348Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d7a5531e-8dc3-11f0-b449-63655e5a3c20": {
    "source_id": "possible",
    "episode_id": "d7a5531e-8dc3-11f0-b449-63655e5a3c20",
    "title": "Stephen Colbert on connection, discovery and human nature",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d7a5531e-8dc3-11f0-b449-63655e5a3c20-958b31128c8a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d7a5531e-8dc3-11f0-b449-63655e5a3c20-958b31128c8a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56810,
      "sha256": "5a1444422a4af54d590de0f091056109b276b5bb11e749cc7b5525f05393a655",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.376Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/37e84202-880d-11f0-a49e-07133fcfb1c0": {
    "source_id": "possible",
    "episode_id": "37e84202-880d-11f0-a49e-07133fcfb1c0",
    "title": "Reid riffs on AI adoption, NVIDIA, and AI’s impact on entry-level jobs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/37e84202-880d-11f0-a49e-07133fcfb1c0-5d70dc7bea65/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/37e84202-880d-11f0-a49e-07133fcfb1c0-5d70dc7bea65/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56825,
      "sha256": "7aa1910169789e888b8a6d430c102b04f4c2176cb3fee9ef807c6aba83262720",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.330Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f4afbc76-82b3-11f0-97e7-17497cc1ca95": {
    "source_id": "possible",
    "episode_id": "f4afbc76-82b3-11f0-97e7-17497cc1ca95",
    "title": "MacKenzie Price on AI-Powered K-12 Schools",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f4afbc76-82b3-11f0-97e7-17497cc1ca95-614e8d579f49/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f4afbc76-82b3-11f0-97e7-17497cc1ca95-614e8d579f49/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56795,
      "sha256": "51c393a8b98603179e6840c9edb28e82217c2818b147d6947417cf2e816a96c2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.388Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f891ef70-7d37-11f0-8e60-d3279a983cde": {
    "source_id": "possible",
    "episode_id": "f891ef70-7d37-11f0-8e60-d3279a983cde",
    "title": "Reid riffs on GPT-5, Figma's IPO, and the end of AOL dial-up",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f891ef70-7d37-11f0-8e60-d3279a983cde-8f5ff91fd889/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f891ef70-7d37-11f0-8e60-d3279a983cde-8f5ff91fd889/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56813,
      "sha256": "263fa06999e411a8b9e86878d456c8cca379b7a2975744af9bb0e27587cd3fc3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.390Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/4e1611a4-7475-11f0-94df-2b5c9339787c": {
    "source_id": "possible",
    "episode_id": "4e1611a4-7475-11f0-94df-2b5c9339787c",
    "title": "Audrey Tang and Divya Siddarth on Outfitting Democracy for the AI Era",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/4e1611a4-7475-11f0-94df-2b5c9339787c-3ff8d5c6e12c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/4e1611a4-7475-11f0-94df-2b5c9339787c-3ff8d5c6e12c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56822,
      "sha256": "be6b528bf6bc97db2f50f2986e6bfc001d0e0c5ec12481269f7a456be674ce01",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.335Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ea747e36-7232-11f0-96e7-2fe59a09e0c5": {
    "source_id": "possible",
    "episode_id": "ea747e36-7232-11f0-96e7-2fe59a09e0c5",
    "title": "Reid riffs on the energy arms race and AI addressing climate change",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ea747e36-7232-11f0-96e7-2fe59a09e0c5-94b3cf4329c2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ea747e36-7232-11f0-96e7-2fe59a09e0c5-94b3cf4329c2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56820,
      "sha256": "afdb523ca3f62e8f8d55ac8740de787afca269a0f5b70dd08302f68c66209788",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.383Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/229616cc-6c8d-11f0-be46-83b3883cae14": {
    "source_id": "possible",
    "episode_id": "229616cc-6c8d-11f0-be46-83b3883cae14",
    "title": "Tony Marx on the Future of Libraries, AI, and Trust",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/229616cc-6c8d-11f0-be46-83b3883cae14-86c2cbd09357/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/229616cc-6c8d-11f0-be46-83b3883cae14-86c2cbd09357/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56804,
      "sha256": "0cb349d39e5f86132b446c668c901e53dadf511cc24ed34fe66db1b3e9f73c28",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.320Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1fc9afc2-670a-11f0-945d-b305f8594ca0": {
    "source_id": "possible",
    "episode_id": "1fc9afc2-670a-11f0-945d-b305f8594ca0",
    "title": "Reid riffs on AI adoption, sensitive data, and digital twins",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1fc9afc2-670a-11f0-945d-b305f8594ca0-d58c5bacfc6f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1fc9afc2-670a-11f0-945d-b305f8594ca0-d58c5bacfc6f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56813,
      "sha256": "02552db838b4b8d70dedf323c616f7896b5bd3a54ca84b3025296d3934ca9893",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.319Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/a6bab4d0-61ac-11f0-b973-039223fda155": {
    "source_id": "possible",
    "episode_id": "a6bab4d0-61ac-11f0-b973-039223fda155",
    "title": "Reid riffs on acquihires, agents, and new startup norms",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/a6bab4d0-61ac-11f0-b973-039223fda155-adc97bdebc62/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/a6bab4d0-61ac-11f0-b973-039223fda155-adc97bdebc62/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39482,
      "sha256": "0feddcc8c8d492d25f374a977abc07ce90ddd7a8b0ce812cbf19342f7a5587d8",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 71,
      "updated_at": "2026-06-09T13:39:31.359Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8f30ce54-5c51-11f0-b7e0-d30283a33ac0": {
    "source_id": "possible",
    "episode_id": "8f30ce54-5c51-11f0-b7e0-d30283a33ac0",
    "title": "Reid riffs on cryptocurrency, stablecoins and regulation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8f30ce54-5c51-11f0-b7e0-d30283a33ac0-1978a54466ec/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8f30ce54-5c51-11f0-b7e0-d30283a33ac0-1978a54466ec/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56809,
      "sha256": "fb472c59cf4bd7e37066f8e0c249eec89fd0c7f1b2f06c09105d49ead9794ad2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.355Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8e035160-56bf-11f0-9c64-0b7110f483f5": {
    "source_id": "possible",
    "episode_id": "8e035160-56bf-11f0-9c64-0b7110f483f5",
    "title": "David Autor on AI’s impact on jobs, expertise, and labor markets",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8e035160-56bf-11f0-9c64-0b7110f483f5-3e997ba43464/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8e035160-56bf-11f0-9c64-0b7110f483f5-3e997ba43464/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56819,
      "sha256": "b877f16651e9a882e933e6a2e64c0ca3593d3002c8997179e1caada0fb092742",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.353Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/5857867e-5144-11f0-aedd-b715ae44f9b1": {
    "source_id": "possible",
    "episode_id": "5857867e-5144-11f0-aedd-b715ae44f9b1",
    "title": "Reid riffs on massive AI acquisitions, robotics, and headcount trimming",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/5857867e-5144-11f0-aedd-b715ae44f9b1-2d94890c7e80/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/5857867e-5144-11f0-aedd-b715ae44f9b1-2d94890c7e80/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 22782,
      "sha256": "0911c2369087fbf99d79c3f173c6e1a3eb6b831b8fba68dd77316e9bba96d0d7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 16,
      "updated_at": "2026-06-09T13:39:31.337Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e6f70454-4bb8-11f0-bc15-93d0944263ff": {
    "source_id": "possible",
    "episode_id": "e6f70454-4bb8-11f0-bc15-93d0944263ff",
    "title": "Hannah Fry on AI, Algorithms, and Human Nature",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e6f70454-4bb8-11f0-bc15-93d0944263ff-9d9e87d9d685/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e6f70454-4bb8-11f0-bc15-93d0944263ff-9d9e87d9d685/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56799,
      "sha256": "0fdf137656be9728f3a4b0ba84efca63ac84f6a68b73f3b7b0d7bdc3a894158f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.382Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/308b8a28-4631-11f0-a687-0f645f55f9a4": {
    "source_id": "possible",
    "episode_id": "308b8a28-4631-11f0-a687-0f645f55f9a4",
    "title": "Reid riffs on if AI can become conscious",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/308b8a28-4631-11f0-a687-0f645f55f9a4-c21ea7292db5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/308b8a28-4631-11f0-a687-0f645f55f9a4-c21ea7292db5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 16005,
      "sha256": "a39eafe2101948eddfb3fe759bb8a15a9bc31879f9f20c7fa71d2a2f9f12b3fd",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 22,
      "updated_at": "2026-06-09T13:39:31.325Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/31f23c96-40a9-11f0-864d-c725a6c64069": {
    "source_id": "possible",
    "episode_id": "31f23c96-40a9-11f0-864d-c725a6c64069",
    "title": "Yuval Noah Harari on trust, the dangers of AI, power, and revolutions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/31f23c96-40a9-11f0-864d-c725a6c64069-f0b5cdc77e1d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/31f23c96-40a9-11f0-864d-c725a6c64069-f0b5cdc77e1d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56822,
      "sha256": "253ae2436f492d0d56dbd75da1b0681281537b31d39a2b4f56d353bb1d2be0a7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.326Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/bbfaf87c-3b3d-11f0-a5c5-534e36481567": {
    "source_id": "possible",
    "episode_id": "bbfaf87c-3b3d-11f0-a5c5-534e36481567",
    "title": "Reid riffs on AI companions, human friends, and age gates",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/bbfaf87c-3b3d-11f0-a5c5-534e36481567-9b42579f1ab7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/bbfaf87c-3b3d-11f0-a5c5-534e36481567-9b42579f1ab7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56810,
      "sha256": "a415ab8e746d68d034e0791a8807c1228642cd4d1ef9ffd0fd5da012668652fe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.370Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6ca41da4-35bf-11f0-ba5b-4b6147970e9a": {
    "source_id": "possible",
    "episode_id": "6ca41da4-35bf-11f0-ba5b-4b6147970e9a",
    "title": "Alexis Ohanian on the future of online and offline communities",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6ca41da4-35bf-11f0-ba5b-4b6147970e9a-8a6af9ccd1f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6ca41da4-35bf-11f0-ba5b-4b6147970e9a-8a6af9ccd1f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56815,
      "sha256": "e07fa24f000dcc9b5211cfbfd3dbeb12b760e5f695bc6efc656c6a22e748e50a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.343Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c2e18d42-302d-11f0-8e8e-83bc94576bf8": {
    "source_id": "possible",
    "episode_id": "c2e18d42-302d-11f0-8e8e-83bc94576bf8",
    "title": "Reid riffs on PBCs, jobs and automation, and AI access for kids",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c2e18d42-302d-11f0-8e8e-83bc94576bf8-b993f183199e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c2e18d42-302d-11f0-8e8e-83bc94576bf8-b993f183199e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56816,
      "sha256": "41932497139990bbcf04a214dae280e3841a119146ab607b62ddd6bcb0aee437",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.370Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/da2d6718-2ac0-11f0-b7e0-472c94292569": {
    "source_id": "possible",
    "episode_id": "da2d6718-2ac0-11f0-b7e0-472c94292569",
    "title": "Jane Goodall on Hope, AI, and the Natural World",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/da2d6718-2ac0-11f0-b7e0-472c94292569-99f24ddb1ab7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/da2d6718-2ac0-11f0-b7e0-472c94292569-99f24ddb1ab7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56800,
      "sha256": "acd05b42960f2bcb646368cf8baaab57a30c48ff4cadfadf1cee8de2d64bfe20",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.378Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/aece1e56-253d-11f0-8502-57720c1899aa": {
    "source_id": "possible",
    "episode_id": "aece1e56-253d-11f0-8502-57720c1899aa",
    "title": "Reid riffs on antitrust, AI coworkers, and Chinese manufacturing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/aece1e56-253d-11f0-8502-57720c1899aa-bfc20623f809/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/aece1e56-253d-11f0-8502-57720c1899aa-bfc20623f809/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56817,
      "sha256": "fe742c9e678f7b3a6a692b889b12d22eb6c8c8aeaa2a405054bcc58016209088",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.367Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1c524a0e-1fc8-11f0-8939-d3ac0aaa1060": {
    "source_id": "possible",
    "episode_id": "1c524a0e-1fc8-11f0-8939-d3ac0aaa1060",
    "title": "Derek Thompson on AI, abundance, and human progress",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1c524a0e-1fc8-11f0-8939-d3ac0aaa1060-2d15505b2761/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1c524a0e-1fc8-11f0-8939-d3ac0aaa1060-2d15505b2761/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56804,
      "sha256": "5260e6b45184104cbdfd31d042acb3324bdf0db848cf6c0671ce7876cf336a14",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.316Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f151c9a6-1a45-11f0-acb1-3bf52e96f114": {
    "source_id": "possible",
    "episode_id": "f151c9a6-1a45-11f0-acb1-3bf52e96f114",
    "title": "Reid riffs on Tobi’s memo, AI and play, and the tweet that cost trillions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f151c9a6-1a45-11f0-acb1-3bf52e96f114-4621736c3001/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f151c9a6-1a45-11f0-acb1-3bf52e96f114-4621736c3001/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56828,
      "sha256": "e75bcb6e0cd476139ef5794ff6731eb818c95beda553323d1fcfe6bcc311f7ff",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.386Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8e2b9cc6-14be-11f0-93de-b72886c12791": {
    "source_id": "possible",
    "episode_id": "8e2b9cc6-14be-11f0-93de-b72886c12791",
    "title": "Demis Hassabis on AI, game theory, multimodality, and the nature of creativity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8e2b9cc6-14be-11f0-93de-b72886c12791-ecb921a985c9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8e2b9cc6-14be-11f0-93de-b72886c12791-ecb921a985c9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56831,
      "sha256": "94b0f355d3c6525bf0b2b581afa61cf2f3c292e10d1bf8f54739dc89dab96a0f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.354Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/18e1a24a-0f13-11f0-9360-a35e9cf5e3f5": {
    "source_id": "possible",
    "episode_id": "18e1a24a-0f13-11f0-9360-a35e9cf5e3f5",
    "title": "Reid riffs on Signal, AI for cancer detection, and GPT-4o image generation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/18e1a24a-0f13-11f0-9360-a35e9cf5e3f5-7692fd5ada90/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/18e1a24a-0f13-11f0-9360-a35e9cf5e3f5-7692fd5ada90/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56827,
      "sha256": "e06dcbdf4131aa2964bfb783c9e8fa14a781d32a8d14a176494eabd5f6c67b0c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.313Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e8c8bb68-0943-11f0-8ea6-4fea3e9a583e": {
    "source_id": "possible",
    "episode_id": "e8c8bb68-0943-11f0-8ea6-4fea3e9a583e",
    "title": "Andrew Bosworth on AI, wearables, and mixed reality",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e8c8bb68-0943-11f0-8ea6-4fea3e9a583e-d5052046cd11/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e8c8bb68-0943-11f0-8ea6-4fea3e9a583e-d5052046cd11/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56804,
      "sha256": "e339b2ecb3e4c01891e54f62f3aa8a5dc820389d3721195d6340c8ef0fe5c0d9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.382Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/abb6da7c-05db-11f0-90af-c3f4604de388": {
    "source_id": "possible",
    "episode_id": "abb6da7c-05db-11f0-90af-c3f4604de388",
    "title": "Re-release of Trevor Noah | Celebrating two years of Possible!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/abb6da7c-05db-11f0-90af-c3f4604de388-2db22a369e6f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/abb6da7c-05db-11f0-90af-c3f4604de388-2db22a369e6f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56815,
      "sha256": "a25868b4603d622fcebbed1b9e33596935780e8a9519d3ff8ab07a5d86fedfb1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.362Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/46c35b6a-0467-11f0-a7c9-a75ddfa20c7f": {
    "source_id": "possible",
    "episode_id": "46c35b6a-0467-11f0-a7c9-a75ddfa20c7f",
    "title": "Reid riffs on AI as “American Intelligence” and a prediction from Anthropic’s CEO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/46c35b6a-0467-11f0-a7c9-a75ddfa20c7f-2edb432a6703/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/46c35b6a-0467-11f0-a7c9-a75ddfa20c7f-2edb432a6703/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56840,
      "sha256": "fd0ddead96399a8896fcfac9d0de71a13442e31ffb8ca3026a47e3c0d522ea98",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.333Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/191a0b66-fecf-11ef-a801-4b140d89046a": {
    "source_id": "possible",
    "episode_id": "191a0b66-fecf-11ef-a801-4b140d89046a",
    "title": "Dana Griffin on AI, belonging, and intergenerational connection",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/191a0b66-fecf-11ef-a801-4b140d89046a-8c7bb12d0798/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/191a0b66-fecf-11ef-a801-4b140d89046a-8c7bb12d0798/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56816,
      "sha256": "c33d040fa2b306d7ff8d266b22fe57dc801db414a7ac6608e1458534eed60ed1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.313Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8ab35bb8-f968-11ef-a3e0-e71f7f8afeb6": {
    "source_id": "possible",
    "episode_id": "8ab35bb8-f968-11ef-a3e0-e71f7f8afeb6",
    "title": "Reid riffs on AI wearables, quantum, and Deep Research",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8ab35bb8-f968-11ef-a3e0-e71f7f8afeb6-fa00047b4230/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8ab35bb8-f968-11ef-a3e0-e71f7f8afeb6-fa00047b4230/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56807,
      "sha256": "401dc0c7af6d5ff854b5ac4b41c916fcc744e9fd1286b4684018cd6b63fb0c3b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.352Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/002ef67a-f3c1-11ef-95da-1bfab2509e82": {
    "source_id": "possible",
    "episode_id": "002ef67a-f3c1-11ef-95da-1bfab2509e82",
    "title": "Latanya Sweeney on AI, trust, and privacy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/002ef67a-f3c1-11ef-95da-1bfab2509e82-8797574a7139/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/002ef67a-f3c1-11ef-95da-1bfab2509e82-8797574a7139/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56794,
      "sha256": "ad458cbee44628c0bc1f20292c91eec5eb3a687ca8fe3925c8bcfad3f280a5ce",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.310Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8716c90a-e8b9-11ef-bb4a-374848694f07": {
    "source_id": "possible",
    "episode_id": "8716c90a-e8b9-11ef-bb4a-374848694f07",
    "title": "Anja Manuel on AI, China, and national security",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8716c90a-e8b9-11ef-bb4a-374848694f07-7d4927a5a819/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8716c90a-e8b9-11ef-bb4a-374848694f07-7d4927a5a819/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56800,
      "sha256": "0709a374d7a8324d90995dba4f7777be2162d907ea4518f928baa33e88de43be",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.351Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c7b48e3e-e319-11ef-adee-7f122c2608c8": {
    "source_id": "possible",
    "episode_id": "c7b48e3e-e319-11ef-adee-7f122c2608c8",
    "title": "Reid and AIs riff on what could go right with AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c7b48e3e-e319-11ef-adee-7f122c2608c8-00fc5e25e2cb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c7b48e3e-e319-11ef-adee-7f122c2608c8-00fc5e25e2cb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56801,
      "sha256": "80ab0a105f9e67f33951f72018a856cf61f9a0dfbef0fffa7d90ae2670ff29f0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.373Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/afeed990-dd9b-11ef-b6a3-a7720d22c93e": {
    "source_id": "possible",
    "episode_id": "afeed990-dd9b-11ef-b6a3-a7720d22c93e",
    "title": "Greg Beato on superagency, AI, and the cognitive industrial revolution",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/afeed990-dd9b-11ef-b6a3-a7720d22c93e-20b8b7ccaa82/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/afeed990-dd9b-11ef-b6a3-a7720d22c93e-20b8b7ccaa82/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56823,
      "sha256": "07723b356cb92c93a2205a3daf7c8947cf5e98a6d1ccfba7ad7599ab77b717f6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.368Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/0f51886a-d81a-11ef-bdea-e7fd53c51061": {
    "source_id": "possible",
    "episode_id": "0f51886a-d81a-11ef-bdea-e7fd53c51061",
    "title": "Bret Taylor on conversational AI, voice, and agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/0f51886a-d81a-11ef-bdea-e7fd53c51061-b3e86e9c04e5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/0f51886a-d81a-11ef-bdea-e7fd53c51061-b3e86e9c04e5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56804,
      "sha256": "efff086636b79e821d8a3a80ccd6fef113cdf8da596462ad4cda520320741857",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.312Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/3dd4903a-d29b-11ef-981c-778666ea992a": {
    "source_id": "possible",
    "episode_id": "3dd4903a-d29b-11ef-981c-778666ea992a",
    "title": "Fei-Fei Li on spatial intelligence and human-centered AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/3dd4903a-d29b-11ef-981c-778666ea992a-3de7443728e8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/3dd4903a-d29b-11ef-981c-778666ea992a-3de7443728e8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56809,
      "sha256": "96b8ce253bd2e8c4d911ab11a219f6e061be917ceccdf4fe2ae946019ceb349a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.331Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/983b91c0-befc-11ef-8757-0f7ff39b74f3": {
    "source_id": "possible",
    "episode_id": "983b91c0-befc-11ef-8757-0f7ff39b74f3",
    "title": "PRESENTING: Pioneers of AI with Dr. Rana El Kaliouby and Musician Taryn Southern",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/983b91c0-befc-11ef-8757-0f7ff39b74f3-36f05838a6b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/983b91c0-befc-11ef-8757-0f7ff39b74f3-36f05838a6b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56833,
      "sha256": "2335d0f02d50ab35786c0c9d342af2ba998480b243ef4851c3e2c6f43e6f989d",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.356Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/3a7233d0-ac16-11ef-b969-9b870f11c629": {
    "source_id": "possible",
    "episode_id": "3a7233d0-ac16-11ef-b969-9b870f11c629",
    "title": "Spencer Hyman on flavor and chocolate",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/3a7233d0-ac16-11ef-b969-9b870f11c629-63b0e9ebab0d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/3a7233d0-ac16-11ef-b969-9b870f11c629-63b0e9ebab0d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56790,
      "sha256": "6a6f1e603402ed0a7ee6c15c952c5a1b407df0856049d13f5c1dbbeae2d8606f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.331Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c4f4f0b0-a68a-11ef-ada8-b7d84947c81d": {
    "source_id": "possible",
    "episode_id": "c4f4f0b0-a68a-11ef-ada8-b7d84947c81d",
    "title": "Reid riffs on AI and public service technology",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c4f4f0b0-a68a-11ef-ada8-b7d84947c81d-cb02ccdffc2b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c4f4f0b0-a68a-11ef-ada8-b7d84947c81d-cb02ccdffc2b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56799,
      "sha256": "56b1032ea2c429311d6f013a0a3950fb0b620c7c4e70c8a8b55a222d5b7b4c55",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.371Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/8f2c567e-a132-11ef-8526-bb6d8babb628": {
    "source_id": "possible",
    "episode_id": "8f2c567e-a132-11ef-8526-bb6d8babb628",
    "title": "Devshi Mehrotra on AI, justice, and public defense",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/8f2c567e-a132-11ef-8526-bb6d8babb628-a4d3fe5dc97f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/8f2c567e-a132-11ef-8526-bb6d8babb628-a4d3fe5dc97f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56803,
      "sha256": "72d3351ef19e5e9ea112cb27b29a608b6796c5b44928640d3951bfe4327432fe",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.354Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/50bc231e-9b84-11ef-b24f-b3a665c4a616": {
    "source_id": "possible",
    "episode_id": "50bc231e-9b84-11ef-b24f-b3a665c4a616",
    "title": "Reid riffs on Bill Gates and promising technology developments",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/50bc231e-9b84-11ef-b24f-b3a665c4a616-d94ad31a8f93/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/50bc231e-9b84-11ef-b24f-b3a665c4a616-d94ad31a8f93/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56815,
      "sha256": "6857ea1bcfc0de2881ffb6fbe3f6c9ea52023a8f3a9764f2d14a6dfeae091054",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.336Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/9e5f8d02-9b04-11ef-bc3b-4fe0d13590c4": {
    "source_id": "possible",
    "episode_id": "9e5f8d02-9b04-11ef-bc3b-4fe0d13590c4",
    "title": "Feed Drop: Reid Hoffman: Entrepreneurship, AI, and the Battle for Democracy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/9e5f8d02-9b04-11ef-bc3b-4fe0d13590c4-0b7be53cefd2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/9e5f8d02-9b04-11ef-bc3b-4fe0d13590c4-0b7be53cefd2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56828,
      "sha256": "42f183afb6d7b2fa533bfb8f72876fcd78eba421aa246373bcdd2dcdeab93696",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.358Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/4c6c6cb8-96c2-11ef-b4ec-537bf85131ee": {
    "source_id": "possible",
    "episode_id": "4c6c6cb8-96c2-11ef-b4ec-537bf85131ee",
    "title": "Bill Gates on possibility, AI, and humanity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/4c6c6cb8-96c2-11ef-b4ec-537bf85131ee-c81963d9d69c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/4c6c6cb8-96c2-11ef-b4ec-537bf85131ee-c81963d9d69c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56796,
      "sha256": "c453ade2ff8596c3f7b640851ed0ae08f590b8a2d1586281701ba46cbee6bf8c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.334Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ccd3da62-9091-11ef-ba49-abc79ba7a509": {
    "source_id": "possible",
    "episode_id": "ccd3da62-9091-11ef-ba49-abc79ba7a509",
    "title": "Reid riffs on iterative development and cultural differences",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ccd3da62-9091-11ef-ba49-abc79ba7a509-d13020b6a37d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ccd3da62-9091-11ef-ba49-abc79ba7a509-d13020b6a37d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56813,
      "sha256": "2617dd5bf8b80782f3474058206e2f9a02a51a9db8dab8892469f0713bc51254",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.374Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f0e9c4da-8b0e-11ef-a4a1-af105a06d94b": {
    "source_id": "possible",
    "episode_id": "f0e9c4da-8b0e-11ef-a4a1-af105a06d94b",
    "title": "James Manyika on global AI and inclusion",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f0e9c4da-8b0e-11ef-a4a1-af105a06d94b-149c509f5a26/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f0e9c4da-8b0e-11ef-a4a1-af105a06d94b-149c509f5a26/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56793,
      "sha256": "8b4e793037ebd9426f547d3742da91e43d06dd10705abafa99448e05dc0ca3ba",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.386Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c79c9932-8581-11ef-9450-0f5a6bd58a60": {
    "source_id": "possible",
    "episode_id": "c79c9932-8581-11ef-9450-0f5a6bd58a60",
    "title": "Reid riffs on the next generation of LLMs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c79c9932-8581-11ef-9450-0f5a6bd58a60-ea27865e2418/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c79c9932-8581-11ef-9450-0f5a6bd58a60-ea27865e2418/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56794,
      "sha256": "01de6d71585d9c4db9fe83ff3489dc9d1834ef5ad055bb10ef9f47db56b87a7e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.372Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/7c8ace3a-801f-11ef-a838-5777bd9a04eb": {
    "source_id": "possible",
    "episode_id": "7c8ace3a-801f-11ef-a838-5777bd9a04eb",
    "title": "Sean White on Inflection and AI frontiers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/7c8ace3a-801f-11ef-a838-5777bd9a04eb-ad4d522191d3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/7c8ace3a-801f-11ef-a838-5777bd9a04eb-ad4d522191d3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56794,
      "sha256": "3c46ebf8359d74ec52e584c596e47a8100a44d391db8be4f9f6ef4361e5fcc14",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.347Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ed9a4f06-7ab1-11ef-9b36-e7970f074ed3": {
    "source_id": "possible",
    "episode_id": "ed9a4f06-7ab1-11ef-9b36-e7970f074ed3",
    "title": "Reid riffs on Silicon Valley, politics, and the election",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ed9a4f06-7ab1-11ef-9b36-e7970f074ed3-4cee6ae05bd9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ed9a4f06-7ab1-11ef-9b36-e7970f074ed3-4cee6ae05bd9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56809,
      "sha256": "60aaae364848139b8f4572a19f6664686f7e97e25fd4e6b250c6a51799a975e2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.384Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ee8ba176-752f-11ef-9eca-d30a0d7ad178": {
    "source_id": "possible",
    "episode_id": "ee8ba176-752f-11ef-9eca-d30a0d7ad178",
    "title": "Sarah Longwell on politics, AI, and elections",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ee8ba176-752f-11ef-9eca-d30a0d7ad178-3fb295065c7c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ee8ba176-752f-11ef-9eca-d30a0d7ad178-3fb295065c7c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56798,
      "sha256": "eb2753155e18cc41c2b971496304e0fb7a7e1538ec0c1f78bb3ba801988a3994",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.385Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/34435db6-6faf-11ef-9219-ff16a6a42165": {
    "source_id": "possible",
    "episode_id": "34435db6-6faf-11ef-9219-ff16a6a42165",
    "title": "Reid riffs on his personal history with AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/34435db6-6faf-11ef-9219-ff16a6a42165-7033b6c479d8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/34435db6-6faf-11ef-9219-ff16a6a42165-7033b6c479d8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56795,
      "sha256": "7c3eff3770c68e212d8915b3077fc5ff809e3813a7f1df6ea145410e2d9805f9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.327Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/a6c1fd56-6a2e-11ef-8776-4f9408f32841": {
    "source_id": "possible",
    "episode_id": "a6c1fd56-6a2e-11ef-8776-4f9408f32841",
    "title": "Daphne Koller on drug discovery and AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/a6c1fd56-6a2e-11ef-8776-4f9408f32841-6e94ee2a53ad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/a6c1fd56-6a2e-11ef-8776-4f9408f32841-6e94ee2a53ad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56791,
      "sha256": "b138d1ffc90990d87ad044bc643e50da21409f68bbc63b7449967af8c6a75609",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.360Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ac6c72a6-64af-11ef-b208-d32d13937e2e": {
    "source_id": "possible",
    "episode_id": "ac6c72a6-64af-11ef-b208-d32d13937e2e",
    "title": "Reid riffs on the future of human connectivity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ac6c72a6-64af-11ef-b208-d32d13937e2e-6841b0ec569f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ac6c72a6-64af-11ef-b208-d32d13937e2e-6841b0ec569f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56799,
      "sha256": "4849bbcf7ae24f9e646fbc9bd91b0413ef162aeddc3e6b912d434b24ea41d578",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.365Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/5725c250-5f3e-11ef-a6fd-efcd0fdfb39b": {
    "source_id": "possible",
    "episode_id": "5725c250-5f3e-11ef-a6fd-efcd0fdfb39b",
    "title": "Nick Thompson on our AI future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/5725c250-5f3e-11ef-a6fd-efcd0fdfb39b-f06f85fc543b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/5725c250-5f3e-11ef-a6fd-efcd0fdfb39b-f06f85fc543b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56783,
      "sha256": "8aa1ba54e81f9900339d9438aa1416fcbe7ef88ae1145328d7899db7835375b0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.336Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/4dae9b9e-59bb-11ef-b380-a3de130ec199": {
    "source_id": "possible",
    "episode_id": "4dae9b9e-59bb-11ef-b380-a3de130ec199",
    "title": "Reid riffs on AI regulation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/4dae9b9e-59bb-11ef-b380-a3de130ec199-dbfa155d2fa2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/4dae9b9e-59bb-11ef-b380-a3de130ec199-dbfa155d2fa2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56780,
      "sha256": "9dfa30e34068d9bd20428fb499b4d2421a70d924cd8f5fdfa3660d9f11475aa9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.335Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/7e7bad02-5425-11ef-ab64-679e84eb47a4": {
    "source_id": "possible",
    "episode_id": "7e7bad02-5425-11ef-ab64-679e84eb47a4",
    "title": "Gina Raimondo on AI, government, and commerce",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/7e7bad02-5425-11ef-ab64-679e84eb47a4-0ab2776730c6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/7e7bad02-5425-11ef-ab64-679e84eb47a4-0ab2776730c6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56798,
      "sha256": "868bc3b52dae6117f475e5ab7efd17a94235960d107fad581e61f50ad11cbddb",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.348Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d5e3e77a-4ea4-11ef-87b4-9f2076da2a12": {
    "source_id": "possible",
    "episode_id": "d5e3e77a-4ea4-11ef-87b4-9f2076da2a12",
    "title": "Reid riffs on AI agents and investments",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d5e3e77a-4ea4-11ef-87b4-9f2076da2a12-02e590f83ffc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d5e3e77a-4ea4-11ef-87b4-9f2076da2a12-02e590f83ffc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56792,
      "sha256": "09deb7771c169e6d3691ebd689b11fb093d99f7e94c1c69f68438c7458e8d11c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.376Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d85502e6-4940-11ef-aa86-a7e200c4e6a0": {
    "source_id": "possible",
    "episode_id": "d85502e6-4940-11ef-aa86-a7e200c4e6a0",
    "title": "Ashton Kutcher on AI and investing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d85502e6-4940-11ef-aa86-a7e200c4e6a0-6d7c9ad364f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d85502e6-4940-11ef-aa86-a7e200c4e6a0-6d7c9ad364f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56787,
      "sha256": "06f14e0e0057a85e948de68bf22302df03ec62954051305428efbb6745c259c6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.377Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e92ff960-43ad-11ef-84ae-af472189d9d7": {
    "source_id": "possible",
    "episode_id": "e92ff960-43ad-11ef-84ae-af472189d9d7",
    "title": "Reid riffs on building better cities",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e92ff960-43ad-11ef-84ae-af472189d9d7-82534a894e54/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e92ff960-43ad-11ef-84ae-af472189d9d7-82534a894e54/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56789,
      "sha256": "3c6c3321f44c110fd0616265628b6099b89a861defb6d80de45c50b5570d1324",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.383Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1c820b4e-3e01-11ef-9dca-df2705ac9c33": {
    "source_id": "possible",
    "episode_id": "1c820b4e-3e01-11ef-9dca-df2705ac9c33",
    "title": "Devon Zuegel on the future of cities and community",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1c820b4e-3e01-11ef-9dca-df2705ac9c33-8c1c0f8a5c60/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1c820b4e-3e01-11ef-9dca-df2705ac9c33-8c1c0f8a5c60/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56803,
      "sha256": "c2c0c74b58ca0c6e7ad4c4734b9495b4ae3748af9313ec0f6dfe286a2f668c3e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.317Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/23246df4-389b-11ef-b709-cbaf3a3cfd94": {
    "source_id": "possible",
    "episode_id": "23246df4-389b-11ef-b709-cbaf3a3cfd94",
    "title": "Reid riffs on California Forever and housing",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/23246df4-389b-11ef-b709-cbaf3a3cfd94-643508a563b0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/23246df4-389b-11ef-b709-cbaf3a3cfd94-643508a563b0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56797,
      "sha256": "dbc4ef721517ee5aa73447d726e9f0a961c6c9ef17ab826eaf1577c01f95734e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.321Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/23620ae0-3325-11ef-aea7-336272323b0b": {
    "source_id": "possible",
    "episode_id": "23620ae0-3325-11ef-aea7-336272323b0b",
    "title": "Jan Sramek on California Forever and the future of cities",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/23620ae0-3325-11ef-aea7-336272323b0b-b3b048be7031/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/23620ae0-3325-11ef-aea7-336272323b0b-b3b048be7031/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56810,
      "sha256": "d3a5db673e50301592f73671833ec72bb32f37ed24c1c489e6746c1829bd25ab",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.322Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/448dec4e-2da7-11ef-8616-cbd685d00470": {
    "source_id": "possible",
    "episode_id": "448dec4e-2da7-11ef-8616-cbd685d00470",
    "title": "Reid riffs on going from idea to launch",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/448dec4e-2da7-11ef-8616-cbd685d00470-1cfb6c177f78/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/448dec4e-2da7-11ef-8616-cbd685d00470-1cfb6c177f78/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56792,
      "sha256": "98bf41bc63a1e97d4ab83fe2ee30c5ba01d43873d231ec019af1c69b8068ac46",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.332Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/0604ad0e-2826-11ef-83d0-57d544116242": {
    "source_id": "possible",
    "episode_id": "0604ad0e-2826-11ef-83d0-57d544116242",
    "title": "Massimo Bottura on the future of food and creativity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/0604ad0e-2826-11ef-83d0-57d544116242-840386c7305e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/0604ad0e-2826-11ef-83d0-57d544116242-840386c7305e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56805,
      "sha256": "8957f51f2917c6afefa3547d26a18459bd65fea0c09e7d34ae22f352bd7ac739",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.311Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1a585898-227f-11ef-9afc-7f9eecf55f3e": {
    "source_id": "possible",
    "episode_id": "1a585898-227f-11ef-9afc-7f9eecf55f3e",
    "title": "Reid riffs on coding and K-12 education",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1a585898-227f-11ef-9afc-7f9eecf55f3e-68ba2853e01d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1a585898-227f-11ef-9afc-7f9eecf55f3e-68ba2853e01d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56792,
      "sha256": "cd721a9ba678bb2ffe5acb6018700e7e73af3920e2421303ba1923e706c0eca3",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.315Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ff3a8e10-1d0a-11ef-abaa-7f90fd3efb09": {
    "source_id": "possible",
    "episode_id": "ff3a8e10-1d0a-11ef-abaa-7f90fd3efb09",
    "title": "Pat Yongpradit on AI literacy and computer science education",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ff3a8e10-1d0a-11ef-abaa-7f90fd3efb09-35dbb3e2a105/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ff3a8e10-1d0a-11ef-abaa-7f90fd3efb09-35dbb3e2a105/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56813,
      "sha256": "eba0562e4e2402757e71fe9676d1e1f190c63b329825d7e2697526fc98b0c808",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.391Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f2b507a0-186f-11ef-be35-27e073ef689e": {
    "source_id": "possible",
    "episode_id": "f2b507a0-186f-11ef-be35-27e073ef689e",
    "title": "BONUS: Reid Hoffman’s speech: Humanity’s Hegelian Golden Braid",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f2b507a0-186f-11ef-be35-27e073ef689e-6e34c4d1e2cf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f2b507a0-186f-11ef-be35-27e073ef689e-6e34c4d1e2cf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56819,
      "sha256": "5aa2aec690d3d83812e93d15a1b660a918a60b0cd334a695cfbec451865d99d4",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.387Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/681e8478-177e-11ef-a132-afbdff8eb923": {
    "source_id": "possible",
    "episode_id": "681e8478-177e-11ef-a132-afbdff8eb923",
    "title": "Reid riffs on tech journalism and the TikTok ban",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/681e8478-177e-11ef-a132-afbdff8eb923-86f3ae04d131/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/681e8478-177e-11ef-a132-afbdff8eb923-86f3ae04d131/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56801,
      "sha256": "5711bb5b324d67455cc5c7f1471ed76fdc52eeac4ddbd756b241f0bb6978d3db",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.341Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6e7880b8-1219-11ef-85a3-8b804f13cc26": {
    "source_id": "possible",
    "episode_id": "6e7880b8-1219-11ef-85a3-8b804f13cc26",
    "title": "Kara Swisher on AI, media, and accountability",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6e7880b8-1219-11ef-85a3-8b804f13cc26-111f2b9676e8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6e7880b8-1219-11ef-85a3-8b804f13cc26-111f2b9676e8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56798,
      "sha256": "f6c5d79d263ad350dcb7f7ad2035875a83221b10bede3d377251deea6fcf9501",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.344Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/872e79d8-0cc8-11ef-89e4-c3f4595897eb": {
    "source_id": "possible",
    "episode_id": "872e79d8-0cc8-11ef-89e4-c3f4595897eb",
    "title": "Reid riffs on AI milestones and AI efforts abroad",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/872e79d8-0cc8-11ef-89e4-c3f4595897eb-b89ef3bc1416/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/872e79d8-0cc8-11ef-89e4-c3f4595897eb-b89ef3bc1416/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56802,
      "sha256": "ddb63fc33b790e014a122952a253456b0510eee2c7aaa1353ceda7d65a12d3f5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.352Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/b290d1dc-0711-11ef-b2ae-5fa943d1ffa6": {
    "source_id": "possible",
    "episode_id": "b290d1dc-0711-11ef-b2ae-5fa943d1ffa6",
    "title": "Kevin Scott on AI and humanism",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/b290d1dc-0711-11ef-b2ae-5fa943d1ffa6-970d2da51abe/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/b290d1dc-0711-11ef-b2ae-5fa943d1ffa6-970d2da51abe/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56783,
      "sha256": "2a03bdc35f9a60b6d2b51d0969ca585b7ad6317008ee85524d4d0e966249d847",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.369Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/1e2ce590-01b6-11ef-827d-8b8ddeba4a16": {
    "source_id": "possible",
    "episode_id": "1e2ce590-01b6-11ef-827d-8b8ddeba4a16",
    "title": "[BONUS + VIDEO] Reid interviews Reid AI, his AI avatar",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/1e2ce590-01b6-11ef-827d-8b8ddeba4a16-c222da630573/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/1e2ce590-01b6-11ef-827d-8b8ddeba4a16-c222da630573/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56807,
      "sha256": "cb53dbd1e0866f9ee328efb3d2d4ab068d958dfc93ff556c61ff17bc866fdeb0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.317Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/36cfd246-010d-11ef-b6d2-5f6d1c1951da": {
    "source_id": "possible",
    "episode_id": "36cfd246-010d-11ef-b6d2-5f6d1c1951da",
    "title": "Introducing: a new Possible",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/36cfd246-010d-11ef-b6d2-5f6d1c1951da-fefc50c7917f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/36cfd246-010d-11ef-b6d2-5f6d1c1951da-fefc50c7917f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56780,
      "sha256": "7471dd2a102115bfd44607cd797d220f9809d716a280c77b377f75aa51560102",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.329Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/82eeb7e6-bf7c-11ee-baa5-8316ed79afa0": {
    "source_id": "possible",
    "episode_id": "82eeb7e6-bf7c-11ee-baa5-8316ed79afa0",
    "title": "Reflections on AI and season two",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/82eeb7e6-bf7c-11ee-baa5-8316ed79afa0-914fa0bf43cd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/82eeb7e6-bf7c-11ee-baa5-8316ed79afa0-914fa0bf43cd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56785,
      "sha256": "216dfc22140502abfebe257e1a46030fafb3a3d3220257d73aa99c2191623257",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.349Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/5ee51ee6-ba11-11ee-9a6b-133f81014f7a": {
    "source_id": "possible",
    "episode_id": "5ee51ee6-ba11-11ee-9a6b-133f81014f7a",
    "title": "Katherine Maher on the future of trusted information",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/5ee51ee6-ba11-11ee-9a6b-133f81014f7a-39c9364b0cd8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/5ee51ee6-ba11-11ee-9a6b-133f81014f7a-39c9364b0cd8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56805,
      "sha256": "e7069f1811ebc05b91e88366b0981bc71285ba642e781685be4c2dda75c0d246",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.338Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e2baafb8-b4aa-11ee-a1b2-ff64da163a0e": {
    "source_id": "possible",
    "episode_id": "e2baafb8-b4aa-11ee-a1b2-ff64da163a0e",
    "title": "Kerry Washington on connection, identity and AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e2baafb8-b4aa-11ee-a1b2-ff64da163a0e-a634454550f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e2baafb8-b4aa-11ee-a1b2-ff64da163a0e-a634454550f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56800,
      "sha256": "76e9d07e2cca805e4801fbe6458e898f7d69e3c4a7aeb289c71bd8da7c31fbc1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.380Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/789fe61a-af33-11ee-8cb7-875fe07795ae": {
    "source_id": "possible",
    "episode_id": "789fe61a-af33-11ee-8cb7-875fe07795ae",
    "title": "Sal Khan on the future of K-12 education",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/789fe61a-af33-11ee-8cb7-875fe07795ae-25c2161b6f8a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/789fe61a-af33-11ee-8cb7-875fe07795ae-25c2161b6f8a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56793,
      "sha256": "e53cc6884a713c68754930de3b9fdc606762f7eb0b510a23dd8a667e88fdb00c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.346Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/48d6b240-9e91-11ee-8c62-d796ad6caccc": {
    "source_id": "possible",
    "episode_id": "48d6b240-9e91-11ee-8c62-d796ad6caccc",
    "title": "Phaedra Ellis-Lamkins on the future of social welfare",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/48d6b240-9e91-11ee-8c62-d796ad6caccc-4c8e7767012b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/48d6b240-9e91-11ee-8c62-d796ad6caccc-4c8e7767012b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56806,
      "sha256": "24433bbd3b02cc92caaf027db057e6fd95a321feacab8d3e22aa25ab213d2559",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.333Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/62579356-9928-11ee-acc2-e7ec3b6cc2db": {
    "source_id": "possible",
    "episode_id": "62579356-9928-11ee-acc2-e7ec3b6cc2db",
    "title": "Sarah Sze on the future of AI and art",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/62579356-9928-11ee-acc2-e7ec3b6cc2db-eb3ca9e821f7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/62579356-9928-11ee-acc2-e7ec3b6cc2db-eb3ca9e821f7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56790,
      "sha256": "c136ee075e3f4d32f4c6ef9d2fe9461d7fb67c36b3117773260fbe96cbe7b1d9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.339Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c552935a-9380-11ee-b448-bfcccd644c7d": {
    "source_id": "possible",
    "episode_id": "c552935a-9380-11ee-b448-bfcccd644c7d",
    "title": "Kim Stanley Robinson on narrative and civilization",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c552935a-9380-11ee-b448-bfcccd644c7d-75c272066fe9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c552935a-9380-11ee-b448-bfcccd644c7d-75c272066fe9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56803,
      "sha256": "006b87353130f8fcb0d46a485f45f4215bf4f7d258ef4973d4c0e96df2279a12",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.372Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d2b9acd6-8e12-11ee-a90f-3b334dbe41a4": {
    "source_id": "possible",
    "episode_id": "d2b9acd6-8e12-11ee-a90f-3b334dbe41a4",
    "title": "Peter Lee on the future of health and medicine",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d2b9acd6-8e12-11ee-a90f-3b334dbe41a4-3722e13c9ac8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d2b9acd6-8e12-11ee-a90f-3b334dbe41a4-3722e13c9ac8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56799,
      "sha256": "0219e87a61bd00148616ee73dd5a68aa5ae149f7468c1a7cf95963400ec4b82f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.374Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/22680562-8322-11ee-ae3c-efc1b1d59b29": {
    "source_id": "possible",
    "episode_id": "22680562-8322-11ee-ae3c-efc1b1d59b29",
    "title": "Siddhartha Mukherjee on the future of disease and diagnostics",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/22680562-8322-11ee-ae3c-efc1b1d59b29-078831b2f1ea/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/22680562-8322-11ee-ae3c-efc1b1d59b29-078831b2f1ea/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56814,
      "sha256": "e9aa8ad875369a2279a89425a7ec79d6e31b6593a6973f5b31b43ce0c943b376",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.319Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/83572e68-7d99-11ee-8f5a-bb46bcc659c2": {
    "source_id": "possible",
    "episode_id": "83572e68-7d99-11ee-8f5a-bb46bcc659c2",
    "title": "Condoleezza Rice on the future of war and geopolitics",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/83572e68-7d99-11ee-8f5a-bb46bcc659c2-c1f7b5c4d955/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/83572e68-7d99-11ee-8f5a-bb46bcc659c2-c1f7b5c4d955/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56806,
      "sha256": "20a89a8921248544399e4773e0f51308787ab14234307cdbd09ab5a42f9bb1b6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.350Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/7bdcb79e-783e-11ee-b6fb-0bc8e2bb8fc1": {
    "source_id": "possible",
    "episode_id": "7bdcb79e-783e-11ee-b6fb-0bc8e2bb8fc1",
    "title": "Anne-Marie Slaughter on the future of the care economy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/7bdcb79e-783e-11ee-b6fb-0bc8e2bb8fc1-a7e1512ff1bb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/7bdcb79e-783e-11ee-b6fb-0bc8e2bb8fc1-a7e1512ff1bb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56807,
      "sha256": "a0f98af23e2a6b246b54af1d7ed07fa41c86c2e92adbf81657dd1c45551091f6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.346Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ad111176-72bb-11ee-9f2f-0f3f7808a886": {
    "source_id": "possible",
    "episode_id": "ad111176-72bb-11ee-9f2f-0f3f7808a886",
    "title": "Marques Brownlee on the future of creators",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ad111176-72bb-11ee-9f2f-0f3f7808a886-7e1ca3002352/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ad111176-72bb-11ee-9f2f-0f3f7808a886-7e1ca3002352/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55830,
      "sha256": "e9d316c73d767a1f6abffa7d7a06c4c902745e9193ee7ab1a38460e1c343395f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.366Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/ac4ffa3a-6f88-11ee-88f8-dfd8c3956c10": {
    "source_id": "possible",
    "episode_id": "ac4ffa3a-6f88-11ee-88f8-dfd8c3956c10",
    "title": "Introducing: Possible season two",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/ac4ffa3a-6f88-11ee-88f8-dfd8c3956c10-5fee375507b8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/ac4ffa3a-6f88-11ee-88f8-dfd8c3956c10-5fee375507b8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56785,
      "sha256": "69a7a85396f06f6da75ab7b3435bf794575f68a42bce5f9d30397ec450d641cf",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.364Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/a842f3ce-5300-11ee-9142-8f3434d9c2d1": {
    "source_id": "possible",
    "episode_id": "a842f3ce-5300-11ee-9142-8f3434d9c2d1",
    "title": "BONUS: Reid Hoffman’s commencement speech at Bologna Business School",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/a842f3ce-5300-11ee-9142-8f3434d9c2d1-c04c02ed84d8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/a842f3ce-5300-11ee-9142-8f3434d9c2d1-c04c02ed84d8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56823,
      "sha256": "0657fa57a56777a3b87847efab38e2854f5caedfe4845a446dfb8a2dd88b1c02",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.362Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/f03222f8-19d6-11ee-a566-872cb75ea911": {
    "source_id": "possible",
    "episode_id": "f03222f8-19d6-11ee-a566-872cb75ea911",
    "title": "Prompt and process with Ethan Mollick [AI miniseries]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/f03222f8-19d6-11ee-a566-872cb75ea911-4a1f16ee2ecf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/f03222f8-19d6-11ee-a566-872cb75ea911-4a1f16ee2ecf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56806,
      "sha256": "c7e60a48b902409c635ed4cfaac4798e81d46b34e15b758f2741b04a6ba24a07",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.385Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/19d7c5c8-153f-11ee-be23-dff13423ceae": {
    "source_id": "possible",
    "episode_id": "19d7c5c8-153f-11ee-be23-dff13423ceae",
    "title": "Socially assistive robots with Maja Matarić [AI miniseries]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/19d7c5c8-153f-11ee-be23-dff13423ceae-2fd8543730b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/19d7c5c8-153f-11ee-be23-dff13423ceae-2fd8543730b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56813,
      "sha256": "8f39411b8dbfb67cc10788d2480c2b6465a9fd15df86aae6e02246fd00965892",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.314Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d3e934d0-0fcf-11ee-bab2-1b7050a07183": {
    "source_id": "possible",
    "episode_id": "d3e934d0-0fcf-11ee-bab2-1b7050a07183",
    "title": "Personal intelligence with Mustafa Suleyman [AI miniseries]",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d3e934d0-0fcf-11ee-bab2-1b7050a07183-17910c005274/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d3e934d0-0fcf-11ee-bab2-1b7050a07183-17910c005274/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56812,
      "sha256": "e13b7153169b5cf2a6da0bcfd2b830caf632a7cda98006c7288da4415185d48e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.375Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6c0f3eaa-f421-11ed-a36a-3b9167ac45c7": {
    "source_id": "possible",
    "episode_id": "6c0f3eaa-f421-11ed-a36a-3b9167ac45c7",
    "title": "Ariel Ekblaw on the future of space exploration",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6c0f3eaa-f421-11ed-a36a-3b9167ac45c7-2ab7398db801/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6c0f3eaa-f421-11ed-a36a-3b9167ac45c7-2ab7398db801/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55835,
      "sha256": "3d01d327fd8e694e8b52910ce852c856ecb687e4b86f6c0c2e702ce5700891a7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.342Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/9b9386fc-e924-11ed-a8ab-db3ba48986e8": {
    "source_id": "possible",
    "episode_id": "9b9386fc-e924-11ed-a8ab-db3ba48986e8",
    "title": "Sam Altman and Greg Brockman on AI and the future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/9b9386fc-e924-11ed-a8ab-db3ba48986e8-4f3e0600c8c4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/9b9386fc-e924-11ed-a8ab-db3ba48986e8-4f3e0600c8c4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56802,
      "sha256": "479dc9fd62b359c81c1695d61f3b37b2e25d98e5bd340c65ca50b601bf3c5819",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.357Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/6113ffb4-e3d1-11ed-8235-833c22f83480": {
    "source_id": "possible",
    "episode_id": "6113ffb4-e3d1-11ed-8235-833c22f83480",
    "title": "Jaime Teevan on the future of work",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/6113ffb4-e3d1-11ed-8235-833c22f83480-e38d7b8a6174/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/6113ffb4-e3d1-11ed-8235-833c22f83480-e38d7b8a6174/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56787,
      "sha256": "93a1e98498218ef299d6e7233f63d91dbb0f7496d900cfdc412a1650599e8519",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.338Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/e0d7e252-de35-11ed-b858-bbbd1adcccfb": {
    "source_id": "possible",
    "episode_id": "e0d7e252-de35-11ed-b858-bbbd1adcccfb",
    "title": "Bryan Stevenson on the future of criminal justice",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/e0d7e252-de35-11ed-b858-bbbd1adcccfb-842af5f6cb3d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/e0d7e252-de35-11ed-b858-bbbd1adcccfb-842af5f6cb3d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56802,
      "sha256": "a0b1d8678f0aca245e2e2f7a2b0d494adac2c9485a11a6064caf5290a39c761c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.379Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/710f1e6c-d8af-11ed-8716-9f926086c898": {
    "source_id": "possible",
    "episode_id": "710f1e6c-d8af-11ed-8716-9f926086c898",
    "title": "Janette Sadik-Khan on the future of cities",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/710f1e6c-d8af-11ed-8716-9f926086c898-4826ca647df1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/710f1e6c-d8af-11ed-8716-9f926086c898-4826ca647df1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56795,
      "sha256": "444deaff82b949fbf3aba75625ddbebf390835caf2f30bebbc007db844b26c24",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.345Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/d5c0568c-d2fb-11ed-a825-a3e9a077ba80": {
    "source_id": "possible",
    "episode_id": "d5c0568c-d2fb-11ed-a825-a3e9a077ba80",
    "title": "Ben Nelson on the future of higher education",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/d5c0568c-d2fb-11ed-a825-a3e9a077ba80-e3c68a07b1a5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/d5c0568c-d2fb-11ed-a825-a3e9a077ba80-e3c68a07b1a5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56797,
      "sha256": "4d411b10fb93a219a78ba433e53e513d82ad304f19ee14ecf86a1beb579ab1c5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.375Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/354cd90c-cd95-11ed-b0f0-4b0a99895820": {
    "source_id": "possible",
    "episode_id": "354cd90c-cd95-11ed-b0f0-4b0a99895820",
    "title": "Saul Griffith on a clean energy future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/354cd90c-cd95-11ed-b0f0-4b0a99895820-4cc81fd1be4c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/354cd90c-cd95-11ed-b0f0-4b0a99895820-4cc81fd1be4c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56791,
      "sha256": "ae34d7fbbafd05143fa2dd1841963a30c1e50bdc6f389cc2b38493756488a886",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.327Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/9e2538b4-c82e-11ed-b075-9bb24ee5567f": {
    "source_id": "possible",
    "episode_id": "9e2538b4-c82e-11ed-b075-9bb24ee5567f",
    "title": "Dr. Kim Budil on the future of fusion",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/9e2538b4-c82e-11ed-b075-9bb24ee5567f-b0c67953a2b9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/9e2538b4-c82e-11ed-b075-9bb24ee5567f-b0c67953a2b9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56790,
      "sha256": "2279363e0b30697e9ef8a542142f3429c213c95884e82064c5406533154d726b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.358Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/c7d6d70c-c2c6-11ed-84e1-bb191de4492b": {
    "source_id": "possible",
    "episode_id": "c7d6d70c-c2c6-11ed-84e1-bb191de4492b",
    "title": "Trevor Noah on the future of entertainment and AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/c7d6d70c-c2c6-11ed-84e1-bb191de4492b-19baff00a44d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/c7d6d70c-c2c6-11ed-84e1-bb191de4492b-19baff00a44d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 56802,
      "sha256": "b53cb4d68700f832ec4c13d636b98b4e01004d40935ec944e0b0f33193d05fc0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.373Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "possible/b9e60bda-c28b-11ed-b49b-37acc178c514": {
    "source_id": "possible",
    "episode_id": "b9e60bda-c28b-11ed-b49b-37acc178c514",
    "title": "Introducing: Possible",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/possible-c4773daf2e6a/b9e60bda-c28b-11ed-b49b-37acc178c514-3c8f5280c7f4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/possible-c4773daf2e6a/b9e60bda-c28b-11ed-b49b-37acc178c514-3c8f5280c7f4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 55809,
      "sha256": "18c6c81061e54ad64ff6f21378eb5344a504cacc7d3c84c24660d2479214f199",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.369Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/748c2de5-a16b-4bfd-b73c-57440513e542": {
    "source_id": "practical-ai",
    "episode_id": "748c2de5-a16b-4bfd-b73c-57440513e542",
    "title": "U.S. Congressman Beyer on AI challenges facing America and the World",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/748c2de5-a16b-4bfd-b73c-57440513e542-6daabf816ab5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/748c2de5-a16b-4bfd-b73c-57440513e542-6daabf816ab5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45016,
      "sha256": "6f60a89a065c7f359257dd5701765a0b66748f910f2054d4080c991f5ce13e5f",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 108,
      "updated_at": "2026-06-09T13:39:31.409Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/1b717d56-974a-4ffe-8189-8df486ba2198": {
    "source_id": "practical-ai",
    "episode_id": "1b717d56-974a-4ffe-8189-8df486ba2198",
    "title": "The Myth of Model Wars: Open vs Closed AI in 2026",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/1b717d56-974a-4ffe-8189-8df486ba2198-19587e4ac72d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/1b717d56-974a-4ffe-8189-8df486ba2198-19587e4ac72d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40507,
      "sha256": "9018430de79ef92ec17dcc57cb931b2974fdddf1bc4d1b8ddfee692f89020096",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 81,
      "updated_at": "2026-06-09T13:39:31.395Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/53e551ea-abda-4837-8fd8-e2983ad02528": {
    "source_id": "practical-ai",
    "episode_id": "53e551ea-abda-4837-8fd8-e2983ad02528",
    "title": "The mythos of Mythos and Allbirds takes flight to the neocloud",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/53e551ea-abda-4837-8fd8-e2983ad02528-f995b3a6077b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/53e551ea-abda-4837-8fd8-e2983ad02528-f995b3a6077b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40560,
      "sha256": "13a3561bc7a84c3743237f19e1498e8abd938b4de4c930aad0151a638eebbec5",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 100,
      "updated_at": "2026-06-09T13:39:31.403Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/be951332-169e-43b4-8963-277b2a1b86ee": {
    "source_id": "practical-ai",
    "episode_id": "be951332-169e-43b4-8963-277b2a1b86ee",
    "title": "Open Source Self-Driving with Comma AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/be951332-169e-43b4-8963-277b2a1b86ee-b123e4b831ee/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/be951332-169e-43b4-8963-277b2a1b86ee-b123e4b831ee/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51179,
      "sha256": "d3cef84127b326dfdd53c1c3f50becaa5075aace7fae3cf39b0744d28817e7da",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 121,
      "updated_at": "2026-06-09T13:39:31.414Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/935cb988-528b-460c-a13b-ac081b371aef": {
    "source_id": "practical-ai",
    "episode_id": "935cb988-528b-460c-a13b-ac081b371aef",
    "title": "Post-Mortem of Anthropic's Claude Code Leak",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/935cb988-528b-460c-a13b-ac081b371aef-e02bb899d1a3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/935cb988-528b-460c-a13b-ac081b371aef-e02bb899d1a3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39577,
      "sha256": "9cf8d7c3dc7f7d1046cdfae64b5ceab96fa596fa381cfad17692107fa3f770d2",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 77,
      "updated_at": "2026-06-09T13:39:31.410Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/c3d9a882-c06e-4e90-bcb8-95b9c5e5eda6": {
    "source_id": "practical-ai",
    "episode_id": "c3d9a882-c06e-4e90-bcb8-95b9c5e5eda6",
    "title": "Agentic Coding and the Economics of Open Source",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/c3d9a882-c06e-4e90-bcb8-95b9c5e5eda6-c868fd7d16cf/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/c3d9a882-c06e-4e90-bcb8-95b9c5e5eda6-c868fd7d16cf/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47391,
      "sha256": "f2e916186bb79afdcaa9a9ad129974165bea0ff657bd88790462efcd91697fc2",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 94,
      "updated_at": "2026-06-09T13:39:31.416Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/c0bc0a38-8ba5-40a7-994e-0e60e37985f3": {
    "source_id": "practical-ai",
    "episode_id": "c0bc0a38-8ba5-40a7-994e-0e60e37985f3",
    "title": "AI at the Edge is a different operating environment",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/c0bc0a38-8ba5-40a7-994e-0e60e37985f3-9e464084b6dc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/c0bc0a38-8ba5-40a7-994e-0e60e37985f3-9e464084b6dc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45519,
      "sha256": "57fc550b2266b251f7cb7a4e411636242976d5fdea077754eea1ac0b2ccf5036",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 86,
      "updated_at": "2026-06-09T13:39:31.415Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/c1054380-2ce1-4eb5-830b-34357f7d99e7": {
    "source_id": "practical-ai",
    "episode_id": "c1054380-2ce1-4eb5-830b-34357f7d99e7",
    "title": "Humility in the Age of Agentic Coding",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/c1054380-2ce1-4eb5-830b-34357f7d99e7-aee78910a2a9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/c1054380-2ce1-4eb5-830b-34357f7d99e7-aee78910a2a9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 66588,
      "sha256": "3e79f190aff0f9aa3c20cd5b0d79125e95c811f4ca5ce46a425fd8f01b97c6a1",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 154,
      "updated_at": "2026-06-09T13:39:31.415Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/65c042ae-28bb-4ec7-b442-4bce381ddcb2": {
    "source_id": "practical-ai",
    "episode_id": "65c042ae-28bb-4ec7-b442-4bce381ddcb2",
    "title": "AI policy and the battle for computing power",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/65c042ae-28bb-4ec7-b442-4bce381ddcb2-143107f300e2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/65c042ae-28bb-4ec7-b442-4bce381ddcb2-143107f300e2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54398,
      "sha256": "cf6c3619d72266a5744e41e547c0d51ffcff54e65ee5adc71fc6b4d63c41ce55",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 118,
      "updated_at": "2026-06-09T13:39:31.407Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/556e1c17-50d5-4099-8fba-2df8ae15661e": {
    "source_id": "practical-ai",
    "episode_id": "556e1c17-50d5-4099-8fba-2df8ae15661e",
    "title": "Cognitive Synthesis and Neural Athletes",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/556e1c17-50d5-4099-8fba-2df8ae15661e-5d6ec9c9a2c7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/556e1c17-50d5-4099-8fba-2df8ae15661e-5d6ec9c9a2c7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52308,
      "sha256": "f6b06ab925f93af8792ad9d903806153141377d7a4d0f9f58cec5eddd1730833",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 104,
      "updated_at": "2026-06-09T13:39:31.404Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/fcbe89dc-70d4-4351-bc8a-ee570292ae36": {
    "source_id": "practical-ai",
    "episode_id": "fcbe89dc-70d4-4351-bc8a-ee570292ae36",
    "title": "AI incidents, audits, and the limits of benchmarks",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/fcbe89dc-70d4-4351-bc8a-ee570292ae36-6e71e8707107/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/fcbe89dc-70d4-4351-bc8a-ee570292ae36-6e71e8707107/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41508,
      "sha256": "050b4116bb13df877b8effa5294d12069a7792ac0b6d78d495a459508a2ba6e0",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.510Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/a35462b5-9a44-435f-bd31-cf8d10d437e7": {
    "source_id": "practical-ai",
    "episode_id": "a35462b5-9a44-435f-bd31-cf8d10d437e7",
    "title": "Inside an AI-Run Company",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/a35462b5-9a44-435f-bd31-cf8d10d437e7-0c4e9cc19581/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/a35462b5-9a44-435f-bd31-cf8d10d437e7-0c4e9cc19581/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53774,
      "sha256": "66f5dfd4ad1f95c1dca26ee3b420be37f4784167910304988a7ce67dbc2c1b3d",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 120,
      "updated_at": "2026-06-09T13:39:31.413Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/e26c0ac8-688a-4957-bbab-3ce2f48ef9e4": {
    "source_id": "practical-ai",
    "episode_id": "e26c0ac8-688a-4957-bbab-3ce2f48ef9e4",
    "title": "How is AI shaping democracy?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/e26c0ac8-688a-4957-bbab-3ce2f48ef9e4-dcfa16d0bb60/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/e26c0ac8-688a-4957-bbab-3ce2f48ef9e4-dcfa16d0bb60/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46868,
      "sha256": "01986f736fc1767749a7ed3f76fb9db23f8f99050264efa1a0703ddd29b1b5f9",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.507Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/57872af6-b6b7-4832-86a9-35608a8296b8": {
    "source_id": "practical-ai",
    "episode_id": "57872af6-b6b7-4832-86a9-35608a8296b8",
    "title": "Controlling AI Models from the Inside",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/57872af6-b6b7-4832-86a9-35608a8296b8-3a11a6d94a87/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/57872af6-b6b7-4832-86a9-35608a8296b8-3a11a6d94a87/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44336,
      "sha256": "54619c5663dd2f0ed40cd57f62738386bf0275780d4e1c8e435b243d52062f2c",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 119,
      "updated_at": "2026-06-09T13:39:31.405Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/3d69fe1e-b2e4-4a33-9efc-4466e56b1887": {
    "source_id": "practical-ai",
    "episode_id": "3d69fe1e-b2e4-4a33-9efc-4466e56b1887",
    "title": "2025 was the year of agents, what's coming in 2026?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/3d69fe1e-b2e4-4a33-9efc-4466e56b1887-ff89a480d33f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/3d69fe1e-b2e4-4a33-9efc-4466e56b1887-ff89a480d33f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45408,
      "sha256": "55565434eed5cc78366340906398ab10e458d53b8fc499ed468e0c4efcd9c4fa",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.400Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/07b2ca44-92af-4b4f-80ac-448a00e8e548": {
    "source_id": "practical-ai",
    "episode_id": "07b2ca44-92af-4b4f-80ac-448a00e8e548",
    "title": "Beyond chatbots: Agents that tackle your SOPs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/07b2ca44-92af-4b4f-80ac-448a00e8e548-de23c228cf9a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/07b2ca44-92af-4b4f-80ac-448a00e8e548-de23c228cf9a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49314,
      "sha256": "c5b8e88b1fcb5ccc899f6f57610a75e09e606330a3a01cbe143bb42c2054792a",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 121,
      "updated_at": "2026-06-09T13:39:31.392Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/22b000ed-38fb-415a-8084-25b7475983cb": {
    "source_id": "practical-ai",
    "episode_id": "22b000ed-38fb-415a-8084-25b7475983cb",
    "title": "The AI engineer skills gap",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/22b000ed-38fb-415a-8084-25b7475983cb-015c8148b75a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/22b000ed-38fb-415a-8084-25b7475983cb-015c8148b75a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44229,
      "sha256": "9d5d5f230b10c5c923890059fd167d7ca1ade8e5cb076a27700d49d599d573d4",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 103,
      "updated_at": "2026-06-09T13:39:31.397Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/fa371b17-2f78-43b7-9cba-9321b35219f3": {
    "source_id": "practical-ai",
    "episode_id": "fa371b17-2f78-43b7-9cba-9321b35219f3",
    "title": "Technical advances in document understanding",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/fa371b17-2f78-43b7-9cba-9321b35219f3-a8a6e857cd2b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/fa371b17-2f78-43b7-9cba-9321b35219f3-a8a6e857cd2b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44957,
      "sha256": "07e8de2636f3218f43557389a7bace20bee5ee835a32b369cd3753872aa67d25",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.509Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/0285ede8-e11a-414d-baa3-c667ce5c971b": {
    "source_id": "practical-ai",
    "episode_id": "0285ede8-e11a-414d-baa3-c667ce5c971b",
    "title": "Chris on AI, autonomous swarming, home automation and Rust!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/0285ede8-e11a-414d-baa3-c667ce5c971b-401964485e3f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/0285ede8-e11a-414d-baa3-c667ce5c971b-401964485e3f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 104425,
      "sha256": "d63967262b2cbaaf60848de9ea7719e4cbc0a35d8836d7619db68b28e67011f3",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 416,
      "updated_at": "2026-06-09T13:39:31.392Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/5bbaf36f-b4da-4f44-b217-932122310fb0": {
    "source_id": "practical-ai",
    "episode_id": "5bbaf36f-b4da-4f44-b217-932122310fb0",
    "title": "Beyond note-taking with Fireflies",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/5bbaf36f-b4da-4f44-b217-932122310fb0-6a7f58420b7d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/5bbaf36f-b4da-4f44-b217-932122310fb0-6a7f58420b7d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49714,
      "sha256": "435855cdcd2201c664745256bd8d3c327e688185a2ad651e76ff0eb87727d409",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 102,
      "updated_at": "2026-06-09T13:39:31.406Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/5604b042-20c2-4aa8-b9c5-95664ad78ddd": {
    "source_id": "practical-ai",
    "episode_id": "5604b042-20c2-4aa8-b9c5-95664ad78ddd",
    "title": "Autonomous Vehicle Research at Waymo",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/5604b042-20c2-4aa8-b9c5-95664ad78ddd-f16874a077db/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/5604b042-20c2-4aa8-b9c5-95664ad78ddd-f16874a077db/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49169,
      "sha256": "eb4021ad4ac95cabfeb65d110a5f24bdafdef7bc55df3e939ccadb35af214db3",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 114,
      "updated_at": "2026-06-09T13:39:31.405Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/21825b5b-994c-4aed-8d3f-25a84159eb80": {
    "source_id": "practical-ai",
    "episode_id": "21825b5b-994c-4aed-8d3f-25a84159eb80",
    "title": "Are we in an AI bubble?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/21825b5b-994c-4aed-8d3f-25a84159eb80-766448c9e34e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/21825b5b-994c-4aed-8d3f-25a84159eb80-766448c9e34e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44167,
      "sha256": "18b7765077dd4558f25d37fc9dc3b1047c446411a0f1707d64d4a39a2cdc1fba",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 92,
      "updated_at": "2026-06-09T13:39:31.396Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/e8faf8b3-70e8-437d-b879-363fbd741efa": {
    "source_id": "practical-ai",
    "episode_id": "e8faf8b3-70e8-437d-b879-363fbd741efa",
    "title": "While loops with tool calls",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/e8faf8b3-70e8-437d-b879-363fbd741efa-83d4515262d3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/e8faf8b3-70e8-437d-b879-363fbd741efa-83d4515262d3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46570,
      "sha256": "60044a077d6fe1efa4f42581ec27e65dd71cb5fe06f66b547c1b5a7f80458e07",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.507Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/26fd3387-635e-4844-be9b-05356c6b8449": {
    "source_id": "practical-ai",
    "episode_id": "26fd3387-635e-4844-be9b-05356c6b8449",
    "title": "Tiny Recursive Networks",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/26fd3387-635e-4844-be9b-05356c6b8449-d9f6e2998344/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/26fd3387-635e-4844-be9b-05356c6b8449-d9f6e2998344/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42963,
      "sha256": "9e90152ce1e87ca835751f8c57dd3c43e2ff0d4026b68644b33bd93f5c886223",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.398Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/8a585606-13c6-4064-821f-6b4be5b232ca": {
    "source_id": "practical-ai",
    "episode_id": "8a585606-13c6-4064-821f-6b4be5b232ca",
    "title": "Dealing with increasingly complicated agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/8a585606-13c6-4064-821f-6b4be5b232ca-db5fa2528f02/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/8a585606-13c6-4064-821f-6b4be5b232ca-db5fa2528f02/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49883,
      "sha256": "975558669497339b2df47cde980a9a98f794df8176a9d72563085525d627f5cc",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 118,
      "updated_at": "2026-06-09T13:39:31.409Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/2a9fd6ef-4894-4931-a47e-6ea7df4d07dc": {
    "source_id": "practical-ai",
    "episode_id": "2a9fd6ef-4894-4931-a47e-6ea7df4d07dc",
    "title": "The impact of AI on the workforce: A state-level case study",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/2a9fd6ef-4894-4931-a47e-6ea7df4d07dc-44b64454e55d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/2a9fd6ef-4894-4931-a47e-6ea7df4d07dc-44b64454e55d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42775,
      "sha256": "e424d3b322cba7247dbdad5e9176f6fbb9d72578d48022a36fc4acc5d0261460",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 107,
      "updated_at": "2026-06-09T13:39:31.399Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/d9e8078b-5582-490f-976e-f5197f3db234": {
    "source_id": "practical-ai",
    "episode_id": "d9e8078b-5582-490f-976e-f5197f3db234",
    "title": "We've all done RAG, now what?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/d9e8078b-5582-490f-976e-f5197f3db234-ff8e9282ef6c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/d9e8078b-5582-490f-976e-f5197f3db234-ff8e9282ef6c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44128,
      "sha256": "4682b9968ec8821bdb73b99b5c8ce026cdb3abab41246ba5049507016dc21bfd",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 99,
      "updated_at": "2026-06-09T13:39:31.506Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/552ed99d-351d-4fbb-b653-d2f5e1c5402a": {
    "source_id": "practical-ai",
    "episode_id": "552ed99d-351d-4fbb-b653-d2f5e1c5402a",
    "title": "Creating a private AI assistant in Thunderbird",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/552ed99d-351d-4fbb-b653-d2f5e1c5402a-3ebe58df47fb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/552ed99d-351d-4fbb-b653-d2f5e1c5402a-3ebe58df47fb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48476,
      "sha256": "4bb513565ac8c018e4a8f8ceabafa584fdfc7f77828771524662c8a6c979ec6e",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 124,
      "updated_at": "2026-06-09T13:39:31.404Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/2f2c3429-83eb-40cd-9bdd-23e02e8467cd": {
    "source_id": "practical-ai",
    "episode_id": "2f2c3429-83eb-40cd-9bdd-23e02e8467cd",
    "title": "Cracking the code of failed AI pilots",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/2f2c3429-83eb-40cd-9bdd-23e02e8467cd-c1424ff0019f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/2f2c3429-83eb-40cd-9bdd-23e02e8467cd-c1424ff0019f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42324,
      "sha256": "8d5f0262ce9c90cbb948f56e4bb622c771c03e0f32fc95be38bf041fa0d1c386",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 81,
      "updated_at": "2026-06-09T13:39:31.399Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/93a2312f-6730-434a-b7c1-2919df8b2897": {
    "source_id": "practical-ai",
    "episode_id": "93a2312f-6730-434a-b7c1-2919df8b2897",
    "title": "GenAI risks and global adoption",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/93a2312f-6730-434a-b7c1-2919df8b2897-0d4be6c339c3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/93a2312f-6730-434a-b7c1-2919df8b2897-0d4be6c339c3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38786,
      "sha256": "7516f603679e85ab3a89edcf7b900ca5479da3587c5abb0683df4a2ab64228db",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.410Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/9d741acd-2d69-449e-af5b-7c95a01be2dd": {
    "source_id": "practical-ai",
    "episode_id": "9d741acd-2d69-449e-af5b-7c95a01be2dd",
    "title": "Inside America’s AI Action Plan",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/9d741acd-2d69-449e-af5b-7c95a01be2dd-d50899013231/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/9d741acd-2d69-449e-af5b-7c95a01be2dd-d50899013231/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39015,
      "sha256": "597cedc44d1b1c2fa12c793380b62db9a48ebce4c6689e3ac3f17128ac7168ac",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 77,
      "updated_at": "2026-06-09T13:39:31.411Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/1457578d-17e0-4567-9443-eaeee007634b": {
    "source_id": "practical-ai",
    "episode_id": "1457578d-17e0-4567-9443-eaeee007634b",
    "title": "Confident, strategic AI leadership",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/1457578d-17e0-4567-9443-eaeee007634b-b050af1f5c85/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/1457578d-17e0-4567-9443-eaeee007634b-b050af1f5c85/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49852,
      "sha256": "aa6e702bb27c247a68f9bcb483d52550469219619863232f0dd36144e4e8cb2d",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 102,
      "updated_at": "2026-06-09T13:39:31.394Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/a1a0a979-7151-48cb-8234-0d31cfbfb373": {
    "source_id": "practical-ai",
    "episode_id": "a1a0a979-7151-48cb-8234-0d31cfbfb373",
    "title": "Educating a data-literate generation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/a1a0a979-7151-48cb-8234-0d31cfbfb373-a88b032de369/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/a1a0a979-7151-48cb-8234-0d31cfbfb373-a88b032de369/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43274,
      "sha256": "7692d263ff525893f8fd794871a3e5091bbfe6dc6a23b38b739dde8078228f73",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 100,
      "updated_at": "2026-06-09T13:39:31.413Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/1b23e30a-100f-4f8a-84df-7ac9e714057f": {
    "source_id": "practical-ai",
    "episode_id": "1b23e30a-100f-4f8a-84df-7ac9e714057f",
    "title": "Workforce dynamics in an AI-assisted world",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/1b23e30a-100f-4f8a-84df-7ac9e714057f-0e3e03c259c3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/1b23e30a-100f-4f8a-84df-7ac9e714057f-0e3e03c259c3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40228,
      "sha256": "7ae66c0c35ae033bf45195876f74d7431842b395467d0bae7be94b07cdf2d05b",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 88,
      "updated_at": "2026-06-09T13:39:31.394Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/fccfe798-4145-481d-af81-c8c4cc73fd7b": {
    "source_id": "practical-ai",
    "episode_id": "fccfe798-4145-481d-af81-c8c4cc73fd7b",
    "title": "Reimagining actuarial science with AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/fccfe798-4145-481d-af81-c8c4cc73fd7b-01c455ade14a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/fccfe798-4145-481d-af81-c8c4cc73fd7b-01c455ade14a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38274,
      "sha256": "fb0ef91d18514b6f25963cac70b87e583cee3ffbeb0c00e642ebdf165e61de89",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.510Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/be96969b-dbf8-402d-bde2-890d642e023a": {
    "source_id": "practical-ai",
    "episode_id": "be96969b-dbf8-402d-bde2-890d642e023a",
    "title": "Agentic AI for Drone & Robotic Swarming",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/be96969b-dbf8-402d-bde2-890d642e023a-1b93311de0a4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/be96969b-dbf8-402d-bde2-890d642e023a-1b93311de0a4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44447,
      "sha256": "d546fa65005365bbe20c5f4214b27033da0c907b28e39a020c22d967308e80bc",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 111,
      "updated_at": "2026-06-09T13:39:31.414Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/a189de61-20ec-443a-b297-bb094cd44c42": {
    "source_id": "practical-ai",
    "episode_id": "a189de61-20ec-443a-b297-bb094cd44c42",
    "title": "AI in the shadows: From hallucinations to blackmail",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/a189de61-20ec-443a-b297-bb094cd44c42-e30118258d8f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/a189de61-20ec-443a-b297-bb094cd44c42-e30118258d8f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40294,
      "sha256": "944fe8836fd04a15be7dc9c68076dedb611b3d5f8ab76ef001ca68a89d0badc8",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 99,
      "updated_at": "2026-06-09T13:39:31.412Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/25f2c986-c65c-4333-b088-6b00c3ac3f05": {
    "source_id": "practical-ai",
    "episode_id": "25f2c986-c65c-4333-b088-6b00c3ac3f05",
    "title": "Finding Nemotron",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/25f2c986-c65c-4333-b088-6b00c3ac3f05-5252e97726d3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/25f2c986-c65c-4333-b088-6b00c3ac3f05-5252e97726d3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51032,
      "sha256": "4d2fc20f573f79a8ef0f23b13f7e4037f43caa22c2dfa264ae50074edd3f7e6c",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.397Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/f5bf4735-b82f-41a3-9c2e-5cc25f5168bc": {
    "source_id": "practical-ai",
    "episode_id": "f5bf4735-b82f-41a3-9c2e-5cc25f5168bc",
    "title": "AI hot takes and debates: Autonomy",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/f5bf4735-b82f-41a3-9c2e-5cc25f5168bc-57591ed028a4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/f5bf4735-b82f-41a3-9c2e-5cc25f5168bc-57591ed028a4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41417,
      "sha256": "c5a3eb45fc5bb91d2f9eec80b833b9a2c3f104197778357ddc17f67d7838a82b",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.508Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/1455019e-f400-4041-88e5-5f9b3b6fc8cc": {
    "source_id": "practical-ai",
    "episode_id": "1455019e-f400-4041-88e5-5f9b3b6fc8cc",
    "title": "Behind-the-Scenes: VC Funding for AI Startups",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/1455019e-f400-4041-88e5-5f9b3b6fc8cc-b88fc3d81508/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/1455019e-f400-4041-88e5-5f9b3b6fc8cc-b88fc3d81508/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39980,
      "sha256": "15effac055581cfa387e871b500d4e134f36e146c6ea09235cd564fc31de6072",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 100,
      "updated_at": "2026-06-09T13:39:31.393Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/4e5c87dc-afca-4fb5-b295-4e4b955627a7": {
    "source_id": "practical-ai",
    "episode_id": "4e5c87dc-afca-4fb5-b295-4e4b955627a7",
    "title": "AI-Automated Film Making",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/4e5c87dc-afca-4fb5-b295-4e4b955627a7-5285d416fb8b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/4e5c87dc-afca-4fb5-b295-4e4b955627a7-5285d416fb8b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36454,
      "sha256": "044b7b734129b63f37d0f3a884ef0ff129e1455f7f8e412d2c532805eea7d71d",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 84,
      "updated_at": "2026-06-09T13:39:31.402Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/d723ab20-4c1c-497a-8b1f-02d5defcefd7": {
    "source_id": "practical-ai",
    "episode_id": "d723ab20-4c1c-497a-8b1f-02d5defcefd7",
    "title": "Federated learning in production (part 2)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/d723ab20-4c1c-497a-8b1f-02d5defcefd7-17142bbc4c2a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/d723ab20-4c1c-497a-8b1f-02d5defcefd7-17142bbc4c2a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39978,
      "sha256": "14d610562e0f6c2561782929a28634b3fb6269d20a47ee997d9ca765ce5cd5e1",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.505Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/cc6e6d9b-5a7d-46fa-b784-6b5f3c12c9e7": {
    "source_id": "practical-ai",
    "episode_id": "cc6e6d9b-5a7d-46fa-b784-6b5f3c12c9e7",
    "title": "Federated learning in production (part 1)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/cc6e6d9b-5a7d-46fa-b784-6b5f3c12c9e7-8d6fbf2f2174/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/cc6e6d9b-5a7d-46fa-b784-6b5f3c12c9e7-8d6fbf2f2174/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43419,
      "sha256": "46bf0e838f22cfd2b31bb4d43acc282bdb4ffee55cd1ffc50dc790cd1f40b44c",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 78,
      "updated_at": "2026-06-09T13:39:31.417Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/4218866a-0122-472b-af2b-98355cf1d7d8": {
    "source_id": "practical-ai",
    "episode_id": "4218866a-0122-472b-af2b-98355cf1d7d8",
    "title": "Emailing like a superhuman",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/4218866a-0122-472b-af2b-98355cf1d7d8-6bc11909a894/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/4218866a-0122-472b-af2b-98355cf1d7d8-6bc11909a894/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46140,
      "sha256": "706d7f14a5614d311454d060db189f94bcd5b5f02e2e3391ef3d3aa71ed06520",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 98,
      "updated_at": "2026-06-09T13:39:31.400Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/0deadba3-7280-47cf-8346-dd75bb5f7983": {
    "source_id": "practical-ai",
    "episode_id": "0deadba3-7280-47cf-8346-dd75bb5f7983",
    "title": "Model Context Protocol Deep Dive",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/0deadba3-7280-47cf-8346-dd75bb5f7983-29376f4f3aae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/0deadba3-7280-47cf-8346-dd75bb5f7983-29376f4f3aae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37751,
      "sha256": "d795eaa0cddf2b65635edd487007087c35f592f0356aebb1522f4db8d37ccfb3",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 101,
      "updated_at": "2026-06-09T13:39:31.393Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/d0825afe-5941-48ef-b4ee-42f963df6b38": {
    "source_id": "practical-ai",
    "episode_id": "d0825afe-5941-48ef-b4ee-42f963df6b38",
    "title": "Seeing beyond the scan in neuroimaging",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/d0825afe-5941-48ef-b4ee-42f963df6b38-b41ace496d50/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/d0825afe-5941-48ef-b4ee-42f963df6b38-b41ace496d50/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42635,
      "sha256": "cd90a82f9f9ab1980ef685a937b9bc7685a80af586c7b87310844383b92f89b2",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 92,
      "updated_at": "2026-06-09T13:39:31.505Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/46192cc2-91ab-46ca-8a26-a0976c1c9f33": {
    "source_id": "practical-ai",
    "episode_id": "46192cc2-91ab-46ca-8a26-a0976c1c9f33",
    "title": "Open source AI to tackle your backlog",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/46192cc2-91ab-46ca-8a26-a0976c1c9f33-3ce5df420497/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/46192cc2-91ab-46ca-8a26-a0976c1c9f33-3ce5df420497/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45018,
      "sha256": "81f02f7e16ff5d1b71d4406b9204f709f847fb1e27a6324e57c30a88578d24d0",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 100,
      "updated_at": "2026-06-09T13:39:31.401Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/6f648f8c-8bfa-432e-8bc1-c49f4e8d58b4": {
    "source_id": "practical-ai",
    "episode_id": "6f648f8c-8bfa-432e-8bc1-c49f4e8d58b4",
    "title": "Orchestrating agents, APIs, and MCP servers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/6f648f8c-8bfa-432e-8bc1-c49f4e8d58b4-1eb35bf6de7d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/6f648f8c-8bfa-432e-8bc1-c49f4e8d58b4-1eb35bf6de7d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40216,
      "sha256": "f242df9ac5e485c1eafa32f8f293ca2a1d924b5d311caa1a331352033b09fd43",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 110,
      "updated_at": "2026-06-09T13:39:31.408Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/5edd910e-8474-40c8-8b83-ee289c67ae3b": {
    "source_id": "practical-ai",
    "episode_id": "5edd910e-8474-40c8-8b83-ee289c67ae3b",
    "title": "Software and hardware acceleration with Groq",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/5edd910e-8474-40c8-8b83-ee289c67ae3b-28a8292aa5ae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/5edd910e-8474-40c8-8b83-ee289c67ae3b-28a8292aa5ae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39098,
      "sha256": "5eaeb3634a411a7f2acb58f69ee3ecd4ee45433afb2490f9e1e22a2ba85a8a5d",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 96,
      "updated_at": "2026-06-09T13:39:31.406Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/97b9dc86-ad4c-4fb7-bfc0-bb98fd13a9fa": {
    "source_id": "practical-ai",
    "episode_id": "97b9dc86-ad4c-4fb7-bfc0-bb98fd13a9fa",
    "title": "AI-assisted coding with GitHub's COO",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/97b9dc86-ad4c-4fb7-bfc0-bb98fd13a9fa-eabcd0e8f18d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/97b9dc86-ad4c-4fb7-bfc0-bb98fd13a9fa-eabcd0e8f18d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 50644,
      "sha256": "ae5254be8dd89739d2ce48763a614115e1e8df936689874842db643a210a7785",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 107,
      "updated_at": "2026-06-09T13:39:31.411Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/f8b53471-70f1-4ade-a68d-c0a89fa9211b": {
    "source_id": "practical-ai",
    "episode_id": "f8b53471-70f1-4ade-a68d-c0a89fa9211b",
    "title": "Optimizing for efficiency with IBM’s Granite",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/f8b53471-70f1-4ade-a68d-c0a89fa9211b-e50e4dc63532/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/f8b53471-70f1-4ade-a68d-c0a89fa9211b-e50e4dc63532/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47347,
      "sha256": "b6d5f33ba08bc559da1fe629ef9495d3ed634c8ddec26954643d01ffe7b25ab2",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 107,
      "updated_at": "2026-06-09T13:39:31.509Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/1c08e18d-2c47-4af0-934c-a672510f1510": {
    "source_id": "practical-ai",
    "episode_id": "1c08e18d-2c47-4af0-934c-a672510f1510",
    "title": "Build a workspace of AI agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/1c08e18d-2c47-4af0-934c-a672510f1510-02aa0f1c1a55/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/1c08e18d-2c47-4af0-934c-a672510f1510-02aa0f1c1a55/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52661,
      "sha256": "7c5c737d4d10618740eacb4ad8c9a3eeb3419bb8686aa8f7183ee20192a0c670",
      "source_kind": "official_transistor_transcript",
      "source_quality": "official_transcript",
      "record_count": 132,
      "updated_at": "2026-06-09T13:39:31.395Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2643": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2643",
    "title": "Mozart to Megadeth at CHRP",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2643-d404d5c17857/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2643-d404d5c17857/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46241,
      "sha256": "b59514c7b55957813b26b579a5aea893193a1721bf73a6ee458c8f1056dd586c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.504Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2640": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2640",
    "title": "Sidekick is an AI Shopify expert",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2640-98ed91651127/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2640-98ed91651127/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46922,
      "sha256": "decfbf150bb1d7ea154fce1e69e56147571708b2f5071e63ce9d1adea92e8eb7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 80,
      "updated_at": "2026-06-09T13:39:31.504Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2631": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2631",
    "title": "Full-duplex, real-time dialogue with Kyutai",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2631-a468faff0ed8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2631-a468faff0ed8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37963,
      "sha256": "be8995c718cdfd0b55414e563563a95e3293d441b4d9a31d9b05316350786a15",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.503Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2629": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2629",
    "title": "Clones, commerce & campaigns",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2629-06e133a7c694/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2629-06e133a7c694/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39525,
      "sha256": "c6c552b1e5125f90b1baa0e70c6cf952743c71dc0e13f34435bb49d6b858062c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 73,
      "updated_at": "2026-06-09T13:39:31.503Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2623": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2623",
    "title": "scikit-learn & data science you own",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2623-1a3b1558ef0c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2623-1a3b1558ef0c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39393,
      "sha256": "b3ec9b09a1c765bf78e2a789208b99b9ea4599c3b8da498cfd5b50ef4e375ab6",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.502Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2615": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2615",
    "title": "Creating tested, reliable AI applications",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2615-4a0fc3777314/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2615-4a0fc3777314/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37227,
      "sha256": "741ba73cc4cbb7710f892086b1ab771a313a6c50ce5c1522691838a0151eef6b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 46,
      "updated_at": "2026-06-09T13:39:31.502Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2604": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2604",
    "title": "AI is changing the cybersecurity threat landscape",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2604-16890b67b81a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2604-16890b67b81a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44820,
      "sha256": "953483d1b5aa945d73481d1860ebfe5b2033a210e85866283438d7a338c04e12",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 53,
      "updated_at": "2026-06-09T13:39:31.501Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2597": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2597",
    "title": "The path towards trustworthy AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2597-c3a2c401d42f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2597-c3a2c401d42f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35369,
      "sha256": "3243bd7715f2adfaa7e44af7c10488ba2fed37320c51ada0ad97940e34221aa9",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 22,
      "updated_at": "2026-06-09T13:39:31.500Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2598": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2598",
    "title": "Big data is dead, analytics is alive",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2598-57bcb87e741c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2598-57bcb87e741c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35484,
      "sha256": "6e3b4a7c979b160693f6b3d3f46d5eb8c03f6773812d638d89994a4530b8ef64",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 39,
      "updated_at": "2026-06-09T13:39:31.500Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2586": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2586",
    "title": "Practical workflow orchestration",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2586-ae4e7c30ca23/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2586-ae4e7c30ca23/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48820,
      "sha256": "85da0994918a736bbc326ee70e2db683f83cd0ebe3f7098d1cf593a832e76435",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 49,
      "updated_at": "2026-06-09T13:39:31.499Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2579": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2579",
    "title": "Towards high-quality (maybe synthetic) datasets",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2579-d3b9003b1ea1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2579-d3b9003b1ea1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44903,
      "sha256": "1e5d4e5053f03df44adb5c67f9d1a35e04c49aa9bb67c46b7b4ecd1935d7d52a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.499Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2576": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2576",
    "title": "Understanding what's possible, doable & scalable",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2576-139c4f792798/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2576-139c4f792798/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48977,
      "sha256": "29f94a5a7e7676a4875c2b5dd2ed9331abb0bc5a9d9bf3f0ea5c32d5eba07c74",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.498Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2570": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2570",
    "title": "GraphRAG (beyond the hype)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2570-fb61b328e76b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2570-fb61b328e76b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49167,
      "sha256": "8b9362033eecc766a9b17b90f57bddd649d844e2bc53f84cfc88608ca8f36476",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.497Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2565": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2565",
    "title": "Pausing to think about scikit-learn & OpenAI o1",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2565-9c0fadda20ef/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2565-9c0fadda20ef/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35541,
      "sha256": "bf4413ef0400b714770fc042b75f5e4787badd05b5bb53872118b65df3a084f9",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 47,
      "updated_at": "2026-06-09T13:39:31.497Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2554": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2554",
    "title": "Cybersecurity in the GenAI age",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2554-fa950ad2bc87/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2554-fa950ad2bc87/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45383,
      "sha256": "21e6d587948adc58363c83d5d8eac3c8442fe4a522701ca606117a2dc17a202b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 39,
      "updated_at": "2026-06-09T13:39:31.496Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2541": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2541",
    "title": "Threat modeling LLM apps",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2541-3c39b39396c4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2541-3c39b39396c4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41461,
      "sha256": "e32ee684a488b24fdbe730373435ac28a41eb748a1251cdc5f30fe8e978e1d6d",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.495Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2534": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2534",
    "title": "Only as good as the data",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2534-fbc65b8a8b9e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2534-fbc65b8a8b9e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35577,
      "sha256": "189bbbbaa9668c28f24e48b744a77c7de9ee9e3d9d80633fd1750bc370c297dc",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 43,
      "updated_at": "2026-06-09T13:39:31.495Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2518": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2518",
    "title": "Gaudi processors & Intel's AI portfolio",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2518-452ceda6ffd7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2518-452ceda6ffd7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37242,
      "sha256": "4aaa74409b0e590cb00c69f255ca73dd4e7677ce816857d783227eb15fdef8cd",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 43,
      "updated_at": "2026-06-09T13:39:31.494Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2515": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2515",
    "title": "Broccoli AI at its best 🥦",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2515-94943dc0e235/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2515-94943dc0e235/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34348,
      "sha256": "53b89291374d1f71ca2fc4e2a60f002b695a9bebfd3d00aa7b1ef2ffd107e4ed",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.493Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2499": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2499",
    "title": "Hyperventilating over the Gartner AI Hype Cycle",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2499-cdcab5256c0d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2499-cdcab5256c0d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51880,
      "sha256": "0016c08099286be220bb8c1744065ee5d0e90156e9bc16d8c77373573008fe93",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 318,
      "updated_at": "2026-06-09T13:39:31.493Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2497": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2497",
    "title": "The first real-time voice assistant",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2497-7ee9488beafd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2497-7ee9488beafd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35651,
      "sha256": "ed9169fc8bafe60010db9d99daa6c1206998f11367468b7ef646479693b88f5f",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 46,
      "updated_at": "2026-06-09T13:39:31.492Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2491": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2491",
    "title": "Vectoring in on Pinecone",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2491-53a75d2d0dc1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2491-53a75d2d0dc1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38923,
      "sha256": "837756118c1b6434e91afb07d224a7c3b44e175d1e24e5daaf5ff0feb68ec187",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 38,
      "updated_at": "2026-06-09T13:39:31.492Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2477": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2477",
    "title": "Stanford's AI Index Report 2024",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2477-0f3d484907db/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2477-0f3d484907db/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43411,
      "sha256": "1ffb405617f0e5c42b97b9d33049bc225784ac09f3ca700a6bbfc4d46edd3b8c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.491Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2473": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2473",
    "title": "Apple Intelligence & Advanced RAG",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2473-295807d388e0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2473-295807d388e0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37739,
      "sha256": "68718bf9701d5f2b33b0a5dd0de75da1f7b9f50940d9485c72bbe78a76596a29",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.490Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2462": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2462",
    "title": "The perplexities of information retrieval",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2462-26e87e32cb70/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2462-26e87e32cb70/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37312,
      "sha256": "f0df346ec0ea1b3e2236856226417d198d394897a25858bd1a3c4d1cb6e0e18d",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.490Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2457": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2457",
    "title": "Using edge models to find sensitive data",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2457-597703f3f85e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2457-597703f3f85e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 30188,
      "sha256": "f621785847a3a10d49ab7411c0123d115e24337db49dffcb0821ac7ff675bfb7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 74,
      "updated_at": "2026-06-09T13:39:31.489Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2449": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2449",
    "title": "Rise of the AI PC & local LLMs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2449-185d645cf576/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2449-185d645cf576/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 27814,
      "sha256": "496e04fd9b8781dde72cb3edfbaf3b79dc1c112a5b08f758e65107e0bc0c520f",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.489Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2442": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2442",
    "title": "AI in the U.S. Congress",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2442-59e80cc1bc6f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2442-59e80cc1bc6f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40067,
      "sha256": "1a62a4a834b2c6aa867c6a36f467d01dec01f1166640408dfc72c85eec98b7b2",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 51,
      "updated_at": "2026-06-09T13:39:31.488Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2436": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2436",
    "title": "First impressions of GPT-4o",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2436-737403d8afa5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2436-737403d8afa5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37268,
      "sha256": "81e22afb335174f1a9f0f8f24ecccff053fda50528c9381e44f9547b006bacba",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 63,
      "updated_at": "2026-06-09T13:39:31.487Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2429": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2429",
    "title": "Full-stack approach for effective AI agents",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2429-e0b1a17eb8c5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2429-e0b1a17eb8c5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51597,
      "sha256": "863607ebd4a6d1a650c0da0e96be205d08c6a480064c2e48f76a6467f0e779ce",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 40,
      "updated_at": "2026-06-09T13:39:31.486Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2419": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2419",
    "title": "Private, open source chat UIs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2419-60835460ce11/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2419-60835460ce11/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34120,
      "sha256": "f05c71f5193769b9e24345056e47ae1effac667df4ae0535d5f99ec0c5d06520",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 64,
      "updated_at": "2026-06-09T13:39:31.486Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2412": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2412",
    "title": "Mamba & Jamba",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2412-9659f3c94ea1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2412-9659f3c94ea1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35152,
      "sha256": "e0b7c369aceeaf1c8b92b816bf27a6697341ed340c49bfe46da7feffb7cfb028",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 36,
      "updated_at": "2026-06-09T13:39:31.485Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2401": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2401",
    "title": "Udio & the age of multi-modal AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2401-ad05cd567b99/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2401-ad05cd567b99/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 32249,
      "sha256": "0438f1313333975aa790da09eb18a06a0b80ab39a9ebce451a4217e00c70374b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.485Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2391": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2391",
    "title": "RAG continues to rise",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2391-dfe8f312c31d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2391-dfe8f312c31d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42316,
      "sha256": "c5c468f35d9832615be39e19433e10e236b57ca87a9ee1a6846c3da9152d09d2",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 106,
      "updated_at": "2026-06-09T13:39:31.484Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2385": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2385",
    "title": "Should kids still learn to code?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2385-23ae057206ae/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2385-23ae057206ae/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33830,
      "sha256": "e317f16d99111ec99d9d0afb975af316b54b5f8e9f30fb9a3ad398d75b2fe470",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.483Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2381": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2381",
    "title": "AI vs software devs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2381-aa49d01e69de/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2381-aa49d01e69de/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53563,
      "sha256": "483b5978903ac790853d43d814d2a93ee51262d322dadec397a95b36128a3d09",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 122,
      "updated_at": "2026-06-09T13:39:31.483Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2376": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2376",
    "title": "Prompting the future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2376-1d6fa65d5e90/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2376-1d6fa65d5e90/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43199,
      "sha256": "ecf0965f875ededbf474da65936085914a033a3cb6dc5f8fbf0586e056053d29",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 43,
      "updated_at": "2026-06-09T13:39:31.482Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2367": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2367",
    "title": "Generating the future of art & entertainment",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2367-c160b4dd3b91/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2367-c160b4dd3b91/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37336,
      "sha256": "fa297bb82f8e7b949974fe20e89d88433f0c734460efc6f66c897e4fa06afce0",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.481Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2355": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2355",
    "title": "YOLOv9: Computer vision is alive and well",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2355-4efa999978e1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2355-4efa999978e1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35875,
      "sha256": "47530b882cc40848606a81b6697ead530e3543048256f85668856aa223fec993",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 55,
      "updated_at": "2026-06-09T13:39:31.481Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2352": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2352",
    "title": "Representation Engineering (Activation Hacking)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2352-9207271dc60a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2352-9207271dc60a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36985,
      "sha256": "d99ade02d5f2b2715c0819c1780cd52171803582e7763f144f78053ee118608a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 82,
      "updated_at": "2026-06-09T13:39:31.480Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2344": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2344",
    "title": "Leading the charge on AI in National Security",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2344-39bf25565bdb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2344-39bf25565bdb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 53090,
      "sha256": "de38ad98403090a1ca7151210b96809bf58882c6c3008b6aa5d1979160ef02e3",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.479Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2339": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2339",
    "title": "Gemini vs OpenAI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2339-c125697f308a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2339-c125697f308a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38886,
      "sha256": "1a7f66d2161156e218b6652e6b3e766da4d39acfef11a699ee7c2c604585f44d",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 66,
      "updated_at": "2026-06-09T13:39:31.479Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2328": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2328",
    "title": "Data synthesis for SOTA LLMs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2328-4c3552c44c9e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2328-4c3552c44c9e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44408,
      "sha256": "d9ca0ff5db2e7883599efdc9a542ddaeedc6321b898eaf99220477d2f3b08ff7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 52,
      "updated_at": "2026-06-09T13:39:31.478Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2321": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2321",
    "title": "Large Action Models (LAMs) & Rabbits 🐇",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2321-f2afa026af17/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2321-f2afa026af17/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38176,
      "sha256": "6cbec62c5507603670a6bd171d482a47d7355c614afc525ec25503fc600a359e",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 50,
      "updated_at": "2026-06-09T13:39:31.477Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2317": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2317",
    "title": "Collaboration & evaluation for LLM apps",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2317-7b3583967501/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2317-7b3583967501/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44826,
      "sha256": "1e66ad4843cd8bbde264f2383dc8fd796202e3db9d4b0486910d568fa02fef79",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 30,
      "updated_at": "2026-06-09T13:39:31.477Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2306": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2306",
    "title": "Advent of GenAI Hackathon recap",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2306-695e7f2b218c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2306-695e7f2b218c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42283,
      "sha256": "20ddbdfb3765f832839a687623520328fa0364065531d7ce8299edc5783183d1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 35,
      "updated_at": "2026-06-09T13:39:31.476Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2303": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2303",
    "title": "AI predictions for 2024",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2303-c02ac49ba1aa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2303-c02ac49ba1aa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38638,
      "sha256": "a3da894d42356fb0dde7137090f39b59782acb158515cb86bb1e254c08347c6e",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 50,
      "updated_at": "2026-06-09T13:39:31.476Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2291": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2291",
    "title": "Open source, on-disk vector search with LanceDB",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2291-25f110ab1bdc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2291-25f110ab1bdc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36869,
      "sha256": "7658224d1a60a049f2940be1adb8fae31aa56e66a96956319d1b3da253fea5d3",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 35,
      "updated_at": "2026-06-09T13:39:31.475Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2287": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2287",
    "title": "The state of open source AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2287-ceefed3dde22/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2287-ceefed3dde22/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42177,
      "sha256": "a08c760aad40cfd88f5c92e1f5e2774094327f3196ad48822c5753bb41f3a2e7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 48,
      "updated_at": "2026-06-09T13:39:31.474Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2282": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2282",
    "title": "Suspicion machines ⚙️",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2282-d4a812e96620/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2282-d4a812e96620/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46428,
      "sha256": "b95fa2ffafb5888a7fdb7067e8de67354d6adb0d56f0b1b3f1c750d3387ad5c9",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 49,
      "updated_at": "2026-06-09T13:39:31.473Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2279": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2279",
    "title": "The OpenAI debacle (a retrospective)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2279-2d2af538f58c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2279-2d2af538f58c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40347,
      "sha256": "58dca01e558073595c33b45353b708d65ea12fb2b71d10955e9d1344a5086b72",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 81,
      "updated_at": "2026-06-09T13:39:31.473Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2267": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2267",
    "title": "Generating product imagery at Shopify",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2267-351c09bd8cef/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2267-351c09bd8cef/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49703,
      "sha256": "63caeee9e96b045bfdd343c76cc7fb00cad1708957f096cb9aed4f4bed7385bc",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 66,
      "updated_at": "2026-06-09T13:39:31.472Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2261": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2261",
    "title": "AI trailblazers putting people first",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2261-20b2d5a9b968/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2261-20b2d5a9b968/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42211,
      "sha256": "21395ea39c94bdbbe890d3dfaad9c6e5dec6d1df62fedebffdb704eebcf8b282",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 42,
      "updated_at": "2026-06-09T13:39:31.471Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2257": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2257",
    "title": "Government regulation of AI has arrived",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2257-2179b0459afd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2257-2179b0459afd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38557,
      "sha256": "16adfa271b38f54914f65efdc32c6040e22b4d2dca45d7032eb72a661da2bdb1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 55,
      "updated_at": "2026-06-09T13:39:31.471Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2254": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2254",
    "title": "Self-hosting & scaling models",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2254-6f2f25c8868b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2254-6f2f25c8868b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42631,
      "sha256": "8432f5c5ecc701b4ff60bde60407eda4dbce1c7ed3a26fb6b8798c64ddd58a28",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 90,
      "updated_at": "2026-06-09T13:39:31.470Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2250": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2250",
    "title": "Deep learning in Rust with Burn 🔥",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2250-a75768474a0b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2250-a75768474a0b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37962,
      "sha256": "0f8dcecca5dd6f872ff69807f1d390d704d4e9482c968d675f4fba14b5aa55e6",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 74,
      "updated_at": "2026-06-09T13:39:31.470Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2247": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2247",
    "title": "AI's impact on developers",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2247-aa67db5e560a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2247-aa67db5e560a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 49397,
      "sha256": "17214432e95c84c4a42acc9d618a5f1ecb9c9a7b2c24ca14880ed9ae26afb8bd",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 93,
      "updated_at": "2026-06-09T13:39:31.469Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2237": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2237",
    "title": "Generative models: exploration to deployment",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2237-8596eef18a6e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2237-8596eef18a6e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42927,
      "sha256": "088b2eaef9cff4b072d14ef6cfffa6e55d1dd084d8023d0f5ac219482968e169",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 61,
      "updated_at": "2026-06-09T13:39:31.468Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2215": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2215",
    "title": "Automate all the UIs!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2215-73c54636ad86/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2215-73c54636ad86/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35610,
      "sha256": "c94aa165d3024452a7fe3f5a4779a24b88e9e70f6356840fe0228239c5320aff",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 52,
      "updated_at": "2026-06-09T13:39:31.468Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2203": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2203",
    "title": "Fine-tuning vs RAG",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2203-d92c012bdb24/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2203-d92c012bdb24/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51477,
      "sha256": "59c8f0c97d2238e8b71d98d2373c26cd6d917efbcb5f5f165861278e293b8588",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 112,
      "updated_at": "2026-06-09T13:39:31.468Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2196": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2196",
    "title": "Automating code optimization with LLMs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2196-8bec14ad4b4b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2196-8bec14ad4b4b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39159,
      "sha256": "68a42b9da9b6f596299fe6e906dee110c43cc8f132f9091646f8876cf0db5107",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 38,
      "updated_at": "2026-06-09T13:39:31.467Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2184": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2184",
    "title": "The new AI app stack",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2184-b19940d55e18/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2184-b19940d55e18/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38366,
      "sha256": "4ebacf5b537e6780ab7f45ec8b8b3389bb1f881b08c984bfb1d9e574081f08ab",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 46,
      "updated_at": "2026-06-09T13:39:31.466Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2177": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2177",
    "title": "Blueprint for an AI Bill of Rights",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2177-6c47e62c764d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2177-6c47e62c764d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36806,
      "sha256": "b93392ef3b1b3fd0cd680a51d698bcebfdba2089819ae13654587b903561a7a8",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 74,
      "updated_at": "2026-06-09T13:39:31.466Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2173": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2173",
    "title": "Vector databases (beyond the hype)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2173-e1613ab7a214/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2173-e1613ab7a214/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52856,
      "sha256": "dd3b0f82693f95ae34da44f6bb95d3b0f65ffeb0fdc6171c27d8b97d44b305a2",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 42,
      "updated_at": "2026-06-09T13:39:31.465Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2168": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2168",
    "title": "There's a new Llama in town",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2168-de036723b4a4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2168-de036723b4a4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44321,
      "sha256": "d2373f9726b31b661d8b7665e1a26cb3610fc40c76328ced94664598c88bee55",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 79,
      "updated_at": "2026-06-09T13:39:31.465Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2165": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2165",
    "title": "Legal consequences of generated content",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2165-4fbb4ca14f2f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2165-4fbb4ca14f2f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45606,
      "sha256": "a85bccec7ec1b675240aa606a985dfef3e8d6430974469fdae7b439a0394249c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 48,
      "updated_at": "2026-06-09T13:39:31.464Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2128": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2128",
    "title": "A developer's toolkit for SOTA AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2128-07756d09477a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2128-07756d09477a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46224,
      "sha256": "5a96b5433b10ee85da8f83b3a855a2a5c5a33d102bec2b3d09aee258b0ff82a7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 46,
      "updated_at": "2026-06-09T13:39:31.463Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2124": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2124",
    "title": "Cambrian explosion of generative models",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2124-3f29d2eb23da/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2124-3f29d2eb23da/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38573,
      "sha256": "787b9ae4671355cb919cc2d794d609fe122a0dcbb49fe913a9e2a507bfdf3247",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 52,
      "updated_at": "2026-06-09T13:39:31.463Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2119": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2119",
    "title": "Automated cartography using AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2119-b63d8f213ede/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2119-b63d8f213ede/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34196,
      "sha256": "173594e6110f059ace08c1e3941945096001f35c3355c05920cf8c998b9c812a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.462Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2116": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2116",
    "title": "From ML to AI to Generative AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2116-c4e957cf4b3c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2116-c4e957cf4b3c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40342,
      "sha256": "a1b62dda7a07367a9031fc9225bdb004c34f91e35ce0804047440010290945f9",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 52,
      "updated_at": "2026-06-09T13:39:31.461Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2109": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2109",
    "title": "AI trends: a Latent Space crossover",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2109-a9fa00c70544/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2109-a9fa00c70544/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 59065,
      "sha256": "bd350701e2e503a7ac6113f015840c37713a1f949114af55d264bc968f05a492",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 130,
      "updated_at": "2026-06-09T13:39:31.461Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2102": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2102",
    "title": "Accidentally building SOTA AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2102-6cf3979663e7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2102-6cf3979663e7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41415,
      "sha256": "589701cb8dbfc466ec9ba9ba9c31d21820cf7670bd5dfdc089219148913e873d",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 77,
      "updated_at": "2026-06-09T13:39:31.460Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2095": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2095",
    "title": "Controlled and compliant AI applications",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2095-0f755c64461b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2095-0f755c64461b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43708,
      "sha256": "aef46168c75fc54d8aa3670573e8d33dda82e0ae2f49d27f1b260fa7aabc852b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 35,
      "updated_at": "2026-06-09T13:39:31.459Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2085": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2085",
    "title": "Data augmentation with LlamaIndex",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2085-651013dce21e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2085-651013dce21e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47961,
      "sha256": "a2ff979563abfba0e894cecf089e190c1b70db375529e89d6f4530015618e156",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 42,
      "updated_at": "2026-06-09T13:39:31.458Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2081": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2081",
    "title": "Creating instruction tuned models",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2081-89d2d5e6ff12/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2081-89d2d5e6ff12/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 28735,
      "sha256": "d4dd0019f886a97b244214d73bafcbbd64679f31df38a7cdff40b47b1d02b54a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 54,
      "updated_at": "2026-06-09T13:39:31.457Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2074": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2074",
    "title": "The last mile of AI app development",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2074-17c87fdde132/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2074-17c87fdde132/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40203,
      "sha256": "b3eda545f12288f235971cd47c35b10889c96be995727bba632d73aec928a5ab",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 36,
      "updated_at": "2026-06-09T13:39:31.457Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2066": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2066",
    "title": "Large models on CPUs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2066-a8683c3ab31e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2066-a8683c3ab31e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37247,
      "sha256": "fe4880361b6ffc77edfc7496e81f22451009d29041caf62f80b4c833170ab389",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 28,
      "updated_at": "2026-06-09T13:39:31.456Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2061": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2061",
    "title": "Causal inference",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2061-d606f6e7ba88/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2061-d606f6e7ba88/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38101,
      "sha256": "5378adf7fcbc25c4cf8ed375bd9817c604d5d56c8c842ee191703ea81e7dae28",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.456Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2057": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2057",
    "title": "Capabilities of LLMs 🤯",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2057-2ef5e3327cd2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2057-2ef5e3327cd2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40562,
      "sha256": "4ee0ea15151bf2cbc174a67d88f37ba299fb4fdd5201c3f3376e4f5bf8faf0f7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 50,
      "updated_at": "2026-06-09T13:39:31.455Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2054": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2054",
    "title": "Computer scientists as rogue art historians",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2054-cea552135442/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2054-cea552135442/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40049,
      "sha256": "6765bddf88eac97267b51cef1c54ec50a33c798d665211711b7802b69edef720",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 57,
      "updated_at": "2026-06-09T13:39:31.455Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2048": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2048",
    "title": "Accelerated data science with a Kaggle grandmaster",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2048-28102440d282/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2048-28102440d282/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38603,
      "sha256": "1c249b2515378e461d83e268cf958f4ba8199a9baeb3c8cce2c37dcd40991b84",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 50,
      "updated_at": "2026-06-09T13:39:31.454Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2037": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2037",
    "title": "Explainable AI that is accessible for all humans",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2037-a2d1ee529d1c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2037-a2d1ee529d1c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39769,
      "sha256": "530215cca4519ebd8688b12fb1ca36f8356f4f2638e688eb3e55cc749b22264a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.453Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2029": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2029",
    "title": "AI search at You.com",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2029-c848de553048/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2029-c848de553048/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40153,
      "sha256": "e30632a9cf89e2b5d599f5692708869626acd36f6f8300417f1210b6f4afc4bc",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 39,
      "updated_at": "2026-06-09T13:39:31.453Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2024": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2024",
    "title": "End-to-end cloud compute for AI/ML",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2024-49362f74ecdb/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2024-49362f74ecdb/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45494,
      "sha256": "f9c8d78c1aaa5eb572a5a7518d9f40c572eb97c97558ce5366e679d4ebab6daf",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 48,
      "updated_at": "2026-06-09T13:39:31.452Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2018": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2018",
    "title": "Success (and failure) in prompting",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2018-a7058cf744c4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2018-a7058cf744c4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39734,
      "sha256": "791f215530cd8894ed0b06d30d3054dd0e9a10ef3e9b095597736cb9122c110f",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 72,
      "updated_at": "2026-06-09T13:39:31.452Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2015": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2015",
    "title": "Applied NLP solutions & AI education",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2015-2b38cd54a1b0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2015-2b38cd54a1b0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35296,
      "sha256": "142f41c882424f572c394987c454a17bf9a81df9bca35ffc31badda391c92736",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 23,
      "updated_at": "2026-06-09T13:39:31.451Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2008": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2008",
    "title": "Serverless GPUs",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2008-32d6187398fd/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2008-32d6187398fd/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36249,
      "sha256": "cb868295dd5dc3ab621d283f01249e1d2f658df92c312035526099168c14a20b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 59,
      "updated_at": "2026-06-09T13:39:31.451Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/2001": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/2001",
    "title": "MLOps is alive and well",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2001-c23e143105b6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-2001-c23e143105b6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 57457,
      "sha256": "d3f0f3710e8b41957dfe13832417617af1012d8bcb6dd28a056d758ace93bc54",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 135,
      "updated_at": "2026-06-09T13:39:31.450Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1994": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1994",
    "title": "3D assets & simulation at NVIDIA",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1994-7a90448c7f18/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1994-7a90448c7f18/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39608,
      "sha256": "ce99f68da20e34fa3f6a74472f3543a59e5a8e7bc381e9558cfa0236649481bb",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 58,
      "updated_at": "2026-06-09T13:39:31.449Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1991": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1991",
    "title": "GPU dev environments that just work",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1991-c1f5b82bf7c8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1991-c1f5b82bf7c8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44350,
      "sha256": "a21e2b53e057e1a2306eea34d4881046447ddc099683b9ede7bd6b59852b90ff",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 47,
      "updated_at": "2026-06-09T13:39:31.448Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1975": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1975",
    "title": "Machine learning at small organizations",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1975-05e6c7320634/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1975-05e6c7320634/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 48307,
      "sha256": "49ad709a93f1f921ddb35588b342bf4e1b1c178e9d3dc75ad8c1f6a3dff465e1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 57,
      "updated_at": "2026-06-09T13:39:31.448Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1964": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1964",
    "title": "ChatGPT goes prime time!",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1964-139bb745a621/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1964-139bb745a621/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40469,
      "sha256": "5b0a1bb29593b32e6017f7ed1ba4f6594cf509ac9ec67b0171694de3aef41542",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 54,
      "updated_at": "2026-06-09T13:39:31.447Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1959": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1959",
    "title": "NLP research by & for local communities",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1959-a9b98b9ec353/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1959-a9b98b9ec353/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34447,
      "sha256": "40bf907014c92c235267b6483c3a3093f9045fc2c1a1e5c2ef9f279d7d7d7466",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 46,
      "updated_at": "2026-06-09T13:39:31.447Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1950": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1950",
    "title": "SOTA machine translation at Unbabel",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1950-2438f33e4bf5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1950-2438f33e4bf5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 26926,
      "sha256": "c610aee9f36cef7ed2191f6bfe61028e7d52710f37e1be2f26a357cb97baae45",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.446Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1946": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1946",
    "title": "AI competitions & cloud resources",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1946-dc599b7559d6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1946-dc599b7559d6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33377,
      "sha256": "607da40123df4ee1635ea4b195f9f8a2ceaeb207fecbd53b847d3679c561de9f",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 49,
      "updated_at": "2026-06-09T13:39:31.445Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1943": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1943",
    "title": "Copilot lawsuits & Galactica \"science\"",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1943-8abf6934938e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1943-8abf6934938e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37363,
      "sha256": "50b18428b9b0fcdd66eed61971cbd40d9b5bd17dfa0a3210229fe09a128f7a54",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 51,
      "updated_at": "2026-06-09T13:39:31.444Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1937": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1937",
    "title": "Protecting us with the Database of Evil",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1937-87e521a724a2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1937-87e521a724a2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45502,
      "sha256": "48e4704ee0dd61ef6f4a6e85f87e1dfaac1bd620b6c4c26779aa08d1272a1da6",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.443Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1930": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1930",
    "title": "Hybrid computing with quantum processors",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1930-cae8d7fede3c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1930-cae8d7fede3c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37244,
      "sha256": "b6e5744814c8b8e01f2befd9b5e1bc16a40ca2fecb2110bf1ce1dc0cd10557d6",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 36,
      "updated_at": "2026-06-09T13:39:31.443Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1925": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1925",
    "title": "The practicalities of releasing models",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1925-38c888ee41ec/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1925-38c888ee41ec/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 33119,
      "sha256": "ab983f9b0fcb2174b600119fdbcecc6a5133d57ae447ec9e0ff49e42cea32d56",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 67,
      "updated_at": "2026-06-09T13:39:31.442Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1883": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1883",
    "title": "AI adoption in large, well-established companies",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1883-8b4215bbb1b7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1883-8b4215bbb1b7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 27870,
      "sha256": "2a9a54c61808376adf796cded197902eec1b3298c8042dc9a988ddb158dd7208",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 24,
      "updated_at": "2026-06-09T13:39:31.442Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1878": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1878",
    "title": "Data for All",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1878-7243b2728b5d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1878-7243b2728b5d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 46316,
      "sha256": "5fbbba2a8d3787875a4f67359c175cb1d33e32e259f647dfec242a694a3c2b66",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 66,
      "updated_at": "2026-06-09T13:39:31.441Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1872": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1872",
    "title": "What's up, DocQuery?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1872-c4f029165c12/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1872-c4f029165c12/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39416,
      "sha256": "1600bca3d2ec502406ebabe72d565f0d6e5a0e56efa504d9f279922155f9077a",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.440Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1860": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1860",
    "title": "Production data labeling workflows",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1860-8d92c0f486f2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1860-8d92c0f486f2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 25789,
      "sha256": "c0dd2b52a6bde1b822beb7fec077e987b232c06009b7f904bc51f7c2c877730b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 30,
      "updated_at": "2026-06-09T13:39:31.440Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1849": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1849",
    "title": "Evaluating models without test data",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1849-c37122e74143/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1849-c37122e74143/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47437,
      "sha256": "571b70c98ce84b4129bb9b202a6486d60571d05aa1de66d235e050858b905d27",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 51,
      "updated_at": "2026-06-09T13:39:31.439Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1841": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1841",
    "title": "Stable Diffusion",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1841-c6de7ccbbf0c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1841-c6de7ccbbf0c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37582,
      "sha256": "7567a60b6999d62a07d099aca286cd577e10fcb0baadc178702758b777117a2d",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 47,
      "updated_at": "2026-06-09T13:39:31.438Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1834": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1834",
    "title": "Licensing & automating creativity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1834-6a88289fb2d4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1834-6a88289fb2d4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38489,
      "sha256": "cbf2c0d63a62973da9f7ed944b047dc89f2e1148554c00a768a8872635bee088",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 73,
      "updated_at": "2026-06-09T13:39:31.437Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1815": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1815",
    "title": "Privacy in the age of AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1815-284a5115b626/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1815-284a5115b626/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37561,
      "sha256": "b4bfd698e197ebc524f3bb3486f90dfe5e6cd09f83563554b2426975b0b83b5e",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 38,
      "updated_at": "2026-06-09T13:39:31.436Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1814": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1814",
    "title": "Practical, positive uses for deep fakes",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1814-9d28bb0681bc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1814-9d28bb0681bc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35095,
      "sha256": "eea0a6c71f503a5a81f2f8286e7220ad075e1a7886b6bf3f2d0e5acec61c6430",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 39,
      "updated_at": "2026-06-09T13:39:31.436Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1807": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1807",
    "title": "CMU's AI pilot lands in the news 🗞",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1807-6a10b8bcd1c1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1807-6a10b8bcd1c1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35978,
      "sha256": "2e3d354612d9f730a7512260d858c57b951687ad4df0c0b9cbcad3c1bc727cba",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 44,
      "updated_at": "2026-06-09T13:39:31.436Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1798": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1798",
    "title": "AlphaFold is revolutionizing biology",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1798-c65f644d0a1a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1798-c65f644d0a1a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39690,
      "sha256": "08c77ffe31424a163dafb24d3a9f59886f9a780752977c7c511dafcf5f9f25d4",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 52,
      "updated_at": "2026-06-09T13:39:31.435Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1792": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1792",
    "title": "AI IRL & Mozilla's Internet Health Report",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1792-72f25cf2bbc7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1792-72f25cf2bbc7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37405,
      "sha256": "186179883655f4711d282785d24fc5b246b4f2165df208790152d282882f272c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.435Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1753": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1753",
    "title": "The geopolitics of artificial intelligence",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1753-22f60aa55daa/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1753-22f60aa55daa/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39945,
      "sha256": "ac1625816fb6f783d4109d1a51b60bead4997a3c823309e1e581eb446c371983",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 60,
      "updated_at": "2026-06-09T13:39:31.434Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1716": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1716",
    "title": "DALL-E is one giant leap for raccoons! 🔭",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1716-a7f1e2ce9bca/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1716-a7f1e2ce9bca/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35166,
      "sha256": "8c02242fc988c60c4eacbe15784ccab516b9a5392ae01cb3d873f4fbb8486222",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 61,
      "updated_at": "2026-06-09T13:39:31.434Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1712": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1712",
    "title": "Cloning voices with Coqui",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1712-dcdd5b2aa270/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1712-dcdd5b2aa270/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 44733,
      "sha256": "f652a3ed968cc178b67361e55a2a63f8ba60cf610660bf84237bc76be66777f4",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 57,
      "updated_at": "2026-06-09T13:39:31.433Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1694": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1694",
    "title": "AI's role in reprogramming immunity",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1694-e3e8061b9f29/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1694-e3e8061b9f29/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43340,
      "sha256": "0aace6b432b6e78cd9a569710e68473892be4a7e6a0d7caebef7a06c97d86762",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 42,
      "updated_at": "2026-06-09T13:39:31.432Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1684": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1684",
    "title": "Machine learning in your database",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1684-72d6b9d74cda/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1684-72d6b9d74cda/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47579,
      "sha256": "ef762b67116faa477378722f982006351cc0ce57bca1f767b328c817e33c3ac2",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 44,
      "updated_at": "2026-06-09T13:39:31.432Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1673": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1673",
    "title": "Digital humans & detecting emotions",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1673-6b75da58d18b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1673-6b75da58d18b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37484,
      "sha256": "8ceeee119651941aec5906e15d9f159a6a262c3f7eec2d37050833a7e0b8e49e",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 98,
      "updated_at": "2026-06-09T13:39:31.431Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1670": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1670",
    "title": "Generalist models & Iceman's voice",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1670-84449bb5fc5e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1670-84449bb5fc5e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36237,
      "sha256": "72dbb219daa674b7d686b4b3ab3ff6e2923689973cba20abf6da30e71d8a8976",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 79,
      "updated_at": "2026-06-09T13:39:31.430Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1664": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1664",
    "title": "🤗 The AI community building the future",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1664-59b5ea16cfe5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1664-59b5ea16cfe5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37308,
      "sha256": "1c055cb3b2a2feb897deed80c79e43c6f219035e8a5cb4e3430d3b9d2608132c",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 33,
      "updated_at": "2026-06-09T13:39:31.429Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1658": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1658",
    "title": "Active learning & endangered languages",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1658-43f50a3ca6c7/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1658-43f50a3ca6c7/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 52631,
      "sha256": "56822a854fb46c3ad3d18095cd880a9e69c99070d34c101bdcba9998abe03147",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 74,
      "updated_at": "2026-06-09T13:39:31.429Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1642": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1642",
    "title": "Learning the language of life",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1642-b8ac137f7962/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1642-b8ac137f7962/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 47199,
      "sha256": "8d9c306ba69168d22a890c7e05ec4acb66c8406159aa1ba8f1c1fc58be8863ca",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.428Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1640": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1640",
    "title": "MLOps is NOT Real",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1640-5f49fb76ad45/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1640-5f49fb76ad45/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45584,
      "sha256": "44f839beb98b69b62f2a649a0551b76ad20203f9061a3de51e9042b890ac54c7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 51,
      "updated_at": "2026-06-09T13:39:31.428Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1638": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1638",
    "title": "🌍 AI in Africa - Agriculture",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1638-16c321d76f52/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1638-16c321d76f52/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39533,
      "sha256": "7860b9d30d141cd0678c7717ce2ab89276764d838e29d707db348b6cabb5c2c1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 34,
      "updated_at": "2026-06-09T13:39:31.427Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1623": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1623",
    "title": "Quick, beautiful web UIs for ML apps",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1623-1453a11ad281/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1623-1453a11ad281/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 43438,
      "sha256": "bd20990fe1ab97656c436446e433bef3250328bc7de48213ef62de04c3b69342",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 55,
      "updated_at": "2026-06-09T13:39:31.426Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1613": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1613",
    "title": "It's been a BIG week in AI news 🗞",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1613-97255f107e0d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1613-97255f107e0d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39242,
      "sha256": "3fa2022d113a4a3add139b78318e6ed44b57d62c7c2614d24086b42b772b0a40",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 152,
      "updated_at": "2026-06-09T13:39:31.426Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1610": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1610",
    "title": "\"Foundation\" models",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1610-5504fbf255be/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1610-5504fbf255be/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36791,
      "sha256": "370e6e78edcecd85fdcbfde7339dab228fcb1690e4466fde23e96dbb24607216",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 71,
      "updated_at": "2026-06-09T13:39:31.425Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1607": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1607",
    "title": "Clothing AI in a data fabric",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1607-b8c338aab81e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1607-b8c338aab81e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 39756,
      "sha256": "ce875a69597182a7cdc800c83ae9e486dbdee04c956cce1ee02bf7cbf7e541c1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 77,
      "updated_at": "2026-06-09T13:39:31.424Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1604": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1604",
    "title": "Creating a culture of innovation",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1604-08c62cd81278/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1604-08c62cd81278/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 45026,
      "sha256": "0e74b02bce13b6742745d48797825c59cc41bb96d75e4b69a5042096a45e3277",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 37,
      "updated_at": "2026-06-09T13:39:31.424Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1598": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1598",
    "title": "Deploying models (to tractors 🚜)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1598-121bd1564753/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1598-121bd1564753/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42692,
      "sha256": "467c7bd2a0d727788ef8311ef4dc7c6677d7b0c335632e0d9311163722293830",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 66,
      "updated_at": "2026-06-09T13:39:31.423Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1588": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1588",
    "title": "One algorithm to rule them all?",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1588-8514959dda70/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1588-8514959dda70/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 37977,
      "sha256": "c61d78558ed983bb470794611b4d99d751d662ce447239b9acca4e9191f43cc6",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 112,
      "updated_at": "2026-06-09T13:39:31.423Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1584": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1584",
    "title": "🌍 AI in Africa - Voice & language tools",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1584-9c6d5f09830e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1584-9c6d5f09830e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36160,
      "sha256": "7ca4b460dcdeb54567a243884b4d4dbe0b1c1f56b7fa94c4a6ed2af02f4927b1",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 27,
      "updated_at": "2026-06-09T13:39:31.422Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1568": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1568",
    "title": "Exploring deep reinforcement learning",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1568-c5f689159fd8/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1568-c5f689159fd8/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 35661,
      "sha256": "3d5bf115fee392b284226f2c205bd896acbc397c95e229fecceb6f5151d8430b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 45,
      "updated_at": "2026-06-09T13:39:31.421Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1564": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1564",
    "title": "The world needs an AI superhero",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1564-3144ba8d4d9c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1564-3144ba8d4d9c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 34891,
      "sha256": "44426a6cfda467a4691d6e052c0c5c4f7f3c64d61f5fe54c86249201c4e3e5b7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 59,
      "updated_at": "2026-06-09T13:39:31.420Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1560": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1560",
    "title": "Democratizing ML for speech",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1560-5a54e3a0e890/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1560-5a54e3a0e890/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 38919,
      "sha256": "616c45b8b8e59d740644b1a5b6e78b5fbd6cacea66ad22b76fe17bd57840af7b",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 56,
      "updated_at": "2026-06-09T13:39:31.420Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1554": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1554",
    "title": "Eliminate AI failures",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1554-4cd76d047322/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1554-4cd76d047322/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 36681,
      "sha256": "3a5364119fbf128e435aac73ceeb2b28c000a48f567028bdea95b78b631e1835",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 41,
      "updated_at": "2026-06-09T13:39:31.419Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1552": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1552",
    "title": "🌍 AI in Africa - Radiant Earth",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1552-9d3c4c7a9287/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1552-9d3c4c7a9287/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 40778,
      "sha256": "fd6ade538fd192ef45c06dc3bc1bcac52fb05f316994702f72859dc8493cdaf5",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 36,
      "updated_at": "2026-06-09T13:39:31.418Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1546": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1546",
    "title": "OpenAI and Hugging Face tooling",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1546-51bd7ec5a24a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1546-51bd7ec5a24a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42066,
      "sha256": "831f86e7eede367fdba414aa681485c81320a12804a05fec78e99dc3de86b453",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 88,
      "updated_at": "2026-06-09T13:39:31.418Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "practical-ai/changelog.com/7/1545": {
    "source_id": "practical-ai",
    "episode_id": "changelog.com/7/1545",
    "title": "Friendly federated learning 🌼",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1545-aa8780aa91d5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/practical-ai-e7f7e11e44de/changelog-com-7-1545-aa8780aa91d5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 41729,
      "sha256": "703a5bdee63c0b9ac4cc32de708b2bbbd3e50537167dd7a01cc88fa7631ff6b7",
      "source_kind": "official_changelog_transcript",
      "source_quality": "official_transcript",
      "record_count": 32,
      "updated_at": "2026-06-09T13:39:31.417Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/6a13923cfe904f3873c51d2b": {
    "source_id": "silicon-valley-101",
    "episode_id": "6a13923cfe904f3873c51d2b",
    "title": "E238｜聊聊Harness时代AI-First的组织架构：从信任人到信任AI",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/6a13923cfe904f3873c51d2b-8465770d76a0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/6a13923cfe904f3873c51d2b-8465770d76a0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84333,
      "sha256": "0d3f391eb87aa1d2d219edf324cce6ba1fe1f5362938495b212816fa1830bd62",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 481,
      "updated_at": "2026-06-09T13:39:31.548Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/6a0e4c4021e40bb435e4a53b": {
    "source_id": "silicon-valley-101",
    "episode_id": "6a0e4c4021e40bb435e4a53b",
    "title": "E237｜央视和FIFA谈判纷争背后，体育赛事转播权的博弈与生意",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/6a0e4c4021e40bb435e4a53b-bbecf6f0acc9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/6a0e4c4021e40bb435e4a53b-bbecf6f0acc9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 111502,
      "sha256": "fa10d2ae3364e3db2e319ea5ae89143e7b3231709bce7e18bf563e0bfa36ac3d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1229,
      "updated_at": "2026-06-09T13:39:31.546Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/6a0663649ea0a02f5ed5182e": {
    "source_id": "silicon-valley-101",
    "episode_id": "6a0663649ea0a02f5ed5182e",
    "title": "E236｜99%的作业都是AI写的：当代名校生眼里，大学还剩下什么？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/6a0663649ea0a02f5ed5182e-c52b10b3af7c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/6a0663649ea0a02f5ed5182e-c52b10b3af7c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 131074,
      "sha256": "bb94af566b1ce56b9b1dc5e9ab68c7b1f0b8f1f0a776ef8ec91b932f61ae9b98",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1330,
      "updated_at": "2026-06-09T13:39:31.545Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69fe7a01140504ded81abb90": {
    "source_id": "silicon-valley-101",
    "episode_id": "69fe7a01140504ded81abb90",
    "title": "E235｜20年内CAR-T治愈癌症？与刘诚博士聊聊癌症治疗的底层哲学",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69fe7a01140504ded81abb90-ec86985c4cce/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69fe7a01140504ded81abb90-ec86985c4cce/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100176,
      "sha256": "9bc4dc6ab80a47dd0f7470cd5d327e9fa81aca618fade2222c167e699c6339e2",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 916,
      "updated_at": "2026-06-09T13:39:31.544Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69e8652f7992995028a2855d": {
    "source_id": "silicon-valley-101",
    "episode_id": "69e8652f7992995028a2855d",
    "title": "E234｜未来实拍电影还存在吗？与导演陆川聊聊AI给影视人的恐惧与自由",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69e8652f7992995028a2855d-38d747377b73/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69e8652f7992995028a2855d-38d747377b73/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 51128,
      "sha256": "04c46b473e1763d7e24c124cf54c561385192c158175b993b1ccb77db0624526",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 460,
      "updated_at": "2026-06-09T13:39:31.543Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69e1793c1c446d3a0f943495": {
    "source_id": "silicon-valley-101",
    "episode_id": "69e1793c1c446d3a0f943495",
    "title": "E233｜硅谷右翼的权力网如何形成？聊聊彼得·蒂尔的思想启蒙拼图",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69e1793c1c446d3a0f943495-1ae908b89a42/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69e1793c1c446d3a0f943495-1ae908b89a42/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 73160,
      "sha256": "f4f86e3bc1b89d2e74c6f3a0efad72a94aec63cb664c5107792c1f00efd20cab",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 641,
      "updated_at": "2026-06-09T13:39:31.542Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69d83d8ff6e591a7ac54d0d2": {
    "source_id": "silicon-valley-101",
    "episode_id": "69d83d8ff6e591a7ac54d0d2",
    "title": "E232｜餐饮出海有新招儿吗？从鼎泰丰与贡茶拿下美国初代销冠聊起",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69d83d8ff6e591a7ac54d0d2-6bc91acef318/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69d83d8ff6e591a7ac54d0d2-6bc91acef318/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 103222,
      "sha256": "6c076a89b60de552330a304adfa282d67cdfe1dd22c931262b7552b196c0c676",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1072,
      "updated_at": "2026-06-09T13:39:31.539Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69cc6100d5fbbf50d3c2d34c": {
    "source_id": "silicon-valley-101",
    "episode_id": "69cc6100d5fbbf50d3c2d34c",
    "title": "E231｜从B2B到A2A：Agent新基建，如何让“一人企业”做全球生意？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69cc6100d5fbbf50d3c2d34c-cca930fa2583/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69cc6100d5fbbf50d3c2d34c-cca930fa2583/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 91697,
      "sha256": "66a89d075521aab130f63d53f7ce80ed8f086b30e1cc813bdb849153d1580e51",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 853,
      "updated_at": "2026-06-09T13:39:31.538Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69c477e9abc3dc8807b8ca2d": {
    "source_id": "silicon-valley-101",
    "episode_id": "69c477e9abc3dc8807b8ca2d",
    "title": "E230｜1万亿收入预期背后：英伟达的巅峰与软肋",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69c477e9abc3dc8807b8ca2d-d151c0991215/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69c477e9abc3dc8807b8ca2d-d151c0991215/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 103309,
      "sha256": "77565e75dd48ad176b6bbfcf9a57e741a990a8faba69c3f2b5af5d72a91b75f9",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 988,
      "updated_at": "2026-06-09T13:39:31.537Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69bc8f3e21b3b2db21bd65d7": {
    "source_id": "silicon-valley-101",
    "episode_id": "69bc8f3e21b3b2db21bd65d7",
    "title": "E229｜从手工作坊到全球第一：中国动力电池逆袭史",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69bc8f3e21b3b2db21bd65d7-e19dc644157b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69bc8f3e21b3b2db21bd65d7-e19dc644157b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 98987,
      "sha256": "0d3813430413bb1ba0909f7e5d75e496c0bf7536ad5e48d1649681d2576162e4",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 981,
      "updated_at": "2026-06-09T13:39:31.516Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69b35445dc0cc48a76772b57": {
    "source_id": "silicon-valley-101",
    "episode_id": "69b35445dc0cc48a76772b57",
    "title": "E228｜谷歌TPU能撼动英伟达吗？前TPU工程师首次揭秘",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69b35445dc0cc48a76772b57-09f90fd0cc29/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69b35445dc0cc48a76772b57-09f90fd0cc29/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 84000,
      "sha256": "bf9205d3473e9a79a084cd2c248cff450b42e44d7f4dd448fe503ebd6ce5ae6b",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 597,
      "updated_at": "2026-06-09T13:39:31.515Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69a77745f44b398f59390e48": {
    "source_id": "silicon-valley-101",
    "episode_id": "69a77745f44b398f59390e48",
    "title": "E227｜美国医疗市场AI争夺战：巨头押注，创业公司能赢吗？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69a77745f44b398f59390e48-74fbdb75344d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69a77745f44b398f59390e48-74fbdb75344d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 88839,
      "sha256": "1d24364c66dcb86ea992cf09ea9c2d159ecbcf582101d30b21a00b4dff1a8fa8",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 711,
      "updated_at": "2026-06-09T13:39:31.514Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/699f8dc4ff5fd5761ab49c2a": {
    "source_id": "silicon-valley-101",
    "episode_id": "699f8dc4ff5fd5761ab49c2a",
    "title": "E226｜聊聊DeepMind创始人哈萨比斯：一个科学家与失控的AI竞赛",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/699f8dc4ff5fd5761ab49c2a-17e2c9135ce4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/699f8dc4ff5fd5761ab49c2a-17e2c9135ce4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 120326,
      "sha256": "62625e52ca568d7e2f8622ef6a14a0275111e835424d3fa60941eac0418cedfe",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1360,
      "updated_at": "2026-06-09T13:39:31.513Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/698fbbc62cbb0d7f6e4ae7e7": {
    "source_id": "silicon-valley-101",
    "episode_id": "698fbbc62cbb0d7f6e4ae7e7",
    "title": "E225｜SaaS业数千亿市值蒸发：AI如何变革组织架构？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/698fbbc62cbb0d7f6e4ae7e7-3a9cdc6a79e5/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/698fbbc62cbb0d7f6e4ae7e7-3a9cdc6a79e5/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 93343,
      "sha256": "62090f792db6c70afd40d35fbd7e9bff64b5bc613ec4922c0dfaa3b4ca99127a",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1056,
      "updated_at": "2026-06-09T13:39:31.513Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "silicon-valley-101/69828c85a712301410e31643": {
    "source_id": "silicon-valley-101",
    "episode_id": "69828c85a712301410e31643",
    "title": "E224｜深度拆解Clawdbot，为何它能成为2026年第一个现象级产品？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/silicon-valley-101-e5e498ac694c/69828c85a712301410e31643-a8bcf2a93ef3/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/silicon-valley-101-e5e498ac694c/69828c85a712301410e31643-a8bcf2a93ef3/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 119731,
      "sha256": "586436720a0f28bd1b85a5f9c240c1a4d47bacb05d96414949fcdd12fc05713d",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1039,
      "updated_at": "2026-06-09T13:39:31.512Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/67f7e9bfbb8fcfee75cafd9d": {
    "source_id": "ted-ai-show",
    "episode_id": "67f7e9bfbb8fcfee75cafd9d",
    "title": "Trends for 2025: AI x Crypto - From Agents in Games & DePIN to Proof of Personhood and More | web3 with a16z crypto",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/67f7e9bfbb8fcfee75cafd9d-d6b4fa23af09/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/67f7e9bfbb8fcfee75cafd9d-d6b4fa23af09/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54671,
      "sha256": "72246a7b86ef87375ed6c95975ac79447a900421b7b1578b827024237b288587",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.569Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/67f01e45d4b40d7b30b861f5": {
    "source_id": "ted-ai-show",
    "episode_id": "67f01e45d4b40d7b30b861f5",
    "title": "The magic intelligence in the sky | Good Robot",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/67f01e45d4b40d7b30b861f5-090a77a5951c/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/67f01e45d4b40d7b30b861f5-090a77a5951c/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54602,
      "sha256": "5a55e650aa759bb32aa7b579e99094c756b548a16a8c76bc17d7d005425f47e6",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.569Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/678fe5f2d186489b148af8a4": {
    "source_id": "ted-ai-show",
    "episode_id": "678fe5f2d186489b148af8a4",
    "title": "How Pokemon Go and augmented reality are transforming how we’ll navigate the world w/ Niantic's Brian McClendon",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/678fe5f2d186489b148af8a4-53cece918511/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/678fe5f2d186489b148af8a4-53cece918511/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54669,
      "sha256": "f1edbb5c12e8fe6b49dd780b633eb1a943bf8700b23e099e2e5abc00fd9dc114",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.568Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/6760c9f027740406d8387653": {
    "source_id": "ted-ai-show",
    "episode_id": "6760c9f027740406d8387653",
    "title": "How AI digital doppelgängers could change the way we communicate w/ Synthesia CEO Victor Riparbelli",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/6760c9f027740406d8387653-7fd3d6c1b698/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/6760c9f027740406d8387653-7fd3d6c1b698/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54656,
      "sha256": "b0e03df38d431ed8fb39128e6e9a205f689bd667198dfa8257739685df9ee148",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.567Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000679819911": {
    "source_id": "ted-ai-show",
    "episode_id": "1000679819911",
    "title": "Could AI really achieve consciousness? w/ neuroscientist Anil Seth",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000679819911-4a3dd82e859d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000679819911-4a3dd82e859d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54600,
      "sha256": "4ec72b5ae589fd72aab6eeb0ace7a63794a1e8cb4acb1e659261bd8076809683",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.567Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000678966760": {
    "source_id": "ted-ai-show",
    "episode_id": "1000678966760",
    "title": "How AI robots learn just like babies — but a million times faster w/ NVIDIA’s Rev Lebaredian",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000678966760-b6d6d9866934/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000678966760-b6d6d9866934/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54630,
      "sha256": "05d3fb8ae03a763cd70ddc22e8a4a79d2fa2acc98df47305d575b43bc147f985",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.566Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000677370904": {
    "source_id": "ted-ai-show",
    "episode_id": "1000677370904",
    "title": "Building an AI creator community w/ Civitai founders Justin Maier and Maxfield Hulker",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000677370904-30bf6fa4bf07/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000677370904-30bf6fa4bf07/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54619,
      "sha256": "15fad3a8279e081128127342b46ef3b3c138d75822da13294898cb944db27bf0",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.566Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000676550420": {
    "source_id": "ted-ai-show",
    "episode_id": "1000676550420",
    "title": "An AI chatbot that talks back w/ ChatGPT’s Advanced Voice Mode",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000676550420-badcf461b00e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000676550420-badcf461b00e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54598,
      "sha256": "6bafee4946c1b0bf5c6adcecddd375f2e745373f79b420c3c22c7343d329b355",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.565Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000675674639": {
    "source_id": "ted-ai-show",
    "episode_id": "1000675674639",
    "title": "How AI is changing national security w/ Kathleen Fisher",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000675674639-3187bad9827f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000675674639-3187bad9827f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54589,
      "sha256": "1f837164dfad4d2ec858c26c5d109fea5998bafcb60cdb1b75563c40444cb719",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.564Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000674764468": {
    "source_id": "ted-ai-show",
    "episode_id": "1000674764468",
    "title": "How open-source AI will reshape power dynamics in tech w/ Hugging Face CSO Thomas Wolf",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000674764468-f9938ec6e069/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000674764468-f9938ec6e069/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54620,
      "sha256": "e0f353ff5cc97ed71dee4e2ada76d4e05269793124c7b193a153c17774ce48b7",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.564Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000673921443": {
    "source_id": "ted-ai-show",
    "episode_id": "1000673921443",
    "title": "How AI is changing who gets hired – and who doesn’t w/ Hilke Schellmann",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000673921443-e9b91c901dd6/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000673921443-e9b91c901dd6/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54609,
      "sha256": "adfca60cb62f5170c79f85fdc224b24968560bd94d2ff996f9675fa99fc7d651",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.563Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000673080771": {
    "source_id": "ted-ai-show",
    "episode_id": "1000673080771",
    "title": "How Meta wants to shape our digital future with open source AI w/ Ragavan Srinivasan",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000673080771-23d5555a6f39/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000673080771-23d5555a6f39/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54618,
      "sha256": "fc7a4413096b7f222e34da28ad9607aebaa35798c6a0906fcc071aeda94ffec5",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.562Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000672142618": {
    "source_id": "ted-ai-show",
    "episode_id": "1000672142618",
    "title": "Is Google’s reign over? The future of AI search w/ Perplexity CEO Aravind Srinivas",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000672142618-ce2c29ad1906/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000672142618-ce2c29ad1906/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54618,
      "sha256": "b31ee88342244942c42e59f8c7f258430386f699cddfc1776ee08f304b486c15",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.562Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000671352075": {
    "source_id": "ted-ai-show",
    "episode_id": "1000671352075",
    "title": "How AI will transform dubbing in Hollywood w/ Scott Mann",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000671352075-07fd307b5e34/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000671352075-07fd307b5e34/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54590,
      "sha256": "86a17c4e1efd6276ebcc924a412d5f82c73121fc7970f7df7eb006da4b6929c9",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.561Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000670438780": {
    "source_id": "ted-ai-show",
    "episode_id": "1000670438780",
    "title": "Your right to mental privacy in the age of brain-sensing tech (from TED Talks Daily)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000670438780-240da239f69d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000670438780-240da239f69d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54618,
      "sha256": "409995790657665fbfc8289ebe15aee12869af262cf6aa3e23ba49382227c70f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.560Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000670059144": {
    "source_id": "ted-ai-show",
    "episode_id": "1000670059144",
    "title": "The UN is speaking up about AI — here’s what they’re saying (w/ Ian Bremmer)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000670059144-eac9ab04e879/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000670059144-eac9ab04e879/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54616,
      "sha256": "0f03f02b88ec111f8c34de945c08eb23e95e3291cc7771543a798d8aba455bc1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.560Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000669737018": {
    "source_id": "ted-ai-show",
    "episode_id": "1000669737018",
    "title": "Humanity’s first AI election w/ WIRED's Vittoria Elliott",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000669737018-2b3a7f3f8c80/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000669737018-2b3a7f3f8c80/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54592,
      "sha256": "37e773cf27f4b98488b774f0ebc1ee26cea5f01cfca8cd37b107ead50f1cfdc2",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.559Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000668932233": {
    "source_id": "ted-ai-show",
    "episode_id": "1000668932233",
    "title": "Can AI read your mind? The battle for your brain w/ Nita Farahany",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000668932233-34c59771fde2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000668932233-34c59771fde2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54599,
      "sha256": "16cb1e065a0e40fd1910aaf018927c14b2e8b81e1993b863fcca5d7d67835584",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.559Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000667517653": {
    "source_id": "ted-ai-show",
    "episode_id": "1000667517653",
    "title": "Can AI predict (and control) the weather? w/ Dion Harris and Tapio Schneider",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000667517653-0304c8b39bad/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000667517653-0304c8b39bad/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54610,
      "sha256": "3e6cbeb92cadf39c46184b44ebad22f777e0d9311cd581ac1fb5de52dab27e81",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.558Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000666668757": {
    "source_id": "ted-ai-show",
    "episode_id": "1000666668757",
    "title": "Sal Khan says AI won’t destroy education — but there’s a catch",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000666668757-0a0aecea01e0/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000666668757-0a0aecea01e0/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 42728,
      "sha256": "e8496a046a6a874926cfdee25eb4aedffd705693e2e79c3a29c0b5e5b87afce1",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 55,
      "updated_at": "2026-06-09T13:39:31.558Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000665071399": {
    "source_id": "ted-ai-show",
    "episode_id": "1000665071399",
    "title": "How to make yourself more human in an automated world (from How to Be a Better Human)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000665071399-4cbf145eeb75/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000665071399-4cbf145eeb75/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54619,
      "sha256": "9a2dc7bfe9e333bb574814cddd6d5b8376430876b9a501761a8b1dc40637a57a",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.557Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000664407700": {
    "source_id": "ted-ai-show",
    "episode_id": "1000664407700",
    "title": "Why AI needs a \"nutrition label\" (from TED Talks Daily)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000664407700-3c26e43cab46/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000664407700-3c26e43cab46/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54589,
      "sha256": "76f3cb6f9049d7756ee975fb310f4e5d9827adbc9d2037d1b06515c3f5428a1f",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.557Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000663721027": {
    "source_id": "ted-ai-show",
    "episode_id": "1000663721027",
    "title": "will.i.am on AI – and the future of creativity (from ReThinking with Adam Grant)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000663721027-73c9fe48740f/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000663721027-73c9fe48740f/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54616,
      "sha256": "e21082512a0a9a037f593eeb1ba82f8abd011fd05c91443e2173352e4277cace",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.556Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000663022739": {
    "source_id": "ted-ai-show",
    "episode_id": "1000663022739",
    "title": "Will AI replace me? with AJ. Jacobs (from Fixable)",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000663022739-f8362b2e21d2/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000663022739-f8362b2e21d2/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54584,
      "sha256": "4dbf4da7d39e3bd2c0bc0e548b35ca27618e7418fc37221466110f74f9e96ebd",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.555Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000662040933": {
    "source_id": "ted-ai-show",
    "episode_id": "1000662040933",
    "title": "The AI-powered tools supercharging your imagination",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000662040933-69928f765b87/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000662040933-69928f765b87/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54585,
      "sha256": "b5859efa73318ab6df28740b1c9e9b1256aafc1ebc75853cf56354a8d57d1c3c",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.554Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000661575998": {
    "source_id": "ted-ai-show",
    "episode_id": "1000661575998",
    "title": "Is AI just all hype? w/ Gary Marcus",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000661575998-ac889c7ae890/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000661575998-ac889c7ae890/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54569,
      "sha256": "639b89510c223ac930ec91dfbbdaf56c67dce8849fce452c845638f4497e72da",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.553Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000660919730": {
    "source_id": "ted-ai-show",
    "episode_id": "1000660919730",
    "title": "Will AI “eat software” — and what’ll happen to coders? w/ GitHub CEO Thomas Dohmke",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000660919730-5e5526443257/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000660919730-5e5526443257/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54624,
      "sha256": "5dbdc710ba741cf9e2ea3c058d614330f5c8d6aeb3d239c13295f1533717b405",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.553Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000660096361": {
    "source_id": "ted-ai-show",
    "episode_id": "1000660096361",
    "title": "AI therapy is here. What does it mean for you? w/ Dr. Alison Darcy and Brian Chandler",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000660096361-eb9912c09ba1/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000660096361-eb9912c09ba1/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54619,
      "sha256": "523eadf98642d8e41973f0ffae8821ac46fb38e6bd8bf46ec1bf01cee509ce0e",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.552Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000659301098": {
    "source_id": "ted-ai-show",
    "episode_id": "1000659301098",
    "title": "Your next best friend may be 100% AI w/ Purnendu Mukherjee",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000659301098-4b31c2e449a4/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000659301098-4b31c2e449a4/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54592,
      "sha256": "a6ec033347c31944b93887dcecdbf322d5c86c518f3c42940471ac8a032e01df",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.552Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000658491012": {
    "source_id": "ted-ai-show",
    "episode_id": "1000658491012",
    "title": "Why we can't fix bias with more AI w/ Patrick Lin",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000658491012-4ba99e846e54/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000658491012-4ba99e846e54/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54583,
      "sha256": "4769df24f5582fdad5316d311e71af484e8c6db6900a6aae75a915bf881b82dc",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.551Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000657694855": {
    "source_id": "ted-ai-show",
    "episode_id": "1000657694855",
    "title": "AI may take jobs – but not our creativity w/ artist Claire Silver",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000657694855-17f106e2cb95/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000657694855-17f106e2cb95/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54601,
      "sha256": "2a0a6ca62da60a92f39e2eaca0ce63cb171fc9248de4917a7a2feb9256467260",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.551Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000657049960": {
    "source_id": "ted-ai-show",
    "episode_id": "1000657049960",
    "title": "What really went down at OpenAI and the future of regulation w/ Helen Toner",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000657049960-32cdf7b107cc/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000657049960-32cdf7b107cc/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 54609,
      "sha256": "f44fe0535010c929568a7409360b14ddb1bdd482b6850f79bbd47326593bc69b",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 105,
      "updated_at": "2026-06-09T13:39:31.550Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "ted-ai-show/1000655951231": {
    "source_id": "ted-ai-show",
    "episode_id": "1000655951231",
    "title": "Is AI destroying our sense of reality? with Sam Gregory",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/ted-ai-show-aed827905671/1000655951231-ab7bd28296df/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/ted-ai-show-aed827905671/1000655951231-ab7bd28296df/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 29641,
      "sha256": "5b02e9cde17f92f6fc64dec8df287949ba5421d8e89489ff34cdd6aa3594c733",
      "source_kind": "official_web_transcript",
      "source_quality": "official_transcript",
      "record_count": 27,
      "updated_at": "2026-06-09T13:39:31.549Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6a170f747460cabdeb56dabb": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6a170f747460cabdeb56dabb",
    "title": "143. 对何小鹏的第二次访谈：更大赌注、人形机器人Iron诞生、那场意外、技术剧变下CEO、GX和缝合怪",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a170f747460cabdeb56dabb-1f4e21e3c87d/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a170f747460cabdeb56dabb-1f4e21e3c87d/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 135038,
      "sha256": "7ce461435d0c5fd85e76100ef93393577aee7b86049eddf0f90506bc9bdfc92f",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1625,
      "updated_at": "2026-06-09T13:39:31.587Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6a15a2cbff7b9a8c0a5b953f": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6a15a2cbff7b9a8c0a5b953f",
    "title": "142. 雨森的创投观察第2集：Harness、下一个字节、2026大机会和Stanley Druckenmiller",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a15a2cbff7b9a8c0a5b953f-7f08739fee38/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a15a2cbff7b9a8c0a5b953f-7f08739fee38/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 238309,
      "sha256": "ee47c80715e8da7afa02cc2b5e278abdd06e8910bf89e404868fbf61a21edbae",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2325,
      "updated_at": "2026-06-09T13:39:31.586Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6a09d58b1b7bd502955258ab": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6a09d58b1b7bd502955258ab",
    "title": "141. Freda的投资札记第2集：Tokenmaxxing、把电机塞进蒸汽机、接力赛变篮球赛、孤独、人的连接",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a09d58b1b7bd502955258ab-1fe038b6ed33/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a09d58b1b7bd502955258ab-1fe038b6ed33/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 116565,
      "sha256": "7b01a02896e841ba75ea789e68cc2eed268c694fab475c21e7c273b0f31e462e",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 990,
      "updated_at": "2026-06-09T13:39:31.585Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6a00aa051b7bd50295dfe41d": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6a00aa051b7bd50295dfe41d",
    "title": "140. 对姚顺宇的4小时访谈：请允许我小疯一下！在Anthropic和Gemini训模型、技术预测、英雄主义已过去",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a00aa051b7bd50295dfe41d-07f5bbbae0af/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6a00aa051b7bd50295dfe41d-07f5bbbae0af/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 335601,
      "sha256": "3650179017e8d0697dbaec1348dec5e659b4d6f004a943c89ed7be16f98b2ea6",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3800,
      "updated_at": "2026-06-09T13:39:31.584Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69f3857a5c60a99573fea0c2": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69f3857a5c60a99573fea0c2",
    "title": "139. 【Agent的综述】和苏煜聊Agent技术史、OpenClaw Moment、边界的消弭和社会的辐射",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69f3857a5c60a99573fea0c2-3a398dcf424e/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69f3857a5c60a99573fea0c2-3a398dcf424e/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 183094,
      "sha256": "2f3d9133e7ceda6ac13e75398adf1728a6ae7ee0ce82d4eebf3d0f7532dd557f",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1864,
      "updated_at": "2026-06-09T13:39:31.582Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69eae15a1e94ae692107cc50": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69eae15a1e94ae692107cc50",
    "title": "138. 对罗福莉3.5小时访谈：AI范式已然巨变！OpenClaw、Agent范式很吃后训练、卡的分配、组织平权",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69eae15a1e94ae692107cc50-6834d28b582a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69eae15a1e94ae692107cc50-6834d28b582a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 316423,
      "sha256": "1e72e1d8efe19b6bd5f6d6a994dc5004fcce046d264adfa47dce3a50d97ce4a1",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3832,
      "updated_at": "2026-06-09T13:39:31.581Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69e4e6951d989496e7fecc7b": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69e4e6951d989496e7fecc7b",
    "title": "137. 对洪乐潼的4小时访谈：AI for Math、把数学变成Lean、数学天书中的证明、直觉、被创造与被发现的",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69e4e6951d989496e7fecc7b-ccb128430c9a/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69e4e6951d989496e7fecc7b-ccb128430c9a/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 453625,
      "sha256": "580774de90f70849ee0778c59695021e5508af6bb3ed7bbecd5703bb88c784c4",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 5853,
      "updated_at": "2026-06-09T13:39:31.580Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69de68cfb977fb2c47f1ee14": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69de68cfb977fb2c47f1ee14",
    "title": "136. 全球大模型季报第9集：和广密聊，Coding是AGI第二幕、硅谷御三家真相、模型正成为新一代OS",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69de68cfb977fb2c47f1ee14-1b9254286373/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69de68cfb977fb2c47f1ee14-1b9254286373/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 100331,
      "sha256": "c7b3e56de270ca6635759e14f64c4714cd016ae554de3338c8d3a6e8447c1fee",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 883,
      "updated_at": "2026-06-09T13:39:31.579Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69d8bbdfe2c8be3155dcc2fe": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69d8bbdfe2c8be3155dcc2fe",
    "title": "135. 和自然选择创始人Tristan聊，Elys、赛博分身、灵魂、Context的获取与流动和AI社交网络",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69d8bbdfe2c8be3155dcc2fe-b7cc6e20add9/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69d8bbdfe2c8be3155dcc2fe-b7cc6e20add9/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 176674,
      "sha256": "aea789e608e23d7df337519994fe79585d10802844aec021726e5e25d7776daa",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1695,
      "updated_at": "2026-06-09T13:39:31.578Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69c953b4b977fb2c478df5c3": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69c953b4b977fb2c478df5c3",
    "title": "134. 【数据的综述】和谢晨聊，新时代的石油、历史、版图、数据金字塔、定价与Recipe",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69c953b4b977fb2c478df5c3-175f101b2fde/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69c953b4b977fb2c478df5c3-175f101b2fde/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 211510,
      "sha256": "553e024837a8996de565897e74d99566aa1315b44a6acfb5e549efb6d56918b3",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 1869,
      "updated_at": "2026-06-09T13:39:31.578Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/69b77577f8b8079bfa8eb837": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "69b77577f8b8079bfa8eb837",
    "title": "133. 对谢赛宁的7小时马拉松访谈：世界模型、逃出硅谷、AMI Labs、两次拒绝Ilya、杨立昆、李飞飞和42",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69b77577f8b8079bfa8eb837-df659a10ea17/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/69b77577f8b8079bfa8eb837-df659a10ea17/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 699661,
      "sha256": "fc4ca7221e51870d62ceaaaf96cc2063cdd188e07e3222b0dbf32aa621fe2c7f",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 9780,
      "updated_at": "2026-06-09T13:39:31.577Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/698ebb0b66e2c30377510cf6": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "698ebb0b66e2c30377510cf6",
    "title": "132. 对星海图创始人高继扬的3小时访谈：鲶鱼、曾国藩、Waymo与Momenta的两面、一只狼与许华哲的离开",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/698ebb0b66e2c30377510cf6-f39474a76244/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/698ebb0b66e2c30377510cf6-f39474a76244/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 267824,
      "sha256": "7645245c0008d9f37676e841976b786cc353e221347ea4f2e4617f12df8c8bc8",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2765,
      "updated_at": "2026-06-09T13:39:31.575Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6976bdf0ef1cf272a76fa9f3": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6976bdf0ef1cf272a76fa9f3",
    "title": "131. 印奇出任阶跃星辰董事长的访谈：聪明人的诱惑、取舍、超长链路残酷淘汰赛、阶跃函数和超多元方程",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6976bdf0ef1cf272a76fa9f3-b463f64f435b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6976bdf0ef1cf272a76fa9f3-b463f64f435b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 192665,
      "sha256": "13e45dab1a35c9f2d24bfda0c513e9c2e150c1e6512a44a977af68ad5485e9dd",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2052,
      "updated_at": "2026-06-09T13:39:31.573Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/6970c1e0109824f9e1c60e7a": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "6970c1e0109824f9e1c60e7a",
    "title": "130. 张月光创业两年首次访谈：妙鸭不是AI Native产品、流程到上下文设计、One Way Door和乙女游戏",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6970c1e0109824f9e1c60e7a-fdbc93e6940b/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/6970c1e0109824f9e1c60e7a-fdbc93e6940b/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 332359,
      "sha256": "e884893d88d1d508001bd2c51438702d06d18a5bfbbbfbe9426b3fcd3df18e1c",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 3909,
      "updated_at": "2026-06-09T13:39:31.572Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  },
  "zhang-xiaojun-business-interview/695f008dc1e012a7abf0be09": {
    "source_id": "zhang-xiaojun-business-interview",
    "episode_id": "695f008dc1e012a7abf0be09",
    "title": "129. 全球大模型第一股的上市访谈，和智谱CEO张鹏聊：敢问路在何方？",
    "transcript": {
      "kind": "transcript_markdown",
      "key": "podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/695f008dc1e012a7abf0be09-f5e089cf3892/transcript.md",
      "public_path": "/api/podcast-assets/podcast-text/v1/zhang-xiaojun-business-interview-e224f38f918a/695f008dc1e012a7abf0be09-f5e089cf3892/transcript.md",
      "file_name": "transcript.md",
      "content_type": "text/markdown; charset=utf-8",
      "size_bytes": 231514,
      "sha256": "765e289f716379f7c97d220700201ef9bb66390ab39a5b00523deee08abd23f2",
      "source_kind": "local_whispercpp_asr",
      "source_quality": "asr_transcript",
      "record_count": 2307,
      "updated_at": "2026-06-09T13:39:31.571Z"
    },
    "transcript_pdf": null,
    "cn_readable": null,
    "cn_knowledge_json": null
  }
} as const;
